import '../assets/base-provider-CjhZmcJC.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useMemo, createContext, useContext, useId as useId$1, forwardRef, useState, useEffect, cloneElement, isValidElement, useRef, useImperativeHandle, useCallback, memo, useLayoutEffect, startTransition, Component, StrictMode } from "react";
import * as ReactDOM from "react-dom";
import { o as customDevOnlyLogger, G as getMeasInternalConfig, H as trackDatadogLogs, I as getIsDatadogLogsInitialized, d as distExports, Q as QueryClient, a as QueryClientProvider, C as CommonConfigProvider } from "./public-get.api-BgCjeY4q.js";
const COMMON_QUERY_CLIENT_CONFIG = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchInterval: false,
      retry: 1
    },
    mutations: {
      retry: false
    }
  }
};
function commonErrorHandler(error) {
  const env = getMeasInternalConfig().environment;
  if (env === "dev" || env === "tst") {
    console.error(error);
  }
}
const executeFunctionSafely = (fn) => {
  try {
    return fn();
  } catch (error) {
    customDevOnlyLogger({
      message: "Error while executing function",
      data: error
    });
    return void 0;
  }
};
function getApiErrorStatusKey(caughtError) {
  if (!(caughtError == null ? void 0 : caughtError.status)) {
    return null;
  }
  switch (String(caughtError.status)) {
    case "401":
      return "shared.apiError.unauthorized";
    case "400":
      return "shared.apiError.badRequest";
    case "500":
      return "shared.apiError.serverError";
    default:
      return "shared.apiError.generic";
  }
}
function safeParseErrorToText(caughtError) {
  let errorAsText = "";
  try {
    if (caughtError == null ? void 0 : caughtError.status) {
      if (String(caughtError.status) === "401") {
        errorAsText = "Unauthorized. Token is missing or invalid";
      } else if (String(caughtError.status) === "400") {
        errorAsText = "Request is missing required parameters";
      } else if (String(caughtError.status) === "500") {
        errorAsText = "API Exception (500)";
      } else {
        errorAsText = "API resource failure";
      }
    } else if (caughtError == null ? void 0 : caughtError.message) {
      errorAsText = caughtError.message;
    } else {
      errorAsText = JSON.stringify(caughtError, null, 2);
    }
  } catch (e) {
    console.error("Failed to parse error to text", e);
  }
  return errorAsText;
}
function checkForAuthErrorStatus(caughtError) {
  if (!(caughtError == null ? void 0 : caughtError.status)) {
    return false;
  }
  return caughtError.status === 401;
}
function checkForNotFoundErrorStatus(caughtError) {
  if (!(caughtError == null ? void 0 : caughtError.status)) {
    return false;
  }
  return caughtError.status === 404;
}
function collectRuntimeErrorDetails(error) {
  const errorName = error == null ? void 0 : error.name;
  const errorMessage = error == null ? void 0 : error.message;
  let errorStack = error == null ? void 0 : error.stack;
  let errorFallback = "";
  if (errorName || errorMessage) {
    errorFallback = `${errorName}:
${errorMessage}`;
  }
  if (errorStack) {
    const errorStackArray = errorStack.split("\n");
    errorStackArray.shift();
    errorStack = errorStackArray.join("\n");
  }
  if (!errorFallback) {
    try {
      const errorAsString = JSON.stringify(error, null, 2);
      if (errorAsString) {
        errorFallback = errorAsString;
      }
    } catch (error2) {
      errorFallback = "Unknown Error";
      customDevOnlyLogger({
        message: "Error while trying to stringify error stack",
        data: error2
      });
    }
  }
  return {
    mainText: errorFallback,
    stackText: errorStack
  };
}
const parseDataDrivenKeySegment = (term) => term.replace(/ /g, "").toLowerCase();
const translateDataDrivenTerm = ({
  prefix,
  root,
  t,
  term
}) => {
  const key = `${root}.${prefix}.${parseDataDrivenKeySegment(term)}`;
  const translated = t(key);
  return translated === key ? term : translated;
};
const translatePassportTerm = ({
  prefix = "common",
  t,
  term
}) => translateDataDrivenTerm({
  prefix,
  root: "sizePassport.resourceKeys",
  t,
  term
});
const buildMeasurementsTranslationPrefix = (productType) => `${productType.toLowerCase()}.measurements`;
const translateWithFallback = ({
  fallback,
  key,
  params,
  t
}) => {
  const translated = t(key, params);
  return translated === key ? fallback : translated;
};
const translateTailorInstructionTitle = ({
  measurementId,
  measurementTitle,
  productId,
  t
}) => translateWithFallback({
  fallback: measurementTitle,
  key: `tailorInstructions.${productId.toLowerCase()}.${parseDataDrivenKeySegment(measurementId)}`,
  t
});
const translateProductType = ({
  productTypeId,
  t
}) => {
  const key = `shared.productTypes.${productTypeId}`;
  const translated = t(key);
  return translated === key ? productTypeId : translated;
};
const NOUN_CAPITALISING_LANGUAGES = ["de"];
const translateProductTypeInSentence = ({
  language,
  productTypeId,
  t
}) => {
  const name = translateProductType({
    productTypeId,
    t
  });
  const normalizedLanguage = language.toLowerCase();
  return NOUN_CAPITALISING_LANGUAGES.some((code) => normalizedLanguage.startsWith(code)) ? name : name.toLocaleLowerCase(normalizedLanguage);
};
const LOCALIZATION_NAMESPACES = {
  SHARED: "shared",
  SIZE_PASSPORT: "size-passport",
  SIZE_PICKER: "size-picker",
  SIZE_CHART: "size-chart",
  RTW_ONLINE: "rtw-online",
  RTW_ALTERATIONS: "rtw-alterations",
  CUSTOM_MADE: "custom-made",
  TAILOR_INSTRUCTIONS: "tailor-instructions"
};
const DEFAULT_LANGUAGE = "en";
const __variableDynamicImportRuntimeHelper = (glob, path, segs) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(
      reject.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + path + (path.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
const importLocaleFile = (namespace, language) => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "../../../locales/custom-made/da.json": () => import("./da-BuDKxC7j.js"), "../../../locales/custom-made/de.json": () => import("./de-h7-trH78.js"), "../../../locales/custom-made/en.json": () => import("./en-hGZzUWyx.js"), "../../../locales/custom-made/es.json": () => import("./es-D2FQmIzT.js"), "../../../locales/custom-made/fi.json": () => import("./fi-CV-_nBDa.js"), "../../../locales/custom-made/fr.json": () => import("./fr-Cv2HXlki.js"), "../../../locales/custom-made/it.json": () => import("./it-H406TWf4.js"), "../../../locales/custom-made/ko.json": () => import("./ko-CUuYXNTw.js"), "../../../locales/custom-made/nl.json": () => import("./nl-BWYEK6c8.js"), "../../../locales/custom-made/pl.json": () => import("./pl-CJclgA6C.js"), "../../../locales/custom-made/sv.json": () => import("./sv-CdImQu44.js"), "../../../locales/custom-made/zh.json": () => import("./zh-DGOeLNbN.js"), "../../../locales/rtw-alterations/da.json": () => import("./da-DBVTc5Kc.js"), "../../../locales/rtw-alterations/de.json": () => import("./de-BhGxjiPm.js"), "../../../locales/rtw-alterations/en.json": () => import("./en-BpguoSGd.js"), "../../../locales/rtw-alterations/es.json": () => import("./es-CX1ftm5N.js"), "../../../locales/rtw-alterations/fi.json": () => import("./fi-D1pnZd8C.js"), "../../../locales/rtw-alterations/fr.json": () => import("./fr-C_98faC7.js"), "../../../locales/rtw-alterations/it.json": () => import("./it-Ciosomwn.js"), "../../../locales/rtw-alterations/ko.json": () => import("./ko-BSSW9oxy.js"), "../../../locales/rtw-alterations/nl.json": () => import("./nl-zTD7fv5D.js"), "../../../locales/rtw-alterations/pl.json": () => import("./pl-e7OQKoY_.js"), "../../../locales/rtw-alterations/sv.json": () => import("./sv-qj4SljWB.js"), "../../../locales/rtw-alterations/zh.json": () => import("./zh-GJvl0SPn.js"), "../../../locales/rtw-online/da.json": () => import("./da-CaRJZPf2.js"), "../../../locales/rtw-online/de.json": () => import("./de-sScaNtaA.js"), "../../../locales/rtw-online/en.json": () => import("./en-nf_f2_DR.js"), "../../../locales/rtw-online/es.json": () => import("./es-Dxj-CnV0.js"), "../../../locales/rtw-online/fi.json": () => import("./fi-BjNetSp0.js"), "../../../locales/rtw-online/fr.json": () => import("./fr-URZ3GvZi.js"), "../../../locales/rtw-online/it.json": () => import("./it-CXKKM0Pp.js"), "../../../locales/rtw-online/ko.json": () => import("./ko-D5SMJq-e.js"), "../../../locales/rtw-online/nl.json": () => import("./nl-DIo3sXjS.js"), "../../../locales/rtw-online/pl.json": () => import("./pl-CKR_k5Xg.js"), "../../../locales/rtw-online/sv.json": () => import("./sv-DA_wkQ6S.js"), "../../../locales/rtw-online/zh.json": () => import("./zh-CL1emjdz.js"), "../../../locales/shared/da.json": () => import("./da-50aXr80x.js"), "../../../locales/shared/de.json": () => import("./de-CsYuOGcz.js"), "../../../locales/shared/en.json": () => import("./en-CJrDKFph.js"), "../../../locales/shared/es.json": () => import("./es-CFVghMK3.js"), "../../../locales/shared/fi.json": () => import("./fi-Bwho_WrA.js"), "../../../locales/shared/fr.json": () => import("./fr-CZeOezkv.js"), "../../../locales/shared/it.json": () => import("./it-BGeeWups.js"), "../../../locales/shared/ko.json": () => import("./ko-DNAiB34L.js"), "../../../locales/shared/nl.json": () => import("./nl-BQbYWn83.js"), "../../../locales/shared/pl.json": () => import("./pl-Cr7narF6.js"), "../../../locales/shared/sv.json": () => import("./sv-DjCoBnFV.js"), "../../../locales/shared/zh.json": () => import("./zh-CmHR4mzo.js"), "../../../locales/size-chart/da.json": () => import("./da-BJGKjZId.js"), "../../../locales/size-chart/de.json": () => import("./de-tIUd6-g0.js"), "../../../locales/size-chart/en.json": () => import("./en-hqG0DtW7.js"), "../../../locales/size-chart/es.json": () => import("./es-DBjusb8Z.js"), "../../../locales/size-chart/fi.json": () => import("./fi-BRobDAGF.js"), "../../../locales/size-chart/fr.json": () => import("./fr-BWnN2ODP.js"), "../../../locales/size-chart/it.json": () => import("./it-QDx6Hju_.js"), "../../../locales/size-chart/ko.json": () => import("./ko-CTpfvMXF.js"), "../../../locales/size-chart/nl.json": () => import("./nl-BLIfQJJN.js"), "../../../locales/size-chart/pl.json": () => import("./pl-YL7Iftek.js"), "../../../locales/size-chart/sv.json": () => import("./sv-Bp78f3nP.js"), "../../../locales/size-chart/zh.json": () => import("./zh-BW_h-Zsc.js"), "../../../locales/size-passport/da.json": () => import("./da-DEgnmkcN.js"), "../../../locales/size-passport/de.json": () => import("./de-SqUjS6Qa.js"), "../../../locales/size-passport/en.json": () => import("./en-DuV4pMzT.js"), "../../../locales/size-passport/es.json": () => import("./es-7R8Wyn8C.js"), "../../../locales/size-passport/fi.json": () => import("./fi-BX_OgXmS.js"), "../../../locales/size-passport/fr.json": () => import("./fr-Bo_6tzoa.js"), "../../../locales/size-passport/it.json": () => import("./it-wVMvkDhX.js"), "../../../locales/size-passport/ko.json": () => import("./ko-DVCCBnsQ.js"), "../../../locales/size-passport/nl.json": () => import("./nl-qogBmHeW.js"), "../../../locales/size-passport/pl.json": () => import("./pl-4EeLhwqx.js"), "../../../locales/size-passport/sv.json": () => import("./sv-6V0ooigI.js"), "../../../locales/size-passport/zh.json": () => import("./zh-BoNynwe9.js"), "../../../locales/size-picker/da.json": () => import("./da-CBlv-7tk.js"), "../../../locales/size-picker/de.json": () => import("./de-BB7g0N7A.js"), "../../../locales/size-picker/en.json": () => import("./en-BaUE3BPn.js"), "../../../locales/size-picker/es.json": () => import("./es-DktE9Qrq.js"), "../../../locales/size-picker/fi.json": () => import("./fi-C0Mby7Ry.js"), "../../../locales/size-picker/fr.json": () => import("./fr-41gBfCCz.js"), "../../../locales/size-picker/it.json": () => import("./it-B4DOesyp.js"), "../../../locales/size-picker/ko.json": () => import("./ko-C-cQeuEY.js"), "../../../locales/size-picker/nl.json": () => import("./nl-BFxYEBEt.js"), "../../../locales/size-picker/pl.json": () => import("./pl-yFeScyh1.js"), "../../../locales/size-picker/sv.json": () => import("./sv-C_3kvAWZ.js"), "../../../locales/size-picker/zh.json": () => import("./zh--8P5zQXH.js"), "../../../locales/tailor-instructions/da.json": () => import("./da-C3idnGf4.js"), "../../../locales/tailor-instructions/de.json": () => import("./de-Cy51vT5-.js"), "../../../locales/tailor-instructions/en.json": () => import("./en-781D7hza.js"), "../../../locales/tailor-instructions/es.json": () => import("./es-DJ4mdXLc.js"), "../../../locales/tailor-instructions/fi.json": () => import("./fi-BusTw6BG.js"), "../../../locales/tailor-instructions/fr.json": () => import("./fr-DX8rF7qu.js"), "../../../locales/tailor-instructions/it.json": () => import("./it-Dhs-09je.js"), "../../../locales/tailor-instructions/ko.json": () => import("./ko-Bak5Orvq.js"), "../../../locales/tailor-instructions/nl.json": () => import("./nl-zgNsdQyd.js"), "../../../locales/tailor-instructions/pl.json": () => import("./pl-C_3XoYD5.js"), "../../../locales/tailor-instructions/sv.json": () => import("./sv-H-spqlIO.js"), "../../../locales/tailor-instructions/zh.json": () => import("./zh-C7MH95mc.js") }), `../../../locales/${namespace}/${language}.json`, 6);
const getLanguagesToTry = (language) => {
  const [baseLanguage] = language.split("-");
  const candidates = [language, baseLanguage, DEFAULT_LANGUAGE];
  return candidates.filter((candidate, index2) => candidates.indexOf(candidate) === index2);
};
const loadOneNamespace = (namespace, language, loadLocaleFile, failureEventName = "i18n_namespace_load_failed") => __async(null, null, function* () {
  const languagesToTry = getLanguagesToTry(language);
  for (const candidate of languagesToTry) {
    try {
      return (yield loadLocaleFile(namespace, candidate)).default;
    } catch (e) {
    }
  }
  trackDatadogLogs({
    eventName: failureEventName,
    eventType: "warn",
    eventDetails: {
      namespace,
      language,
      triedLanguages: languagesToTry
    }
  });
  return void 0;
});
const loadMergedNamespaces = (namespaces, language, loadLocaleFile, failureEventName) => __async(null, null, function* () {
  const loaded = yield Promise.all(namespaces.map((namespace) => loadOneNamespace(namespace, language, loadLocaleFile, failureEventName)));
  const merged = {};
  let loadedCount = 0;
  for (const translations of loaded) {
    if (translations) {
      loadedCount += 1;
      Object.assign(merged, translations);
    }
  }
  return {
    loadedCount,
    merged
  };
});
const loadNamespaceMessages = (_0, _1, ..._2) => __async(null, [_0, _1, ..._2], function* (namespaces, language, loadLocaleFile = importLocaleFile) {
  var _a;
  const isDefaultLanguage = language === DEFAULT_LANGUAGE;
  const [requested, fallback] = yield Promise.all([loadMergedNamespaces(namespaces, language, loadLocaleFile), isDefaultLanguage ? void 0 : loadMergedNamespaces(namespaces, DEFAULT_LANGUAGE, loadLocaleFile, "i18n_fallback_namespace_load_failed")]);
  if (namespaces.length > 0 && requested.loadedCount === 0) {
    throw new Error(`[i18n] all requested namespaces failed to load for "${language}" (${namespaces.join(", ")})`);
  }
  return isDefaultLanguage ? {
    [language]: requested.merged
  } : {
    [language]: requested.merged,
    [DEFAULT_LANGUAGE]: (_a = fallback == null ? void 0 : fallback.merged) != null ? _a : {}
  };
});
const createEmptyMessages = (language) => ({
  [language]: {},
  [DEFAULT_LANGUAGE]: {}
});
const loggedMissingKeys = /* @__PURE__ */ new Set();
const handleMissingKey = ({
  key,
  language
}) => {
  const dedupeKey = `${language}:${key}`;
  if (loggedMissingKeys.has(dedupeKey)) return;
  loggedMissingKeys.add(dedupeKey);
  if (getIsDatadogLogsInitialized()) {
    trackDatadogLogs({
      eventName: "i18n_key_missing",
      eventType: "warn",
      eventDetails: {
        key,
        language
      }
    });
  } else {
    customDevOnlyLogger({
      message: `[i18n] missing translation for key "${key}" (language: "${language}")`
    }, "warn");
  }
};
const isUndefined = (value) => value === void 0;
const isNull = (value) => value === null;
const isObject = (value) => typeof value === "object" && !isNull(value);
const isString = (value) => typeof value === "string";
const getPropertyByPath = (obj, path) => {
  const [first, ...rest] = path.split(".");
  const value = obj[first];
  if (isObject(value)) {
    return getPropertyByPath(value, rest.join("."));
  }
  return value;
};
const interpolate = (template, parameters) => template.replace(/\{(\w+)\}/g, (_, match) => parameters[match] !== void 0 ? String(parameters[match]) : `{${match}}`);
const getStringValue = (translations, key) => {
  const value = getPropertyByPath(translations, key);
  return isString(value) ? value : null;
};
const translate = (translations, fallbackTranslations, key, parameters) => {
  var _a;
  const translationValue = (_a = getStringValue(translations, key)) != null ? _a : getStringValue(fallbackTranslations, key);
  if (!translationValue) return key;
  return !isUndefined(parameters) ? interpolate(translationValue, parameters) : translationValue;
};
const DEFAULT_FALLBACK_LANGUAGE = "en";
const createI18n = (translations, language, fallbackLanguage = DEFAULT_FALLBACK_LANGUAGE, onMissingKey) => {
  let languageTranslations = translations[language];
  if (isUndefined(languageTranslations)) {
    console.warn(`No translations found for language: ${language}, falling back to ${fallbackLanguage}`);
    languageTranslations = translations[fallbackLanguage];
    if (isUndefined(languageTranslations)) {
      throw new Error(`No translations found for fallback language: ${fallbackLanguage}`);
    }
  }
  return (key, parameters, languageOverride) => {
    const resolvedLanguage = languageOverride != null ? languageOverride : language;
    const result = translate(languageOverride ? translations[languageOverride] : languageTranslations, translations[fallbackLanguage], key, parameters);
    if (result === key) onMissingKey == null ? void 0 : onMissingKey({
      key,
      language: resolvedLanguage
    });
    return result;
  };
};
const I18NContext = createContext({
  language: "en",
  messages: {},
  t: () => {
    return "";
  }
});
const useI18N = () => useContext(I18NContext);
const ClientI18NProvider = ({
  children,
  language,
  messages,
  onMissingKey
}) => {
  const t = useMemo(() => createI18n(messages, language, DEFAULT_FALLBACK_LANGUAGE, onMissingKey), [messages, language, onMissingKey]);
  const value = useMemo(() => ({
    language,
    messages,
    t
  }), [language, messages, t]);
  return /* @__PURE__ */ jsx(I18NContext.Provider, { value, children });
};
function useLocalization() {
  const {
    t
  } = useI18N();
  return t;
}
function useLocalizationLanguage() {
  const {
    language
  } = useI18N();
  return language;
}
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const CLASS_PART_SEPARATOR = "-";
const createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(({
    validator
  }) => validator(classRest))) == null ? void 0 : _a.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = (className) => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
};
const createClassMap = (config) => {
  const {
    theme,
    classGroups
  } = config;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const classGroupId in classGroups) {
    processClassesRecursively(classGroups[classGroupId], classMap, classGroupId, theme);
  }
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = (func) => func.isThemeGetter;
const createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  const update = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = "!";
const MODIFIER_SEPARATOR = ":";
const MODIFIER_SEPARATOR_LENGTH = MODIFIER_SEPARATOR.length;
const createParseClassName = (config) => {
  const {
    prefix,
    experimentalParseClassName
  } = config;
  let parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let parenDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index2 = 0; index2 < className.length; index2++) {
      let currentCharacter = className[index2];
      if (bracketDepth === 0 && parenDepth === 0) {
        if (currentCharacter === MODIFIER_SEPARATOR) {
          modifiers.push(className.slice(modifierStart, index2));
          modifierStart = index2 + MODIFIER_SEPARATOR_LENGTH;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index2;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      } else if (currentCharacter === "(") {
        parenDepth++;
      } else if (currentCharacter === ")") {
        parenDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const baseClassName = stripImportantModifier(baseClassNameWithImportantModifier);
    const hasImportantModifier = baseClassName !== baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (prefix) {
    const fullPrefix = prefix + MODIFIER_SEPARATOR;
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => className.startsWith(fullPrefix) ? parseClassNameOriginal(className.substring(fullPrefix.length)) : {
      isExternal: true,
      modifiers: [],
      hasImportantModifier: false,
      baseClassName: className,
      maybePostfixModifierPosition: void 0
    };
  }
  if (experimentalParseClassName) {
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => experimentalParseClassName({
      className,
      parseClassName: parseClassNameOriginal
    });
  }
  return parseClassName;
};
const stripImportantModifier = (baseClassName) => {
  if (baseClassName.endsWith(IMPORTANT_MODIFIER)) {
    return baseClassName.substring(0, baseClassName.length - 1);
  }
  if (baseClassName.startsWith(IMPORTANT_MODIFIER)) {
    return baseClassName.substring(1);
  }
  return baseClassName;
};
const createSortModifiers = (config) => {
  const orderSensitiveModifiers = Object.fromEntries(config.orderSensitiveModifiers.map((modifier) => [modifier, true]));
  const sortModifiers = (modifiers) => {
    if (modifiers.length <= 1) {
      return modifiers;
    }
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier) => {
      const isPositionSensitive = modifier[0] === "[" || orderSensitiveModifiers[modifier];
      if (isPositionSensitive) {
        sortedModifiers.push(...unsortedModifiers.sort(), modifier);
        unsortedModifiers = [];
      } else {
        unsortedModifiers.push(modifier);
      }
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
  };
  return sortModifiers;
};
const createConfigUtils = (config) => __spreadValues({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  sortModifiers: createSortModifiers(config)
}, createClassGroupUtils(config));
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds,
    sortModifiers
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index2 = classNames.length - 1; index2 >= 0; index2 -= 1) {
    const originalClassName = classNames[index2];
    const {
      isExternal,
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    if (isExternal) {
      result = originalClassName + (result.length > 0 ? " " + result : result);
      continue;
    }
    let hasPostfixModifier = !!maybePostfixModifierPosition;
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
function twJoin() {
  let index2 = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index2 < arguments.length) {
    if (argument = arguments[index2++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
const toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const fractionRegex = /^\d+\/\d+$/;
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isFraction = (value) => fractionRegex.test(value);
const isNumber = (value) => !!value && !Number.isNaN(Number(value));
const isInteger = (value) => !!value && Number.isInteger(Number(value));
const isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
const isTshirtSize = (value) => tshirtUnitRegex.test(value);
const isAny = () => true;
const isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
const isNever = () => false;
const isShadow = (value) => shadowRegex.test(value);
const isImage = (value) => imageRegex.test(value);
const isAnyNonArbitrary = (value) => !isArbitraryValue(value) && !isArbitraryVariable(value);
const isArbitrarySize = (value) => getIsArbitraryValue(value, isLabelSize, isNever);
const isArbitraryValue = (value) => arbitraryValueRegex.test(value);
const isArbitraryLength = (value) => getIsArbitraryValue(value, isLabelLength, isLengthOnly);
const isArbitraryNumber = (value) => getIsArbitraryValue(value, isLabelNumber, isNumber);
const isArbitraryPosition = (value) => getIsArbitraryValue(value, isLabelPosition, isNever);
const isArbitraryImage = (value) => getIsArbitraryValue(value, isLabelImage, isImage);
const isArbitraryShadow = (value) => getIsArbitraryValue(value, isLabelShadow, isShadow);
const isArbitraryVariable = (value) => arbitraryVariableRegex.test(value);
const isArbitraryVariableLength = (value) => getIsArbitraryVariable(value, isLabelLength);
const isArbitraryVariableFamilyName = (value) => getIsArbitraryVariable(value, isLabelFamilyName);
const isArbitraryVariablePosition = (value) => getIsArbitraryVariable(value, isLabelPosition);
const isArbitraryVariableSize = (value) => getIsArbitraryVariable(value, isLabelSize);
const isArbitraryVariableImage = (value) => getIsArbitraryVariable(value, isLabelImage);
const isArbitraryVariableShadow = (value) => getIsArbitraryVariable(value, isLabelShadow, true);
const getIsArbitraryValue = (value, testLabel, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false) => {
  const result = arbitraryVariableRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return shouldMatchNoLabel;
  }
  return false;
};
const isLabelPosition = (label) => label === "position" || label === "percentage";
const isLabelImage = (label) => label === "image" || label === "url";
const isLabelSize = (label) => label === "length" || label === "size" || label === "bg-size";
const isLabelLength = (label) => label === "length";
const isLabelNumber = (label) => label === "number";
const isLabelFamilyName = (label) => label === "family-name";
const isLabelShadow = (label) => label === "shadow";
const getDefaultConfig = () => {
  const themeColor = fromTheme("color");
  const themeFont = fromTheme("font");
  const themeText = fromTheme("text");
  const themeFontWeight = fromTheme("font-weight");
  const themeTracking = fromTheme("tracking");
  const themeLeading = fromTheme("leading");
  const themeBreakpoint = fromTheme("breakpoint");
  const themeContainer = fromTheme("container");
  const themeSpacing = fromTheme("spacing");
  const themeRadius = fromTheme("radius");
  const themeShadow = fromTheme("shadow");
  const themeInsetShadow = fromTheme("inset-shadow");
  const themeTextShadow = fromTheme("text-shadow");
  const themeDropShadow = fromTheme("drop-shadow");
  const themeBlur = fromTheme("blur");
  const themePerspective = fromTheme("perspective");
  const themeAspect = fromTheme("aspect");
  const themeEase = fromTheme("ease");
  const themeAnimate = fromTheme("animate");
  const scaleBreak = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const scalePosition = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ];
  const scalePositionWithArbitrary = () => [...scalePosition(), isArbitraryVariable, isArbitraryValue];
  const scaleOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const scaleOverscroll = () => ["auto", "contain", "none"];
  const scaleUnambiguousSpacing = () => [isArbitraryVariable, isArbitraryValue, themeSpacing];
  const scaleInset = () => [isFraction, "full", "auto", ...scaleUnambiguousSpacing()];
  const scaleGridTemplateColsRows = () => [isInteger, "none", "subgrid", isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartAndEnd = () => ["auto", {
    span: ["full", isInteger, isArbitraryVariable, isArbitraryValue]
  }, isInteger, isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartOrEnd = () => [isInteger, "auto", isArbitraryVariable, isArbitraryValue];
  const scaleGridAutoColsRows = () => ["auto", "min", "max", "fr", isArbitraryVariable, isArbitraryValue];
  const scaleAlignPrimaryAxis = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"];
  const scaleAlignSecondaryAxis = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"];
  const scaleMargin = () => ["auto", ...scaleUnambiguousSpacing()];
  const scaleSizing = () => [isFraction, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleColor = () => [themeColor, isArbitraryVariable, isArbitraryValue];
  const scaleBgPosition = () => [...scalePosition(), isArbitraryVariablePosition, isArbitraryPosition, {
    position: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleBgRepeat = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }];
  const scaleBgSize = () => ["auto", "cover", "contain", isArbitraryVariableSize, isArbitrarySize, {
    size: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleGradientStopPosition = () => [isPercent, isArbitraryVariableLength, isArbitraryLength];
  const scaleRadius = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    themeRadius,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleBorderWidth = () => ["", isNumber, isArbitraryVariableLength, isArbitraryLength];
  const scaleLineStyle = () => ["solid", "dashed", "dotted", "double"];
  const scaleBlendMode = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const scaleMaskImagePosition = () => [isNumber, isPercent, isArbitraryVariablePosition, isArbitraryPosition];
  const scaleBlur = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    themeBlur,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleRotate = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleScale = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleSkew = () => [isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleTranslate = () => [isFraction, "full", ...scaleUnambiguousSpacing()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [isTshirtSize],
      breakpoint: [isTshirtSize],
      color: [isAny],
      container: [isTshirtSize],
      "drop-shadow": [isTshirtSize],
      ease: ["in", "out", "in-out"],
      font: [isAnyNonArbitrary],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [isTshirtSize],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [isTshirtSize],
      shadow: [isTshirtSize],
      spacing: ["px", isNumber],
      text: [isTshirtSize],
      "text-shadow": [isTshirtSize],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", isFraction, isArbitraryValue, isArbitraryVariable, themeAspect]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isNumber, isArbitraryValue, isArbitraryVariable, themeContainer]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": scaleBreak()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": scaleBreak()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: scalePositionWithArbitrary()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: scaleOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": scaleOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": scaleOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: scaleOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": scaleOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": scaleOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: scaleInset()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": scaleInset()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": scaleInset()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: scaleInset()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: scaleInset()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: scaleInset()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: scaleInset()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: scaleInset()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: scaleInset()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [isInteger, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [isFraction, "full", "auto", themeContainer, ...scaleUnambiguousSpacing()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [isNumber, isFraction, "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [isInteger, "first", "last", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": scaleGridAutoColsRows()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": scaleGridAutoColsRows()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: scaleUnambiguousSpacing()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": scaleUnambiguousSpacing()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": scaleUnambiguousSpacing()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...scaleAlignPrimaryAxis(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...scaleAlignSecondaryAxis(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...scaleAlignPrimaryAxis()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": scaleAlignPrimaryAxis()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: scaleUnambiguousSpacing()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: scaleUnambiguousSpacing()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: scaleUnambiguousSpacing()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: scaleMargin()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: scaleMargin()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: scaleMargin()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: scaleMargin()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: scaleMargin()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: scaleMargin()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: scaleMargin()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: scaleMargin()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: scaleMargin()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: scaleSizing()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [themeContainer, "screen", ...scaleSizing()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          themeContainer,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...scaleSizing()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          themeContainer,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [themeBreakpoint]
          },
          ...scaleSizing()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...scaleSizing()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...scaleSizing()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...scaleSizing()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", themeText, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [themeFontWeight, isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", isPercent, isArbitraryValue]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isArbitraryVariableFamilyName, isArbitraryValue, themeFont]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [themeTracking, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [isNumber, "none", isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          themeLeading,
          ...scaleUnambiguousSpacing()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: scaleColor()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: scaleColor()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...scaleLineStyle(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [isNumber, "from-font", "auto", isArbitraryVariable, isArbitraryLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: scaleColor()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [isNumber, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: scaleUnambiguousSpacing()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: scaleBgPosition()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: scaleBgRepeat()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: scaleBgSize()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, isInteger, isArbitraryVariable, isArbitraryValue],
          radial: ["", isArbitraryVariable, isArbitraryValue],
          conic: [isInteger, isArbitraryVariable, isArbitraryValue]
        }, isArbitraryVariableImage, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: scaleColor()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: scaleColor()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: scaleColor()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: scaleColor()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: scaleRadius()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": scaleRadius()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": scaleRadius()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": scaleRadius()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": scaleRadius()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": scaleRadius()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": scaleRadius()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": scaleRadius()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": scaleRadius()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": scaleRadius()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": scaleRadius()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": scaleRadius()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": scaleRadius()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": scaleRadius()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": scaleRadius()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: scaleBorderWidth()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": scaleBorderWidth()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": scaleBorderWidth()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": scaleBorderWidth()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": scaleBorderWidth()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": scaleBorderWidth()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": scaleBorderWidth()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": scaleBorderWidth()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": scaleBorderWidth()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": scaleBorderWidth()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": scaleBorderWidth()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: scaleColor()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": scaleColor()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": scaleColor()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": scaleColor()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": scaleColor()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": scaleColor()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": scaleColor()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": scaleColor()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": scaleColor()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: scaleColor()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...scaleLineStyle(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", isNumber, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: scaleColor()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: scaleColor()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", themeInsetShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": scaleColor()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: scaleBorderWidth()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: scaleColor()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [isNumber, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": scaleColor()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": scaleBorderWidth()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": scaleColor()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", themeTextShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": scaleColor()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...scaleBlendMode(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": scaleBlendMode()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [isNumber]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": scaleMaskImagePosition()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": scaleMaskImagePosition()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": scaleColor()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": scaleColor()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": scaleMaskImagePosition()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": scaleMaskImagePosition()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": scaleColor()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": scaleColor()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": scaleMaskImagePosition()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": scaleMaskImagePosition()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": scaleColor()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": scaleColor()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": scaleMaskImagePosition()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": scaleMaskImagePosition()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": scaleColor()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": scaleColor()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": scaleMaskImagePosition()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": scaleMaskImagePosition()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": scaleColor()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": scaleColor()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": scaleMaskImagePosition()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": scaleMaskImagePosition()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": scaleColor()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": scaleColor()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": scaleMaskImagePosition()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": scaleMaskImagePosition()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": scaleColor()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": scaleColor()
      }],
      "mask-image-radial": [{
        "mask-radial": [isArbitraryVariable, isArbitraryValue]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": scaleMaskImagePosition()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": scaleMaskImagePosition()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": scaleColor()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": scaleColor()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": scalePosition()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [isNumber]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": scaleMaskImagePosition()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": scaleMaskImagePosition()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": scaleColor()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": scaleColor()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: scaleBgPosition()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: scaleBgRepeat()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: scaleBgSize()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: scaleBlur()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeDropShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": scaleColor()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": scaleBlur()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": scaleUnambiguousSpacing()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [isNumber, "initial", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", themeEase, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", themeAnimate, isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [themePerspective, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": scalePositionWithArbitrary()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: scaleRotate()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": scaleRotate()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": scaleRotate()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": scaleRotate()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: scaleScale()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": scaleScale()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": scaleScale()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": scaleScale()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: scaleSkew()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": scaleSkew()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": scaleSkew()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [isArbitraryVariable, isArbitraryValue, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: scalePositionWithArbitrary()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: scaleTranslate()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": scaleTranslate()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": scaleTranslate()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": scaleTranslate()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: scaleColor()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: scaleColor()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryVariable, isArbitraryValue]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...scaleColor()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isNumber, isArbitraryVariableLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...scaleColor()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
};
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
const cn = (...inputs) => {
  return twMerge(clsx(inputs));
};
const AlterationsIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M9.7998 5.60059H7.7002c-1.1598 0-2.10059.94078-2.10059 2.10058V20.3008c0 1.1598.94079 2.0996 2.10059 2.0996h12.5996c1.1598 0 2.1006-.9398 2.1006-2.0996v-2.0996h1.3994v2.0996c0 1.933-1.567 3.5-3.5 3.5H7.7002c-1.933 0-3.5-1.567-3.5-3.5V7.70117c0-1.933 1.567-3.5 3.5-3.5h2.0996v1.39942ZM21.2266 3.5498c.5194-.51895 1.3616-.51917 1.8808 0l1.3428 1.34375c.5194.5194.5194 1.36147 0 1.88086L14.3711 16.8545c-.1959.1959-.4484.3254-.7217.3711l-3.4492.5752.5752-3.4492c.0456-.2734.1751-.5258.3711-.7217L21.2266 3.5498Zm-9.1895 10.9707c-.0102.0103-.0171.0238-.0195.0381l-.2842 1.709 1.708-.2852c.0144-.0024.0278-.0092.0381-.0195l8.0478-8.04786-1.4423-1.44238-8.0479 8.04784ZM22.2158 4.44141c-.0273-.02725-.0713-.02731-.0986 0l-1.1416 1.13964 1.4424 1.44239 1.1416-1.13965c.0273-.02734.0273-.07227 0-.09961l-1.3438-1.34277Z" }) }));
const AppleIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M724.602 465.438c.407-30.664 8.791-60.729 24.373-87.399s37.855-49.078 64.747-65.139c-17.084-23.702-39.621-43.207-65.822-56.967-26.201-13.761-55.344-21.396-85.115-22.301-63.505-6.476-125.071 36.915-157.432 36.915-32.987 0-82.812-36.272-136.465-35.2-34.705 1.089-68.527 10.893-98.172 28.456s-54.1 42.285-70.984 71.76c-73.14 123.013-18.584 303.802 51.477 403.237 35.054 48.69 76.021 103.079 129.626 101.15 52.455-2.114 72.047-32.494 135.365-32.494 62.731 0 81.111 32.494 135.804 31.268 56.287-.888 91.751-48.907 125.574-98.059 25.185-34.693 44.565-73.038 57.422-113.612-32.701-13.436-60.607-35.926-80.239-64.666s-30.121-62.458-30.159-96.949m-103.303-297.2c30.69-35.791 45.81-81.793 42.148-128.238-46.887 4.784-90.198 26.553-121.303 60.97-15.208 16.814-26.856 36.375-34.278 57.564a165.8 165.8 0 0 0-8.975 65.926c23.452.235 46.654-4.703 67.857-14.442 21.203-9.738 39.855-24.024 54.551-41.78" }) }));
const ArrowBackIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.29297 10.0002L12.2929 17.0001L13 16.293L6.70718 10.0002L13 3.70723L12.2929 3.00012L5.29297 10.0002Z" }) }));
const ArrowForwardIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.707 10 7.70662 2.99995l-.70711.70711L13.2928 10l-6.29287 6.2928.7071.7072 6.99997-7Z", clipRule: "evenodd" }) }));
const ArrowTopRightIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M367.678 300H682.32L250 732.32 285.355 767.68 717.68 335.355V650H767.68V250H367.678V300Z" }) }));
const BagIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M350 175c0-13.8 11.2-25 25-25h250c13.8 0 25 11.2 25 25v25h50v-25c0-41.4-33.6-75-75-75H375c-41.4 0-75 33.6-75 75v25h50zm475 75H175c-41.4 0-75 33.6-75 75v450c0 41.4 33.6 75 75 75h650c41.4 0 75-33.6 75-75V325c0-41.4-33.6-75-75-75m25 525c0 13.8-11.2 25-25 25H175c-13.8 0-25-11.2-25-25V325c0-13.8 11.2-25 25-25h650c13.8 0 25 11.2 25 25z" }) }));
const BaseStyleIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsx("path", { id: "Base Style", d: "M9.42913 6.66221L13.2268 8.80936C13.5051 8.9699 13.7035 9.12152 13.8221 9.26421C13.9407 9.40245 14 9.56299 14 9.74582C14 9.93311 13.9407 10.0981 13.8221 10.2408C13.7035 10.379 13.5051 10.5262 13.2268 10.6823L7.87586 13.7191C7.71163 13.8172 7.55881 13.8885 7.4174 13.9331C7.27599 13.9777 7.13685 14 7 14C6.85859 14 6.71945 13.9777 6.5826 13.9331C6.44575 13.8885 6.29293 13.8172 6.12414 13.7191L0.773216 10.6823C0.499511 10.5262 0.301075 10.379 0.177908 10.2408C0.0593027 10.0981 0 9.93311 0 9.74582C0 9.56299 0.0593027 9.40245 0.177908 9.26421C0.301075 9.12152 0.499511 8.9699 0.773216 8.80936L4.55718 6.6689L5.11142 6.96401C6.29514 7.59429 7.71595 7.58945 8.89534 6.95111L9.42913 6.66221ZM7 8.50167C6.85859 8.50167 6.71945 8.47938 6.5826 8.43478C6.44575 8.39019 6.29293 8.32107 6.12414 8.22742L0.773216 5.19064C0.499511 5.0301 0.301075 4.88071 0.177908 4.74248C0.0593027 4.60424 0 4.44147 0 4.25418C0 4.06689 0.0593027 3.90412 0.177908 3.76589C0.301075 3.62765 0.499511 3.47826 0.773216 3.31773L6.12414 0.280936C6.29293 0.187291 6.44575 0.118172 6.5826 0.0735786C6.71945 0.0245262 6.85859 0 7 0C7.13685 0 7.27599 0.0245262 7.4174 0.0735786C7.55881 0.118172 7.71163 0.187291 7.87586 0.280936L13.2268 3.31773C13.5051 3.47826 13.7035 3.62765 13.8221 3.76589C13.9407 3.90412 14 4.06689 14 4.25418C14 4.44147 13.9407 4.60424 13.8221 4.74248C13.7035 4.88071 13.5051 5.0301 13.2268 5.19064L7.87586 8.22742C7.71163 8.32107 7.55881 8.39019 7.4174 8.43478C7.27599 8.47938 7.13685 8.50167 7 8.50167ZM7 7.31104C7.08667 7.31104 7.18703 7.27982 7.30108 7.21739L12.4946 4.32107C12.5311 4.30323 12.5494 4.28094 12.5494 4.25418C12.5494 4.22743 12.5311 4.20513 12.4946 4.18729L7.30108 1.28428C7.18703 1.22631 7.08667 1.19732 7 1.19732C6.90877 1.19732 6.80841 1.22631 6.69893 1.28428L1.50538 4.18729C1.47344 4.20513 1.45748 4.22743 1.45748 4.25418C1.45748 4.28094 1.47344 4.30323 1.50538 4.32107L6.69893 7.21739C6.80841 7.27982 6.90877 7.31104 7 7.31104Z", fill: `url(#${uid}paint0_linear_13120_20415)` }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_13120_20415`, x1: 12, y1: 13.5, x2: 4.29489, y2: 2.49361, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#DBB82C" }),
      /* @__PURE__ */ jsx("stop", { offset: 0.291667, stopColor: "#F1B032" }),
      /* @__PURE__ */ jsx("stop", { offset: 0.630208, stopColor: "#ED8F2D" }),
      /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E85F26" })
    ] }) })
  ] }));
};
const BellIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M500 80c-33 0-60 27-60 60v22C316 191 230 306 230 440v170l-80 120v50h700v-50l-80-120V440c0-134-86-249-210-278v-22c0-33-27-60-60-60m0 60c-166 0-210 150-210 300v188l-62 92h544l-62-92V440c0-150-44-300-210-300M400 820c0 55 45 100 100 100s100-45 100-100z", clipRule: "evenodd" }) }));
const BrandPickupIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 100 100", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsxs("g", { stroke: "#2d2e2c", style: {
  mixBlendMode: "multiply"
}, children: [
  /* @__PURE__ */ jsx("path", { strokeWidth: 1.5, d: "M49.496 17.75c10.373 0 18.75 8.202 18.75 18.281 0 2.831-.66 5.51-1.838 7.902L49.705 69.318a.25.25 0 0 1-.418 0L32.583 43.933a17.8 17.8 0 0 1-1.837-7.902c0-10.08 8.378-18.281 18.75-18.281Z" }),
  /* @__PURE__ */ jsx("circle", { cx: 49.496, cy: 35, r: 7 }),
  /* @__PURE__ */ jsx("path", { strokeWidth: 1.5, d: "M24 82h51" })
] }) }));
const BrandRegisterIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 100 100", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsxs("g", { style: {
  mixBlendMode: "multiply"
}, children: [
  /* @__PURE__ */ jsx("path", { fill: "#2d2e2c", d: "M66.62 24a3 3 0 0 1 3 3v4.777h-1V27a2 2 0 0 0-2-2H15.147a2 2 0 0 0-2 2v38.769h47.119v1H12.148V27a3 3 0 0 1 3-3z" }),
  /* @__PURE__ */ jsx("path", { stroke: "#2d2e2c", strokeWidth: 1.5, d: "M12 69.25h49" }),
  /* @__PURE__ */ jsx("rect", { width: 25.232, height: 44.836, x: 61.016, y: 32.527, stroke: "#2d2e2c", strokeWidth: 1.5, rx: 1.25 }),
  /* @__PURE__ */ jsx("path", { stroke: "#2d2e2c", d: "M16.934 28.792h3.386M22.246 28.792h3.386M27.55 28.792h3.387" })
] }) }));
const BrandReturnPackageIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 100 100", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { stroke: "#2d2e2c", strokeWidth: 1.5, d: "M86.249 42.822v14.375L49.051 77.541 12.75 57.203V42.83l37.473-18.986z" }),
  /* @__PURE__ */ jsx("path", { stroke: "#2d2e2c", strokeDasharray: "2.31 1.15", strokeWidth: 0.5, d: "m49.025 77.406.022-16.176" }),
  /* @__PURE__ */ jsx("path", { stroke: "#2d2e2c", d: "m85.924 42.825-36.863 18.87-35.985-18.87" }),
  /* @__PURE__ */ jsx("path", { fill: "#2d2e2c", d: "m39.66 47.527 10.404-1.885-7.816-3.729zm26.348-15.211-.677-.323L44.829 43.83l.677.322.677.323L66.685 32.64z" })
] }));
const BuyAgainIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M14.1523 6.00083L12.1765 7.97656L13.0251 8.82509L16.4493 5.40083L13.0251 1.97656L12.1765 2.82509L14.1523 4.80083L12.0008 4.80083C10.335 4.80083 8.72081 5.37841 7.43316 6.43515C6.14551 7.4919 5.26411 8.96243 4.93914 10.5962C4.61417 12.2299 4.86573 13.9258 5.65096 15.3949C6.43619 16.864 7.70651 18.0153 9.24547 18.6528C10.7844 19.2902 12.4968 19.3743 14.0908 18.8908C15.6849 18.4073 17.0619 17.386 17.9874 16.0009C18.7814 14.8126 19.2008 13.4196 19.2008 12.0008L19.2008 11.4008L18.0008 11.4008L18.0008 12.0008C18.0008 13.1831 17.6513 14.344 16.9896 15.3342C16.2184 16.4884 15.0709 17.3395 13.7425 17.7425C12.4141 18.1454 10.9872 18.0753 9.70469 17.5441C8.42223 17.0129 7.36363 16.0534 6.70926 14.8292C6.0549 13.605 5.84527 12.1917 6.11608 10.8303C6.38689 9.46883 7.12139 8.24339 8.19443 7.36277C9.26747 6.48214 10.6127 6.00083 12.0008 6.00083L14.1523 6.00083Z", fill: "#2D2E2C", style: {
  fill: "#2D2E2C",
  fillOpacity: 1
} }) }));
const CalendarIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 16 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Outline", fillRule: "evenodd", clipRule: "evenodd", d: "M5 1H11V0H12V1H14.5C15.3284 1 16 1.67157 16 2.5V12.5C16 13.3284 15.3284 14 14.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5C1.61065e-08 1.67157 0.671573 1 1.5 1H4V0H5V1ZM1 6V12.5C1 12.7761 1.22386 13 1.5 13H14.5C14.7761 13 15 12.7761 15 12.5V6H1ZM1.5 2C1.22386 2 1 2.22386 1 2.5V5H15V2.5C15 2.22386 14.7761 2 14.5 2H12V3H11V2H5V3H4V2H1.5Z", fill: "var(--fill-0, #2D2E2C)" }) }));
const CallIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M400.6 166.7H207.7c-20.1 0-37 15.1-39.1 35.1-1.1 10.2-25.3 253.3 137.7 447.3 113.2 134.7 286.9 210.7 516.1 225.8.9.1 1.7.1 2.6.1 10 0 19.6-3.8 26.9-10.6 7.9-7.4 12.5-17.9 12.5-28.7v-193c0-18.1-12.3-33.8-29.8-38.2L680.2 566q-4.8-1.2-9.6-1.2c-10.3 0-20.3 4.1-27.8 11.5L562.1 657c-76.8-43.1-137-104.9-179.6-184.4l84.4-84.5c9.8-9.8 13.7-23.9 10.4-37.3l-38.6-154.3c-4.3-17.6-20.1-29.8-38.1-29.8m-.1 39.3 38.6 154.3-104.5 104.6c43 91.5 114.9 182 234.9 240.5l101.1-101.2 154.3 38.6v192.9C144.5 790.9 207.6 206 207.6 206z", clipRule: "evenodd" }) }));
const CartIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Vector", children: [
  /* @__PURE__ */ jsx("path", { d: "M3 14C3 14.5523 2.55228 15 2 15C1.44772 15 1 14.5523 1 14C1 13.4477 1.44772 13 2 13C2.55228 13 3 13.4477 3 14Z", fill: "var(--fill-0, #2D2E2C)" }),
  /* @__PURE__ */ jsx("path", { d: "M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z", fill: "var(--fill-0, #2D2E2C)" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5901 1H0V0H2.4099L2.6099 1H14.0524L13.6098 5.43083C13.492 6.60952 12.5632 7.54377 11.3852 7.66842L3.58435 8.49387C3.46657 8.52562 3.30537 8.62157 3.11566 8.82011C2.9201 9.02476 2.72734 9.30418 2.55649 9.6262C2.31453 10.0823 2.13981 10.5785 2.05594 11H13V12H1V11.5C1 10.8044 1.27758 9.90307 1.67312 9.15753C1.87388 8.77914 2.11692 8.41783 2.39266 8.12926C2.54948 7.96515 2.72904 7.81189 2.92922 7.69559L1.5901 1ZM3.90086 7.45479L11.28 6.67397C11.9868 6.59918 12.5441 6.03863 12.6147 5.33142L12.9476 2H2.8099L3.90086 7.45479Z", fill: "var(--fill-0, #2D2E2C)" })
] }) }));
const CashmereIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 25 24", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "m13.16 19.875-1.5 3.75" }),
  /* @__PURE__ */ jsx("path", { fill: "#000", d: "m23.654 18.375.353.354.355-.355-.356-.354zm-8.635-8.572-.354.354.001.001zm3.385 13.822-.49-.098.843.452zm.34-1.7-.49-.097zM8.227 17.304l-.475.159c.166.498.55 1.213 1.18 1.811.639.606 1.543 1.102 2.723 1.102v-1c-.876 0-1.544-.361-2.034-.827a3.7 3.7 0 0 1-.92-1.403zm3.428 2.572v.5h5.408v-1h-5.408zm11.999-1.5.352-.355L15.37 9.45l-.352.354-.353.355 8.635 8.572zm-8.635-8.572.353-.353c-.42-.42-.93-.95-1.636-1.364-.719-.42-1.62-.711-2.832-.711v1c1.038 0 1.765.245 2.327.574.575.337.996.77 1.434 1.208zm3.725 12.123-.49-.098-.34 1.699.49.098.49.098.34-1.7zm-.34 1.699.353.354 5.25-5.25-.353-.354-.354-.354-5.25 5.25zm-7.5-15.75v-.5h-1.5v1h1.5zm6.16 12v.5c.766 0 1.34.7 1.19 1.453l.49.098.49.098a2.214 2.214 0 0 0-2.17-2.649z" }),
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M.445 2.946C1.335 1.41 3.126.5 5.03.5c2.84 0 5 2.16 5 5s-2.16 5.5-5 5.5H.53c-.285 1.143 1.443 3 3.5 3h2.5c-1.365 1.82-2.493 3.187-3.399 4.08M10.531.5c2.84 0 5.348 2.178 5.348 5.018 0 1.42-.575 2.705-1.505 3.636M13.531 15a2.53 2.53 0 0 0-2.102-1.125h-.148" })
] }));
const ChangeIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsxs("g", { transform: "translate(1.8336 2.5168) scale(1.333333)", children: [
  /* @__PURE__ */ jsx("path", { d: "M2.01213 4.02426L2.4364 3.6L1.14853 2.31213L5.82426 2.31213V1.71213L1.14853 1.71213L2.4364 0.424264L2.01213 0L0 2.01213L2.01213 4.02426Z" }),
  /* @__PURE__ */ jsx("path", { d: "M7.2364 4.2L6.81213 4.62426L8.1 5.91213L3.42426 5.91213V6.51213L8.1 6.51213L6.81213 7.8L7.2364 8.22426L9.24853 6.21213L7.2364 4.2Z" })
] }) }));
const CheckIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M695.275 300.394a.5.5 0 0 0-.732.001l-27.181 29.393c-75.834 81.439-156.724 173.864-232.487 256.458a.5.5 0 0 1-.698.036l-104.465-92.159-29.828-26.3a.5.5 0 0 0-.727.071l-48.874 63.741a.5.5 0 0 0 .065.678l29.632 26.336L412.6 675.704l27.187 23.973a.5.5 0 0 0 .698-.036l24.531-26.553c84.01-90.227 175.027-195.745 257.438-284.258l27.231-29.447a.5.5 0 0 0-.002-.681z", clipRule: "evenodd" }) }));
const CheckmarkIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1000 1000", fill: "currentColor", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M398.512 679.176l407.441-456.52 38.098 30.84-442.559 495.86-219.168-208.727 35.356-33.672zm0 0" }) }));
const ChevronDownIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M499.99,692.69l350.01-350.02-35.36-35.36-314.65,314.66L185.35,307.33l-35.35,35.35,349.99,350h0Z" }) }));
const ChevronLeftIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M307.32,500.01l350,349.99,35.35-35.35-314.64-314.64,314.66-314.65-35.36-35.36-350.02,350.01h.01Z" }) }));
const ChevronRightIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M692.69,500.01L342.67,150l-35.36,35.36,314.66,314.65-314.64,314.64,35.35,35.35,350-349.99h.01Z" }) }));
const ChevronUpIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M500.01,307.31l-350.01,350.02,35.36,35.36,314.65-314.66,314.64,314.64,35.35-35.35-349.99-350h0Z" }) }));
const CircleIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none" }, props), { children: /* @__PURE__ */ jsx("circle", { cx: 6, cy: 6, r: 5, stroke: "#fff", strokeWidth: 2 }) }));
const ClockIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M500 1000C224.3 1000 0 775.7 0 500S224.3 0 500 0s500 224.3 500 500-224.3 500-500 500m0-933.3C261.1 66.7 66.7 261.1 66.7 500S261.1 933.3 500 933.3 933.3 738.9 933.3 500 738.9 66.7 500 66.7" }),
  /* @__PURE__ */ jsx("path", { d: "M510 483.3V200h-50v283.3c0 27.6 22.4 50 50 50h250v-50z" })
] }));
const CloseIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M763.7 272c2-2 2-5.2.1-7.2l-27.7-29.6c-1.8-1.9-4.8-2.1-6.8-.3l-.2.2L500 464.3l-228-228c-2-2-5.2-2-7.2-.1l-29.6 27.7c-1.9 1.8-2.1 4.8-.3 6.8l.2.2L464.3 500l-228 228c-2 2-2 5.2-.1 7.2l27.7 29.6c1.8 1.9 4.8 2.1 6.8.3l.2-.2L500 535.7l228 228c2 2 5.2 2 7.2.1l29.6-27.7c1.9-1.8 2.1-4.8.3-6.8l-.2-.2L535.7 500z", clipRule: "evenodd" }) }));
const CopyIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H6V17C6 17.5523 6.44771 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H14V3C14 2.44772 13.5523 2 13 2H3ZM13 6V3H3V13H6V7C6 6.44771 6.44772 6 7 6H13ZM7 17H17V7H7V17Z" }) }));
const CottonIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M12.004.5c3.162 0 5.796 2.106 6.408 5.087 2.981.612 5.092 3.25 5.092 6.413 0 3.615-2.794 6.5-6.41 6.5H6.914c-3.615 0-6.41-2.885-6.41-6.5 0-3.162 2.103-5.801 5.084-6.413C6.198 2.607 8.842.5 12.004.5Z" }),
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M14.88 12.613c0-2.234-1.128-4.22-2.878-5.488-1.75 1.268-2.878 3.254-2.878 5.488 0 .898.185 1.755.516 2.542a5 5 0 0 0-.495-.551c-1.185-1.13-2.809-1.59-4.366-1.386a4.78 4.78 0 0 0 1.454 4.159C7.41 18.5 9.013 18.5 10.48 18.5h2.854c1.469 0 3.26 0 4.44-1.124a4.78 4.78 0 0 0 1.452-4.158c-1.557-.204-3.18.256-4.365 1.386q-.276.264-.5.557c.333-.79.519-1.648.519-2.548ZM11.996 12.075V24" })
] }));
const CsrCo2Icon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 38 34", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Union", d: "M14.5 29.25H16.3477L13.75 33.75L11.1523 29.25H13V17.75H14.5V29.25ZM24.5 29.25H26.3477L23.75 33.75L21.1523 29.25H23V17.75H24.5V29.25ZM21.75 0C25.2116 0 27.7966 1.34051 29.5059 3.32324C31.0597 5.12594 31.8614 7.42523 31.9834 9.65039C32.9462 9.91624 34.1474 10.4522 35.1865 11.3779C36.4779 12.5285 37.5 14.2681 37.5 16.75C37.5 19.2619 36.3653 20.9955 34.7998 22.0732C33.2684 23.1274 31.3588 23.5361 29.75 23.5361V22.0361C31.1412 22.0361 32.7316 21.6768 33.9502 20.8379C35.1345 20.0224 36 18.7379 36 16.75C36 14.7321 35.1887 13.3882 34.1885 12.4971C33.1659 11.5861 31.9263 11.1357 31.1162 10.9883L30.5 10.876V10.25C30.5 8.15643 29.7999 5.96141 28.3691 4.30176C26.9534 2.65971 24.7882 1.5 21.75 1.5C16.9349 1.5 14.1869 4.90112 13.4326 6.56055L12.9854 7.5459L12.2197 6.78027C12.0299 6.59044 11.1552 6 9.75 6C8.42453 6 7.54935 6.60562 6.96191 7.3877C6.35453 8.19634 6.06692 9.18674 5.99512 9.83301L5.94238 10.3096L5.4873 10.4619C4.17075 10.9008 1.5 12.6857 1.5 16.25C1.5 18.0648 2.13515 19.4911 3.19141 20.4678C4.25388 21.4502 5.80701 22.0361 7.73828 22.0361V23.5361C5.50491 23.5361 3.56334 22.8541 2.17285 21.5684C0.776397 20.2769 0 18.435 0 16.25C0 12.1726 2.81314 9.97182 4.5752 9.20703C4.73274 8.39703 5.09594 7.37508 5.7627 6.4873C6.58359 5.39439 7.87548 4.5 9.75 4.5C10.9071 4.5 11.8417 4.80911 12.4873 5.15625C13.7676 3.05714 16.826 0 21.75 0Z", fill: "var(--fill-0, #2D2E2C)" }) }));
const CsrFairWearIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 45 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Fair Wear Logo", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M24.2323 0L21.5361 8.71701H3.42965L0 19.8058H25.627L28.3224 11.0912H41.5696L45 0H24.2323Z", fill: "var(--fill-0, white)" }),
  /* @__PURE__ */ jsxs("g", { id: "Vector_2", children: [
    /* @__PURE__ */ jsx("path", { d: "M16.5762 15.1506C16.6541 15.1506 16.6955 15.1506 16.7369 15.1506C17.0436 15.1506 17.3503 15.1506 17.6578 15.1506C17.6748 15.1506 17.6919 15.1514 17.7089 15.1506C17.7973 15.1473 17.8103 15.1349 17.8249 15.0482C17.8274 15.0309 17.8265 15.0136 17.8282 14.9963C17.8558 14.7734 17.8833 14.5506 17.9125 14.3286C17.9434 14.0976 17.9758 13.8673 18.0075 13.6363C18.0391 13.4052 18.07 13.175 18.1008 12.9439C18.1276 12.7401 18.1527 12.5354 18.1787 12.3316C18.1698 12.3274 18.1608 12.3233 18.1519 12.3192C17.631 13.2525 17.1109 14.1859 16.5762 15.1506Z", fill: "#C33333" }),
    /* @__PURE__ */ jsx("path", { d: "M23.4112 12.0667C23.326 12.0436 23.2359 12.0295 23.1475 12.027C22.973 12.0213 22.7978 12.0246 22.6233 12.0254C22.5179 12.0262 22.5171 12.027 22.4814 12.1319C22.2785 12.7244 22.0765 13.3169 21.8745 13.9094C21.8607 13.949 21.8517 13.9895 21.8404 14.0299C21.8615 14.0406 21.872 14.0505 21.8834 14.0514C22.1601 14.0613 22.4367 14.0621 22.711 14.025C22.7694 14.0167 22.8262 13.9944 22.8814 13.9713C23.1175 13.8748 23.2416 13.6767 23.3268 13.4473C23.3795 13.3053 23.429 13.1626 23.4761 13.019C23.5361 12.8341 23.5994 12.6501 23.6473 12.4619C23.6952 12.2688 23.6019 12.1186 23.4112 12.0667Z", fill: "#C33333" }),
    /* @__PURE__ */ jsx("path", { d: "M31.4405 3.51387C30.922 4.44557 30.4035 5.37726 29.8762 6.32629C29.9354 6.32876 29.9768 6.33207 30.0173 6.33289C30.32 6.33372 30.6218 6.33289 30.9244 6.33289C31.1175 6.33289 31.1127 6.33207 31.1346 6.13401C31.1597 5.89881 31.1954 5.66362 31.2263 5.42925C31.2547 5.21139 31.2839 4.99353 31.3123 4.77566C31.335 4.60484 31.3561 4.43401 31.3788 4.26319C31.4072 4.04945 31.4372 3.83654 31.464 3.62198C31.4681 3.58732 31.4616 3.55183 31.4599 3.51635C31.4534 3.5147 31.447 3.51387 31.4405 3.51387Z", fill: "#C33333" }),
    /* @__PURE__ */ jsx("path", { d: "M24.2323 0L21.5361 8.71701H3.42965L0 19.8058H25.627L28.3224 11.0912H41.5696L45 0H24.2323ZM7.50433 17.571C7.22847 17.5925 7.07431 17.4027 7.07999 17.1856C7.08567 16.9777 7.0808 16.7697 7.08486 16.5617C7.09216 16.1549 7.10108 15.7481 7.11001 15.3412C7.11893 14.917 7.12948 14.4929 7.13841 14.0687C7.13841 14.0571 7.13435 14.0456 7.12705 14.0109C7.07674 14.0794 7.03617 14.1322 6.99885 14.1875C6.624 14.7396 6.24996 15.2925 5.8743 15.8454C5.56679 16.2977 5.25847 16.7499 4.95096 17.2021C4.81141 17.4076 4.62804 17.5496 4.37814 17.5718C4.05846 17.5999 3.90024 17.3498 3.94324 17.108C4.05359 16.4924 4.89984 11.7159 4.95826 11.3974C4.9964 11.1903 5.17977 11.0623 5.34528 11.0648C5.48159 11.0665 5.6179 11.0623 5.75421 11.0665C5.79965 11.0673 5.84752 11.078 5.89052 11.0945C5.97328 11.1267 6.02278 11.1919 6.02359 11.2827C6.0244 11.347 6.01385 11.4114 6.00168 11.475C5.89539 12.0081 5.46537 14.1322 5.35746 14.6612C5.33717 14.7627 5.31202 14.8634 5.29173 14.9649C5.28606 14.9913 5.29092 15.0202 5.29092 15.078C5.37287 14.9533 5.44021 14.8543 5.50431 14.7536C5.80371 14.2849 6.10229 13.8162 6.40087 13.3474C6.70676 12.868 7.01264 12.3877 7.31772 11.9082C7.43374 11.725 7.59358 11.6062 7.8021 11.5534C8.10718 11.475 8.38142 11.687 8.3157 12.0386C8.29217 12.1649 8.15992 13.9969 8.15261 14.1174C8.14126 14.2857 8.13314 14.4541 8.12178 14.6224C8.11448 14.7347 8.10474 14.8461 8.09663 14.9583C8.09501 14.988 8.09663 15.0177 8.11854 15.0557C8.15911 14.9847 8.20211 14.9146 8.23943 14.8419C8.47148 14.3839 9.48488 12.3802 9.76074 11.8372C9.84107 11.6796 9.92464 11.5236 10.0025 11.3644C10.1023 11.1614 10.2589 11.0599 10.4829 11.0648C10.6062 11.0673 10.7303 11.0623 10.8537 11.0689C10.9843 11.0764 11.0727 11.144 11.08 11.2554C11.0849 11.3206 8.24592 16.905 8.10393 17.1666C7.97411 17.4027 7.77776 17.5496 7.50433 17.571ZM13.7876 14.7495C13.5231 14.7536 12.637 14.7503 12.4577 14.7512C12.349 14.752 12.3482 14.7528 12.3125 14.8551C12.1867 15.2182 11.8127 16.3043 11.751 16.4842C11.7453 16.4998 11.7437 16.5172 11.7356 16.5502C11.7867 16.5527 11.8314 16.5568 11.876 16.5568C12.2979 16.5576 12.7198 16.556 13.1417 16.5584C13.205 16.5584 13.2691 16.5675 13.3308 16.5824C13.4549 16.6121 13.5044 16.6764 13.4979 16.8035C13.4947 16.863 13.4086 17.1353 13.3811 17.212C13.3072 17.4175 13.1555 17.5083 12.9478 17.5099C12.594 17.5124 12.2403 17.5108 11.8865 17.5108C11.4898 17.5108 11.0938 17.5116 10.6971 17.5099C10.6346 17.5099 10.5689 17.5009 10.5096 17.4819C10.3896 17.4439 10.3384 17.3515 10.3685 17.2294C10.3912 17.1378 10.4253 17.0486 10.4561 16.9587C10.6257 16.4594 12.3555 11.4048 12.3823 11.3454C12.4488 11.1952 12.5632 11.1086 12.7255 11.0912C12.7596 11.0879 12.7936 11.0887 12.8277 11.0887C13.6545 11.0887 14.4813 11.0879 15.3089 11.0904C15.3754 11.0904 15.4444 11.1028 15.5077 11.1234C15.5904 11.1498 15.6237 11.22 15.6212 11.3066C15.6204 11.3322 15.6221 11.3603 15.6139 11.3842C15.5701 11.5154 15.5296 11.6474 15.4768 11.7753C15.4087 11.9387 15.2797 12.0204 15.1052 12.0237C14.9649 12.0262 13.8565 12.0246 13.4427 12.0262C13.2618 12.027 13.291 11.9891 13.222 12.1871C13.0768 12.6031 12.9405 13.0223 12.8001 13.4399C12.7628 13.5496 12.7239 13.6585 12.6752 13.7972C12.7458 13.7972 13.6472 13.7955 14.0521 13.7988C14.1227 13.7997 14.1965 13.812 14.2638 13.836C14.362 13.8715 14.4066 13.9606 14.3782 14.0654C14.3401 14.2073 14.2971 14.3484 14.2444 14.4846C14.1624 14.6917 13.9847 14.7462 13.7876 14.7495ZM18.6395 17.1642C18.6192 17.3655 18.4862 17.4992 18.2874 17.5083C18.1259 17.5149 17.9637 17.5149 17.8014 17.5091C17.605 17.5025 17.5134 17.401 17.5223 17.203C17.5271 17.1039 17.631 16.3703 17.6683 16.0905C17.631 16.0856 17.5985 16.0781 17.5661 16.0781C17.106 16.0773 16.6452 16.079 16.1851 16.0757C16.1048 16.0748 16.061 16.107 16.0245 16.1747C15.8444 16.5089 15.6578 16.839 15.4817 17.1749C15.3608 17.4043 15.1839 17.5223 14.9259 17.5116C14.8326 17.5075 14.5851 17.5116 14.5551 17.5083C14.375 17.4877 14.2939 17.3482 14.3734 17.1815C14.4367 17.0495 14.5137 16.924 14.5876 16.7978C14.8837 16.2869 17.7219 11.3875 17.7844 11.3C17.8817 11.1622 18.0156 11.0879 18.1868 11.0887C18.4294 11.0896 18.6728 11.0879 18.9154 11.0904C18.9616 11.0912 19.0087 11.0987 19.0525 11.1135C19.1629 11.1506 19.2302 11.2389 19.2278 11.357C19.2245 11.4989 18.6582 16.9843 18.6395 17.1642ZM24.8157 12.4025C24.6769 12.8118 24.5382 13.2212 24.3954 13.6288C24.324 13.8335 24.2217 14.0225 24.0919 14.1966C23.9012 14.4533 23.6473 14.6216 23.3617 14.747C23.3463 14.7536 23.33 14.7586 23.313 14.7635C23.2595 14.78 23.2424 14.8139 23.2473 14.8716C23.2668 15.0738 23.3236 16.022 23.399 16.2861C23.4193 16.3563 23.4469 16.4248 23.4793 16.4899C23.528 16.5881 23.6148 16.6294 23.7211 16.6302C23.8234 16.6311 23.9256 16.6294 24.0278 16.6311C24.2047 16.6335 24.2615 16.7062 24.2152 16.8753C24.1771 17.0173 24.1341 17.1576 24.0879 17.297C24.0384 17.4456 23.9126 17.5347 23.7584 17.5363C23.6351 17.538 23.511 17.538 23.3877 17.5363C22.9195 17.5306 22.629 17.3094 22.4627 16.8927C22.3743 16.6707 22.3345 16.4363 22.3037 16.2003C22.2712 15.9511 22.2258 15.1927 22.2039 15.0656C22.182 14.9401 22.1738 14.9377 22.0554 14.9377C21.9101 14.9368 21.7657 14.9368 21.6205 14.9377C21.5142 14.9385 21.5134 14.9393 21.4769 15.0449C21.3325 15.4658 20.8391 16.9042 20.7345 17.2013C20.6647 17.4002 20.517 17.5075 20.3077 17.5116C20.1673 17.5149 20.0262 17.5124 19.8858 17.5116C19.8647 17.5116 19.8428 17.5116 19.8217 17.5075C19.6667 17.4769 19.5507 17.3878 19.6172 17.1831C19.687 16.9694 21.5759 11.4659 21.6099 11.3726C21.6749 11.1936 21.8079 11.0929 21.9986 11.0912C22.3053 11.0879 22.6128 11.0904 22.9195 11.0904C22.9195 11.0912 22.9195 11.092 22.9195 11.0929C23.2092 11.0929 23.4996 11.0846 23.7893 11.0953C24.0416 11.1053 24.2866 11.1622 24.5098 11.2918C24.7256 11.418 24.8611 11.5971 24.8871 11.8579C24.9073 12.0469 24.8757 12.2259 24.8157 12.4025ZM26.2234 5.93347C26.096 5.93347 26.096 5.9343 26.0538 6.05726C25.8169 6.74303 25.58 7.42881 25.343 8.11458C25.3106 8.20866 25.2765 8.30191 25.2432 8.39517C25.1767 8.58332 25.0412 8.6807 24.8481 8.68978C24.6948 8.6972 24.5406 8.69803 24.3881 8.6906C24.1609 8.67987 24.0619 8.57589 24.1471 8.31429C24.2899 7.87444 26.0319 2.81407 26.1195 2.56567C26.1893 2.36761 26.3175 2.27189 26.5244 2.27106C27.4112 2.26941 29.236 2.27023 29.2611 2.27436C29.378 2.29087 29.4453 2.36431 29.4404 2.48397C29.438 2.55659 29.4218 2.62921 29.4039 2.69936C29.3877 2.76208 29.3601 2.82149 29.3382 2.88256C29.2595 3.10538 29.1297 3.20441 28.8968 3.20523C28.3427 3.20771 27.7885 3.20606 27.2343 3.20606C27.2003 3.20606 27.1662 3.20523 27.1321 3.20606C27.0331 3.20853 27.0299 3.21018 26.9966 3.30756C26.84 3.76557 26.6842 4.22358 26.5276 4.68076C26.4919 4.78639 26.4554 4.8912 26.4084 5.02736C26.4822 5.02736 26.5276 5.02736 26.5731 5.02736C26.965 5.02736 27.3577 5.02571 27.7496 5.02901C27.8161 5.02984 27.8842 5.04387 27.9475 5.0645C28.0246 5.09008 28.0554 5.15445 28.0587 5.23615C28.0644 5.36241 28.0084 5.47217 27.9711 5.58605C27.894 5.81877 27.7398 5.93512 27.4769 5.93347C27.0591 5.931 26.6412 5.93347 26.2234 5.93347ZM32.5066 2.86028C32.475 3.14746 31.9443 8.32997 31.9273 8.39599C31.8802 8.58332 31.7715 8.67987 31.5841 8.68978C31.4186 8.69885 31.2514 8.69885 31.0859 8.68978C30.8985 8.67987 30.8141 8.58662 30.8263 8.39599C30.8376 8.20701 30.8676 8.01886 30.892 7.8307C30.9106 7.68546 30.9342 7.54022 30.9528 7.39497C30.9577 7.35784 30.9358 7.26046 30.8352 7.26046C30.3873 7.26046 29.9402 7.26129 29.4924 7.25881C29.4169 7.25798 29.369 7.27614 29.3301 7.34959C29.1873 7.62026 29.0364 7.88682 28.8879 8.15419C28.8311 8.2557 28.7759 8.35803 28.7167 8.45871C28.625 8.61385 28.479 8.67987 28.311 8.69143C28.1707 8.70133 28.0295 8.69555 27.8891 8.69225C27.8477 8.69143 27.8039 8.68152 27.765 8.66584C27.6619 8.62541 27.6108 8.53133 27.6546 8.42735C27.709 8.29696 27.778 8.17152 27.8477 8.04856C28.1285 7.55837 30.7881 2.97334 31.0299 2.55577C31.1021 2.43198 31.1971 2.33625 31.3358 2.29664C31.3885 2.28179 31.4445 2.27354 31.4989 2.27271C31.7334 2.27023 31.9679 2.27106 32.2023 2.27189C32.2445 2.27189 32.2892 2.27271 32.3289 2.28509C32.4668 2.32718 32.5366 2.42538 32.5326 2.57722C32.5293 2.6713 32.5163 2.76538 32.5066 2.86028ZM33.7196 8.69225C33.6514 8.6939 33.3699 8.69638 33.2977 8.69143C33.2474 8.68813 33.1955 8.67905 33.1492 8.66089C33.0673 8.62871 33.0153 8.56599 33.0259 8.47026C33.0332 8.40672 34.9991 2.62261 35.0308 2.54256C35.0997 2.36761 35.2279 2.27519 35.4137 2.27189C35.5711 2.26941 35.7294 2.27106 35.8868 2.27106C35.9168 2.27106 35.9468 2.27189 35.9752 2.28014C36.1285 2.32222 36.1553 2.39485 36.1431 2.49965C36.1358 2.5632 34.2527 8.08818 34.1521 8.37783C34.0798 8.58662 33.9411 8.68813 33.7196 8.69225ZM40.8864 3.47013C40.7663 3.83571 40.398 4.89697 40.3225 5.05707C40.1261 5.47464 39.8073 5.761 39.387 5.93265C39.2831 5.97474 39.2807 5.98464 39.2913 6.09522C39.3099 6.29741 39.3237 6.49959 39.3407 6.70177C39.3627 6.9642 39.3667 7.2291 39.4414 7.4841C39.4568 7.53774 39.4787 7.58973 39.5006 7.6409C39.5509 7.75725 39.645 7.80759 39.7651 7.81007C39.8714 7.81255 39.9785 7.80842 40.0848 7.81172C40.2251 7.81502 40.2917 7.89177 40.2576 8.03123C40.217 8.19463 40.1643 8.35473 40.1083 8.514C40.0653 8.63531 39.9655 8.70711 39.8454 8.71123C39.6418 8.71783 39.4365 8.71536 39.2345 8.6939C38.8937 8.65759 38.6714 8.44881 38.531 8.14182C38.4312 7.92395 38.3817 7.69124 38.3509 7.45522C38.3192 7.21095 38.2665 6.40056 38.2438 6.24294C38.2276 6.12576 38.2113 6.11833 38.0929 6.1175C37.9436 6.11668 37.7943 6.11998 37.645 6.11668C37.5785 6.11503 37.5452 6.14226 37.5241 6.20498C37.4259 6.49546 36.9221 7.94871 36.7703 8.38526C36.7022 8.58084 36.5594 8.68648 36.3557 8.69143C36.2064 8.69473 35.8397 8.68647 35.8081 8.67575C35.6604 8.62458 35.6076 8.52473 35.6539 8.37206C35.6977 8.22682 37.5922 2.70596 37.6361 2.58383C37.7131 2.36926 37.847 2.27189 38.0701 2.27106C38.3598 2.26941 39.443 2.27271 39.6945 2.27023C39.9403 2.26776 40.1773 2.31315 40.4053 2.4031C40.6527 2.50048 40.8393 2.66305 40.9075 2.9329C40.9513 3.11115 40.944 3.29518 40.8864 3.47013Z", fill: "#C33333" }),
    /* @__PURE__ */ jsx("path", { d: "M39.5209 3.27125C39.4746 3.25062 39.4243 3.23411 39.3748 3.22999C39.2272 3.21513 38.7347 3.20936 38.6365 3.20523C38.5748 3.20276 38.5424 3.22999 38.5245 3.28693C38.4953 3.38183 38.4637 3.47591 38.4312 3.56999C38.2551 4.08411 38.0783 4.59824 37.9038 5.11236C37.8657 5.22542 37.8746 5.2378 37.9979 5.23532C38.2186 5.2312 38.4393 5.22542 38.66 5.21304C38.8393 5.20396 38.9975 5.13959 39.129 5.00756C39.2377 4.89862 39.6856 3.6228 39.6831 3.51305C39.6791 3.39586 39.6223 3.31746 39.5209 3.27125Z", fill: "#C33333" })
  ] })
] }) }));
const CsrZeroWasteIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 15 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Subtract", d: "M1.125 20.625H13.875V19.1064L15 20.2314V21.75H0V19.8564L1.125 18.7314V20.625ZM15 16.5186L13.875 15.3936V5.98145L15 4.85645V16.5186ZM1.125 6.35645V15.0186L0 16.1436V5.23145L1.125 6.35645ZM15 1.14355L13.875 2.26855V1.125H1.125V2.64355L0 1.51855V0H15V1.14355Z", fill: "var(--fill-0, #2D2E2C)" }) }));
const CustomMadeIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { id: "Outline", children: [
      /* @__PURE__ */ jsxs("g", { id: "Intersect", children: [
        /* @__PURE__ */ jsx("path", { d: "M14.6 8H16C16 3.58172 12.4183 0 8 0V1.4C11.6451 1.4 14.6 4.35492 14.6 8Z", fill: "var(--fill-0, #2D2E2C)" }),
        /* @__PURE__ */ jsx("path", { d: "M14.6 8H16C16 3.58172 12.4183 0 8 0V1.4C11.6451 1.4 14.6 4.35492 14.6 8Z", fill: `url(#${uid}paint0_linear_13120_20378)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_2", children: [
        /* @__PURE__ */ jsx("path", { d: "M14.6 8C14.6 11.6451 11.6451 14.6 8 14.6V16C12.4183 16 16 12.4183 16 8H14.6Z", fill: "var(--fill-0, #2D2E2C)" }),
        /* @__PURE__ */ jsx("path", { d: "M14.6 8C14.6 11.6451 11.6451 14.6 8 14.6V16C12.4183 16 16 12.4183 16 8H14.6Z", fill: `url(#${uid}paint1_linear_13120_20378)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_3", children: [
        /* @__PURE__ */ jsx("path", { d: "M1.4 8H0C0 12.4183 3.58172 16 8 16V14.6C4.35492 14.6 1.4 11.6451 1.4 8Z", fill: "var(--fill-0, #2D2E2C)" }),
        /* @__PURE__ */ jsx("path", { d: "M1.4 8H0C0 12.4183 3.58172 16 8 16V14.6C4.35492 14.6 1.4 11.6451 1.4 8Z", fill: `url(#${uid}paint2_linear_13120_20378)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_4", children: [
        /* @__PURE__ */ jsx("path", { d: "M8 0C3.58172 0 0 3.58172 0 8H1.4C1.4 4.35492 4.35492 1.4 8 1.4V0Z", fill: "var(--fill-0, #2D2E2C)" }),
        /* @__PURE__ */ jsx("path", { d: "M8 0C3.58172 0 0 3.58172 0 8H1.4C1.4 4.35492 4.35492 1.4 8 1.4V0Z", fill: `url(#${uid}paint3_linear_13120_20378)` })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_13120_20378`, x1: 8, y1: 1.14286, x2: 14.8571, y2: 8, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#2085CE" }),
        /* @__PURE__ */ jsx("stop", { offset: 0.0498047, stopColor: "#2387C7" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#58B64A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint1_linear_13120_20378`, x1: 14.8571, y1: 8, x2: 8, y2: 14.8571, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#58B64A" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#DC9F1C" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint2_linear_13120_20378`, x1: 8, y1: 14.8571, x2: 1.14286, y2: 8, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#DC9F1C" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E42922" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint3_linear_13120_20378`, x1: 1.14286, y1: 8, x2: 8, y2: 1.14286, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E42922" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#2085CE" })
      ] })
    ] })
  ] }));
};
const DeliveryDhlIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 42 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
  /* @__PURE__ */ jsx("rect", { width: 42, height: 9.26856, fill: "#FFCC00" }),
  /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("path", { d: "M6.5 3.07L9.84 0H14.1C14.5 0 14.5 0.12 14.3 0.32C14.1 0.53 13.75 1 13.54 1.26C13.44 1.39 13.26 1.65 13.87 1.65H19C18.6 2.19 17.28 3.66 14.92 3.66H6.5V3.07Z", fill: "#D40511" }),
    /* @__PURE__ */ jsx("path", { d: "M20.56 1.65L19 3.66H14.85L16.41 1.65H20.56Z", fill: "#D40511" }),
    /* @__PURE__ */ jsx("path", { d: "M26.32 1.65L24.76 3.66H20.61L22.17 1.65H26.32Z", fill: "#D40511" }),
    /* @__PURE__ */ jsx("path", { d: "M27.64 1.65C27.64 1.65 27.34 2.05 27.2 2.24C26.68 2.92 27.13 3.66 28.78 3.66H35.33L37 1.65H27.64Z", fill: "#D40511" })
  ] })
] }));
const DeliveryDpdIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 42 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group 19819", children: [
  /* @__PURE__ */ jsx("path", { id: "path7", fillRule: "evenodd", clipRule: "evenodd", d: "M26.3808 14.5462C25.5381 14.7814 24.4406 14.8794 23.5 14.8794C21.0503 14.8794 19.4434 13.6055 19.4434 11.2734C19.4434 9.05891 20.9523 7.62831 23.1472 7.62831C23.6371 7.62831 24.1663 7.6871 24.4798 7.84388V4.62988H26.3808V14.5462ZM24.4798 9.49005C24.1859 9.35287 23.7743 9.27448 23.304 9.27448C22.1478 9.27448 21.3835 9.97999 21.3835 11.2146C21.3835 12.5277 22.2066 13.2724 23.5587 13.2724C23.7939 13.2724 24.1663 13.2724 24.4798 13.194V9.49005ZM42.0001 14.5462C41.1574 14.7814 40.0599 14.8794 39.0996 14.8794C36.6695 14.8794 35.0429 13.6055 35.0429 11.2734C35.0429 9.05891 36.5519 7.62831 38.7469 7.62831C39.2564 7.62831 39.7659 7.6871 40.0795 7.84388V4.62988H42.0001V14.5462ZM40.0795 9.49005C39.7855 9.35287 39.3936 9.27448 38.9232 9.27448C37.7474 9.27448 36.9831 9.97999 36.9831 11.2146C36.9831 12.5277 37.8258 13.2724 39.178 13.2724C39.4132 13.2724 39.7659 13.2724 40.0795 13.194V9.49005ZM29.3792 9.49005C29.6928 9.35287 30.1435 9.31367 30.5159 9.31367C31.6917 9.31367 32.4952 9.97999 32.4952 11.1754C32.4952 12.5864 31.5937 13.2332 30.3983 13.2528V14.8794H30.4963C32.9656 14.8794 34.4354 13.5271 34.4354 11.1167C34.4354 8.92172 32.8676 7.62831 30.5551 7.62831C29.3792 7.62831 28.223 7.90268 27.4587 8.21621V17.525H29.3792V9.49005Z", fill: "var(--fill-0, #3F3F42)" }),
  /* @__PURE__ */ jsx("path", { id: "path9", fillRule: "evenodd", clipRule: "evenodd", d: "M16.3047 4.14844H16.3248H16.3047Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path11", fillRule: "evenodd", clipRule: "evenodd", d: "M15.834 3.89941L16.1475 4.25217L16.3239 4.15418L15.834 3.89941V3.89941Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path13", fillRule: "evenodd", clipRule: "evenodd", d: "M15.3643 3.64648L15.9718 4.352L16.1873 4.23441L15.9522 3.96005L15.3643 3.64648V3.64648Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path15", fillRule: "evenodd", clipRule: "evenodd", d: "M14.874 3.38965L15.7951 4.44792L16.0107 4.33033L15.4815 3.70321L14.874 3.38965V3.38965Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path17", fillRule: "evenodd", clipRule: "evenodd", d: "M14.4041 3.13577L15.6191 4.54679L15.8347 4.42921L14.992 3.44933L14.4041 3.13577ZM16.7362 5.62463L16.599 5.70302L16.7362 5.8598V5.62463V5.62463Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path19", fillRule: "evenodd", clipRule: "evenodd", d: "M13.9336 2.875L15.4426 4.63878L15.6582 4.5212L14.5215 3.18856L13.9336 2.875V2.875ZM16.6576 5.65783L16.4421 5.79501L16.736 6.14777V5.77541L16.6576 5.65783H16.6576Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path21", fillRule: "evenodd", clipRule: "evenodd", d: "M13.4434 2.62598L15.2659 4.74251L15.5011 4.62493L14.0509 2.93954L13.4434 2.62598V2.62598ZM16.481 5.76156L16.2654 5.89874L16.7357 6.44748V6.07512L16.481 5.76156Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path23", fillRule: "evenodd", clipRule: "evenodd", d: "M12.9736 2.37305L15.1098 4.84233L15.3253 4.72475L13.5616 2.6866L12.9736 2.37305V2.37305ZM16.3052 5.88098L16.0896 5.99856L16.7363 6.76287V6.39051L16.3052 5.88098Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path25", fillRule: "evenodd", clipRule: "evenodd", d: "M12.5032 2.11617L14.9333 4.93821L15.1488 4.82062L13.0911 2.42973L12.5032 2.11617V2.11617ZM16.1287 5.97685L15.9131 6.09444L16.7362 7.05472V6.68237L16.1287 5.97685Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path27", fillRule: "evenodd", clipRule: "evenodd", d: "M12.0137 1.8623L14.7573 5.0371L14.9729 4.91951L12.6212 2.17586L12.0137 1.8623V1.8623ZM15.9527 6.07574L15.7372 6.19333L16.7366 7.34958V6.97723L15.9527 6.07574V6.07574Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path29", fillRule: "evenodd", clipRule: "evenodd", d: "M11.543 1.60254L14.5806 5.14969L14.7961 5.0125L12.1309 1.9161L11.543 1.60254V1.60254ZM15.776 6.16873L15.5604 6.28632L16.7363 7.65815V7.2858L15.776 6.16873Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path31", fillRule: "evenodd", clipRule: "evenodd", d: "M11.0527 1.35352L14.4039 5.25342L14.6195 5.11623L11.6603 1.66707L11.0527 1.35352ZM15.6189 6.27246L15.3838 6.39005L16.736 7.95785V7.5855L15.6189 6.27246V6.27246Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path33", fillRule: "evenodd", clipRule: "evenodd", d: "M10.583 1.0957L14.2281 5.34833L14.4633 5.21117L11.1905 1.40926L10.583 1.0957ZM15.4432 6.3674L15.2276 6.48499L16.7366 8.26837V7.87642L15.4432 6.3674V6.3674Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path35", fillRule: "evenodd", clipRule: "evenodd", d: "M10.1124 0.842856L14.0711 5.44824L14.2866 5.31105L10.7003 1.15641L10.1124 0.842856V0.842856ZM15.2665 6.46731L15.0509 6.5849L16.7363 8.56425V8.1919L15.2665 6.46731V6.46731Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path37", fillRule: "evenodd", clipRule: "evenodd", d: "M9.62207 0.568359L13.8943 5.5461L14.1099 5.40891L10.2296 0.901515L9.62207 0.568359ZM15.0898 6.56517L14.8742 6.68275L16.7359 8.85806V8.48573L15.0898 6.56517V6.56517Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path39", fillRule: "evenodd", clipRule: "evenodd", d: "M9.15216 0.314527L13.7184 5.64501L13.9339 5.52743L9.75969 0.647683L9.15216 0.314527ZM14.9138 6.66409L14.6982 6.78167L16.7364 9.17255V8.78062L14.9138 6.66409V6.66409Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path41", fillRule: "evenodd", clipRule: "evenodd", d: "M8.68164 0.0800781L13.5418 5.74372L13.7574 5.62614L9.26954 0.393637L8.68164 0.0800781ZM14.7372 6.7628L14.5217 6.88038L16.7362 9.46724V9.09488L14.7372 6.7628V6.7628Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path43", fillRule: "evenodd", clipRule: "evenodd", d: "M8.36822 0L13.3655 5.84002L13.5811 5.72244L8.79937 0.137182L8.68178 0.0783897C8.5838 0.0195974 8.48581 0 8.36822 0ZM14.561 6.8591L14.3454 6.97668L16.7363 9.75951V9.38716L14.561 6.8591V6.8591Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path45", fillRule: "evenodd", clipRule: "evenodd", d: "M8.36821 0C8.28982 0 8.21143 0.0195974 8.13304 0.0391949L13.1892 5.93801L13.4243 5.82043L8.427 0C8.4074 0 8.38781 0 8.36821 0ZM14.4042 6.95708L14.1886 7.07467L16.7363 10.0731V9.68112L14.4042 6.95708V6.95708Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path47", fillRule: "evenodd", clipRule: "evenodd", d: "M8.1922 0.0175781C8.15301 0.0371756 8.09421 0.0567729 8.07462 0.0763705L7.95703 0.135163L13.0327 6.03398L13.2483 5.91639L8.1922 0.0175781V0.0175781ZM14.2282 7.05305L14.0126 7.19024L16.7367 10.365V9.99266L14.2282 7.05305V7.05305Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path49", fillRule: "evenodd", clipRule: "evenodd", d: "M7.99585 0.0976562L7.78027 0.215241L12.856 6.13366L13.0716 6.01607L7.99585 0.0976562V0.0976562ZM14.0514 7.15273L13.8359 7.28991L16.7363 10.6607V10.2883L14.0514 7.15273V7.15273Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path51", fillRule: "evenodd", clipRule: "evenodd", d: "M7.81909 0.195312L7.60352 0.312897L12.6792 6.23131L12.8948 6.11373L7.81909 0.195312V0.195312ZM13.8747 7.25039L13.6591 7.38757L16.7359 10.9739V10.6015L13.8747 7.25039Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path53", fillRule: "evenodd", clipRule: "evenodd", d: "M7.64331 0.292969L7.42773 0.410554L12.5035 6.32897L12.719 6.21138L7.64331 0.292969V0.292969ZM13.6989 7.34804L13.4833 7.48523L16.7365 11.2675V10.8952L13.6989 7.34804Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path55", fillRule: "evenodd", clipRule: "evenodd", d: "M7.46655 0.390625L7.25098 0.50821L12.3267 6.42663L12.5423 6.30904L7.46655 0.390625V0.390625ZM13.5221 7.4457L13.3066 7.58288L16.7361 11.5612V11.1888L13.5221 7.4457V7.4457Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path57", fillRule: "evenodd", clipRule: "evenodd", d: "M7.28979 0.480469L7.07422 0.598052L12.15 6.51647L12.3655 6.39888L7.28979 0.480469V0.480469ZM13.365 7.53554L13.1494 7.67273L16.7357 11.8666V11.4942L13.365 7.53554V7.53554Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path59", fillRule: "evenodd", clipRule: "evenodd", d: "M7.11379 0.568239L6.89821 0.705422L11.9936 6.62384L12.2091 6.50626L7.11379 0.568239V0.568239ZM13.189 7.66251L12.9734 7.7801L16.7361 12.1699V11.7976L13.189 7.66251V7.66251Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path61", fillRule: "evenodd", clipRule: "evenodd", d: "M6.93725 0.665039L6.72168 0.782625L11.817 6.72064L12.0326 6.60306L6.93725 0.665039V0.665039ZM13.0124 7.75931L12.7969 7.8769L16.736 12.4823V12.0903L13.0124 7.75931Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path63", fillRule: "evenodd", clipRule: "evenodd", d: "M6.76147 0.762695L6.5459 0.880281L11.6412 6.83789L11.8568 6.70071L6.76147 0.762695ZM12.8367 7.85697L12.6211 7.97455L16.7366 12.7759V12.4036L12.8367 7.85697Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path65", fillRule: "evenodd", clipRule: "evenodd", d: "M6.58471 0.864258L6.36914 0.981841L11.4645 6.93946L11.6801 6.80227L6.58471 0.864258ZM12.6599 7.95853L12.4443 8.07612L16.7362 13.0734V12.7011L12.6599 7.95853Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path67", fillRule: "evenodd", clipRule: "evenodd", d: "M6.40893 0.962891L6.19336 1.08048L11.2887 7.03809L11.5043 6.90091L6.40893 0.962891V0.962891ZM12.4841 8.05717L12.2686 8.17475L16.7368 13.3877V12.9957L12.4841 8.05717V8.05717Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path69", fillRule: "evenodd", clipRule: "evenodd", d: "M6.23197 1.05951L6.0164 1.17709L11.1117 7.13471L11.3273 6.99753L6.23197 1.05951ZM12.3268 8.15378L12.1112 8.27137L16.7362 13.6802V13.3079L12.3268 8.15378V8.15378Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path71", fillRule: "evenodd", clipRule: "evenodd", d: "M6.05548 1.13574L5.82031 1.25333L10.9548 7.23054L11.1704 7.09336L6.05548 1.13574V1.13574ZM12.1503 8.24961L11.9347 8.3672L16.7361 13.9721V13.5997L12.1503 8.24961V8.24961Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path73", fillRule: "evenodd", clipRule: "evenodd", d: "M5.87873 1.22949L5.64355 1.34708L10.7977 7.34389C10.8173 7.3047 10.8369 7.2851 10.8761 7.2655L10.9937 7.18711L5.87873 1.22949L5.87873 1.22949ZM11.9735 8.34337L11.758 8.46095L16.6965 14.2226C16.7161 14.1638 16.7357 14.105 16.7357 14.0462V13.8894L11.9735 8.34337H11.9735Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path75", fillRule: "evenodd", clipRule: "evenodd", d: "M5.70281 1.33128L5.46764 1.44886L10.7394 7.58286V7.50447C10.7394 7.44568 10.7785 7.36729 10.8178 7.30849L5.70281 1.33128ZM11.7976 8.44515L11.6408 8.54314C11.6212 8.54314 11.6017 8.56274 11.5821 8.56274L16.599 14.4224C16.6578 14.344 16.697 14.2656 16.7166 14.1872L11.7976 8.44515V8.44515Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path77", fillRule: "evenodd", clipRule: "evenodd", d: "M5.52616 1.43164L5.29102 1.54923L10.7391 7.8988V7.50684L5.52616 1.43164V1.43164ZM11.2486 8.46713L16.4615 14.5619C16.5203 14.5227 16.5791 14.4443 16.6379 14.3855L11.621 8.54552C11.5426 8.58471 11.425 8.58471 11.3466 8.54552L11.2486 8.46713Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path79", fillRule: "evenodd", clipRule: "evenodd", d: "M5.35038 1.53027L5.11523 1.64786L16.2857 14.6606L16.4425 14.5822C16.4621 14.5626 16.4817 14.543 16.5013 14.5234L11.3668 8.54616H11.3472L10.8965 8.27179C10.8573 8.2522 10.8377 8.213 10.7985 8.17381C10.7593 8.11501 10.7593 8.07582 10.7397 8.03662V7.82105L5.35038 1.53027V1.53027Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path81", fillRule: "evenodd", clipRule: "evenodd", d: "M5.17353 1.62775L4.93836 1.74533L16.1089 14.758L16.3244 14.6404L5.17353 1.62775Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path83", fillRule: "evenodd", clipRule: "evenodd", d: "M4.99689 1.7041L4.76172 1.82169L15.9518 14.854L16.1674 14.7364L4.99689 1.7041Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path85", fillRule: "evenodd", clipRule: "evenodd", d: "M4.82099 1.80544L4.58582 1.92303L15.776 14.9553L15.9915 14.8377L4.82099 1.80544Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path87", fillRule: "evenodd", clipRule: "evenodd", d: "M4.64435 1.90234L4.40918 2.01993L15.5993 15.0522L15.8149 14.9346L4.64435 1.90234Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path89", fillRule: "evenodd", clipRule: "evenodd", d: "M4.448 2L4.23242 2.11759L15.4226 15.1695L15.6381 15.0323L4.448 2Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path91", fillRule: "evenodd", clipRule: "evenodd", d: "M4.27221 2.09766L4.05664 2.21524L15.2468 15.2671L15.4623 15.1299L4.27221 2.09766Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path93", fillRule: "evenodd", clipRule: "evenodd", d: "M4.09643 2.19629L3.88086 2.31387L15.0906 15.3658L15.3062 15.2286L4.09643 2.19629Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path95", fillRule: "evenodd", clipRule: "evenodd", d: "M3.91967 2.27441L3.7041 2.392L14.9138 15.4635L15.1294 15.3263L3.91967 2.27441Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path97", fillRule: "evenodd", clipRule: "evenodd", d: "M3.74292 2.37305L3.52734 2.49063L14.7371 15.5621L14.9526 15.4445L3.74292 2.37305Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path99", fillRule: "evenodd", clipRule: "evenodd", d: "M3.56616 2.4707L3.35059 2.58829L8.79868 8.93784L8.97504 9.05543C9.05343 9.09462 9.13182 9.19261 9.13182 9.2906V9.3102L14.5603 15.6598L14.7759 15.5422L3.56616 2.4707Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path101", fillRule: "evenodd", clipRule: "evenodd", d: "M3.3903 2.56848L3.17473 2.68606L8.28967 8.66329L8.93636 9.01602L3.3903 2.56848ZM9.11274 9.23159C9.11274 9.25119 9.13234 9.27079 9.13234 9.29038V9.62354L14.3845 15.7576L14.6 15.64L9.11274 9.23159V9.23159Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path103", fillRule: "evenodd", clipRule: "evenodd", d: "M3.21362 2.66504L2.99805 2.78262L7.77983 8.3679L8.42655 8.72066L3.21362 2.66504V2.66504ZM9.13203 9.54373V9.91609L14.2274 15.8541L14.4429 15.7365L9.13203 9.54373V9.54373Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path105", fillRule: "evenodd", clipRule: "evenodd", d: "M3.03784 2.76367L2.82227 2.88126L7.29049 8.07459L7.91761 8.42734L3.03784 2.76367V2.76367ZM9.13263 9.83834V10.2303L14.0516 15.9527L14.2672 15.8352L9.13263 9.83834V9.83834Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path107", fillRule: "evenodd", clipRule: "evenodd", d: "M2.86108 2.84277L2.64551 2.96036L6.78057 7.78134L7.40769 8.15369L2.86108 2.84277ZM9.13225 10.1526V10.525L13.8748 16.0514L14.0904 15.9338L9.13225 10.1526V10.1526Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path109", fillRule: "evenodd", clipRule: "evenodd", d: "M2.68432 2.94141L2.46875 3.05899L6.27064 7.48802L6.89777 7.86037L2.68432 2.94141V2.94141ZM9.13186 10.4472V10.8196L13.6981 16.1501L13.9136 16.0325L9.13186 10.4472V10.4472Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path111", fillRule: "evenodd", clipRule: "evenodd", d: "M2.50848 3.03884L2.29291 3.15643L5.76164 7.2131L6.38877 7.56586L2.50848 3.03884ZM9.1324 10.7406V11.1326L13.5222 16.2671L13.7378 16.1299L9.1324 10.7406V10.7406Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path113", fillRule: "evenodd", clipRule: "evenodd", d: "M2.33178 3.13574L2.11621 3.25333L5.25181 6.91805L5.87891 7.2708L2.33178 3.13574V3.13574ZM9.13208 11.0531V11.4255L13.3651 16.364L13.5807 16.2268L9.13208 11.0531V11.0531Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path115", fillRule: "evenodd", clipRule: "evenodd", d: "M2.15502 3.2334L1.93945 3.35098L4.74189 6.62375L5.38859 6.97651L2.15502 3.2334V3.2334ZM9.1317 11.3467V11.7191L13.1884 16.4617L13.4039 16.3245L9.1317 11.3467Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path117", fillRule: "evenodd", clipRule: "evenodd", d: "M1.97924 3.32422L1.76367 3.4418L4.23295 6.32262L4.87967 6.69497L1.97924 3.32422V3.32422ZM7.11377 9.67378L7.62331 10.2617V10.0461C7.62331 10.0069 7.58411 9.94814 7.54491 9.92855L7.11377 9.67378V9.67378ZM9.13229 11.6335V12.0255L13.0126 16.5525L13.2282 16.4153L9.13229 11.6335V11.6335Z", fill: "var(--fill-0, #DB0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path119", fillRule: "evenodd", clipRule: "evenodd", d: "M1.80248 3.41113L1.58691 3.52872L3.72303 6.03718L4.36975 6.40953L1.80248 3.41113V3.41113ZM6.60385 9.38834L7.62292 10.5642V10.1918L7.25057 9.76069L6.60385 9.38834V9.38834ZM9.13191 11.9556V12.328L12.8358 16.659L13.0514 16.5414L9.13191 11.9556V11.9556Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path121", fillRule: "evenodd", clipRule: "evenodd", d: "M1.6267 3.50781L1.41113 3.6254L3.23369 5.76151L3.86081 6.11426L1.6267 3.50781V3.50781ZM6.09491 9.11267L7.62352 10.8764V10.5041L6.74163 9.46542L6.09491 9.11267ZM9.13251 12.2483V12.6206L12.66 16.7557L12.8756 16.6381L9.13251 12.2483Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path123", fillRule: "evenodd", clipRule: "evenodd", d: "M1.44995 3.60645L1.23438 3.72403L2.72377 5.46819L3.35089 5.82094L1.44995 3.60645V3.60645ZM5.60459 8.81937L7.62314 11.1711V10.7987L6.23171 9.1721L5.60459 8.81937ZM9.13212 12.5625V12.9348L12.5029 16.8543L12.7185 16.7367L9.13212 12.5625V12.5625Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path125", fillRule: "evenodd", clipRule: "evenodd", d: "M1.27319 3.69629L1.05762 3.81387L2.21387 5.16611L2.84098 5.51884L1.27319 3.69629V3.69629ZM5.0947 8.51727L7.62276 11.4569V11.0845L5.72179 8.88959L5.0947 8.51727ZM9.13175 12.8483V13.2206L12.3261 16.9441L12.5417 16.8266L9.13175 12.8483V12.8483Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path127", fillRule: "evenodd", clipRule: "evenodd", d: "M1.09739 3.80188L0.881816 3.91947L1.70491 4.87975L2.33202 5.2521L1.09739 3.80188ZM4.58574 8.23091L7.62333 11.778V11.4057L5.21286 8.60326L4.58574 8.23091ZM9.13232 13.1498V13.5222L12.1503 17.0497L12.3659 16.9321L9.13232 13.1498V13.1498Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path129", fillRule: "evenodd", clipRule: "evenodd", d: "M0.920649 3.89941L0.705078 4.017L1.19501 4.58533L1.84173 4.95768L0.920649 3.89941V3.89941ZM4.07584 7.95608L7.62297 12.0715V11.6992L4.70296 8.30884L4.07584 7.95608ZM9.13196 13.4629V13.8353L11.9736 17.1473L12.1892 17.0297L9.13196 13.4629V13.4629Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path131", fillRule: "evenodd", clipRule: "evenodd", d: "M0.744968 3.97862L0.5098 4.09621L0.686175 4.31178L1.33289 4.66454L0.744968 3.97862ZM3.567 7.66294L7.62367 12.3859V11.994L4.21372 8.0157L3.567 7.66294ZM9.13265 13.7577V14.1301L11.7979 17.2657L12.0135 17.1285L9.13265 13.7577Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path133", fillRule: "evenodd", clipRule: "evenodd", d: "M0.568821 4.06934L0.431641 4.14773L0.823589 4.3633L0.568821 4.06934V4.06934ZM3.05769 7.3617L7.6239 12.6726V12.3003L3.70441 7.73406L3.05769 7.3617V7.3617ZM9.13289 14.0444V14.4364L11.6414 17.3564L11.8569 17.2192L9.13289 14.0444V14.0444Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path135", fillRule: "evenodd", clipRule: "evenodd", d: "M2.56641 7.07129L7.62255 12.9701V12.5978L3.19352 7.44364L2.56641 7.07129ZM9.13153 14.3615V14.7339L11.4636 17.4579L11.6792 17.3207L9.13153 14.3615V14.3615Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path137", fillRule: "evenodd", clipRule: "evenodd", d: "M2.05773 6.79986L7.6234 13.2866V12.8947L2.68484 7.15262L2.05773 6.79986V6.79986ZM9.13239 14.6584V15.0308L11.2881 17.5589L11.5037 17.4217L9.13239 14.6584V14.6584Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path139", fillRule: "evenodd", clipRule: "evenodd", d: "M1.54883 6.50684L7.62403 13.5815V13.2092L2.17595 6.85959L1.54883 6.50684V6.50684ZM9.13302 14.9533V15.3453L11.1124 17.6578L11.3279 17.5402L9.13302 14.9533Z", fill: "var(--fill-0, #DC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path141", fillRule: "evenodd", clipRule: "evenodd", d: "M1.03906 6.21484L7.6238 13.8774V13.5051L1.66618 6.5872L1.03906 6.21484ZM9.13279 15.2689V15.6412L10.9358 17.7577L11.1513 17.6401L9.13279 15.2689V15.2689Z", fill: "var(--fill-0, #DB0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path143", fillRule: "evenodd", clipRule: "evenodd", d: "M0.529279 5.91805L7.62355 14.1882V13.8158L1.1564 6.2904L0.529279 5.91805ZM9.13254 15.56V15.9323L10.7787 17.8529L10.9943 17.7353L9.13254 15.56V15.56Z", fill: "var(--fill-0, #DA0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path145", fillRule: "evenodd", clipRule: "evenodd", d: "M0.0194798 5.63963L7.62328 14.4781V14.1057L0.666195 5.99239L0.0194798 5.63963V5.63963ZM9.13227 15.8499V16.2418L10.6021 17.9468L10.8177 17.8292L9.13227 15.8499Z", fill: "var(--fill-0, #D90032)" }),
  /* @__PURE__ */ jsx("path", { id: "path147", fillRule: "evenodd", clipRule: "evenodd", d: "M0 5.62402V5.89839L7.6234 14.776V14.4037L0.15678 5.70241L0 5.62402ZM9.13239 16.1674V16.4026C9.13239 16.4418 9.11279 16.481 9.0932 16.5006L10.4258 18.0488L10.6414 17.9312L9.13239 16.1674V16.1674Z", fill: "var(--fill-0, #D80032)" }),
  /* @__PURE__ */ jsx("path", { id: "path149", fillRule: "evenodd", clipRule: "evenodd", d: "M0 5.82017V6.21212L7.6234 15.0898V14.7174L0 5.82017ZM9.11279 16.4616C9.09319 16.54 9.0344 16.6184 8.97561 16.638L8.95601 16.6576L10.2494 18.147L10.465 18.0294L9.11279 16.4616L9.11279 16.4616Z", fill: "var(--fill-0, #D70032)" }),
  /* @__PURE__ */ jsx("path", { id: "path151", fillRule: "evenodd", clipRule: "evenodd", d: "M0 6.1347V6.50705L7.6234 15.3847V15.0123L0 6.1347ZM8.99521 16.6193C8.99521 16.6389 8.99521 16.6389 8.97561 16.6389L8.77966 16.7565L10.0731 18.2459L10.2886 18.1283L8.99521 16.6193L8.99521 16.6193Z", fill: "var(--fill-0, #D60032)" }),
  /* @__PURE__ */ jsx("path", { id: "path153", fillRule: "evenodd", clipRule: "evenodd", d: "M0 6.42773V6.80009L7.6234 15.6777V15.3054L0 6.42773ZM8.83842 16.7164L8.60328 16.8536L9.91629 18.3626L10.1319 18.2254L8.83842 16.7164Z", fill: "var(--fill-0, #D50032)" }),
  /* @__PURE__ */ jsx("path", { id: "path155", fillRule: "evenodd", clipRule: "evenodd", d: "M0 6.74316V7.11552L7.6234 15.9931V15.6208L0 6.74316ZM8.66207 16.8162L8.52489 16.8946C8.4857 16.9142 8.4465 16.9142 8.40731 16.9142L9.73991 18.4624L9.95549 18.3253L8.66207 16.8162V16.8162Z", fill: "var(--fill-0, #D40032)" }),
  /* @__PURE__ */ jsx("path", { id: "path157", fillRule: "evenodd", clipRule: "evenodd", d: "M0 7.03516V7.40751L7.6234 16.2851V15.9128L0 7.03516ZM8.05455 16.8143L9.56354 18.5584L9.77911 18.4213L8.4661 16.9123C8.4465 16.9123 8.4073 16.9319 8.38771 16.9319H8.36811C8.30932 16.9319 8.27012 16.9123 8.23093 16.8927L8.05455 16.8143L8.05455 16.8143Z", fill: "var(--fill-0, #D30032)" }),
  /* @__PURE__ */ jsx("path", { id: "path159", fillRule: "evenodd", clipRule: "evenodd", d: "M0 7.33199V7.72394L9.38716 18.6593L9.60273 18.5221L8.19173 16.8759L7.76059 16.6408C7.68219 16.6016 7.6234 16.5036 7.6234 16.4056V16.2096L0 7.33199Z", fill: "var(--fill-0, #D20032)" }),
  /* @__PURE__ */ jsx("path", { id: "path161", fillRule: "evenodd", clipRule: "evenodd", d: "M0 7.64272V8.01507L9.21078 18.7545L9.42635 18.6369L0 7.64272Z", fill: "var(--fill-0, #D10032)" }),
  /* @__PURE__ */ jsx("path", { id: "path163", fillRule: "evenodd", clipRule: "evenodd", d: "M0 7.94043V8.31278L9.0344 18.8562L9.24998 18.7386L0 7.94043Z", fill: "var(--fill-0, #D00032)" }),
  /* @__PURE__ */ jsx("path", { id: "path165", fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.23242V8.62437L8.87762 18.9522L9.09319 18.8346L0 8.23242Z", fill: "var(--fill-0, #CF0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path167", fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.54688V8.9192L8.70127 19.0511L8.91682 18.9335L0 8.54688Z", fill: "var(--fill-0, #CE0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path169", fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.84001V9.21237L8.50529 19.1287C8.56409 19.1091 8.62288 19.0895 8.68167 19.0699L8.74046 19.0307L0 8.84001Z", fill: "var(--fill-0, #CD0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path171", fillRule: "evenodd", clipRule: "evenodd", d: "M0 9.13363V9.52559L8.25052 19.1283C8.28972 19.1283 8.32891 19.1283 8.36811 19.1283C8.4269 19.1283 8.4857 19.1283 8.54449 19.1087L0 9.13363Z", fill: "var(--fill-0, #CC0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path173", fillRule: "evenodd", clipRule: "evenodd", d: "M0 9.44816V9.82051L7.79978 18.9137L8.07415 19.0705C8.13294 19.1097 8.23093 19.1293 8.30932 19.1293L0 9.44816Z", fill: "var(--fill-0, #CB0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path175", fillRule: "evenodd", clipRule: "evenodd", d: "M0 9.74121V10.1136L7.29024 18.6189L7.93696 18.9912L0 9.74121Z", fill: "var(--fill-0, #CA0032)" }),
  /* @__PURE__ */ jsx("path", { id: "path177", fillRule: "evenodd", clipRule: "evenodd", d: "M0 10.0525V10.4249L6.78071 18.3226L7.42743 18.695L0 10.0525Z", fill: "var(--fill-0, #C90032)" }),
  /* @__PURE__ */ jsx("path", { id: "path179", fillRule: "evenodd", clipRule: "evenodd", d: "M0 10.3447V10.7171L6.27117 18.0269L6.89829 18.3993L0 10.3447Z", fill: "var(--fill-0, #C80033)" }),
  /* @__PURE__ */ jsx("path", { id: "path181", fillRule: "evenodd", clipRule: "evenodd", d: "M0 10.6417V11.014L5.76163 17.7359L6.38876 18.1083L0 10.6417Z", fill: "var(--fill-0, #C70033)" }),
  /* @__PURE__ */ jsx("path", { id: "path183", fillRule: "evenodd", clipRule: "evenodd", d: "M0 10.9492V11.3216L5.23252 17.4164L5.87922 17.7887L0 10.9492Z", fill: "var(--fill-0, #C60033)" }),
  /* @__PURE__ */ jsx("path", { id: "path185", fillRule: "evenodd", clipRule: "evenodd", d: "M0 11.246V11.6184L4.72299 17.1252L5.36968 17.4976L0 11.246Z", fill: "var(--fill-0, #C50033)" }),
  /* @__PURE__ */ jsx("path", { id: "path187", fillRule: "evenodd", clipRule: "evenodd", d: "M0 11.542V11.9143L4.21345 16.8333L4.86017 17.2056L0 11.542V11.542Z", fill: "var(--fill-0, #C40033)" }),
  /* @__PURE__ */ jsx("path", { id: "path189", fillRule: "evenodd", clipRule: "evenodd", d: "M0 11.8494V12.2218L3.70391 16.5332L4.35063 16.9055L0 11.8494Z", fill: "var(--fill-0, #C30033)" }),
  /* @__PURE__ */ jsx("path", { id: "path191", fillRule: "evenodd", clipRule: "evenodd", d: "M0 12.1465V12.5188L3.19438 16.2423L3.8411 16.6147L0 12.1465Z", fill: "var(--fill-0, #C20033)" }),
  /* @__PURE__ */ jsx("path", { id: "path193", fillRule: "evenodd", clipRule: "evenodd", d: "M0 12.4433V12.8352L2.68484 15.9512L3.31196 16.3236L0 12.4433Z", fill: "var(--fill-0, #C10033)" }),
  /* @__PURE__ */ jsx("path", { id: "path195", fillRule: "evenodd", clipRule: "evenodd", d: "M0 12.7578V13.1302L2.15572 15.6583L2.80243 16.0306L0 12.7578Z", fill: "var(--fill-0, #C00033)" }),
  /* @__PURE__ */ jsx("path", { id: "path197", fillRule: "evenodd", clipRule: "evenodd", d: "M0 13.0467V13.419L1.64618 15.3592L2.2929 15.712L0 13.0467Z", fill: "var(--fill-0, #BF0033)" }),
  /* @__PURE__ */ jsx("path", { id: "path199", fillRule: "evenodd", clipRule: "evenodd", d: "M0 13.3398V13.7318L1.13665 15.0448L1.78337 15.4172L0 13.3398Z", fill: "var(--fill-0, #BE0033)" }),
  /* @__PURE__ */ jsx("path", { id: "path201", fillRule: "evenodd", clipRule: "evenodd", d: "M0 13.6582V14.0306L0.627117 14.7557L1.27383 15.128L0 13.6582Z", fill: "var(--fill-0, #BD0033)" }),
  /* @__PURE__ */ jsx("path", { id: "path203", fillRule: "evenodd", clipRule: "evenodd", d: "M0 13.9473V14.0453C0 14.2412 0.137182 14.4764 0.293961 14.5744L0.7643 14.8292L0 13.9473V13.9473Z", fill: "var(--fill-0, #BC0033)" }),
  /* @__PURE__ */ jsx("path", { id: "path205", fillRule: "evenodd", clipRule: "evenodd", d: "M0.117188 14.3994C0.156382 14.4386 0.17598 14.4778 0.215175 14.4974L0.117188 14.3994Z", fill: "var(--fill-0, #BB0033)" })
] }) }));
const DeliveryFedexIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 42 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group 19818", children: [
  /* @__PURE__ */ jsx("g", { id: "Group", children: /* @__PURE__ */ jsx("path", { id: "Vector", d: "M38.2845 12.415L36.5642 10.4857L34.8589 12.415H31.2708L34.7777 8.47512L31.2708 4.53405H34.971L36.7087 6.44857L38.3809 4.53405H41.9516L38.4621 8.45857L42 12.415H38.2845ZM24.3808 12.415V0H31.2708V2.76728H27.2993V4.53405H31.2708V7.19684H27.2993V9.64078H31.2708V12.415H24.3808Z", fill: "var(--fill-0, #FF5A00)" }) }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M21.4716 0V5.08364H21.4393C20.7959 4.34368 19.9917 4.08579 19.0591 4.08579C17.1482 4.08579 15.7087 5.38654 15.2034 7.1049C14.627 5.21113 13.1407 4.05036 10.9372 4.05036C9.14733 4.05036 7.73446 4.85393 6.9964 6.16368V4.53622H3.29736V2.76907H7.33452V0.00058161H0V12.4217H3.29736V7.20074H6.58397C6.48274 7.60222 6.43213 8.01482 6.43334 8.42889C6.43334 11.0188 8.41129 12.8388 10.9366 12.8388C13.0594 12.8388 14.4595 11.8406 15.1993 10.0235H12.3733C11.9913 10.5704 11.7011 10.7318 10.9369 10.7318C10.0511 10.7318 9.28664 9.95819 9.28664 9.04223H15.0408C15.2904 11.0998 16.8925 12.8739 19.0913 12.8739C20.0398 12.8739 20.9082 12.4072 21.4391 11.6188H21.471V12.4235H24.3783V0.00058161H21.4716V0V0ZM9.37835 7.23791C9.56207 6.44857 10.1736 5.9328 10.9369 5.9328C11.7774 5.9328 12.3579 6.4326 12.5103 7.23791H9.37835ZM19.7072 10.5315C18.636 10.5315 17.9702 9.53274 17.9702 8.48958C17.9702 7.3744 18.5495 6.30308 19.7072 6.30308C20.9085 6.30308 21.3871 7.37498 21.3871 8.48958C21.3871 9.5461 20.8804 10.5315 19.7072 10.5315Z", fill: "var(--fill-0, #29007C)" })
] }) }));
const DeliverySfExpressIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M5.63507 4.4064C7.50707 3.3216 9.68147 2.6976 11.9999 2.6976C14.3183 2.6976 16.4975 3.3216 18.3695 4.4064L20.6111 2.6352C18.1535 0.9744 15.1919 0 11.9999 0C8.80787 0 5.84627 0.9696 3.38867 2.6304L5.63507 4.4064Z", fill: "var(--fill-0, #231815)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M5.63515 19.5986C7.50715 20.6834 9.68155 21.3074 12.0048 21.3074C14.3232 21.3074 16.5024 20.6834 18.3744 19.5986L20.616 21.3698C18.1584 23.0306 15.1968 24.0002 12.0048 24.0002C8.81275 24.0002 5.85115 23.0306 3.39355 21.3698L5.63515 19.5986Z", fill: "var(--fill-0, #231815)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M19.5984 5.64484C20.6832 7.51684 21.3072 9.69124 21.3072 12.0144C21.3072 14.3376 20.6832 16.512 19.5984 18.384L21.3696 20.6256C23.0304 18.1632 24 15.2016 24 12.0096C24 8.81764 23.0304 5.85604 21.3696 3.39844L19.5984 5.64484Z", fill: "var(--fill-0, #231815)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M4.4064 5.64484C3.3216 7.51684 2.6976 9.69124 2.6976 12.0144C2.6976 14.3376 3.3216 16.512 4.4064 18.384L2.6352 20.6256C0.9744 18.1632 0 15.2016 0 12.0096C0 8.81764 0.9696 5.85604 2.6304 3.39844L4.4064 5.64484Z", fill: "var(--fill-0, #231815)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_5", d: "M11.0398 7.46861V9.50381C11.0398 9.50381 10.1518 8.56781 8.51496 8.56781C6.87336 8.56781 6.93576 9.50381 6.93576 9.59501C6.93576 9.86381 6.81096 10.219 8.64456 11.0926C10.5214 11.9902 11.4766 13.1614 11.4766 14.6014C11.4766 16.0414 10.5886 17.7502 8.17896 17.7502C6.02376 17.7502 4.91496 16.6942 4.91496 16.6942V14.3422C4.91496 14.3422 5.96136 15.883 7.97736 15.883C9.50856 15.883 9.43656 14.6686 9.43656 14.5102C9.43656 14.3518 9.33576 13.6318 8.51496 13.2334C7.69416 12.8302 5.99976 12.0718 5.49096 11.3662C4.98696 10.6558 4.91016 10.1566 4.91016 9.60941C4.91016 8.58221 5.71176 6.72461 8.42376 6.72461C10.2574 6.72941 11.0398 7.46861 11.0398 7.46861Z", fill: "var(--fill-0, #231815)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_6", d: "M16.2383 6.69531C14.5103 6.69531 12.6143 7.43931 12.6143 7.43931V8.18331V8.45211V17.7929H14.6735V8.90331C14.9951 8.74491 15.5183 8.61051 16.3679 8.61051C18.2207 8.61051 19.1951 9.46491 19.1951 9.46491V7.43931C19.1951 7.44411 18.1343 6.69531 16.2383 6.69531Z", fill: "var(--fill-0, #231815)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_7", d: "M18.274 12.2307C18.274 12.9411 17.698 13.5171 16.9876 13.5171C16.2772 13.5171 15.7012 12.9411 15.7012 12.2307C15.7012 11.5203 16.2772 10.9443 16.9876 10.9443C17.698 10.9443 18.274 11.5155 18.274 12.2307Z", fill: "var(--fill-0, #E60012)" })
] }) }));
const DeliveryTntIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 42 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Vector", d: "M23.9081 4.1493C23.936 4.14902 23.9636 4.15425 23.9894 4.1647C24.0152 4.17515 24.0387 4.19061 24.0584 4.21017C24.0781 4.22972 24.0937 4.25299 24.1042 4.27859C24.1147 4.3042 24.12 4.33163 24.1197 4.35929V10.7344C24.1202 10.7599 24.1154 10.7852 24.1058 10.8089C24.0961 10.8325 24.0818 10.854 24.0636 10.872C24.0455 10.89 24.0238 10.9042 24 10.9138C23.9762 10.9233 23.9507 10.928 23.925 10.9276H22.5958C22.51 10.9159 22.4301 10.8777 22.3673 10.8184C22.3673 10.8184 19.9798 7.56786 19.9036 7.48387C19.8388 7.38936 19.7848 7.28793 19.7428 7.18149V10.7344C19.743 10.7606 19.7378 10.7865 19.7275 10.8105C19.7172 10.8346 19.7021 10.8563 19.6831 10.8744C19.6641 10.8925 19.6416 10.9065 19.6169 10.9157C19.5922 10.9248 19.5659 10.9289 19.5396 10.9276H18.0496C18.0233 10.9289 17.997 10.9248 17.9723 10.9157C17.9476 10.9065 17.9251 10.8925 17.9061 10.8744C17.8871 10.8563 17.872 10.8346 17.8617 10.8105C17.8514 10.7865 17.8462 10.7606 17.8464 10.7344V4.35929C17.8462 4.33316 17.8514 4.30726 17.8617 4.28319C17.872 4.25912 17.8871 4.23738 17.9061 4.2193C17.9251 4.20122 17.9476 4.18717 17.9723 4.17803C17.997 4.16888 18.0233 4.16482 18.0496 4.1661H19.3788C19.4626 4.17621 19.5404 4.21479 19.5989 4.2753C19.5989 4.2753 21.9609 7.46707 22.0625 7.60986C22.1286 7.70499 22.1853 7.80625 22.2318 7.91224V4.35929C22.2314 4.3338 22.2361 4.30849 22.2458 4.28487C22.2554 4.26124 22.2697 4.23977 22.2879 4.22175C22.3061 4.20373 22.3277 4.18951 22.3515 4.17995C22.3753 4.17039 22.4008 4.16568 22.4265 4.1661C22.4265 4.1493 23.815 4.1493 23.9081 4.1493ZM34.406 13.3802C31.1719 13.3802 28.539 10.7596 28.539 7.54266C28.539 4.31729 31.1719 1.69668 34.406 1.69668C37.6315 1.69668 40.2645 4.31729 40.2645 7.54266C40.2645 10.7596 37.6315 13.3802 34.406 13.3802ZM20.9873 13.3802C17.7533 13.3802 15.1203 10.7596 15.1203 7.54266C15.1203 4.31729 17.7533 1.69668 20.9873 1.69668C24.2129 1.69668 26.8458 4.31729 26.8458 7.54266C26.8458 10.7596 24.2129 13.3802 20.9873 13.3802ZM7.56864 13.3802C4.33461 13.3802 1.70167 10.7596 1.70167 7.54266C1.70167 4.31729 4.33461 1.69668 7.56864 1.69668C10.7942 1.69668 13.4271 4.31729 13.4271 7.54266C13.4187 10.7596 10.7857 13.3802 7.56864 13.3802V13.3802ZM34.406 6.31889e-07C31.4937 6.31889e-07 28.9623 1.65468 27.6839 4.06531C27.0496 2.84098 26.0874 1.8138 24.903 1.09661C23.7186 0.379432 22.3579 0 20.9704 0C19.5828 0 18.2221 0.379432 17.0377 1.09661C15.8534 1.8138 14.8912 2.84098 14.2568 4.06531C13.6198 2.84127 12.6559 1.8146 11.4703 1.0976C10.2847 0.380599 8.92324 0.000887514 7.53477 6.31889e-07C3.39488 6.31889e-07 0 3.38496 0 7.54266C0 11.692 3.39488 15.0769 7.56864 15.0769C10.4725 15.0769 13.0123 13.4222 14.2822 11.0116C14.9182 12.2346 15.8808 13.2607 17.0648 13.9776C18.2488 14.6946 19.6087 15.0749 20.9958 15.0769C23.9081 15.0769 26.4394 13.4222 27.7178 11.0116C28.3529 12.2353 29.3153 13.262 30.4995 13.979C31.6837 14.6961 33.044 15.0759 34.4314 15.0769C38.6051 15.0769 42 11.692 42 7.54266C41.9746 3.38496 38.5713 6.31889e-07 34.406 6.31889e-07ZM4.72405 4.2753C4.69836 4.27487 4.67285 4.27958 4.64903 4.28914C4.62522 4.2987 4.60358 4.31292 4.58542 4.33094C4.56725 4.34896 4.55292 4.37043 4.54329 4.39406C4.53365 4.41769 4.5289 4.443 4.52933 4.46848V5.73679C4.5289 5.76228 4.53365 5.78759 4.54329 5.81121C4.55292 5.83484 4.56725 5.85631 4.58542 5.87433C4.60358 5.89235 4.62522 5.90657 4.64903 5.91613C4.67285 5.92569 4.69836 5.9304 4.72405 5.92998H6.26487C6.36414 5.92913 6.4632 5.9207 6.56118 5.90478V10.9024C6.56075 10.9279 6.5655 10.9532 6.57514 10.9768C6.58477 11.0005 6.5991 11.0219 6.61727 11.04C6.63543 11.058 6.65707 11.0722 6.68088 11.0818C6.7047 11.0913 6.73021 11.096 6.7559 11.0956H8.33904C8.36473 11.096 8.39024 11.0913 8.41406 11.0818C8.43787 11.0722 8.45951 11.058 8.47768 11.04C8.49584 11.0219 8.51017 11.0005 8.5198 10.9768C8.52944 10.9532 8.53419 10.9279 8.53376 10.9024V5.90478C8.65736 5.92003 8.78173 5.92844 8.90627 5.92998H10.3794C10.405 5.9304 10.4306 5.92569 10.4544 5.91613C10.4782 5.90657 10.4998 5.89235 10.518 5.87433C10.5362 5.85631 10.5505 5.83484 10.5601 5.81121C10.5698 5.78759 10.5745 5.76228 10.5741 5.73679V4.46848C10.5745 4.443 10.5698 4.41769 10.5601 4.39406C10.5505 4.37043 10.5362 4.34896 10.518 4.33094C10.4998 4.31292 10.4782 4.2987 10.4544 4.28914C10.4306 4.27958 10.405 4.27487 10.3794 4.2753H4.72405ZM37.2421 4.2753C37.2678 4.27487 37.2933 4.27958 37.3171 4.28914C37.3409 4.2987 37.3626 4.31292 37.3807 4.33094C37.3989 4.34896 37.4132 4.37043 37.4228 4.39406C37.4325 4.41769 37.4372 4.443 37.4368 4.46848V5.73679C37.4372 5.76228 37.4325 5.78759 37.4228 5.81121C37.4132 5.83484 37.3989 5.85631 37.3807 5.87433C37.3626 5.89235 37.3409 5.90657 37.3171 5.91613C37.2933 5.92569 37.2678 5.9304 37.2421 5.92998H35.7775C35.6501 5.92866 35.5229 5.92025 35.3965 5.90478V10.9024C35.3969 10.9279 35.3922 10.9532 35.3825 10.9768C35.3729 11.0005 35.3586 11.0219 35.3404 11.04C35.3222 11.058 35.3006 11.0722 35.2768 11.0818C35.253 11.0913 35.2275 11.096 35.2018 11.0956H33.6186C33.5929 11.096 33.5674 11.0913 33.5436 11.0818C33.5198 11.0722 33.4982 11.058 33.48 11.04C33.4618 11.0219 33.4475 11.0005 33.4379 10.9768C33.4282 10.9532 33.4235 10.9279 33.4239 10.9024V5.90478C33.3259 5.9207 33.2269 5.92913 33.1276 5.92998H31.5868C31.5611 5.9304 31.5356 5.92569 31.5118 5.91613C31.4879 5.90657 31.4663 5.89235 31.4481 5.87433C31.43 5.85631 31.4157 5.83484 31.406 5.81121C31.3964 5.78759 31.3916 5.76228 31.3921 5.73679V4.46848C31.3916 4.443 31.3964 4.41769 31.406 4.39406C31.4157 4.37043 31.43 4.34896 31.4481 4.33094C31.4663 4.31292 31.4879 4.2987 31.5118 4.28914C31.5356 4.27958 31.5611 4.27487 31.5868 4.2753H37.2421Z", fill: "var(--fill-0, #FF6600)" }) }));
const DeliveryUpsIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 22 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group 845081163", children: [
  /* @__PURE__ */ jsxs("g", { id: "Group", children: [
    /* @__PURE__ */ jsx("path", { id: "Vector", d: "M10.9087 25.7782C11.1494 25.6723 16.9071 23.1882 18.7172 21.7055C20.614 20.1553 21.6153 17.9312 21.6153 15.2641V2.7474L21.4613 2.66075C16.8494 0.176657 11.1398 0.340337 10.8991 0.349965C10.6776 0.340337 4.96808 0.176657 0.356136 2.66075L0.202084 2.7474V15.2641C0.202084 17.9215 1.20342 20.1457 3.09056 21.7055C4.91031 23.1786 10.668 25.6723 10.9087 25.7782Z", fill: "var(--fill-0, #503629)" }),
    /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M0.866544 15.3223C0.866544 17.7486 1.7716 19.7609 3.46618 21.157C4.99707 22.4087 9.61864 24.4884 10.8992 25.0564C12.1894 24.4884 16.8109 22.4087 18.3322 21.157C20.0364 19.7609 20.9318 17.739 20.9318 15.3223V2.58406C14.5098 1.98711 6.89384 2.35298 0.866544 7.87961V15.3223ZM10.8992 26C10.8992 26 4.79488 23.3715 2.91736 21.8213C0.94357 20.2134 0 17.9411 0 15.3223V2.3915C4.81413 -0.198506 10.8992 0.00368761 10.8992 0.00368761C10.8992 0.00368761 16.9939 -0.198506 21.808 2.3915V15.3223C21.808 17.9411 20.8548 20.2134 18.8907 21.831C17.0035 23.3715 10.8992 26 10.8992 26Z", fill: "var(--fill-0, #FBBC15)" })
  ] }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M17.0613 13.5314C17.9086 14.0321 18.2456 14.3594 18.2648 14.9564C18.2841 15.6304 17.8219 16.0348 17.1094 16.0251C16.4932 16.0251 15.7615 15.6785 15.2704 15.2452V17.0168C15.877 17.3731 16.628 17.6138 17.3887 17.6138C19.2854 17.6138 20.1423 16.2658 20.1712 15.043C20.2097 13.9262 19.892 13.0692 18.2937 12.1257C17.5716 11.702 17.0132 11.4324 17.0324 10.7296C17.0517 10.046 17.6197 9.80527 18.1589 9.8149C18.8329 9.82452 19.478 10.1904 19.8824 10.6044V8.92909C19.5454 8.66913 18.8233 8.27437 17.7738 8.30326C16.5125 8.34177 15.1838 9.25646 15.1934 10.8066C15.1934 11.8368 15.4726 12.5975 17.0613 13.5314Z", fill: "var(--fill-0, #FBBC15)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M10.5234 9.99731C10.6775 9.92028 10.9471 9.86251 11.2071 9.86251C12.3239 9.86251 12.7861 10.7579 12.7861 12.905C12.7861 15.004 12.2565 16.0246 11.1493 16.0246C10.8893 16.0246 10.6582 15.9572 10.5234 15.9091V9.99731V9.99731ZM10.5234 17.4785C10.716 17.5362 10.9952 17.5844 11.39 17.5844C13.5275 17.5844 14.7502 15.6587 14.7502 12.8473C14.7502 10.0454 13.4889 8.30273 11.1974 8.30273C10.1479 8.30273 9.30066 8.53381 8.60742 8.98634V21.5223H10.5331V17.4785H10.5234Z", fill: "var(--fill-0, #FBBC15)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_5", d: "M4.71772 17.6122C5.89237 17.6122 6.88408 17.3427 7.61583 16.842V8.50391H5.69017V15.754C5.47835 15.8984 5.17025 15.9851 4.77549 15.9851C3.88969 15.9851 3.76452 15.1763 3.76452 14.6275V8.50391H1.83887V14.5408C1.8485 16.582 2.81132 17.6122 4.71772 17.6122Z", fill: "var(--fill-0, #FBBC15)" })
] }) }));
const DeliveryIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M940.7 479 827.8 321c-9.4-13.1-24.5-20.9-40.7-20.9H700V200c0-27.6-22.4-50-50-50H100c-27.6 0-50 22.4-50 50v500c0 27.6 22.4 50 50 50h53.1c11.1 43.1 50.3 75 96.9 75s85.7-31.9 96.8-75H650c1 0 2.1 0 3.1-.1 11.1 43.2 50.2 75.1 96.9 75.1 46.6 0 85.8-31.9 96.9-75H900c27.6 0 50-22.4 50-50V508c0-10.4-3.3-20.6-9.3-29M250 775c-27.6 0-50-22.4-50-50s22.4-50 50-50 50 22.4 50 50-22.4 50-50 50m400-75H346.8c-11.1-43.1-50.3-75-96.8-75-46.6 0-85.8 31.9-96.9 75H100V200h550zm100 75c-27.6 0-50-22.4-50-50s22.4-50 50-50 50 22.4 50 50-22.4 50-50 50m150-75h-53.1c-11.1-43.1-50.3-75-96.9-75-18.2 0-35.3 4.9-50 13.4V350h87.1L900 508z", clipRule: "evenodd" }) }));
const DocumentIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M19.1992 4L19.1992 20C19.1992 20.5523 18.7515 21 18.1992 21L5.79922 21C5.24693 21 4.79922 20.5523 4.79922 20L4.79922 12L4.79922 4C4.79922 3.44771 5.24693 3 5.79922 3L18.1992 3C18.7515 3 19.1992 3.44772 19.1992 4Z", stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("line", { x1: 7.19922, y1: 7.90039, x2: 13.1992, y2: 7.90039, stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("line", { x1: 14.4004, y1: 7.90039, x2: 16.8004, y2: 7.90039, stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("line", { x1: 7.19922, y1: 10.3008, x2: 13.1992, y2: 10.3008, stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("line", { x1: 14.4004, y1: 10.3008, x2: 16.8004, y2: 10.3008, stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("line", { x1: 7.19922, y1: 12.6992, x2: 13.1992, y2: 12.6992, stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("line", { x1: 14.4004, y1: 12.6992, x2: 16.8004, y2: 12.6992, stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("line", { x1: 14.4004, y1: 17.5, x2: 16.8004, y2: 17.5, stroke: "#2D2E2C", style: {
    stroke: "#2D2E2C",
    strokeOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M18.5992 4.20039C18.5992 3.86902 18.3306 3.60039 17.9992 3.60039H5.99922C5.66785 3.60039 5.39922 3.86902 5.39922 4.20039V19.8004C5.39922 20.1318 5.66785 20.4004 5.99922 20.4004H17.9992C18.3306 20.4004 18.5992 20.1318 18.5992 19.8004V4.20039ZM16.7992 16.8004V18.0004H14.3992V16.8004H16.7992ZM13.1992 12.0004V13.2004H7.19922V12.0004H13.1992ZM16.7992 12.0004V13.2004H14.3992V12.0004H16.7992ZM13.1992 9.60039V10.8004H7.19922V9.60039H13.1992ZM16.7992 9.60039V10.8004H14.3992V9.60039H16.7992ZM13.1992 7.20039V8.40039H7.19922V7.20039H13.1992ZM16.7992 7.20039V8.40039H14.3992V7.20039H16.7992ZM19.7992 19.8004L19.7898 19.9844C19.7038 20.8316 19.0304 21.505 18.1832 21.591L17.9992 21.6004H5.99922C5.00511 21.6004 4.19922 20.7945 4.19922 19.8004V4.20039C4.19922 3.20628 5.00511 2.40039 5.99922 2.40039H17.9992C18.9933 2.40039 19.7992 3.20628 19.7992 4.20039V19.8004Z", fill: "#2D2E2C", style: {
    fill: "#2D2E2C",
    fillOpacity: 1
  } })
] }));
const DotIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M500 600c55.228 0 100-44.772 100-100s-44.772-100-100-100-100 44.772-100 100 44.772 100 100 100", clipRule: "evenodd" }) }));
const DotsIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("circle", { cx: 3, cy: 8, r: 1.25 }),
  /* @__PURE__ */ jsx("circle", { cx: 8, cy: 8, r: 1.25 }),
  /* @__PURE__ */ jsx("circle", { cx: 13, cy: 8, r: 1.25 })
] }));
const EditIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M721.9 136.3c-3.5-3.5-7.6-6.3-12.1-8.2-4.7-2-9.8-3-14.9-3s-10.2 1-14.9 3-8.9 4.9-12.4 8.5l-461 501.8c-2.8 3-4.8 6.7-5.8 10.7l-49.9 194.7c-2.3 8.9.5 18.3 7.2 24.5s16.3 8.3 25 5.3L368.2 811c4.2-1.3 8.1-3.7 11.1-7l460.5-500.1.3-.3c13.8-15.5 13-39.4-2.1-53.9zm-375 629.1-136.3 46.2 36.9-144 339.8-369.9 99.1 99.1zm373.4-405.5-99.1-99.1 74.1-80.6 100.4 97.9z" }) }));
const EmailIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M825 175H175c-41.4 0-75 33.6-75 75v500c0 41.4 33.6 75 75 75h650c41.4 0 75-33.6 75-75V250c0-41.4-33.6-75-75-75m25 575c0 13.8-11.2 25-25 25H175c-13.8 0-25-11.2-25-25V353.8l350 200 350-200zm0-453.8-350 200-350-200V250c0-13.8 11.2-25 25-25h650c13.8 0 25 11.2 25 25z" }) }));
const FacebookIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M542.209 850V608.639h95.358l19.783-107.353H542.209v-37.967c0-56.726 22.334-78.548 80.13-78.548 17.949 0 32.402.436 40.721 1.307v-97.306c-15.764-4.37-54.299-8.726-76.634-8.726-117.791 0-172.09 55.419-172.09 174.982v46.258H341.65v107.353h72.686V842.23C260.815 804.263 147 666.025 147 501.286 147 307.278 304.821 150 499.5 150S852 307.278 852 501.286C852 680.891 716.739 828.993 542.209 850" }) }));
const FilterIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M495 275c-10-70-75-125-145-125s-135 55-145 125H50v50h155c10 70 75 125 145 125s135-55 145-125h455v-50zM350 400c-55 0-100-45-100-100s45-100 100-100 100 45 100 100-45 100-100 100m300 150c-75 0-135 55-145 125H50v50h455c10 70 75 125 145 125s135-55 145-125h155v-50H795c-10-70-75-125-145-125m0 250c-55 0-100-45-100-100s45-100 100-100 100 45 100 100-45 100-100 100m0 0" }) }));
const FreeReturnsIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "m800 184.8-285.7-125c-9.1-4-19.5-4-28.6 0L200 184.8c-13 5.7-21.4 18.5-21.4 32.7v314.8c0 14.2 8.4 27.1 21.4 32.7l285.7 125c4.6 2 9.4 3 14.3 3s9.8-1 14.3-3L800 565c13-5.7 21.4-18.5 21.4-32.7V217.6c0-14.2-8.4-27.1-21.4-32.8m-300-78.6 250.6 109.6L500 325.5 249.4 215.8zM226.8 258.6l249.1 109v265.7l-249.1-109zm297.3 374.6V367.6l249.1-109v265.7zm118.8 146.3H165.3l83.8-83.8c9.4-9.4 9.4-24.7 0-34.1s-24.7-9.4-34.1 0l-125 125c-9.4 9.4-9.4 24.7 0 34.1l125 125c4.7 4.7 10.9 7.1 17 7.1s12.3-2.4 17-7.1c9.4-9.4 9.4-24.7 0-34.1l-83.8-83.8h477.5v-48.3z" }),
  /* @__PURE__ */ jsx("path", { d: "M869.6 433c22.1 34.9 34.8 76.2 34.8 120.6 0 62.6-24.2 118.6-68.1 159-44 40.5-109.3 66.8-193.5 66.8v48.2c94.4 0 171.9-29.7 226.2-79.6 54.3-50 83.7-119 83.7-194.5 0-77.1-31.8-146.7-83-196.5v76z" })
] }));
const GiftIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Outline", children: [
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 8H2V14.5C2 14.7761 2.22386 15 2.5 15H13.5C13.7761 15 14 14.7761 14 14.5V8ZM1 7V14.5C1 15.3284 1.67157 16 2.5 16H13.5C14.3284 16 15 15.3284 15 14.5V7H1Z", fill: "var(--fill-0, #2D2E2C)" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 5H1V7H15V5ZM0 4V8H16V4H0Z", fill: "var(--fill-0, #2D2E2C)" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 16L7.5 2H8.5L8.5 16H7.5Z", fill: "var(--fill-0, #2D2E2C)" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.51227 0.0480379C5.99723 -0.0484251 6.49989 0.00108323 6.95671 0.190302C7.41352 0.379521 7.80397 0.699953 8.07867 1.11108C8.35338 1.5222 8.5 2.00555 8.5 2.5H7.5C7.5 2.20333 7.41203 1.91332 7.2472 1.66665C7.08238 1.41997 6.84811 1.22771 6.57403 1.11418C6.29994 1.00065 5.99834 0.970945 5.70736 1.02882C5.41639 1.0867 5.14912 1.22956 4.93934 1.43934C4.72956 1.64912 4.5867 1.91639 4.52882 2.20737C4.47094 2.49834 4.50065 2.79994 4.61418 3.07403C4.72771 3.34812 4.91997 3.58238 5.16664 3.74721C5.41332 3.91203 5.70333 4 6 4V5C5.50555 5 5.0222 4.85338 4.61107 4.57867C4.19995 4.30397 3.87952 3.91353 3.6903 3.45671C3.50108 2.99989 3.45157 2.49723 3.54804 2.01228C3.6445 1.52732 3.8826 1.08187 4.23223 0.732234C4.58186 0.382603 5.02732 0.144501 5.51227 0.0480379Z", fill: "var(--fill-0, #2D2E2C)" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.4877 0.0480388C10.0028 -0.0484242 9.50011 0.00108406 9.04329 0.190303C8.58648 0.379522 8.19603 0.699954 7.92133 1.11108C7.64662 1.5222 7.5 2.00555 7.5 2.5H8.5C8.5 2.20333 8.58797 1.91332 8.7528 1.66665C8.91762 1.41997 9.15188 1.22771 9.42597 1.11418C9.70006 1.00065 10.0017 0.970946 10.2926 1.02882C10.5836 1.0867 10.8509 1.22956 11.0607 1.43934C11.2704 1.64912 11.4133 1.91639 11.4712 2.20737C11.5291 2.49834 11.4993 2.79994 11.3858 3.07403C11.2723 3.34812 11.08 3.58238 10.8334 3.74721C10.5867 3.91203 10.2967 4 10 4V5C10.4945 5 10.9778 4.85338 11.3889 4.57867C11.8 4.30397 12.1205 3.91353 12.3097 3.45671C12.4989 2.9999 12.5484 2.49723 12.452 2.01228C12.3555 1.52732 12.1174 1.08187 11.7678 0.732235C11.4181 0.382604 10.9727 0.144502 10.4877 0.0480388Z", fill: "var(--fill-0, #2D2E2C)" })
] }) }));
const GoogleIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { id: "Google__G__Logo 1", clipPath: `url(#${uid}clip0_13120_21726)`, children: [
      /* @__PURE__ */ jsx("path", { id: "Vector", d: "M15.9997 8.18417C15.9997 7.64035 15.9547 7.09359 15.8588 6.55859H8.16016V9.63925H12.5688C12.3858 10.6328 11.798 11.5117 10.9373 12.0703V14.0692H13.5675C15.112 12.6758 15.9997 10.6181 15.9997 8.18417Z", fill: "var(--fill-0, #4285F4)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M8.16091 16.0002C10.3622 16.0002 12.2186 15.2918 13.5712 14.0689L10.941 12.07C10.2093 12.558 9.26456 12.8343 8.16391 12.8343C6.03457 12.8343 4.22914 11.4263 3.58134 9.5332H0.867188V11.5938C2.25275 14.2953 5.07487 16.0002 8.16091 16.0002V16.0002Z", fill: "var(--fill-0, #34A853)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M3.57548 9.5338C3.23358 8.54023 3.23358 7.46435 3.57548 6.47078V4.41016H0.864323C-0.293316 6.67067 -0.293316 9.33391 0.864323 11.5944L3.57548 9.5338V9.5338Z", fill: "var(--fill-0, #FBBC04)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M8.16091 3.16644C9.32454 3.1488 10.4492 3.57798 11.2919 4.36578L13.6222 2.08174C12.1467 0.72367 10.1883 -0.0229773 8.16091 0.000539111C5.07487 0.000539111 2.25275 1.70548 0.867188 4.40987L3.57834 6.4705C4.22314 4.57449 6.03157 3.16644 8.16091 3.16644V3.16644Z", fill: "var(--fill-0, #EA4335)" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: `${uid}clip0_13120_21726`, children: /* @__PURE__ */ jsx("rect", { width: 16, height: 16, fill: "white" }) }) })
  ] }));
};
const GradientCheckmarkIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { id: "Outline", children: [
      /* @__PURE__ */ jsxs("g", { id: "Intersect", children: [
        /* @__PURE__ */ jsx("path", { d: "M7 1.2V0C3.13401 0 0 3.13401 0 7H1.2C1.2 3.79675 3.79675 1.2 7 1.2Z", fill: `url(#${uid}paint0_linear_13120_20357)` }),
        /* @__PURE__ */ jsx("path", { d: "M7 1.2V0C3.13401 0 0 3.13401 0 7H1.2C1.2 3.79675 3.79675 1.2 7 1.2Z", fill: `url(#${uid}paint1_linear_13120_20357)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_2", children: [
        /* @__PURE__ */ jsx("path", { d: "M12.8 7H14C14 3.13401 10.866 0 7 0V1.2C10.2033 1.2 12.8 3.79675 12.8 7Z", fill: `url(#${uid}paint2_linear_13120_20357)` }),
        /* @__PURE__ */ jsx("path", { d: "M12.8 7H14C14 3.13401 10.866 0 7 0V1.2C10.2033 1.2 12.8 3.79675 12.8 7Z", fill: `url(#${uid}paint3_linear_13120_20357)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_3", children: [
        /* @__PURE__ */ jsx("path", { d: "M12.8 7C12.8 10.2033 10.2033 12.8 7 12.8V14C10.866 14 14 10.866 14 7H12.8Z", fill: `url(#${uid}paint4_linear_13120_20357)` }),
        /* @__PURE__ */ jsx("path", { d: "M12.8 7C12.8 10.2033 10.2033 12.8 7 12.8V14C10.866 14 14 10.866 14 7H12.8Z", fill: `url(#${uid}paint5_linear_13120_20357)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_4", children: [
        /* @__PURE__ */ jsx("path", { d: "M1.2 7H0C0 10.866 3.13401 14 7 14V12.8C3.79675 12.8 1.2 10.2033 1.2 7Z", fill: `url(#${uid}paint6_linear_13120_20357)` }),
        /* @__PURE__ */ jsx("path", { d: "M1.2 7H0C0 10.866 3.13401 14 7 14V12.8C3.79675 12.8 1.2 10.2033 1.2 7Z", fill: `url(#${uid}paint7_linear_13120_20357)` })
      ] }),
      /* @__PURE__ */ jsx("path", { id: "Stroke", d: "M4.5 6.90039L6.47581 8.90039L9.9002 4.90039", stroke: "var(--stroke-0, #2D2E2C)", strokeWidth: 0.9 })
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_13120_20357`, x1: 1, y1: 7, x2: 7, y2: 1, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E42922" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#2085CE" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint1_linear_13120_20357`, x1: 0.875, y1: 7, x2: 7, y2: 0.875, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#2085CE" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#58B64A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint2_linear_13120_20357`, x1: 7, y1: 1, x2: 13, y2: 7, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#2085CE" }),
        /* @__PURE__ */ jsx("stop", { offset: 0.0498047, stopColor: "#2387C7" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#58B64A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint3_linear_13120_20357`, x1: 7, y1: 0.875, x2: 13.125, y2: 7, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#58B64A" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#DC9F1C" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint4_linear_13120_20357`, x1: 13, y1: 7, x2: 7, y2: 13, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#58B64A" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#DC9F1C" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint5_linear_13120_20357`, x1: 13.125, y1: 7, x2: 7, y2: 13.125, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#DC9F1C" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E42922" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint6_linear_13120_20357`, x1: 7, y1: 13, x2: 1, y2: 7, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#DC9F1C" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E42922" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint7_linear_13120_20357`, x1: 7, y1: 13.125, x2: 0.875, y2: 7, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E42922" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#2085CE" })
      ] })
    ] })
  ] }));
};
const GradientCircleIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsx("path", { d: "M13.28 8.0001H14.4C14.4 4.46548 11.5346 1.6001 8 1.6001V2.7201C10.9161 2.7201 13.28 5.08403 13.28 8.0001Z", fill: "#2D2E2C" }),
    /* @__PURE__ */ jsx("path", { d: "M13.28 8.0001H14.4C14.4 4.46548 11.5346 1.6001 8 1.6001V2.7201C10.9161 2.7201 13.28 5.08403 13.28 8.0001Z", fill: `url(#${uid}paint0_linear_19314_46)` }),
    /* @__PURE__ */ jsx("path", { d: "M13.28 8C13.28 10.9161 10.9161 13.28 8 13.28V14.4C11.5346 14.4 14.4 11.5346 14.4 8H13.28Z", fill: "#2D2E2C" }),
    /* @__PURE__ */ jsx("path", { d: "M13.28 8C13.28 10.9161 10.9161 13.28 8 13.28V14.4C11.5346 14.4 14.4 11.5346 14.4 8H13.28Z", fill: `url(#${uid}paint1_linear_19314_46)` }),
    /* @__PURE__ */ jsx("path", { d: "M2.72001 8H1.60001C1.60001 11.5346 4.46538 14.4 8.00001 14.4V13.28C5.08394 13.28 2.72001 10.9161 2.72001 8Z", fill: "#2D2E2C" }),
    /* @__PURE__ */ jsx("path", { d: "M2.72001 8H1.60001C1.60001 11.5346 4.46538 14.4 8.00001 14.4V13.28C5.08394 13.28 2.72001 10.9161 2.72001 8Z", fill: `url(#${uid}paint2_linear_19314_46)` }),
    /* @__PURE__ */ jsx("path", { d: "M8.00001 1.6001C4.46538 1.6001 1.60001 4.46548 1.60001 8.0001H2.72001C2.72001 5.08403 5.08394 2.7201 8.00001 2.7201V1.6001Z", fill: "#2D2E2C" }),
    /* @__PURE__ */ jsx("path", { d: "M8.00001 1.6001C4.46538 1.6001 1.60001 4.46548 1.60001 8.0001H2.72001C2.72001 5.08403 5.08394 2.7201 8.00001 2.7201V1.6001Z", fill: `url(#${uid}paint3_linear_19314_46)` }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_19314_46`, x1: 8, y1: 2.51438, x2: 13.4857, y2: 8.0001, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#2085CE" }),
        /* @__PURE__ */ jsx("stop", { offset: 0.0498047, stopColor: "#2387C7" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#58B64A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint1_linear_19314_46`, x1: 13.4857, y1: 8, x2: 8, y2: 13.4857, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#58B64A" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#DC9F1C" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint2_linear_19314_46`, x1: 8.00001, y1: 13.4857, x2: 2.51429, y2: 8, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#DC9F1C" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E42922" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint3_linear_19314_46`, x1: 2.51429, y1: 8.0001, x2: 8.00001, y2: 2.51438, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E42922" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#2085CE" })
      ] })
    ] })
  ] }));
};
const HideIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "m869.3 475.3.2-.3c-28.4-56-74.1-102.9-130.6-137.2l103-94.8c10.2-9.3 10.8-25.2 1.5-35.3-9.3-10.2-25.2-10.8-35.3-1.5l-116.3 107c-57.8-25.6-123.5-39.4-191.9-38.6-160.4-2-306.6 77.2-369.1 200.3-3.8 7.7-5.8 16.1-5.8 24.6s2 16.9 5.8 24.6C164.6 590.4 222.6 644 294 679L183 781.1c-10.2 9.3-10.8 25.2-1.5 35.3 9.3 10.2 25.2 10.8 35.3 1.5L345 700.2c48.2 16.4 100.7 25 154.9 24.4 160.8 2.1 306.9-77.2 369.4-200.3 3.8-7.7 5.7-16 5.7-24.5s-2-16.8-5.7-24.5M331.1 645.1c-66.1-29.9-120-77.8-150.6-137.9q-1.8-3.6-1.8-7.5c0-2.6.6-5.2 1.8-7.5C235 385.9 361.4 317.7 499.9 319.7c54.5-.8 107.2 9.2 154.3 28.2l-67.1 61.7c-3.3-3.2-6.9-6.3-10.5-9.1-12.9-10-27.6-17.2-43.3-21.2-21.8-6-44.8-6-66.6 0-3.1.8-6.1 2.3-8.6 4.3-2.6 2-4.7 4.5-6.4 7.3-1.6 2.9-2.7 6-3.1 9.3s-.2 6.6.6 9.8c1.9 6.5 6.1 11.9 11.9 15.2s12.5 4.1 18.9 2.3c19-5.4 39.3-3 56.6 6.8 4.8 2.7 9.3 5.9 13.3 9.6L440.2 544.7c-5.6-7.4-9.9-15.9-12.6-25.1-3.6-13.1-3.6-26.9 0-40 .9-3.2 1.1-6.6.6-9.8-.4-3.3-1.5-6.5-3.1-9.3-1.6-2.9-3.8-5.4-6.4-7.4q-3.9-3-8.7-4.2c-6.3-1.8-13.1-1-18.9 2.3s-10 8.7-11.9 15.1c-4.3 16-5.4 32.7-3.3 49.1s7.4 32.2 15.5 46.5c3.4 6 7.3 11.6 11.6 16.9zm243.3-136c-1.3 9.9-4.4 19.3-9.3 27.9s-11.4 16.1-19.1 22.1-16.6 10.3-26 12.8c-12 3.4-24.6 3.7-36.6 1l90.9-83.6c.9 6.5 1 13.2.1 19.8m245.1-1.6c-54.3 105.6-180.6 174-319.6 171.9-40.1.6-79.2-4.7-115.8-15.1l58.3-53.6c7.7 4 15.9 7.1 24.3 9.3 31.7 9 65.6 5 94.4-11.4 28.8-16.3 50.2-43.6 59.6-75.9 4.3-16 5.4-32.6 3.3-49.1-1.4-11.1-4.3-22-8.5-32.2l86.9-80c50.6 29.7 91.6 70.9 116.8 120.4 1.2 2.4 1.8 5 1.8 7.7s-.6 5.3-1.8 7.7z" }) }));
const HomeIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Outline", children: [
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.33914 1.1326C7.14761 0.9558 6.85239 0.955801 6.66086 1.1326L1.16086 6.20952C1.05832 6.30418 1 6.43737 1 6.57692V13.6391H13L13 6.57692C13 6.43737 12.9417 6.30418 12.8391 6.20952L7.33914 1.1326ZM5.98258 0.397794C6.55717 -0.132599 7.44283 -0.132597 8.01742 0.397795L13.5174 5.47472C13.825 5.75868 14 6.15828 14 6.57692L14 14.6391H0V6.57692C0 6.15828 0.174956 5.75868 0.48258 5.47472L5.98258 0.397794Z", fill: "var(--fill-0, #2D2E2C)" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 7.63909H9.5V14.6391H8.5V8.63909H5.5V14.6391H4.5V7.63909Z", fill: "var(--fill-0, #2D2E2C)" })
] }) }));
const InfoCircleIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M500 0C223.9 0 0 223.9 0 500s223.9 500 500 500 500-223.9 500-500S776.1 0 500 0m39.5 748.4c0 8.2-6.6 14.8-14.8 14.8h-49.4c-8.2 0-14.8-6.6-14.8-14.8V409.6c0-8.2 6.6-14.8 14.8-14.8h49.4c8.2 0 14.8 6.6 14.8 14.8zM500 329.9c-28.3 0-51.3-23-51.3-51.3s23-51.3 51.3-51.3 51.3 23 51.3 51.3-23 51.3-51.3 51.3" }) }));
const InfoIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M493.478 336.957c12.078 0 21.739-2.416 31.401-12.078 9.662-7.246 12.077-19.323 12.077-31.401s-2.415-21.739-12.077-31.401C515.217 254.831 505.556 250 493.478 250s-21.739 2.415-31.401 12.077C454.831 269.324 450 281.401 450 293.478c0 12.078 2.415 21.739 12.077 31.401 7.247 7.247 19.324 12.078 31.401 12.078m-33.816 74.879v326.087c0 4.831 4.831 9.662 9.662 12.077h48.309c4.831 0 9.662-4.831 9.662-9.662V411.836c0-4.831-4.831-9.662-9.662-9.662h-48.309c-4.831 0-9.662 4.831-9.662 9.662" }) }));
const InstagramIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M355.044 152.45c-37.24 1.757-62.671 7.7-84.903 16.436-23.009 8.967-42.511 21-61.915 40.474s-31.353 38.99-40.257 62.034c-8.617 22.281-14.455 47.733-16.1 84.994s-2.009 49.238-1.827 144.284.602 106.96 2.408 144.298c1.778 37.233 7.7 62.657 16.436 84.896 8.981 23.009 21 42.504 40.481 61.915s38.983 31.332 62.083 40.25c22.26 8.603 47.719 14.469 84.973 16.1s49.245 2.009 144.263 1.827 106.981-.602 144.312-2.373 62.622-7.735 84.868-16.429c23.009-9.002 42.518-21 61.915-40.488s31.339-39.018 40.236-62.076c8.624-22.26 14.483-47.719 16.1-84.945 1.631-37.359 2.016-49.287 1.834-144.319s-.609-106.946-2.38-144.27-7.7-62.671-16.429-84.924c-8.995-23.009-21-42.49-40.474-61.915s-39.018-31.36-62.069-40.236c-22.274-8.617-47.719-14.49-84.973-16.1s-49.245-2.023-144.298-1.841-106.953.588-144.284 2.408m4.088 632.716c-34.125-1.484-52.654-7.154-65.002-11.9-16.352-6.3-28-13.916-40.306-26.103s-19.866-23.877-26.25-40.194c-4.795-12.348-10.57-30.856-12.166-64.981-1.736-36.883-2.1-47.957-2.303-141.4s.154-104.503 1.771-141.4c1.456-34.097 7.161-52.647 11.9-64.988 6.3-16.373 13.888-28 26.103-40.299s23.87-19.873 40.201-26.257c12.334-4.816 30.842-10.542 64.953-12.166 36.911-1.75 47.971-2.1 141.4-2.303s104.517.147 141.442 1.771c34.097 1.484 52.654 7.133 64.981 11.9 16.359 6.3 28 13.867 40.299 26.103s19.88 23.849 26.264 40.215c4.823 12.299 10.549 30.8 12.159 64.932 1.757 36.911 2.156 47.978 2.324 141.4s-.161 104.517-1.778 141.4c-1.491 34.125-7.147 52.661-11.9 65.023-6.3 16.345-13.895 28-26.117 40.292s-23.863 19.866-40.201 26.25c-12.32 4.809-30.849 10.549-64.932 12.173-36.911 1.736-47.971 2.1-141.435 2.303s-104.489-.175-141.4-1.771m285.32-472.227a42 42 0 0 0 25.995 38.761 42.002 42.002 0 0 0 54.777-54.978 42 42 0 0 0-38.856-25.853 42 42 0 0 0-41.916 42.07M320.289 500.35c.196 99.26 80.808 179.543 180.047 179.354S679.914 598.91 679.725 499.65 598.903 320.086 499.65 320.282 320.1 401.104 320.289 500.35m63.042-.126a116.66 116.66 0 0 1 19.534-64.856 116.66 116.66 0 0 1 119.669-49.847 116.672 116.672 0 0 1 85.342 158.906 116.67 116.67 0 0 1-107.645 72.235 116.65 116.65 0 0 1-82.569-34.004 116.66 116.66 0 0 1-34.331-82.434" }) }));
const LinenIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M19.437 4.84c-.354-2.007-2.125-5.596-6.375-3.896a2.76 2.76 0 0 1-2.124 0c-4.25-1.7-6.02 1.889-6.375 3.896M19.16 19.437c2.007-.354 5.596-2.125 3.896-6.375a2.76 2.76 0 0 1 0-2.124c1.7-4.25-1.889-6.02-3.896-6.375M4.563 19.16c.354 2.007 2.125 5.596 6.375 3.896a2.76 2.76 0 0 1 2.124 0c4.25 1.7 6.02-1.889 6.375-3.896M4.84 4.563C2.833 4.917-.756 6.688.944 10.938a2.76 2.76 0 0 1 0 2.124c-1.7 4.25 1.889 6.02 3.896 6.375M19.647 19.636l-2.545-2.545M19.647 4.364l-2.545 2.545M4.373 19.636l2.545-2.545M4.373 4.364l2.545 2.545M9.098 9.09l1.19.548a4.11 4.11 0 0 0 3.438 0l1.19-.547-.548 1.19a4.11 4.11 0 0 0 0 3.438l.548 1.19-1.19-.547a4.11 4.11 0 0 0-3.438 0l-1.19.547.547-1.19a4.11 4.11 0 0 0 0-3.438z" }) }));
const LinkIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
  /* @__PURE__ */ jsx("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
] }));
const LinkedinIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Outline", fillRule: "evenodd", clipRule: "evenodd", d: "M14 14H11.1234V9.10057C11.1234 7.75728 10.613 7.00661 9.54981 7.00661C8.39316 7.00661 7.78887 7.7878 7.78887 9.10057V14H5.01667V4.66667H7.78887V5.92387C7.78887 5.92387 8.6224 4.38152 10.603 4.38152C12.5827 4.38152 14 5.59043 14 8.09071V14ZM1.70944 3.44454C0.765169 3.44454 0 2.67337 0 1.72227C0 0.771173 0.765169 0 1.70944 0C2.65371 0 3.41842 0.771173 3.41842 1.72227C3.41842 2.67337 2.65371 3.44454 1.70944 3.44454ZM0.277995 14H3.16869V4.66667H0.277995V14Z", fill: "var(--fill-0, #2D2E2C)" }) }));
const LocationFullIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M773.5 396.1c0-150.9-122.6-273.5-273.5-273.5S226.5 245.2 226.5 396.1c0 205.1 273.5 501.4 273.5 501.4s273.5-296.3 273.5-501.4m-364.7 0c0-50.1 41-91.2 91.2-91.2 50.1 0 91.2 41 91.2 91.2 0 24.2-9.6 47.4-26.7 64.5a91.2 91.2 0 0 1-64.5 26.7c-24.2 0-47.4-9.6-64.5-26.7-17.1-17.2-26.7-40.4-26.7-64.5" }) }));
const LocationIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", id: "Layer_1", x: 0, y: 0, fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("style", { children: ".st0{fill-rule:evenodd;clip-rule:evenodd}" }),
  /* @__PURE__ */ jsx("path", { d: "M500 125c-164.6 0-300 127.6-300 287.5 0 139.8 73 261 143.2 345.7 35.4 42.6 70.7 76.7 97.2 100.2 13.3 11.8 24.4 20.9 32.2 27.1 3.9 3.1 7 5.5 9.2 7.1 1.1.8 2.3 1.7 3.4 2.5 8.7 6.3 20.9 6.3 29.6 0 1.1-.8 2.3-1.6 3.4-2.5 2.2-1.6 5.3-4 9.2-7.1 7.8-6.3 18.9-15.4 32.1-27.1 26.5-23.5 61.8-57.6 97.2-100.2C727 673.5 800 552.3 800 412.5 800 252.6 664.6 125 500 125m118.3 601.2c-33.4 40.2-66.8 72.5-91.9 94.7-10.5 9.3-19.5 16.8-26.4 22.4-6.9-5.6-15.9-13.1-26.4-22.4-25.1-22.2-58.5-54.5-91.9-94.7-67.2-81-131.7-191-131.7-313.7C250 282.4 360.8 175 500 175s250 107.4 250 237.5c0 122.7-64.5 232.7-131.7 313.7", className: "st0" }),
  /* @__PURE__ */ jsx("path", { d: "M500 300c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125m0 200c-41.4 0-75-33.6-75-75s33.6-75 75-75 75 33.6 75 75-33.6 75-75 75", className: "st0" })
] }));
const LockIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M750.05 800v50h-500v-50zm0-350h-500v400l-5.128-.246c-23.52-2.395-42.234-21.106-44.629-44.629l-.242-5.125V450c0-27.613 22.383-50 50-50h500c27.613 0 50 22.387 50 50v350c0 25.887-19.672 47.191-44.875 49.754l-5.125.246zm-425-100c0-96.648 78.348-175 175-175 96.65 0 175 78.352 175 175h50c0-124.266-100.734-225-225-225-124.265 0-225 100.734-225 225zm0 0" }) }));
const LogoutIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 20 20", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M8 3.5H5C4.72386 3.5 4.5 3.72386 4.5 4V16C4.5 16.2761 4.72386 16.5 5 16.5H8V17.5H5C4.17157 17.5 3.5 16.8284 3.5 16V4C3.5 3.17157 4.17157 2.5 5 2.5H8V3.5Z" }),
  /* @__PURE__ */ jsx("path", { d: "M16.707 10L12.3535 14.3535L11.6465 13.6465L14.793 10.5H8V9.5H14.793L11.6465 6.35352L12.3535 5.64648L16.707 10Z" })
] }));
const LookBuilderIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { id: "Outline", children: [
      /* @__PURE__ */ jsx("path", { id: "Intersect", d: "M7.93655 5.44459L7.37087 4.87891C6.19929 6.05048 6.19929 7.94997 7.37087 9.12155L7.93655 8.55586C7.0774 7.69671 7.0774 6.30375 7.93655 5.44459Z", fill: `url(#${uid}paint0_linear_13120_20419)` }),
      /* @__PURE__ */ jsx("path", { id: "Intersect_2", d: "M11.048 5.44482L11.6137 4.87913C10.4422 3.70756 8.54267 3.70756 7.37109 4.87913L7.93678 5.44482C8.79593 4.58566 10.1889 4.58566 11.048 5.44482Z", fill: `url(#${uid}paint1_linear_13120_20419)` }),
      /* @__PURE__ */ jsx("path", { id: "Intersect_3", d: "M11.0478 5.44459C11.907 6.30375 11.907 7.69671 11.0478 8.55586L11.6135 9.12155C12.7851 7.94997 12.7851 6.05048 11.6135 4.87891L11.0478 5.44459Z", fill: `url(#${uid}paint2_linear_13120_20419)` }),
      /* @__PURE__ */ jsx("path", { id: "Intersect_4", d: "M7.93678 8.55563L7.37109 9.12132C8.54267 10.2929 10.4422 10.2929 11.6137 9.12132L11.048 8.55563C10.1889 9.41479 8.79593 9.41479 7.93678 8.55563Z", fill: `url(#${uid}paint3_linear_13120_20419)` }),
      /* @__PURE__ */ jsx("circle", { id: "Ellipse 1101", cx: 3, cy: 3, r: 2.6, stroke: `url(#${uid}paint4_linear_13120_20419)`, strokeWidth: 0.8 }),
      /* @__PURE__ */ jsx("circle", { id: "Ellipse 1103", cx: 3, cy: 11, r: 2.6, stroke: `url(#${uid}paint5_linear_13120_20419)`, strokeWidth: 0.8 })
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_13120_20419`, x1: 7.72487, y1: 8.76777, x2: 7.72487, y2: 5.23223, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#389A97" }),
        /* @__PURE__ */ jsx("stop", { offset: 0.513837, stopColor: "#2285CD" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#93506A" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#93506A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint1_linear_13120_20419`, x1: 11.2602, y1: 5.23269, x2: 7.72465, y2: 5.23269, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#3E78B5" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#93506A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint2_linear_13120_20419`, x1: 11.2599, y1: 5.23223, x2: 10.9064, y2: 8.41421, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#3E78B5" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#2285CD" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint3_linear_13120_20419`, x1: 10.9066, y1: 8.41396, x2: 8.0782, y2: 8.41396, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#2285CD" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#389A97" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint4_linear_13120_20419`, x1: 0.5, y1: 4.5, x2: 5.5, y2: 2.5, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#DC9F1C" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E42922" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint5_linear_13120_20419`, x1: 4.5, y1: 13, x2: 1.5, y2: 9, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#58B64A" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#DC9F1C" })
      ] })
    ] })
  ] }));
};
const MenuIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M100 300h800v50H100zm0 350h800v50H100z" }) }));
const MessageIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M104.2 204c0-32.2 24.9-60.3 58.2-60.3h635.7c33.2 0 58.3 28.1 58.3 60.3v473.7c0 32.3-25.1 60.3-58.3 60.3H688v97.6c0 8.5-5.2 16.2-13.1 19.3-7.9 3.2-16.9 1.2-22.8-5l-106.6-112H162.4c-33.3 0-58.2-28.1-58.2-60.3zm58.2-18.7c-8.1 0-16.5 7.2-16.5 18.7v473.7c0 11.4 8.4 18.6 16.5 18.6h392.1c5.7 0 11.2 2.3 15.1 6.5l76.9 80.7v-66.3c0-11.5 9.3-20.8 20.8-20.8h130.9c8.1 0 16.6-7.3 16.6-18.6V204c0-11.4-8.5-18.7-16.6-18.7z", clipRule: "evenodd" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M235.4 389.3c0-11.5 9.3-20.8 20.8-20.8H705c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8H256.3c-11.5 0-20.9-9.3-20.9-20.8m0 118.8c0-11.5 9.3-20.8 20.8-20.8h224.4c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8H256.3c-11.5 0-20.9-9.3-20.9-20.8", clipRule: "evenodd" })
] }));
const MinusIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M746 480.811a4 4 0 0 1 4 4v40.076a4 4 0 0 1-4 4H254a4 4 0 0 1-4-4v-40.076a4 4 0 0 1 4-4z" }) }));
const NoneIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5007 5.64955C16.0271 4.37173 14.104 3.59844 12.0004 3.59844C7.3612 3.59844 3.60039 7.35925 3.60039 11.9984C3.60039 14.1021 4.37368 16.0251 5.65151 17.4988L17.5007 5.64955ZM6.50004 18.3473L18.3493 6.49808C19.6271 7.97176 20.4004 9.89479 20.4004 11.9984C20.4004 16.6376 16.6396 20.3984 12.0004 20.3984C9.89674 20.3984 7.97371 19.6251 6.50004 18.3473ZM12.0004 21.5984C17.3023 21.5984 21.6004 17.3004 21.6004 11.9984C21.6004 6.6965 17.3023 2.39844 12.0004 2.39844C6.69846 2.39844 2.40039 6.6965 2.40039 11.9984C2.40039 17.3004 6.69846 21.5984 12.0004 21.5984Z" }) }));
const PaymentAlipayIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 27 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "_å¾å±_1", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M9.26074 20.1111C9.26074 20.6027 9.61956 20.9332 10.1209 20.9332C10.6223 20.9332 10.9811 20.6027 10.9811 20.1111C10.9811 19.6196 10.6223 19.2891 10.1209 19.2891C9.61956 19.2891 9.26074 19.6294 9.26074 20.1111Z", fill: "var(--fill-0, #1677FF)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M8.35337 19.4961H6.86035V26.3935H8.35337V19.4961Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M4.24313 19.7325H2.24015L0 26.3939H1.37997L1.75845 25.0901H4.13008L4.4889 26.3939H6.25595L4.24313 19.7325ZM2.06934 24.0039L2.95778 20.933H2.99587L3.83639 24.0039H2.06934Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M10.8661 21.3301H9.37305V26.3953H10.8661V21.3301Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_5", d: "M26.4677 21.3385L26.4775 21.3299H25.0693L24.1808 24.4094H24.1341L23.113 21.3299H21.4405L23.4534 26.4136L22.6128 27.9631V28H23.9252L26.4677 21.3385Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_6", d: "M14.5798 21.2258C14.0317 21.2258 13.6066 21.4335 13.1249 21.8304V21.3291H11.6318V28.0003H13.1249V26.3463C13.4087 26.4213 13.6729 26.4594 13.9949 26.4594C15.3269 26.4594 16.5275 25.4763 16.5275 23.729C16.5275 22.1597 15.6587 21.2246 14.581 21.2246M13.636 25.5243C13.4665 25.5243 13.3055 25.5058 13.1261 25.4493V22.709C13.4382 22.4915 13.6926 22.3883 14.0145 22.3883C14.5724 22.3883 15.016 22.8319 15.016 23.7769C15.016 24.986 14.3635 25.5255 13.636 25.5255", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_7", d: "M21.1481 25.1282V23.0122C21.1481 21.8596 20.4673 21.2267 19.268 21.2267C18.5024 21.2267 17.9728 21.3594 17.0094 21.6519L17.2736 22.8144C18.1522 22.4174 18.5393 22.2479 18.946 22.2479C19.4375 22.2479 19.6551 22.5981 19.6551 23.1363V23.1744C17.9445 23.4951 17.4149 23.6758 17.0844 24.0063C16.8386 24.2521 16.7341 24.6011 16.7341 25.0078C16.7341 25.981 17.4899 26.5008 18.1989 26.5008C18.7285 26.5008 19.1537 26.303 19.73 25.868L19.8345 26.3976H21.3275L21.1481 25.1307V25.1282ZM19.6551 25.1663C19.2581 25.3838 19.0308 25.4686 18.7666 25.4686C18.4078 25.4686 18.1805 25.2327 18.1805 24.8542C18.1805 24.7129 18.2087 24.5703 18.3218 24.4573C18.5012 24.2779 18.8514 24.1452 19.6538 23.9572V25.1663H19.6551Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_8", d: "M18.9051 0H7.35661C5.85253 0 4.63477 1.22882 4.63477 2.74519V14.392C4.63477 15.9084 5.85253 17.1372 7.35661 17.1372H18.9051C20.4092 17.1372 21.6257 15.9084 21.6257 14.392V2.74519C21.6257 1.22882 20.408 0 18.9051 0Z", fill: "var(--fill-0, #1677FF)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_9", d: "M18.6239 10.7612C17.9444 10.5314 17.0314 10.1799 16.0151 9.81007C16.6258 8.73977 17.1125 7.522 17.4332 6.19733H14.0846V4.98079H18.1877V4.30125H14.0846V2.27246H12.4097C12.1161 2.27246 12.1161 2.56492 12.1161 2.56492V4.30125H7.96632V4.98079H12.1161V6.19733H8.6901V6.87687H15.3344C15.091 7.7223 14.7642 8.51489 14.3771 9.23498C12.2217 8.51735 9.92015 7.93611 8.47505 8.2937C7.55097 8.52349 6.95499 8.93392 6.60601 9.36278C5.00116 11.3326 6.15134 14.3248 9.54167 14.3248C11.5459 14.3248 13.4776 13.1979 14.9743 11.34C17.2059 12.4226 21.6259 14.2805 21.6259 14.2805V11.6324C21.6259 11.6324 21.0705 11.5882 18.6239 10.7612ZM9.22586 13.1795C6.58266 13.1795 5.80113 11.0794 7.10737 9.9305C7.5436 9.54219 8.33988 9.35295 8.76505 9.30994C10.3355 9.15388 11.7892 9.75723 13.5046 10.6027C12.2992 12.1891 10.7631 13.1795 9.22709 13.1795", fill: "var(--fill-0, white)" })
] }) }));
const PaymentAmexIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M32 0H0V32H32V0Z", fill: "var(--fill-0, white)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M0 0V32H32V26.944H27.584L25.952 25.0349L24.256 26.944H11.712V16.7789H7.57312L12.7469 5.06688H17.7811L18.9971 7.72288V5.06688H25.248L26.2931 7.85088L27.3171 5.06688H32V0H0ZM28.384 6.72L26.7411 11.0509L26.304 12.2246L25.856 11.0509L24.2029 6.72H20.5869V15.2538H22.7629V9.69664L22.752 8.576L23.1789 9.69664L25.2589 15.2538H27.328L29.4189 9.69664L29.824 8.58688V15.2538H32V6.72H28.384ZM13.92 6.72L10.144 15.2538H12.6182L13.28 13.6109H17.4189L18.08 15.2538H20.5869L16.832 6.72H13.92ZM14.9222 9.61088L15.3491 8.54464L15.776 9.61088L16.6611 11.7651H14.0371L14.9222 9.61088ZM28.5549 16.7898L25.984 19.552L23.424 16.7898H20.5869H13.4611V25.2909H20.5869V23.4458H15.6371V21.9629H20.4909V20.1286H15.6371V18.6349H20.5869V16.7898L24.5651 21.056L20.5869 25.2909H23.3389L25.9309 22.5178L28.512 25.2909H31.3382L27.3491 21.024L31.3382 16.7898H28.5549ZM29.5891 21.0138L32 23.4669V18.592L29.5891 21.0138Z", fill: "var(--fill-0, #006FCF)" })
] }) }));
const PaymentApplePayIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 48 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M13.5577 10.7038C13.9516 10.2112 14.2189 9.54972 14.1484 8.87378C13.5718 8.90245 12.8682 9.25416 12.4609 9.74718C12.0951 10.1694 11.7714 10.8586 11.8558 11.5062C12.503 11.5623 13.1497 11.1827 13.5577 10.7038Z", fill: "black", style: {
    fill: "black",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M14.1413 11.6325C13.2014 11.5765 12.4022 12.166 11.9534 12.166C11.5043 12.166 10.8169 11.6607 10.0735 11.6744C9.10586 11.6886 8.20802 12.2357 7.717 13.1058C6.70704 14.8465 7.45047 17.4286 8.4326 18.8464C8.90954 19.5477 9.48434 20.32 10.2417 20.2923C10.9573 20.2642 11.2378 19.8289 12.1077 19.8289C12.9769 19.8289 13.2295 20.2923 13.987 20.2782C14.7726 20.2642 15.2637 19.5765 15.7406 18.8744C16.2878 18.0749 16.5118 17.3029 16.5259 17.2605C16.5118 17.2464 15.0111 16.6707 14.9972 14.9445C14.983 13.4991 16.1754 12.8116 16.2315 12.7689C15.5581 11.773 14.5061 11.6607 14.1413 11.6325Z", fill: "black", style: {
    fill: "black",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M22.3257 9.67615C24.3687 9.67615 25.7912 11.0843 25.7912 13.1346C25.7912 15.1921 24.3394 16.6076 22.2745 16.6076H20.0126V20.2047H18.3784V9.67615L22.3257 9.67615ZM20.0126 15.2359H21.8878C23.3106 15.2359 24.1204 14.4699 24.1204 13.1419C24.1204 11.8141 23.3106 11.0552 21.8951 11.0552H20.0126V15.2359Z", fill: "black", style: {
    fill: "black",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M26.2188 18.0229C26.2188 16.6803 27.2475 15.8559 29.0717 15.7537L31.1729 15.6297V15.0388C31.1729 14.1851 30.5965 13.6743 29.6335 13.6743C28.7213 13.6743 28.1522 14.112 28.0137 14.798H26.5253C26.6128 13.4116 27.7947 12.3901 29.6918 12.3901C31.5523 12.3901 32.7415 13.3751 32.7415 14.9146V20.2044H31.2312V18.9422H31.1949C30.7499 19.7959 29.7793 20.3357 28.7725 20.3357C27.2695 20.3357 26.2188 19.4018 26.2188 18.0229ZM31.1729 17.3298V16.7242L29.2831 16.8409C28.3419 16.9066 27.8093 17.3225 27.8093 17.9791C27.8093 18.6503 28.3638 19.0881 29.2102 19.0881C30.3119 19.0881 31.1729 18.3293 31.1729 17.3298Z", fill: "black", style: {
    fill: "black",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M34.1675 23.0281V21.7512C34.2841 21.7803 34.5467 21.7803 34.6781 21.7803C35.4077 21.7803 35.8017 21.4739 36.0424 20.686C36.0424 20.6713 36.1812 20.219 36.1812 20.2117L33.4087 12.5287H35.1158L37.0568 18.7744H37.0858L39.0268 12.5287H40.6903L37.8154 20.6056C37.159 22.4663 36.4002 23.0645 34.8096 23.0645C34.6781 23.0645 34.2841 23.0499 34.1675 23.0281Z", fill: "black", style: {
    fill: "black",
    fillOpacity: 1
  } })
] }));
const PaymentBancontactIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 38 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { id: "Group 845081165", children: [
      /* @__PURE__ */ jsx("path", { id: "rounded_white_background", d: "M1.3 0H36.4648C36.8096 0 37.1402 0.136963 37.384 0.38076C37.6278 0.624558 37.7648 0.955218 37.7648 1.3V24.7C37.7648 25.0448 37.6278 25.3754 37.384 25.6192C37.1402 25.863 36.8096 26 36.4648 26H1.3C0.955218 26 0.624558 25.863 0.380761 25.6192C0.136964 25.3754 0 25.0448 0 24.7V1.3C0 0.955219 0.136964 0.624559 0.380761 0.380761C0.624558 0.136964 0.955218 1.63433e-07 1.3 0Z", fill: "var(--fill-0, white)" }),
      /* @__PURE__ */ jsx("path", { id: "Bancontact", d: "M3.36328 22.5607V18.0771H4.74678C5.75239 18.0771 6.39931 18.455 6.39931 19.2365C6.39931 19.6784 6.19434 19.9859 5.90611 20.1652C6.32243 20.3573 6.56583 20.7288 6.56583 21.2349C6.56583 22.138 5.90611 22.5607 4.88129 22.5607L3.36328 22.5607ZM4.25359 19.941H4.91332C5.31683 19.941 5.48978 19.7425 5.48978 19.3774C5.48978 18.9867 5.17593 18.8586 4.75318 18.8586H4.25359V19.941ZM4.25359 21.7793H4.80442C5.34246 21.7793 5.65631 21.6448 5.65631 21.2221C5.65631 20.8057 5.3873 20.6328 4.88129 20.6328H4.25359V21.7793ZM8.29237 22.6376C7.41487 22.6376 6.97291 22.2084 6.97291 21.632C6.97291 20.9979 7.49173 20.6264 8.26034 20.62C8.45134 20.6235 8.64184 20.6406 8.83039 20.6712V20.5175C8.83039 20.1268 8.60622 19.941 8.17708 19.941C7.88798 19.9374 7.60091 19.9896 7.33159 20.0948L7.17147 19.403C7.44689 19.2877 7.88884 19.2108 8.27956 19.2108C9.22111 19.2108 9.68867 19.7105 9.68867 20.5751V22.3558C9.42607 22.4903 8.93288 22.6376 8.29237 22.6376ZM8.83039 21.9138V21.2285C8.68106 21.1952 8.52862 21.1781 8.37564 21.1772C8.08099 21.1772 7.85042 21.2925 7.85042 21.5936C7.85042 21.8626 8.04257 22.0035 8.38204 22.0035C8.5364 22.0085 8.68984 21.9778 8.83039 21.9138ZM10.311 22.5607V19.4927C10.7713 19.3078 11.2625 19.2121 11.7585 19.2108C12.6937 19.2108 13.2317 19.672 13.2317 20.5239V22.5607H12.3478V20.5879C12.3478 20.146 12.1428 19.941 11.7521 19.941C11.5581 19.9383 11.3658 19.9776 11.1885 20.0563V22.5607L10.311 22.5607ZM16.3206 19.403L16.1541 20.1012C15.9253 20.002 15.6796 19.9477 15.4303 19.941C14.9115 19.941 14.6297 20.3061 14.6297 20.9082C14.6297 21.5679 14.9243 21.9074 15.4752 21.9074C15.721 21.9007 15.9629 21.844 16.1861 21.7409L16.327 22.4518C16.037 22.5809 15.7221 22.6443 15.4047 22.6376C14.3415 22.6376 13.7266 21.9779 13.7266 20.9338C13.7266 19.8962 14.3351 19.2108 15.3535 19.2108C15.6855 19.2092 16.0145 19.2746 16.3206 19.403ZM18.2302 22.6376C17.2438 22.6376 16.6289 21.9522 16.6289 20.921C16.6289 19.8962 17.2438 19.2108 18.2302 19.2108C19.223 19.2108 19.825 19.8962 19.825 20.921C19.825 21.9522 19.223 22.6376 18.2302 22.6376ZM18.2302 21.9074C18.6849 21.9074 18.9219 21.5295 18.9219 20.921C18.9219 20.3189 18.6849 19.941 18.2302 19.941C17.7818 19.941 17.532 20.3189 17.532 20.921C17.532 21.5295 17.7818 21.9074 18.2302 21.9074ZM20.3365 22.5607V19.4927C20.7968 19.3078 21.2881 19.2121 21.7841 19.2108C22.7192 19.2108 23.2573 19.672 23.2573 20.5239V22.5607H22.3733V20.5879C22.3733 20.146 22.1684 19.941 21.7777 19.941C21.5837 19.9383 21.3914 19.9776 21.214 20.0563V22.5607L20.3365 22.5607ZM25.2507 22.6376C24.4885 22.6376 24.0978 22.2212 24.0978 21.3758V19.9923H23.6622V19.2877H24.0978V18.5767L24.9816 18.5319V19.2877H25.6926V19.9923H24.9816V21.363C24.9816 21.7345 25.1354 21.9074 25.4236 21.9074C25.5378 21.9071 25.6517 21.8942 25.7631 21.869L25.8079 22.5799C25.625 22.6205 25.438 22.6398 25.2507 22.6376ZM27.4817 22.6376C26.6042 22.6376 26.1622 22.2084 26.1622 21.632C26.1622 20.9979 26.6811 20.6264 27.4497 20.62C27.6407 20.6235 27.8312 20.6406 28.0197 20.6712V20.5175C28.0197 20.1268 27.7956 19.941 27.3664 19.941C27.0773 19.9374 26.7902 19.9896 26.5209 20.0948L26.3608 19.403C26.6362 19.2877 27.0782 19.2108 27.4689 19.2108C28.4104 19.2108 28.878 19.7105 28.878 20.5751V22.3558C28.6154 22.4903 28.1222 22.6376 27.4817 22.6376ZM28.0197 21.9138V21.2285C27.8704 21.1952 27.7179 21.1781 27.565 21.1772C27.2703 21.1772 27.0398 21.2925 27.0398 21.5936C27.0398 21.8626 27.2319 22.0035 27.5714 22.0035C27.7257 22.0085 27.8792 21.9778 28.0197 21.9138ZM31.9022 19.403L31.7356 20.1012C31.5068 20.002 31.2611 19.9477 31.0119 19.941C30.4931 19.941 30.2112 20.3061 30.2112 20.9082C30.2112 21.5679 30.5058 21.9074 31.0567 21.9074C31.3025 21.9007 31.5444 21.844 31.7677 21.7409L31.9086 22.4518C31.6186 22.5809 31.3036 22.6443 30.9862 22.6376C29.923 22.6376 29.3081 21.9779 29.3081 20.9338C29.3081 19.8962 29.9166 19.2108 30.935 19.2108C31.267 19.2092 31.596 19.2746 31.9022 19.403ZM33.8455 22.6376C33.0833 22.6376 32.6926 22.2212 32.6926 21.3758V19.9923H32.2571V19.2877H32.6926V18.5767L33.5765 18.5319V19.2877H34.2875V19.9923H33.5765V21.363C33.5765 21.7345 33.7302 21.9074 34.0185 21.9074C34.1327 21.9071 34.2465 21.8942 34.3579 21.869L34.4028 22.5799C34.2198 22.6205 34.0329 22.6398 33.8455 22.6376Z", fill: "var(--fill-0, #1E3764)" }),
      /* @__PURE__ */ jsx("path", { id: "blue-symbol", d: "M9.5287 15.8358C14.2059 15.8358 16.5444 12.7177 18.883 9.59961H3.36328V15.8358H9.5287Z", fill: `url(#${uid}paint0_linear_13120_20497)` }),
      /* @__PURE__ */ jsx("path", { id: "yellow-symbol", d: "M28.2369 3.36253C23.5598 3.36253 21.2212 6.48065 18.8826 9.59877H34.4024V3.36253H28.2369Z", fill: `url(#${uid}paint1_linear_13120_20497)` })
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_13120_20497`, x1: 6.50243, y1: 13.0056, x2: 17.8558, y2: 8.78866, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#005AB9" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#1E3764" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint1_linear_13120_20497`, x1: 19.8223, y1: 10.1397, x2: 31.8772, y2: 6.02681, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FBA900" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFD800" })
      ] })
    ] })
  ] }));
};
const PaymentCreditCardIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 48 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsx("g", { id: "Type=Creadit Card", children: /* @__PURE__ */ jsx("g", { id: "Credit Card", children: /* @__PURE__ */ jsxs("g", { clipPath: `url(#${uid}clip0_10269_4276)`, children: [
      /* @__PURE__ */ jsx("rect", { x: 1, y: 1, width: 46, height: 30, rx: 4, fill: "#006FCF", style: {
        fill: "#006FCF",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsxs("g", { id: "AX", children: [
        /* @__PURE__ */ jsx("path", { id: "Vector", d: "M24.1338 15.0936H26.2164V10.375H23.95V11.032L23.5212 10.375H21.5611V11.2112L21.1936 10.375H17.5797C17.4572 10.375 17.3347 10.4347 17.2122 10.4347C17.0897 10.4347 17.0284 10.4945 16.9059 10.5542C16.7834 10.6139 16.7221 10.6139 16.5996 10.6736V10.375H6.24783L5.94156 11.1515L5.6353 10.375H3.18517V11.2112L2.81765 10.375H0.857545L0 12.4058V15.0936H1.40882L1.65384 14.4365H2.14386L2.38888 15.0936H13.1694V14.4963L13.5982 15.0936H16.5996V14.7352C16.6609 14.7949 16.7834 14.7949 16.8446 14.8546C16.9059 14.9144 17.0284 14.9144 17.0897 14.9741C17.2122 15.0338 17.3347 15.0338 17.4572 15.0338H19.6623L19.9073 14.3768H20.3973L20.6423 15.0338H23.6437V14.4365L24.1338 15.0936ZM27.5027 21.0664V16.6465H10.6581L10.2293 17.2438L9.80052 16.6465H4.90026V21.365H9.80052L10.2293 20.7678L10.6581 21.365H13.7207V20.3497H13.5982C14.027 20.3497 14.3945 20.2899 14.7008 20.1705V21.4248H16.9059V20.8275L17.3347 21.4248H26.4614C26.8289 21.3053 27.1964 21.2456 27.5027 21.0664Z", fill: "white", style: {
          fill: "white",
          fillOpacity: 1
        } }),
        /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M26.4614 19.9315H24.8076V20.5885H26.4001C27.0739 20.5885 27.5027 20.1704 27.5027 19.5731C27.5027 18.9758 27.1352 18.6772 26.5226 18.6772H25.7876C25.6039 18.6772 25.4813 18.5577 25.4813 18.3785C25.4813 18.1993 25.6039 18.0799 25.7876 18.0799H27.1964L27.5027 17.4229H25.8489C25.1751 17.4229 24.7463 17.841 24.7463 18.3785C24.7463 18.9758 25.1138 19.2744 25.7264 19.2744H26.4614C26.6452 19.2744 26.7677 19.3939 26.7677 19.5731C26.8289 19.812 26.7064 19.9315 26.4614 19.9315ZM23.46 19.9315H21.8062V20.5885H23.3987C24.0725 20.5885 24.5013 20.1704 24.5013 19.5731C24.5013 18.9758 24.1338 18.6772 23.5212 18.6772H22.7862C22.6024 18.6772 22.4799 18.5577 22.4799 18.3785C22.4799 18.1993 22.6024 18.0799 22.7862 18.0799H24.195L24.5013 17.4229H22.8475C22.1737 17.4229 21.7449 17.841 21.7449 18.3785C21.7449 18.9758 22.1124 19.2744 22.7249 19.2744H23.46C23.6437 19.2744 23.7663 19.3939 23.7663 19.5731C23.8275 19.812 23.6437 19.9315 23.46 19.9315ZM21.3161 18.0201V17.3631H18.7435V20.5287H21.3161V19.8717H19.4785V19.2147H21.2549V18.5577H19.4785V17.9604H21.3161V18.0201ZM17.1509 18.0201C17.4572 18.0201 17.5797 18.1993 17.5797 18.3785C17.5797 18.5577 17.4572 18.7369 17.1509 18.7369H16.2321V17.9604L17.1509 18.0201ZM16.2321 19.3939H16.5996L17.5797 20.5287H18.4985L17.3959 19.3342C17.9472 19.2147 18.2535 18.8563 18.2535 18.3785C18.2535 17.7812 17.8247 17.3631 17.1509 17.3631H15.4358V20.5287H16.1709L16.2321 19.3939ZM14.272 18.4382C14.272 18.6772 14.1495 18.8563 13.8432 18.8563H12.8632V18.0201H13.782C14.0882 18.0201 14.272 18.1993 14.272 18.4382ZM12.1281 17.3631V20.5287H12.8632V19.4536H13.8432C14.517 19.4536 15.007 19.0355 15.007 18.3785C15.007 17.7812 14.5783 17.3034 13.9045 17.3034L12.1281 17.3631ZM11.0256 20.5287H11.9444L10.6581 18.9161L11.9444 17.3631H11.0256L10.2293 18.3785L9.433 17.3631H8.5142L9.80052 18.9161L8.5142 20.469H9.433L10.2293 19.4536L11.0256 20.5287ZM8.26919 18.0201V17.3631H5.69655V20.5287H8.26919V19.8717H6.43159V19.2147H8.20793V18.5577H6.43159V17.9604H8.26919V18.0201ZM23.1537 12.4057L24.44 14.317H25.3588V11.1514H24.6238V13.2419L24.44 12.9432L23.2762 11.1514H22.2962V14.317H23.0312V12.1668L23.1537 12.4057ZM19.9686 12.3459L20.2136 11.6889L20.4586 12.3459L20.7648 13.0627H19.6623L19.9686 12.3459ZM21.2549 14.317H22.0512L20.6423 11.1514H19.6623L18.2535 14.317H19.0498L19.356 13.66H20.9486L21.2549 14.317ZM17.8247 14.317L18.131 13.66H17.9472C17.3959 13.66 17.0897 13.3016 17.0897 12.764V12.7043C17.0897 12.1668 17.3959 11.8084 17.9472 11.8084H18.7435V11.1514H17.8859C16.9059 11.1514 16.3546 11.8084 16.3546 12.7043V12.764C16.3546 13.7197 16.9059 14.317 17.8247 14.317ZM15.0683 14.317H15.8033V11.2111H15.0683V14.317ZM13.4757 11.8084C13.782 11.8084 13.9045 11.9876 13.9045 12.1668C13.9045 12.3459 13.782 12.5251 13.4757 12.5251H12.5569V11.7487L13.4757 11.8084ZM12.5569 13.1821H12.9244L13.9045 14.317H14.8233L13.7207 13.1224C14.272 13.003 14.5783 12.6446 14.5783 12.1668C14.5783 11.5695 14.1495 11.1514 13.4757 11.1514H11.7606V14.317H12.4957L12.5569 13.1821ZM11.2093 11.8084V11.1514H8.63671V14.317H11.2093V13.66H9.37175V13.003H11.1481V12.3459H9.37175V11.7487H11.2093V11.8084ZM5.6353 14.317H6.30908L7.22788 11.7487V14.317H7.96292V11.1514H6.73786L6.00282 13.3016L5.26778 11.1514H4.04271V14.317H4.77775V11.7487L5.6353 14.317ZM1.65384 12.3459L1.89885 11.6889L2.14386 12.3459L2.45013 13.0627H1.34757L1.65384 12.3459ZM2.94016 14.317H3.73645L2.32762 11.1514H1.40882L0 14.317H0.796292L1.10256 13.66H2.69514L2.94016 14.317Z", fill: "#006FCF", style: {
          fill: "#006FCF",
          fillOpacity: 1
        } })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "VISA", children: [
        /* @__PURE__ */ jsx("mask", { id: `${uid}mask0_10269_4276`, style: {
          maskType: "alpha"
        }, maskUnits: "userSpaceOnUse", x: 11, y: 0, width: 36, height: 32, children: /* @__PURE__ */ jsx("path", { id: "mask", d: "M20 0H47V32H11L20 0Z", fill: "#21569A", style: {
          fill: "#21569A",
          fillOpacity: 1
        } }) }),
        /* @__PURE__ */ jsxs("g", { mask: `url(#${uid}mask0_10269_4276)`, children: [
          /* @__PURE__ */ jsx("path", { id: "bg", d: "M20 0H47V32H11L20 0Z", fill: "#1334CB", style: {
            fill: "#1334CB",
            fillOpacity: 1
          } }),
          /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M22.8543 11.4309L20.851 20.5933H18.4244L20.4276 11.4309H22.8524H22.8543ZM33.0536 17.3471L34.3287 13.9057L35.0626 17.3471H33.0546H33.0536ZM35.7594 20.5933H38L36.0414 11.4309H33.9755C33.5084 11.4309 33.1163 11.6958 32.9426 12.1028L29.3045 20.5933H31.8508L32.3558 19.2254H35.4661L35.7604 20.5933H35.7594ZM29.4298 17.6023C29.4393 15.1836 26.012 15.0502 26.0338 13.9675C26.0414 13.6408 26.3613 13.2908 27.062 13.2009C27.4085 13.1574 28.3655 13.1236 29.4516 13.6118L29.877 11.6687C29.2931 11.4618 28.5431 11.2627 27.6079 11.2627C25.2126 11.2627 23.5255 12.5078 23.5131 14.2914C23.498 15.61 24.717 16.3456 25.6341 16.7855C26.5797 17.234 26.8968 17.5221 26.8921 17.9233C26.8864 18.5381 26.1392 18.8107 25.4433 18.8204C24.2233 18.8397 23.516 18.4985 22.953 18.2404L22.5144 20.2511C23.0821 20.5044 24.1284 20.7248 25.2107 20.7364C27.757 20.7364 29.4231 19.5058 29.4307 17.6014L29.4298 17.6023ZM19.3909 11.4299L15.4623 20.5923H12.8989L10.9678 13.2821C10.851 12.8317 10.7495 12.6663 10.3925 12.4759C9.8086 12.1666 8.84496 11.8766 8 11.6967L8.05696 11.4309H12.1821C12.7081 11.4309 13.1809 11.7731 13.3005 12.3647L14.322 17.6681L16.8427 11.4328H19.3899L19.3909 11.4299Z", fill: "white", style: {
            fill: "white",
            fillOpacity: 1
          } })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "MC", children: [
        /* @__PURE__ */ jsx("mask", { id: `${uid}mask1_10269_4276`, style: {
          maskType: "alpha"
        }, maskUnits: "userSpaceOnUse", x: 28, y: 0, width: 20, height: 32, children: /* @__PURE__ */ jsx("path", { id: "mask_2", d: "M37 0H48V32H28L37 0Z", fill: "#3E3939", style: {
          fill: "#3E3939",
          fillOpacity: 1
        } }) }),
        /* @__PURE__ */ jsxs("g", { mask: `url(#${uid}mask1_10269_4276)`, children: [
          /* @__PURE__ */ jsx("path", { id: "bg_2", d: "M37 0H48V32H28L37 0Z", fill: "#141413", style: {
            fill: "#141413",
            fillOpacity: 1
          } }),
          /* @__PURE__ */ jsxs("g", { id: "Group 845081166", children: [
            /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M43.332 11.7832H38.082V21.2182H43.332V11.7832Z", fill: "#FF5F00", style: {
              fill: "#FF5F00",
              fillOpacity: 1
            } }),
            /* @__PURE__ */ jsx("path", { id: "Vector_5", d: "M38.4167 16.5C38.4167 14.5867 39.3133 12.8817 40.7083 11.7833C39.6883 10.98 38.4 10.5 37 10.5C33.6867 10.5 31 13.1867 31 16.5C31 19.8133 33.6867 22.5 37 22.5C38.4 22.5 39.6867 22.02 40.7083 21.2167C39.3133 20.1183 38.4167 18.4133 38.4167 16.5Z", fill: "#EB001B", style: {
              fill: "#EB001B",
              fillOpacity: 1
            } }),
            /* @__PURE__ */ jsx("path", { id: "Vector_6", d: "M50.4163 16.5C50.4163 19.8133 47.7297 22.5 44.4163 22.5C43.0163 22.5 41.7297 22.02 40.708 21.2167C42.103 20.1183 42.9997 18.4133 42.9997 16.5C42.9997 14.5867 42.103 12.8817 40.708 11.7833C41.728 10.98 43.0163 10.5 44.4163 10.5C47.7297 10.5 50.4163 13.1867 50.4163 16.5Z", fill: "#F79E1B", style: {
              fill: "#F79E1B",
              fillOpacity: 1
            } })
          ] })
        ] })
      ] })
    ] }) }) }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: `${uid}clip0_10269_4276`, children: /* @__PURE__ */ jsx("rect", { x: 1, y: 1, width: 46, height: 30, rx: 4, fill: "white", style: {
      fill: "white",
      fillOpacity: 1
    } }) }) })
  ] }));
};
const PaymentDotpayIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 40 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M5.1417 2.58533V0.00198841H6.74952V9.58383C6.71816 9.58717 6.69055 9.5927 6.66295 9.59266C5.47462 9.59152 4.28609 9.60326 3.09807 9.58296C2.45956 9.57198 1.83263 9.47018 1.2884 9.08652C0.628448 8.62124 0.273369 7.96414 0.115369 7.19201C-0.0835007 6.22031 -0.0387024 5.26339 0.355316 4.34065C0.812259 3.27046 1.64689 2.71064 2.78466 2.62689C3.49289 2.57473 4.20656 2.59658 4.91775 2.5855C4.98608 2.58443 5.05442 2.58533 5.1417 2.58533V2.58533ZM5.13057 8.27769V3.89626C4.50068 3.89626 3.88094 3.86826 3.26483 3.90344C2.51632 3.94618 1.96523 4.44103 1.78059 5.17081C1.62555 5.78373 1.63679 6.4003 1.78638 7.01022C1.95789 7.70948 2.38633 8.19529 3.11493 8.26437C3.77804 8.32726 4.45181 8.27769 5.13057 8.27769V8.27769ZM10.8992 9.66218C8.92675 9.66015 7.3259 8.0437 7.32752 6.05575C7.32911 4.08377 8.94994 2.47676 10.9322 2.48173C12.9028 2.4867 14.4982 4.10566 14.4953 6.09752C14.4924 8.05879 12.8729 9.66422 10.8992 9.66218ZM10.891 8.07215C11.304 8.07215 11.717 8.07277 12.13 8.07191C12.3619 8.07142 12.5297 7.90673 12.5302 7.6773C12.5313 7.15438 12.5271 6.63145 12.5327 6.10857C12.5343 5.95733 12.4741 5.84538 12.3469 5.7878C12.2469 5.74254 12.2357 5.68061 12.2367 5.5882C12.2404 5.23774 12.2408 4.88715 12.2374 4.53665C12.2343 4.22106 12.0457 4.03524 11.7367 4.03517C11.1802 4.03507 10.6238 4.0351 10.0674 4.03517C9.74277 4.0352 9.56165 4.2154 9.56003 4.54432C9.55827 4.90057 9.5633 5.25697 9.55558 5.61305C9.55444 5.66573 9.51206 5.73612 9.46726 5.76574C9.33262 5.85487 9.2545 5.96023 9.2565 6.13135C9.26253 6.64271 9.25781 7.15417 9.25905 7.6656C9.2596 7.90227 9.43152 8.07153 9.66916 8.07194C10.0764 8.07267 10.4837 8.07215 10.891 8.07215V8.07215ZM10.0788 5.72297C10.0788 5.42274 10.0723 5.1249 10.0813 4.82757C10.0865 4.65279 10.2289 4.5252 10.4154 4.52161C10.7369 4.51543 11.0587 4.51484 11.3801 4.52185C11.5801 4.5262 11.7112 4.66183 11.7154 4.86361C11.7213 5.14533 11.7169 5.42723 11.7169 5.72297H10.0788ZM19.1227 8.31154V9.59309C18.8556 9.59309 18.5926 9.6 18.3301 9.59157C17.8551 9.57638 17.3748 9.59043 16.9068 9.52253C16.1947 9.41917 15.7403 8.92373 15.6365 8.20228C15.5934 7.90205 15.5691 7.59664 15.5668 7.29334C15.5586 6.21788 15.5636 5.14231 15.5636 4.06677V3.87263H14.3005V2.591H15.5573V0H17.1838V2.58344H19.122V3.86151H17.1875V4.06605C17.1875 5.08407 17.1843 6.10209 17.1901 7.12008C17.1913 7.32555 17.2103 7.53392 17.2493 7.73545C17.318 8.0896 17.4936 8.24978 17.8581 8.27836C18.2005 8.30518 18.5453 8.30208 18.8891 8.31122C18.9626 8.31323 19.0363 8.31154 19.1227 8.31154V8.31154Z", fill: "var(--fill-0, #801617)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", fillRule: "evenodd", clipRule: "evenodd", d: "M33.7874 2.58631H35.4087C35.4087 2.64735 35.4087 2.70807 35.4087 2.76883C35.4098 4.13202 35.4039 5.49529 35.4178 6.85831C35.4206 7.13462 35.4764 7.41583 35.5463 7.68475C35.6443 8.0622 35.9319 8.25023 36.3029 8.27737C36.7254 8.30823 37.1507 8.30346 37.5748 8.31013C37.8373 8.31427 38.1 8.31092 38.3735 8.31092V2.59401H39.9873C39.9905 2.61566 39.9994 2.64766 39.9994 2.67962C39.9984 4.90557 40.0015 7.13155 39.9913 9.35742C39.9892 9.81669 39.9032 10.2679 39.7307 10.6996C39.4531 11.3944 38.9271 11.7676 38.205 11.8666C37.8487 11.9155 37.486 11.9343 37.1259 11.9373C36.0753 11.9463 35.0245 11.9405 33.9737 11.9405H33.7962V10.6632C33.8594 10.6632 33.9208 10.6633 33.9822 10.6632C35.1018 10.6616 36.2214 10.6623 37.341 10.6557C37.5056 10.6548 37.6736 10.635 37.8335 10.5966C38.1427 10.5223 38.3083 10.3186 38.3428 10.0051C38.3571 9.87468 38.3704 9.74423 38.3863 9.59306H38.2035C37.5834 9.59306 36.9627 9.60884 36.3434 9.58695C35.9914 9.57452 35.6325 9.53586 35.2928 9.44728C34.4518 9.228 33.8748 8.51049 33.8301 7.63942C33.7966 6.98556 33.7931 6.32983 33.7891 5.67483C33.7828 4.65139 33.7874 3.62788 33.7874 2.58631V2.58631ZM19.6387 2.58529C20.4107 2.58529 21.1734 2.58163 21.9361 2.58657C22.4636 2.58995 22.9914 2.59682 23.5185 2.61677C24.8857 2.66855 25.7371 3.55388 26.0457 4.6086C26.4009 5.82246 26.3741 7.02209 25.7846 8.16574C25.3282 9.05116 24.5736 9.50805 23.5879 9.55417C22.8491 9.58876 22.1083 9.58168 21.3684 9.59304C21.3347 9.59356 21.301 9.59311 21.254 9.59311V12H19.6387V2.58529ZM21.2611 3.89332V8.28055C21.8574 8.28055 22.4426 8.30558 23.0248 8.27437C23.782 8.23378 24.255 7.81735 24.4536 7.08323C24.5994 6.54429 24.6257 5.99706 24.5519 5.446C24.4267 4.51149 23.8879 3.96913 22.9566 3.90085C22.3986 3.85991 21.8351 3.89332 21.2611 3.89332V3.89332ZM31.6099 5.32807C31.5854 5.06534 31.5916 4.80909 31.5323 4.56913C31.4298 4.15498 31.1231 3.95093 30.7119 3.90153C30.5359 3.88037 30.3577 3.86956 30.1805 3.86908C29.1241 3.86615 28.0676 3.86763 27.0111 3.86763H26.8113V2.59792C26.8364 2.59433 26.8685 2.5858 26.9005 2.5858C28.1981 2.58618 29.4958 2.57779 30.7932 2.59478C31.1451 2.59937 31.5074 2.64017 31.8449 2.73559C32.583 2.94423 32.9868 3.48573 33.1319 4.21857C33.194 4.53168 33.2194 4.85659 33.2214 5.17642C33.2306 6.61429 33.2254 8.05226 33.2254 9.49023V9.58495C33.1703 9.58813 33.1265 9.59286 33.0827 9.59286C31.6358 9.59217 30.1889 9.59638 28.7421 9.58547C28.4465 9.5833 28.1473 9.5446 27.8567 9.48702C27.3304 9.3827 26.9322 9.07038 26.702 8.59486C26.5121 8.20277 26.4265 7.76991 26.4692 7.32577C26.51 6.90171 26.5867 6.48477 26.8347 6.12565C27.1562 5.66013 27.6225 5.41876 28.1703 5.38814C28.9714 5.3434 29.775 5.34368 30.5775 5.32904C30.9094 5.32303 31.2414 5.32807 31.6099 5.32807V5.32807ZM31.5832 6.6243C30.6698 6.6243 29.7699 6.61612 28.8702 6.62786C28.4407 6.63348 28.1483 6.93516 28.1086 7.36502C28.0628 7.86108 28.2545 8.14723 28.7158 8.24772C28.8823 8.284 29.0551 8.30647 29.2252 8.30813C29.9133 8.31482 30.6014 8.31089 31.2895 8.31089H31.5832V6.6243Z", fill: "var(--fill-0, #040504)" })
] }) }));
const PaymentGiropayIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 48 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M24 0H44.9829C46.6492 0 48 1.26414 48 2.82353V29.1765C48 30.7359 46.6492 32 44.9829 32H24V0Z", fill: "var(--fill-0, #000268)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", fillRule: "evenodd", clipRule: "evenodd", d: "M2.75478 0H24V32H2.75478C1.23336 32 0 30.7359 0 29.1765V2.82353C0 1.26414 1.23336 0 2.75478 0Z", fill: "var(--fill-0, white)" }),
  /* @__PURE__ */ jsxs("g", { id: "layer1", children: [
    /* @__PURE__ */ jsx("path", { id: "_92186184", fillRule: "evenodd", clipRule: "evenodd", d: "M29.8843 16.0148C29.8843 16.8958 29.4486 17.5013 28.7272 17.5013C28.0898 17.5013 27.5585 16.8958 27.5585 16.089C27.5585 15.2609 28.0258 14.6452 28.7272 14.6452C29.4709 14.6452 29.8843 15.2822 29.8843 16.0148ZM25.6484 21.0677H27.5585V18.0631H27.5799C27.9417 18.7215 28.6641 18.9655 29.3327 18.9655C30.9778 18.9655 31.8588 17.607 31.8588 15.9721C31.8588 14.635 31.0205 13.1797 29.4913 13.1797C28.6214 13.1797 27.8146 13.5304 27.4315 14.3056H27.4101V13.3081H25.6484V21.0677ZM34.4677 17.0866C34.4677 16.5562 34.9767 16.3553 35.6252 16.3553C35.9115 16.3553 36.188 16.3753 36.432 16.3868C36.432 17.034 35.9756 17.6924 35.2532 17.6924C34.8073 17.6924 34.4677 17.4697 34.4677 17.0866ZM38.3208 18.8384C38.2364 18.4036 38.215 17.9676 38.215 17.5328V15.4733C38.215 13.7855 36.9948 13.1797 35.5825 13.1797C34.7655 13.1797 34.0543 13.2966 33.3746 13.573L33.4071 14.8688C33.9361 14.5709 34.5531 14.4541 35.1688 14.4541C35.8577 14.4541 36.4205 14.6563 36.432 15.4102C36.188 15.3676 35.8475 15.3351 35.5398 15.3351C34.5216 15.3351 32.6847 15.5373 32.6847 17.2248C32.6847 18.425 33.6609 18.9655 34.7544 18.9655C35.5398 18.9655 36.0711 18.6588 36.5062 17.9676H36.5275C36.5275 18.2552 36.5587 18.5406 36.5702 18.8384H38.3208ZM39.1804 21.0677C39.5734 21.153 39.9659 21.196 40.3691 21.196C42.1209 21.196 42.5343 19.8474 43.0758 18.4565L45.1041 13.3081H43.1927L42.0569 16.9171H42.0356L40.8465 13.3081H38.788L41.0275 18.9655C40.8892 19.4541 40.5287 19.7305 40.0611 19.7305C39.7948 19.7305 39.5623 19.698 39.3072 19.6137L39.1804 21.0677Z", fill: "var(--fill-0, white)" }),
    /* @__PURE__ */ jsx("path", { id: "_47303032", fillRule: "evenodd", clipRule: "evenodd", d: "M3.57375 16.0214C3.57375 15.2674 3.94577 14.6406 4.657 14.6406C5.51668 14.6406 5.87724 15.3305 5.87724 15.9462C5.87724 16.7957 5.33576 17.3687 4.657 17.3687C4.084 17.3687 3.57375 16.881 3.57375 16.0214ZM7.72461 13.3035H5.99413V14.3011H5.97406C5.56954 13.6214 4.91086 13.1751 4.0942 13.1751C2.37485 13.1751 1.59961 14.4078 1.59961 16.0529C1.59961 17.6878 2.54463 18.8338 4.06139 18.8338C4.82677 18.8338 5.4638 18.536 5.91991 17.8888H5.94125V18.1866C5.94125 19.2689 5.34691 19.789 4.24358 19.789C3.44697 19.789 2.95806 19.6193 2.37485 19.3329L2.27931 20.8408C2.72428 21.0003 3.4782 21.1915 4.39201 21.1915C6.62128 21.1915 7.72461 20.4586 7.72461 18.1866V13.3035ZM10.954 11H9.04293V12.4011H10.954V11ZM9.04389 18.8338H10.954V13.3035H9.04389V18.8338ZM16.2744 13.2392C16.0833 13.2079 15.8495 13.1751 15.6272 13.1751C14.7991 13.1751 14.3217 13.6214 13.9923 14.3224H13.971V13.3035H12.2303V18.8338H14.1407V16.4991C14.1407 15.4159 14.6405 14.7686 15.5317 14.7686C15.7553 14.7686 15.9664 14.7686 16.1789 14.8314L16.2744 13.2392ZM19.5644 17.6238C18.6834 17.6238 18.3228 16.8912 18.3228 16.0742C18.3228 15.2461 18.6834 14.5135 19.5644 14.5135C20.4464 14.5135 20.8072 15.2461 20.8072 16.0742C20.8072 16.8912 20.4464 17.6238 19.5644 17.6238ZM19.5644 18.9609C21.3904 18.9609 22.7814 17.9003 22.7814 16.0742C22.7814 14.237 21.3904 13.1751 19.5644 13.1751C17.7387 13.1751 16.3487 14.237 16.3487 16.0742C16.3487 17.9003 17.7387 18.9609 19.5644 18.9609Z", fill: "var(--fill-0, #FF0007)" })
  ] })
] }) }));
const PaymentGooglePayIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 48 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M34.7099 4H13.2903C6.59671 4 1.12012 9.4766 1.12012 16.1702C1.12012 22.8638 6.59671 28.3404 13.2903 28.3404H34.7099C41.4035 28.3404 46.8801 22.8638 46.8801 16.1702C46.8801 9.4766 41.4035 4 34.7099 4Z", fill: "white", style: {
    fill: "white",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M34.7099 4.98579C36.2129 4.98579 37.6733 5.28396 39.0486 5.86813C40.3812 6.43404 41.5739 7.24336 42.6084 8.27175C43.6368 9.30013 44.4461 10.4989 45.012 11.8315C45.5962 13.2068 45.8943 14.6672 45.8943 16.1702C45.8943 17.6732 45.5962 19.1337 45.012 20.5089C44.4461 21.8415 43.6368 23.0342 42.6084 24.0687C41.58 25.0971 40.3812 25.9064 39.0486 26.4723C37.6733 27.0565 36.2129 27.3546 34.7099 27.3546H13.2903C11.7873 27.3546 10.3269 27.0565 8.95165 26.4723C7.61901 25.9064 6.42633 25.0971 5.39186 24.0687C4.36348 23.0403 3.55416 21.8415 2.98824 20.5089C2.40407 19.1337 2.1059 17.6732 2.1059 16.1702C2.1059 14.6672 2.40407 13.2068 2.98824 11.8315C3.55416 10.4989 4.36348 9.30621 5.39186 8.27175C6.42024 7.24336 7.61901 6.43404 8.95165 5.86813C10.3269 5.28396 11.7873 4.98579 13.2903 4.98579H34.7099ZM34.7099 4H13.2903C6.59671 4 1.12012 9.4766 1.12012 16.1702C1.12012 22.8638 6.59671 28.3404 13.2903 28.3404H34.7099C41.4035 28.3404 46.8801 22.8638 46.8801 16.1702C46.8801 9.4766 41.4035 4 34.7099 4Z", fill: "#3C4043", style: {
    fill: "#3C4043",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M22.9423 17.0319V20.7133H21.7739V11.6222H24.8712C25.6562 11.6222 26.3256 11.8839 26.8732 12.4072C27.4331 12.9305 27.713 13.5694 27.713 14.324C27.713 15.0968 27.4331 15.7357 26.8732 16.253C26.3317 16.7702 25.6623 17.0258 24.8712 17.0258H22.9423V17.0319ZM22.9423 12.7419V15.9122H24.8956C25.3581 15.9122 25.7475 15.754 26.0518 15.4436C26.3621 15.1333 26.5203 14.756 26.5203 14.3301C26.5203 13.9102 26.3621 13.539 26.0518 13.2287C25.7475 12.9062 25.3641 12.7479 24.8956 12.7479H22.9423V12.7419Z", fill: "#3C4043", style: {
    fill: "#3C4043",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M30.7677 14.2896C31.6318 14.2896 32.3133 14.5208 32.8123 14.9833C33.3112 15.4457 33.5607 16.0786 33.5607 16.8818V20.7154H32.4472V19.8513H32.3985C31.9178 20.5633 31.2727 20.9162 30.4695 20.9162C29.7819 20.9162 29.2099 20.7154 28.7474 20.3077C28.2849 19.9 28.0537 19.395 28.0537 18.7864C28.0537 18.1414 28.2971 17.6303 28.7839 17.253C29.2707 16.8696 29.9218 16.681 30.7312 16.681C31.4249 16.681 31.9969 16.8088 32.4411 17.0644V16.7966C32.4411 16.3889 32.2829 16.0481 31.9603 15.7621C31.6378 15.4761 31.2606 15.3362 30.8285 15.3362C30.1774 15.3362 29.6602 15.61 29.2829 16.1638L28.2545 15.5187C28.8204 14.6973 29.6602 14.2896 30.7677 14.2896ZM29.2586 18.8047C29.2586 19.109 29.3863 19.3645 29.648 19.5653C29.9036 19.7661 30.2078 19.8696 30.5547 19.8696C31.0476 19.8696 31.4857 19.687 31.8691 19.3219C32.2524 18.9568 32.4472 18.5309 32.4472 18.038C32.0821 17.752 31.577 17.6059 30.9259 17.6059C30.4512 17.6059 30.0557 17.7216 29.7393 17.9467C29.4168 18.184 29.2586 18.47 29.2586 18.8047Z", fill: "#3C4043", style: {
    fill: "#3C4043",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M39.9153 14.4875L36.0208 23.4448H34.816L36.2642 20.311L33.6963 14.4875H34.9681L36.8179 18.954H36.8423L38.6435 14.4875H39.9153Z", fill: "#3C4043", style: {
    fill: "#3C4043",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M18.294 16.2931C18.294 15.9121 18.2599 15.5476 18.1966 15.1971H13.2993V17.2052L16.1198 17.2058C16.0054 17.874 15.6372 18.4435 15.0731 18.8233V20.1261H16.752C17.7323 19.2188 18.294 17.8776 18.294 16.2931Z", fill: "#4285F4", style: {
    fill: "#4285F4",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M15.0745 18.8219C14.6072 19.1371 14.0054 19.3215 13.3013 19.3215C11.9413 19.3215 10.7876 18.4051 10.3744 17.1698H8.64258V18.5134C9.50058 20.216 11.264 21.3843 13.3013 21.3843C14.7094 21.3843 15.8924 20.9213 16.7534 20.1241L15.0745 18.8219Z", fill: "#34A853", style: {
    fill: "#34A853",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M10.211 16.1719C10.211 15.825 10.2688 15.4897 10.3741 15.1745V13.8309H8.64224C8.28748 14.535 8.08789 15.3297 8.08789 16.1719C8.08789 17.0141 8.28809 17.8088 8.64224 18.5128L10.3741 17.1692C10.2688 16.854 10.211 16.5187 10.211 16.1719Z", fill: "#FABB05", style: {
    fill: "#FABB05",
    fillOpacity: 1
  } }),
  /* @__PURE__ */ jsx("path", { d: "M13.3013 13.0243C14.0699 13.0243 14.7581 13.289 15.3015 13.8062L16.7893 12.3196C15.8857 11.4781 14.7076 10.9614 13.3013 10.9614C11.2647 10.9614 9.50058 12.1298 8.64258 13.8324L10.3744 15.176C10.7876 13.9407 11.9413 13.0243 13.3013 13.0243Z", fill: "#E94235", style: {
    fill: "#E94235",
    fillOpacity: 1
  } })
] }));
const PaymentIdealIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 33 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { id: "ideal 1", clipPath: `url(#${uid}clip0_13120_20622)`, children: [
      /* @__PURE__ */ jsx("path", { id: "Vector", d: "M8.79492 4.57208V24.9652H17.673C25.7377 24.9652 29.2346 20.4082 29.2346 13.9787C29.2346 7.82043 25.7381 3.03418 17.673 3.03418H10.3325C10.1305 3.03418 9.93056 3.07396 9.744 3.15125C9.55743 3.22854 9.38792 3.34183 9.24514 3.48464C9.10236 3.62745 8.98911 3.79699 8.91186 3.98358C8.83461 4.17016 8.79488 4.37014 8.79492 4.57208Z", fill: "var(--fill-0, #CC0066)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M2.3065 0.7686C1.89874 0.768971 1.50778 0.931118 1.21945 1.21945C0.931118 1.50778 0.768971 1.89874 0.7686 2.3065V25.6935C0.768971 26.1013 0.931118 26.4922 1.21945 26.7805C1.50778 27.0689 1.89874 27.231 2.3065 27.2314H16.6537C26.2426 27.2314 31.5241 22.5211 31.5241 13.9685C31.5241 2.48325 22.2071 0.7686 16.6537 0.7686H2.3065ZM16.6537 28H2.3065C1.69498 27.9994 1.10869 27.7561 0.676274 27.3237C0.243862 26.8913 0.000648536 26.305 0 25.6935L0 2.3065C0.000648536 1.69498 0.243862 1.10869 0.676274 0.676274C1.10869 0.243862 1.69498 0.000648536 2.3065 0L16.6537 0C30.261 0 32.2927 8.7514 32.2927 13.9685C32.2927 23.017 26.7389 28 16.6537 28Z", fill: "var(--fill-0, black)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M11.8458 15.197C12.0001 15.197 12.1503 15.1718 12.2962 15.1221C12.4418 15.0721 12.5713 14.9891 12.6847 14.8729C12.7988 14.7574 12.8898 14.6059 12.9577 14.4193C13.026 14.2331 13.0603 14.0053 13.0603 13.7368C13.0603 13.4911 13.0361 13.2696 12.9889 13.0718C12.9475 12.8874 12.8672 12.714 12.7533 12.5633C12.6398 12.4193 12.4905 12.3075 12.3204 12.2392C12.1401 12.1639 11.9186 12.1265 11.655 12.1265H10.8906V15.1974H11.8461L11.8458 15.197ZM11.921 11.2259C12.2346 11.2259 12.5272 11.2763 12.7974 11.3764C13.062 11.4725 13.3021 11.6261 13.5002 11.8262C13.6983 12.0264 13.8527 12.2766 13.9647 12.5769C14.0756 12.8772 14.1316 13.2297 14.1316 13.6346C14.1316 13.9895 14.0861 14.3171 13.9951 14.6174C13.9041 14.917 13.7666 15.1767 13.5825 15.3948C13.3943 15.6163 13.1586 15.7925 12.893 15.9103C12.6179 16.0356 12.2938 16.0979 11.921 16.0979H9.81925V11.2259H11.921ZM18.4856 11.2263V12.1265H15.9135V13.1705H18.2739V14.0032H15.9135V15.1974H18.5402V16.0979H14.8421V11.2259L18.4856 11.2263ZM22.2152 14.2146L21.601 12.4268H21.5873L20.9531 14.2146H22.2152ZM22.154 11.2259L23.9754 16.0979H22.8634L22.4949 15.0129H20.6728L20.2909 16.0979H19.2129L21.0553 11.2259H22.154ZM25.7205 11.2263V15.197H28.0949V16.0976H24.6491V11.2256H25.7201L25.7205 11.2263Z", fill: "var(--fill-0, white)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M7.03083 13.6614C7.03083 13.9565 6.9727 14.2488 6.85976 14.5214C6.74682 14.7941 6.58128 15.0418 6.3726 15.2505C6.16391 15.4592 5.91617 15.6248 5.64351 15.7377C5.37085 15.8506 5.07861 15.9088 4.78348 15.9088C4.48836 15.9088 4.19612 15.8506 3.92346 15.7377C3.6508 15.6248 3.40305 15.4592 3.19437 15.2505C2.98568 15.0418 2.82014 14.7941 2.7072 14.5214C2.59426 14.2488 2.53613 13.9565 2.53613 13.6614C2.53613 13.0654 2.77291 12.4938 3.19437 12.0723C3.61583 11.6508 4.18745 11.4141 4.78348 11.4141C5.37952 11.4141 5.95114 11.6508 6.3726 12.0723C6.79406 12.4938 7.03083 13.0654 7.03083 13.6614ZM6.48553 24.965C4.60498 24.965 3.08003 23.4404 3.08003 21.5595V18.9037C3.08003 18.4521 3.25943 18.019 3.57876 17.6997C3.89808 17.3804 4.33119 17.201 4.78278 17.201C5.23438 17.201 5.66748 17.3804 5.98681 17.6997C6.30614 18.019 6.48553 18.4521 6.48553 18.9037V24.965Z", fill: "var(--fill-0, black)" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: `${uid}clip0_13120_20622`, children: /* @__PURE__ */ jsx("rect", { width: 32.55, height: 28, fill: "white" }) }) })
  ] }));
};
const PaymentKlarnaIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 48 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Lager 2", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M42.3656 0H5.63443C2.52262 0 0 2.52262 0 5.63443V13.7813C0 16.8931 2.52262 19.4157 5.63443 19.4157H42.3656C45.4774 19.4157 48 16.8931 48 13.7813V5.63443C48 2.52262 45.4774 0 42.3656 0Z", fill: "var(--fill-0, #FFB3C7)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M38.4373 8.50738C37.9905 8.20292 37.4691 8.02606 36.9293 7.99586C36.3894 7.96565 35.8516 8.08322 35.3736 8.33593C34.8956 8.58865 34.4955 8.96692 34.2165 9.43006C33.9375 9.89319 33.79 10.4236 33.79 10.9643C33.79 11.505 33.9375 12.0355 34.2165 12.4986C34.4955 12.9617 34.8956 13.34 35.3736 13.5927C35.8516 13.8454 36.3894 13.963 36.9293 13.9328C37.4691 13.9026 37.9905 13.7257 38.4373 13.4213V13.7813H40.1243V8.147H38.4373V8.50738ZM36.9031 12.414C36.6196 12.3989 36.3468 12.3011 36.1184 12.1326C35.89 11.9641 35.716 11.7324 35.6179 11.466C35.5198 11.1997 35.502 10.9104 35.5666 10.6341C35.6311 10.3577 35.7753 10.1063 35.9813 9.911C36.1873 9.7157 36.4459 9.58507 36.7254 9.53526C37.0048 9.48544 37.2927 9.51863 37.5534 9.63073C37.8142 9.74282 38.0364 9.92889 38.1925 10.1659C38.3486 10.403 38.4318 10.6806 38.4318 10.9644C38.421 11.3593 38.254 11.7337 37.9673 12.0055C37.6807 12.2773 37.2979 12.4242 36.9031 12.414Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M15.3027 5.63597H13.5373V13.7813H15.3027V5.63597Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M30.7946 7.99576C30.4629 7.97615 30.1314 8.03749 29.8287 8.17449C29.526 8.31148 29.2611 8.52002 29.057 8.78214V8.14763H27.377V13.7817H29.0772V10.8208C29.0641 10.6507 29.0878 10.4798 29.1467 10.3197C29.2056 10.1596 29.2982 10.014 29.4184 9.89294C29.5385 9.77184 29.6834 9.67803 29.843 9.6179C30.0026 9.55776 30.1734 9.5327 30.3435 9.54443C31.085 9.54443 31.5111 9.98737 31.5111 10.8091V13.7817H33.1963V10.1987C33.1962 8.88745 32.1537 7.99576 30.7946 7.99576Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_5", d: "M20.6404 8.50738C20.1936 8.20292 19.6722 8.02606 19.1324 7.99586C18.5926 7.96565 18.0547 8.08322 17.5767 8.33593C17.0987 8.58865 16.6987 8.96692 16.4196 9.43006C16.1406 9.89319 15.9932 10.4236 15.9932 10.9643C15.9932 11.505 16.1406 12.0355 16.4196 12.4986C16.6987 12.9617 17.0987 13.34 17.5767 13.5927C18.0547 13.8454 18.5926 13.963 19.1324 13.9328C19.6722 13.9026 20.1936 13.7257 20.6404 13.4213V13.7813H22.3274V8.147H20.6404V8.50738ZM19.1061 12.414C18.8227 12.399 18.5499 12.3012 18.3214 12.1327C18.093 11.9642 17.919 11.7325 17.8208 11.4662C17.7227 11.1998 17.7049 10.9106 17.7694 10.6342C17.834 10.3578 17.9782 10.1064 18.1841 9.91105C18.3901 9.71574 18.6488 9.58509 18.9282 9.53526C19.2076 9.48543 19.4955 9.51861 19.7563 9.6307C20.0171 9.74279 20.2392 9.92886 20.3954 10.1659C20.5515 10.403 20.6347 10.6806 20.6347 10.9644C20.6239 11.3592 20.4569 11.7337 20.1703 12.0054C19.8837 12.2772 19.501 12.4242 19.1061 12.414Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_6", d: "M24.9362 8.88078V8.14691H23.209V13.7813H24.9399V11.1509C24.9399 10.2633 25.9019 9.78625 26.5694 9.78625C26.5761 9.78625 26.5827 9.78692 26.5894 9.78697V8.14724C26.2767 8.13885 25.9659 8.20034 25.6799 8.32724C25.3939 8.45413 25.1398 8.64324 24.9362 8.88078Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_7", d: "M41.9152 11.7832C41.7058 11.7832 41.5011 11.8453 41.327 11.9617C41.1529 12.078 41.0172 12.2434 40.937 12.4369C40.8569 12.6303 40.8359 12.8432 40.8768 13.0486C40.9177 13.254 41.0185 13.4427 41.1666 13.5908C41.3147 13.7388 41.5033 13.8397 41.7087 13.8805C41.9141 13.9214 42.127 13.9004 42.3205 13.8203C42.514 13.7401 42.6793 13.6044 42.7957 13.4303C42.912 13.2562 42.9741 13.0515 42.9741 12.842C42.9741 12.703 42.9467 12.5653 42.8935 12.4368C42.8403 12.3083 42.7623 12.1916 42.664 12.0933C42.5657 11.995 42.4489 11.917 42.3205 11.8638C42.192 11.8106 42.0543 11.7832 41.9152 11.7832Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_8", d: "M12.3202 5.63477H10.4906C10.4934 6.36849 10.3237 7.0926 9.99506 7.74863C9.66644 8.40466 9.18815 8.97421 8.59882 9.41131L7.87402 9.95419L10.6826 13.7842H12.9917L10.4076 10.26C11.017 9.65433 11.4999 8.93349 11.8283 8.13945C12.1567 7.34541 12.3239 6.49401 12.3202 5.63477Z", fill: "var(--fill-0, black)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_9", d: "M7.65124 5.63477H5.81836V13.7839H7.65124V5.63477Z", fill: "var(--fill-0, black)" })
] }) }));
const PaymentMastercardIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 33 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group 845081166", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M20.5547 2.13867H11.8047V17.8637H20.5547V2.13867Z", fill: "var(--fill-0, #FF5F00)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M12.3611 10C12.3611 6.81111 13.8556 3.96944 16.1806 2.13889C14.4806 0.8 12.3333 0 10 0C4.47778 0 0 4.47778 0 10C0 15.5222 4.47778 20 10 20C12.3333 20 14.4778 19.2 16.1806 17.8611C13.8556 16.0306 12.3611 13.1889 12.3611 10Z", fill: "var(--fill-0, #EB001B)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M32.3612 10C32.3612 15.5222 27.8834 20 22.3612 20C20.0279 20 17.8834 19.2 16.1807 17.8611C18.5057 16.0306 20.0001 13.1889 20.0001 10C20.0001 6.81111 18.5057 3.96944 16.1807 2.13889C17.8807 0.8 20.0279 0 22.3612 0C27.8834 0 32.3612 4.47778 32.3612 10Z", fill: "var(--fill-0, #F79E1B)" })
] }) }));
const PaymentPaypalIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 46 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M14.7098 2.43848C14.6151 2.43848 14.5347 2.5072 14.5199 2.60079L13.424 9.55036C13.42 9.57574 13.4216 9.60169 13.4286 9.62641C13.4356 9.65114 13.4479 9.67405 13.4646 9.69358C13.4813 9.71311 13.502 9.72879 13.5254 9.73954C13.5487 9.75029 13.5741 9.75586 13.5998 9.75586H14.8994C14.9939 9.75586 15.0745 9.687 15.0893 9.59355L15.4112 7.55276C15.4258 7.45931 15.5064 7.39044 15.6011 7.39044H16.7826C18.1631 7.39044 19.3351 6.38315 19.5491 5.01823C19.765 3.64176 18.6896 2.44146 17.1655 2.43848H14.7098ZM15.9731 3.98989H16.9184C17.6967 3.98989 17.9502 4.44912 17.87 4.95697C17.7899 5.46592 17.3963 5.8408 16.6434 5.8408H15.6812L15.9731 3.98989ZM22.1923 4.46229C21.8642 4.46352 21.4866 4.53075 21.0626 4.70732C20.0903 5.11263 19.6233 5.95027 19.425 6.56095C19.425 6.56095 18.7938 8.42408 20.2198 9.44767C20.2198 9.44767 21.5424 10.4331 23.0312 9.38696L23.0055 9.55036C23.0015 9.57572 23.0031 9.60164 23.0101 9.62635C23.0171 9.65105 23.0293 9.67395 23.046 9.69348C23.0627 9.713 23.0833 9.72869 23.1067 9.73945C23.13 9.75022 23.1553 9.75582 23.181 9.75586H24.4147C24.5094 9.75586 24.5898 9.687 24.6046 9.59355L25.355 4.83446C25.3591 4.80907 25.3575 4.78312 25.3506 4.75838C25.3436 4.73364 25.3314 4.71071 25.3147 4.69115C25.298 4.6716 25.2773 4.65589 25.254 4.6451C25.2306 4.63432 25.2053 4.62872 25.1796 4.62868H23.9458C23.8512 4.62868 23.7706 4.69754 23.756 4.79099L23.7156 5.04716C23.7156 5.04716 23.1769 4.45863 22.1923 4.46229ZM22.2327 5.96549C22.3743 5.96549 22.5039 5.98505 22.6202 6.0224C23.1525 6.19327 23.4543 6.70465 23.3669 7.25896C23.2592 7.94149 22.6995 8.44405 21.9816 8.44405C21.8401 8.44405 21.7105 8.42463 21.5941 8.38727C21.062 8.2164 20.7583 7.70502 20.8456 7.15071C20.9533 6.46818 21.5148 5.96549 22.2327 5.96549Z", fill: "var(--fill-0, #003087)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M32.4756 2.43855C32.3809 2.43855 32.3005 2.50727 32.2857 2.60086L31.1898 9.55043C31.1859 9.57581 31.1874 9.60176 31.1944 9.62648C31.2014 9.65121 31.2137 9.67412 31.2304 9.69365C31.2471 9.71318 31.2678 9.72886 31.2912 9.73961C31.3145 9.75036 31.3399 9.75593 31.3656 9.75593H32.6652C32.7597 9.75593 32.8403 9.68707 32.8551 9.59362L33.177 7.55282C33.1917 7.45938 33.2722 7.39051 33.3669 7.39051H34.5484C35.929 7.39051 37.1007 6.38322 37.3147 5.0183C37.5306 3.64183 36.4554 2.44153 34.9313 2.43855H32.4756ZM33.7389 3.98996H34.6843C35.4625 3.98996 35.716 4.44919 35.6359 4.95704C35.5557 5.46598 35.1622 5.84087 34.4092 5.84087H33.447L33.7389 3.98996ZM39.958 4.46236C39.6298 4.46358 39.2522 4.53082 38.8283 4.70739C37.8559 5.1127 37.389 5.95034 37.1907 6.56102C37.1907 6.56102 36.5597 8.42415 37.9858 9.44774C37.9858 9.44774 39.3081 10.4332 40.797 9.38703L40.7713 9.55043C40.7673 9.57581 40.7689 9.60176 40.7759 9.62648C40.7829 9.65121 40.7952 9.67412 40.8119 9.69365C40.8286 9.71318 40.8493 9.72886 40.8727 9.73961C40.896 9.75036 40.9214 9.75593 40.9471 9.75593H42.1807C42.2753 9.75593 42.3557 9.68707 42.3706 9.59362L43.1213 4.83453C43.1253 4.80912 43.1238 4.78314 43.1168 4.75839C43.1098 4.73363 43.0975 4.71068 43.0808 4.69112C43.0641 4.67156 43.0434 4.65586 43.02 4.64509C42.9966 4.63432 42.9712 4.62875 42.9455 4.62875H41.7118C41.6171 4.62875 41.5366 4.69761 41.5219 4.79106L41.4816 5.04723C41.4816 5.04723 40.9426 4.45869 39.958 4.46236ZM39.9983 5.96555C40.14 5.96555 40.2696 5.98511 40.3859 6.02247C40.9182 6.19334 41.22 6.70472 41.1326 7.25903C41.0249 7.94156 40.4652 8.44412 39.7473 8.44412C39.6058 8.44412 39.4762 8.4247 39.3598 8.38734C38.8276 8.21647 38.5239 7.70509 38.6113 7.15078C38.719 6.46825 39.2805 5.96555 39.9983 5.96555Z", fill: "var(--fill-0, #0070E0)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M25.9404 4.62904C25.8426 4.62904 25.773 4.72453 25.8029 4.81757L27.1555 9.01475L25.9325 10.9927C25.8731 11.0887 25.9421 11.2127 26.055 11.2127H27.5005C27.5418 11.2127 27.5824 11.202 27.6184 11.1816C27.6544 11.1613 27.6846 11.1321 27.706 11.0967L31.4834 4.84772C31.5414 4.75169 31.4722 4.62891 31.36 4.62891H29.9146C29.8729 4.62894 29.8319 4.63984 29.7956 4.66054C29.7594 4.68124 29.7292 4.71101 29.7079 4.74694L28.221 7.25729L27.4662 4.76555C27.4417 4.68446 27.3668 4.62891 27.2822 4.62891L25.9404 4.62904Z", fill: "var(--fill-0, #003087)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M44.5226 2.43848C44.428 2.43848 44.3475 2.50734 44.3327 2.60079L43.2366 9.55009C43.2325 9.57549 43.2341 9.60147 43.2411 9.62623C43.248 9.65098 43.2603 9.67393 43.277 9.69349C43.2937 9.71305 43.3145 9.72876 43.3378 9.73952C43.3612 9.75029 43.3866 9.75587 43.4123 9.75586H44.7119C44.8064 9.75586 44.887 9.687 44.9018 9.59355L45.9976 2.64398C46.0016 2.61862 46.0001 2.5927 45.9931 2.56799C45.9861 2.54329 45.9738 2.52039 45.9572 2.50086C45.9405 2.48134 45.9198 2.46565 45.8965 2.45489C45.8732 2.44412 45.8478 2.43852 45.8222 2.43848H44.5226Z", fill: "var(--fill-0, #0070E0)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_5", d: "M3.87511 2.43855C3.79139 2.43861 3.71045 2.46854 3.64681 2.52293C3.58318 2.57733 3.54102 2.65264 3.52793 2.73533L2.95108 6.39395C2.97798 6.22308 3.12521 6.09717 3.29825 6.09717H4.98862C6.68984 6.09717 8.13341 4.85612 8.39718 3.17432C8.41681 3.04876 8.42794 2.92201 8.43047 2.79495C7.99813 2.56826 7.49027 2.43855 6.93379 2.43855H3.87511Z", fill: "var(--fill-0, #001C64)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_6", d: "M8.43046 2.79509C8.42793 2.92215 8.41681 3.04889 8.39718 3.17445C8.1334 4.85626 6.68971 6.09731 4.98861 6.09731H3.29825C3.12534 6.09731 2.97798 6.22308 2.95108 6.39409L2.42067 9.75607L2.08844 11.8652C2.08196 11.9059 2.08439 11.9476 2.09557 11.9873C2.10676 12.027 2.12643 12.0639 2.15322 12.0952C2.18002 12.1266 2.2133 12.1518 2.25078 12.1691C2.28825 12.1863 2.32903 12.1953 2.37029 12.1952H4.20503C4.28875 12.1952 4.36969 12.1653 4.43333 12.1109C4.49696 12.0565 4.53911 11.9811 4.5522 11.8985L5.03547 8.83326C5.04857 8.75053 5.09076 8.67518 5.15445 8.62078C5.21814 8.56638 5.29916 8.53648 5.38292 8.53648H6.46315C8.16438 8.53648 9.60794 7.29543 9.87172 5.61363C10.059 4.41998 9.45786 3.33378 8.43046 2.79509Z", fill: "var(--fill-0, #0070E0)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_7", d: "M1.79048 0C1.61757 0 1.4702 0.125776 1.44331 0.29651L0.00354348 9.42623C-0.0237577 9.59955 0.110171 9.75629 0.285659 9.75629H2.42072L2.95085 6.39431L3.5277 2.73568C3.54079 2.653 3.58295 2.57769 3.64658 2.52329C3.71022 2.46889 3.79116 2.43897 3.87488 2.4389H6.93355C7.49017 2.4389 7.9979 2.56875 8.43023 2.79531C8.45984 1.26414 7.19638 0 5.45929 0H1.79048Z", fill: "var(--fill-0, #003087)" })
] }) }));
const PaymentPaytrailIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ width: "1em", height: "1em", viewBox: "0 0 48 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { clipPath: `url(#${uid}clip0_10269_4403)`, children: [
      /* @__PURE__ */ jsx("rect", { width: 48, height: 32, rx: 4, fill: "#E42E87", style: {
        fill: "#E42E87",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M16.667 5.97084C17.3573 5.97084 17.917 5.42501 17.917 4.75001C17.917 4.07501 17.3573 3.52917 16.667 3.52917C15.9767 3.52917 15.417 4.07501 15.417 4.75001C15.417 5.42501 15.9767 5.97084 16.667 5.97084Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M31.4209 6C32.1112 6 32.6709 5.44028 32.6709 4.75C32.6709 4.05972 32.1112 3.5 31.4209 3.5C30.7306 3.5 30.1709 4.05972 30.1709 4.75C30.1709 5.44028 30.7306 6 31.4209 6Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M16.6445 4.83887C16.6445 8.91248 19.9459 12.2139 24.0195 12.2139C28.0931 12.2139 31.3945 8.91248 31.3945 4.83887", stroke: "white", style: {
        stroke: "white",
        strokeOpacity: 1
      }, strokeWidth: 0.833333 }),
      /* @__PURE__ */ jsx("path", { d: "M34.3851 24.2084V19.9821H33.8115V19.2557H35.1587V23.4821H35.7253V24.2084H34.3851ZM32.699 24.2084L32.6851 23.9084V21.3557H32.1323V20.6293H33.4587V23.4821H33.999V24.2084H32.699ZM33.3184 20.0084C33.2156 20.1015 33.1031 20.1487 32.9781 20.1487C32.8531 20.1487 32.7406 20.1015 32.6378 20.0084C32.5448 19.9057 32.4976 19.7932 32.4976 19.6682C32.4976 19.5307 32.5448 19.4154 32.6378 19.3209C32.7406 19.2279 32.8531 19.1807 32.9781 19.1807C33.1031 19.1807 33.2156 19.2279 33.3184 19.3209C33.4115 19.4237 33.4587 19.5362 33.4587 19.6612C33.4587 19.7987 33.4115 19.914 33.3184 20.0084ZM30.992 22.7946C30.899 22.7459 30.8073 22.7057 30.7184 22.6751C30.599 22.6307 30.467 22.6084 30.3253 22.6084C30.2003 22.6084 30.0976 22.6223 30.0156 22.6515C29.9337 22.6807 29.8684 22.7196 29.8184 22.7682C29.7073 22.8654 29.6517 22.9876 29.6517 23.1348C29.6517 23.2459 29.6934 23.3459 29.7781 23.4348C29.8184 23.4751 29.867 23.5057 29.9253 23.5279C29.9823 23.5501 30.0559 23.5612 30.1448 23.5612C30.292 23.5612 30.449 23.5196 30.6184 23.4348C30.7601 23.364 30.8851 23.2751 30.992 23.1682V22.7946ZM30.992 24.2084V23.9682C30.8545 24.0529 30.7059 24.1209 30.549 24.1751C30.3906 24.2279 30.2295 24.2557 30.0656 24.2557C29.724 24.2557 29.4392 24.1418 29.2128 23.9154C28.9865 23.6973 28.8726 23.4293 28.8726 23.1084C28.8726 22.7612 29.0059 22.4751 29.2726 22.2487C29.4017 22.1334 29.549 22.0501 29.7156 21.9987C29.8823 21.9473 30.0656 21.9223 30.2656 21.9223C30.4212 21.9223 30.5851 21.9446 30.7587 21.989C30.7934 21.9973 30.8323 22.0084 30.8726 22.0196C30.9128 22.0307 30.9531 22.0446 30.992 22.0626V21.6487C30.992 21.5598 30.9795 21.4904 30.9559 21.4418C30.9309 21.3932 30.899 21.3557 30.8587 21.3279C30.8059 21.2918 30.7392 21.264 30.6587 21.2446C30.5795 21.2251 30.4809 21.214 30.3656 21.214C30.3073 21.214 30.2406 21.2223 30.1656 21.2376C30.0906 21.2529 30.0128 21.2737 29.9351 21.2973C29.8573 21.3223 29.7837 21.3459 29.7156 21.3709C29.6462 21.3959 29.5878 21.4168 29.5392 21.4348L29.299 20.8418C29.4545 20.7793 29.5878 20.7293 29.699 20.6918C29.8101 20.6543 29.9281 20.6196 30.0517 20.589C30.1753 20.5584 30.2851 20.5418 30.3781 20.5418C30.5823 20.5418 30.7684 20.5626 30.9351 20.6057C31.1017 20.6473 31.249 20.714 31.3781 20.8029C31.5115 20.9057 31.6087 21.0279 31.6712 21.1696C31.7337 21.3112 31.7642 21.4723 31.7642 21.6501V23.4834H32.2906V24.2098H30.9906L30.992 24.2084ZM28.6059 21.3418C28.392 21.3418 28.2156 21.3668 28.0753 21.4154C27.9351 21.464 27.8226 21.5265 27.7392 21.6015C27.6587 21.6723 27.5976 21.7571 27.5531 21.8543C27.5087 21.9515 27.4865 22.0946 27.4865 22.2807V23.4807H28.1337V24.2071H26.7142V21.3543H26.1142V20.6279H27.4878V21.0015C27.5059 20.9932 27.5462 20.9668 27.6073 20.9251C27.6684 20.8834 27.7323 20.8459 27.7934 20.8154C27.9406 20.7446 28.074 20.6959 28.1962 20.6682C28.3184 20.6418 28.4573 20.6307 28.6128 20.6348L28.9462 20.6418V21.3418H28.6059ZM25.1656 24.2821C25.0406 24.2821 24.9295 24.2654 24.8295 24.2321C24.7295 24.1987 24.642 24.1418 24.5656 24.0626C24.4906 23.9876 24.4378 23.8987 24.4087 23.7987C24.3795 23.6987 24.3656 23.5904 24.3656 23.4751V21.3557H23.8059V20.6293H24.3656V19.9293L25.1392 19.9098V20.6293H25.799V21.3557H25.1392V23.4084C25.1392 23.4793 25.1462 23.5237 25.1587 23.5418H25.192L25.799 23.4418V24.1751L25.1656 24.2821ZM22.892 21.3557L21.2781 25.6223H20.5253L21.1323 23.9154L20.0851 21.3557H19.492V20.6293H20.599L20.7656 21.0626L21.5184 22.9098L22.1045 21.3571H21.6976V20.6307H23.4378V21.3571H22.8906L22.892 21.3557ZM18.299 22.7959C18.2059 22.7473 18.1142 22.7071 18.0253 22.6765C17.9059 22.6321 17.774 22.6098 17.6323 22.6098C17.5073 22.6098 17.4045 22.6237 17.3226 22.6529C17.2406 22.6821 17.1753 22.7209 17.1253 22.7696C17.0142 22.8668 16.9587 22.989 16.9587 23.1362C16.9587 23.2473 17.0003 23.3473 17.0851 23.4362C17.1253 23.4765 17.174 23.5071 17.2323 23.5293C17.2892 23.5515 17.3628 23.5626 17.4517 23.5626C17.599 23.5626 17.7559 23.5209 17.9253 23.4362C18.067 23.3654 18.192 23.2765 18.299 23.1696V22.7959ZM18.299 24.2098V23.9696C18.1615 24.0543 18.0128 24.1223 17.8559 24.1765C17.6976 24.2293 17.5365 24.2571 17.3726 24.2571C17.0309 24.2571 16.7462 24.1432 16.5198 23.9168C16.2934 23.6987 16.1795 23.4307 16.1795 23.1098C16.1795 22.7626 16.3128 22.4765 16.5795 22.2501C16.7087 22.1348 16.8559 22.0515 17.0226 22.0001C17.1892 21.9487 17.3726 21.9237 17.5726 21.9237C17.7281 21.9237 17.892 21.9459 18.0656 21.9904C18.1003 21.9987 18.1392 22.0098 18.1795 22.0209C18.2198 22.0321 18.2601 22.0459 18.299 22.064V21.6501C18.299 21.5612 18.2865 21.4918 18.2628 21.4432C18.2378 21.3946 18.2059 21.3571 18.1656 21.3293C18.1128 21.2932 18.0462 21.2654 17.9656 21.2459C17.8851 21.2265 17.7878 21.2154 17.6726 21.2154C17.6142 21.2154 17.5476 21.2237 17.4726 21.239C17.3976 21.2543 17.3198 21.2751 17.242 21.2987C17.1642 21.3237 17.0906 21.3473 17.0226 21.3723C16.9531 21.3973 16.8948 21.4182 16.8462 21.4362L16.6059 20.8432C16.7615 20.7807 16.8948 20.7307 17.0059 20.6932C17.117 20.6557 17.2351 20.6209 17.3587 20.5904C17.4823 20.5598 17.592 20.5432 17.6851 20.5432C17.8892 20.5432 18.0753 20.564 18.242 20.6071C18.4087 20.6487 18.5559 20.7154 18.6851 20.8043C18.8184 20.9071 18.9156 21.0293 18.9781 21.1709C19.0406 21.3126 19.0712 21.4737 19.0712 21.6515V23.4848H19.5976V24.2112H18.2976L18.299 24.2098ZM15.3392 20.4265C15.299 20.3223 15.2476 20.2404 15.1865 20.1834C15.1198 20.1209 15.024 20.0723 14.9003 20.0362C14.7767 20.0001 14.6142 19.9834 14.4142 19.9834H13.7281V21.6168H14.4142C14.5962 21.6168 14.749 21.5987 14.8712 21.564C14.9934 21.5279 15.0948 21.4793 15.174 21.4168C15.2448 21.3584 15.3003 21.2848 15.3406 21.1932C15.3809 21.1029 15.4003 20.9848 15.4003 20.8432C15.4003 20.6696 15.3809 20.5307 15.3406 20.4265M16.0878 21.4293C16.0128 21.6209 15.8962 21.7876 15.7406 21.9293C15.5851 22.0709 15.4073 22.1765 15.2073 22.2432C15.0073 22.3098 14.7878 22.3432 14.5476 22.3432H13.7281V24.2098H12.3281V23.4834H12.9281V19.9834H12.3281V19.2571H14.4809C14.7337 19.2571 14.967 19.289 15.1781 19.3543C15.3892 19.4182 15.5753 19.5223 15.7351 19.664C15.8948 19.8057 16.0128 19.9723 16.0878 20.1612C16.1628 20.3501 16.2017 20.564 16.2017 20.8043C16.2017 21.0307 16.1642 21.2404 16.0878 21.4307", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M25.1408 26.3333C25.5963 26.3333 25.9311 26.6292 25.9311 27.0986V27.4958C25.9311 28.0445 25.5769 28.2903 25.1005 28.2903C24.8658 28.2903 24.588 28.2403 24.3741 28.1597C24.3422 28.1486 24.3311 28.1306 24.3311 28.0986V25.7194C24.3311 25.6833 24.3491 25.6653 24.3852 25.6653H24.6963C24.7324 25.6653 24.7505 25.6833 24.7505 25.7194V26.4125C24.863 26.3653 24.9963 26.3333 25.1408 26.3333ZM25.5061 27.5V27.0986C25.5061 26.8236 25.3574 26.7056 25.0977 26.7056C24.9602 26.7056 24.8408 26.7417 24.7505 26.8V27.8653C24.8366 27.9014 24.9672 27.9153 25.0894 27.9153C25.3491 27.9153 25.5047 27.807 25.5047 27.5H25.5061Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M27.4583 26.4279C27.4583 26.396 27.4763 26.3779 27.5125 26.3779H27.8236C27.8597 26.3779 27.8777 26.396 27.8777 26.4279V28.1293C27.8777 28.6849 27.625 28.971 27.0722 28.971C26.7652 28.971 26.5527 28.8988 26.3638 28.7432C26.3347 28.721 26.3347 28.7002 26.3527 28.671L26.5083 28.4502C26.5263 28.421 26.5513 28.414 26.5763 28.4321C26.7138 28.5265 26.8722 28.5988 27.068 28.5988C27.3166 28.5988 27.4763 28.4904 27.4611 28.1293C27.3458 28.1654 27.2083 28.1946 27.075 28.1946C26.7 28.1946 26.3027 27.9557 26.3027 27.4585V26.4293C26.3027 26.3974 26.325 26.3793 26.3569 26.3793H26.6708C26.7027 26.3793 26.7208 26.3974 26.7208 26.4293V27.4404C26.7208 27.7182 26.9152 27.8154 27.1319 27.8154C27.2541 27.8196 27.3777 27.7863 27.4569 27.7432V26.4293L27.4583 26.4279Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M29.1655 28.2469C29.1294 28.2469 29.1113 28.2288 29.1113 28.1927V26.5386C29.1113 26.5094 29.1224 26.4886 29.1516 26.4733C29.3613 26.383 29.6141 26.333 29.8697 26.333C30.3683 26.333 30.7072 26.5636 30.7072 27.1413V28.1927C30.7072 28.2288 30.6891 28.2469 30.6572 28.2469H30.3433C30.3113 28.2469 30.2891 28.2288 30.2891 28.1927V27.1497C30.2891 26.8108 30.1335 26.7094 29.8697 26.7094C29.7474 26.7094 29.6127 26.7275 29.5308 26.7497V28.1941C29.5308 28.2302 29.5127 28.2483 29.4766 28.2483H29.1655V28.2469Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M32.6621 27.4386C32.6621 27.4705 32.644 27.4886 32.6079 27.4886H31.5107V27.59C31.5107 27.8108 31.6621 27.9219 31.894 27.9219C32.126 27.9219 32.269 27.8455 32.4037 27.7552C32.4287 27.7372 32.4579 27.7413 32.476 27.7663L32.6246 27.965C32.6468 27.99 32.6426 28.0191 32.6135 28.0413C32.4218 28.1927 32.1871 28.29 31.8801 28.29C31.4718 28.29 31.0898 28.0663 31.0898 27.5858V27.0733C31.0898 26.5427 31.4871 26.333 31.8843 26.333C32.2815 26.333 32.6648 26.5427 32.6648 27.0733V27.4386H32.6621ZM31.8815 26.7025C31.669 26.7025 31.5093 26.8038 31.5093 27.0705V27.165H32.2537V27.0705C32.2537 26.8066 32.0843 26.7025 31.8815 26.7025Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M33.7311 27.9083C33.763 27.9083 33.8214 27.9041 33.8797 27.9014C33.9158 27.9014 33.938 27.9194 33.938 27.9514V28.2264C33.938 28.2555 33.9242 28.2805 33.888 28.2847C33.8269 28.2889 33.7505 28.2916 33.6964 28.2916C33.3214 28.2916 33.0283 28.1 33.0283 27.6236V25.9736C33.0283 25.9416 33.0464 25.9236 33.0825 25.9236H33.3575C33.3867 25.9236 33.4075 25.9416 33.4117 25.9708L33.4436 26.4041H33.8297C33.8617 26.4041 33.8839 26.4222 33.8839 26.4541V26.718C33.8839 26.75 33.8617 26.768 33.8297 26.768H33.4464V27.5944C33.4464 27.793 33.5478 27.9083 33.7311 27.9083Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } }),
      /* @__PURE__ */ jsx("path", { d: "M34.8824 28.2898C34.6366 28.2898 34.3769 28.2217 34.1491 28.0551C34.1172 28.037 34.1172 28.012 34.1352 27.9829L34.2727 27.7481C34.2908 27.7162 34.313 27.712 34.3449 27.7342C34.5074 27.8537 34.7019 27.919 34.8908 27.919C35.0797 27.919 35.2269 27.8467 35.2269 27.7092C35.2269 27.5648 35.0533 27.5245 34.8908 27.4967C34.6199 27.4467 34.1616 27.3342 34.1616 26.8967C34.1616 26.4954 34.5408 26.3301 34.9269 26.3301C35.1324 26.3301 35.3422 26.3801 35.5547 26.4967C35.5838 26.5106 35.5908 26.5398 35.5727 26.569L35.4352 26.7995C35.4172 26.8245 35.3922 26.8315 35.363 26.8176C35.2297 26.7454 35.0672 26.6981 34.9047 26.6981C34.6922 26.6981 34.5755 26.7773 34.5755 26.8967C34.5755 27.0454 34.738 27.0815 34.9769 27.1273C35.2727 27.1815 35.6491 27.2759 35.6491 27.6912C35.6491 28.1065 35.3172 28.2912 34.8838 28.2912L34.8824 28.2898Z", fill: "white", style: {
        fill: "white",
        fillOpacity: 1
      } })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: `${uid}clip0_10269_4403`, children: /* @__PURE__ */ jsx("rect", { width: 48, height: 32, fill: "white", style: {
      fill: "white",
      fillOpacity: 1
    } }) }) })
  ] }));
};
const PaymentTrustlyIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 30 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Layer_1-2", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M7.74414 4.67139H12.7183V0.703595L16.6865 4.67139L12.7183 8.63876V10.6694H17.5351V4.67139H21.9597V0H7.74414V4.67139Z", fill: "var(--fill-0, #231F20)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M2.01609 20.188V14.5767H0V13.2451H5.4784V14.5767H3.46232V20.188H2.0165H2.01609Z", fill: "var(--fill-0, #231F20)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M5.24902 20.1949V15.1543H6.58062V15.953C6.89462 15.2777 7.30332 15.1543 7.74109 15.1543H8.25488V16.505H7.81752C7.18993 16.505 6.6288 16.8663 6.6288 17.9695V20.1949H5.24985H5.24902Z", fill: "var(--fill-0, #231F20)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M8.88323 18.35V15.1543H10.2622V18.036C10.2622 18.6258 10.5475 19.0631 11.1373 19.0631C11.7271 19.0631 12.0693 18.6258 12.0693 18.0455V15.1543H13.4483V20.1949H12.1358V19.5578C11.8031 20.062 11.3084 20.3091 10.6804 20.3091C9.57727 20.3091 8.88281 19.5482 8.88281 18.35H8.88323Z", fill: "var(--fill-0, #231F20)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_5", d: "M14.037 18.7758L15.2352 18.5C15.2921 18.89 15.6061 19.1849 16.2055 19.1849C16.6715 19.1849 16.9282 18.9947 16.9282 18.7571C16.9282 18.5669 16.8235 18.4244 16.3479 18.3197L15.5584 18.1486C14.5503 17.9297 14.1221 17.4637 14.1221 16.6172C14.1221 15.7708 14.8353 15.0576 16.1764 15.0576C17.6031 15.0576 18.1738 15.9136 18.2307 16.4748L17.0229 16.741C16.966 16.4461 16.7471 16.123 16.1477 16.123C15.7673 16.123 15.4819 16.2941 15.4819 16.5416C15.4819 16.751 15.6244 16.8652 15.872 16.9221L17.0229 17.1883C17.898 17.3881 18.3067 17.911 18.3067 18.6528C18.3067 19.4516 17.6696 20.2889 16.2142 20.2889C14.6164 20.2889 14.0935 19.3282 14.0361 18.7766L14.037 18.7758Z", fill: "var(--fill-0, #231F20)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_6", d: "M20.9627 20.1953C20.0689 20.1953 19.4695 19.7006 19.4695 18.7212V16.3625H18.623V15.1546H19.4695V14.0324L20.8485 13.6328V15.1546H21.8661V16.3625H20.8485V18.4737C20.8485 18.8446 21.0387 18.9874 21.4096 18.9874H21.9421V20.1953H20.9627Z", fill: "var(--fill-0, #231F20)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_7", d: "M22.6924 20.188V13.2451H24.0713V20.188H22.6924Z", fill: "var(--fill-0, #231F20)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_8", d: "M28.2284 15.1543H29.7025L27.6009 22.0021H26.1268L26.707 20.1949H25.9461L24.5576 15.1543H26.0317L27.0684 19.0536L28.2289 15.1543H28.2284Z", fill: "var(--fill-0, #231F20)" })
] }) }));
const PaymentUnionpayIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 48 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Group", children: [
  /* @__PURE__ */ jsx("path", { id: "Vector", d: "M9.38276 0H21.3412C23.0105 0 24.0488 1.36062 23.6594 3.03546L18.0918 26.939C17.6989 28.608 16.0276 29.9698 14.3571 29.9698H2.39982C0.732852 29.9698 -0.307726 28.608 0.0816888 26.939L5.65155 3.03546C6.04096 1.36062 7.71143 0 9.38276 0Z", fill: "var(--fill-0, #E21836)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M20.3459 0H34.0978C35.7668 0 35.0142 1.36062 34.6216 3.03546L29.055 26.939C28.6644 28.608 28.7862 29.9698 27.1137 29.9698H13.3618C11.6893 29.9698 10.6542 28.608 11.0471 26.939L16.6135 3.03546C17.0087 1.36062 18.6757 0 20.3459 0Z", fill: "var(--fill-0, #00447C)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M33.5524 0H45.5108C47.1825 0 48.2207 1.36062 47.8281 3.03546L42.2614 26.939C41.8685 28.608 40.196 29.9698 38.5247 29.9698H26.5717C24.8992 29.9698 23.8619 28.608 24.2536 26.939L29.8211 3.03546C30.2106 1.36062 31.8798 0 33.5524 0Z", fill: "var(--fill-0, #007B84)" }),
  /* @__PURE__ */ jsx("path", { id: "Vector_4", d: "M12.5059 7.6604C11.2762 7.67294 10.913 7.6604 10.797 7.633C10.7524 7.84491 9.92252 11.6729 9.92019 11.6761C9.74152 12.4506 9.61152 13.0026 9.16993 13.3591C8.91926 13.5663 8.62661 13.6663 8.28733 13.6663C7.74197 13.6663 7.42426 13.3955 7.37092 12.8819L7.36072 12.7056C7.36072 12.7056 7.52686 11.6682 7.52686 11.6624C7.52686 11.6624 8.3978 8.17399 8.55374 7.71287C8.5619 7.68663 8.56423 7.67294 8.56628 7.6604C6.87104 7.67527 6.57052 7.6604 6.54983 7.633C6.53846 7.6706 6.49649 7.88688 6.49649 7.88688L5.60719 11.8186L5.53082 12.1521L5.38304 13.2428C5.38304 13.5663 5.44658 13.8304 5.57308 14.0537C5.97824 14.7617 7.13395 14.8678 7.78774 14.8678C8.63011 14.8678 9.42031 14.6888 9.95429 14.3621C10.8812 13.8144 11.1237 12.9583 11.34 12.1976L11.4403 11.8073C11.4403 11.8073 12.3374 8.18419 12.4899 7.71287C12.4957 7.68663 12.498 7.67294 12.5059 7.6604ZM15.5585 10.5832C15.3422 10.5832 14.9469 10.6356 14.5919 10.8097C14.4631 10.8758 14.3412 10.9522 14.2127 11.0283L14.3287 10.6094L14.2652 10.5389C13.5123 10.6913 13.3438 10.7117 12.6483 10.8097L12.59 10.8484C12.5093 11.5179 12.4376 12.0213 12.1383 13.3374C12.0243 13.8224 11.9059 14.3121 11.7873 14.7959L11.8194 14.8574C12.532 14.8198 12.7483 14.8198 13.3677 14.83L13.4178 14.7755C13.4965 14.3724 13.5067 14.278 13.681 13.4615C13.763 13.0744 13.9338 12.2239 14.018 11.9211C14.1728 11.8494 14.3255 11.7788 14.4712 11.7788C14.8184 11.7788 14.7761 12.0817 14.7627 12.2023C14.7479 12.4049 14.6214 13.0666 14.4917 13.6347L14.4051 14.0013C14.3447 14.2721 14.2786 14.5353 14.2182 14.8038L14.2445 14.8574C14.9469 14.8198 15.1612 14.8198 15.761 14.83L15.8316 14.7755C15.94 14.1459 15.9718 13.9774 16.1642 13.0607L16.2609 12.6396C16.4489 11.8153 16.5434 11.3973 16.4011 11.0568C16.2507 10.6753 15.8899 10.5832 15.5585 10.5832ZM18.9685 11.4462C18.5951 11.5179 18.357 11.5657 18.1203 11.5966C17.8857 11.6342 17.6569 11.6683 17.296 11.7185L17.2675 11.7444L17.2412 11.7651C17.2036 12.0338 17.1774 12.2661 17.1275 12.5393C17.0853 12.8217 17.0203 13.1426 16.9145 13.6037C16.8326 13.9567 16.7903 14.0797 16.7437 14.2039C16.6982 14.3281 16.6481 14.4487 16.556 14.7959L16.5775 14.8279L16.5956 14.8574C16.9328 14.8413 17.1535 14.83 17.3803 14.8279C17.6067 14.8198 17.8414 14.8279 18.2046 14.83L18.2363 14.804L18.2704 14.7755C18.3229 14.4624 18.3308 14.3782 18.3628 14.2255C18.3946 14.0616 18.4494 13.8349 18.5838 13.2292C18.6473 12.9447 18.7181 12.6611 18.784 12.3708C18.8525 12.0816 18.9242 11.7969 18.9924 11.5124L18.9822 11.478L18.9685 11.4462ZM18.9765 10.2826C18.6372 10.0823 18.0417 10.1459 17.6409 10.4225C17.2413 10.6936 17.1958 11.0783 17.534 11.2812C17.8674 11.4759 18.4652 11.4179 18.8625 11.1389C19.2613 10.862 19.3111 10.4808 18.9765 10.2826ZM21.0283 14.9201C21.7148 14.9201 22.4184 14.731 22.948 14.1696C23.3555 13.7143 23.5423 13.0369 23.6071 12.7579C23.8178 11.8334 23.6537 11.4017 23.4476 11.1388C23.1346 10.738 22.5813 10.6095 22.0074 10.6095C21.6623 10.6095 20.8403 10.6436 20.1982 11.2356C19.7371 11.6626 19.524 12.242 19.3955 12.7976C19.2658 13.3636 19.1165 14.3827 20.0536 14.7619C20.3428 14.886 20.7596 14.9201 21.0283 14.9201ZM20.9747 12.8399C21.133 12.1397 21.3198 11.5521 21.7967 11.5521C22.1704 11.5521 22.1975 11.9893 22.0313 12.6918C22.0016 12.8477 21.8652 13.4275 21.6807 13.6744C21.5518 13.8565 21.3994 13.967 21.2309 13.967C21.1808 13.967 20.8826 13.967 20.8779 13.5242C20.8756 13.3056 20.9202 13.0824 20.9747 12.8399ZM25.323 14.8301L25.3766 14.7756C25.4527 14.3725 25.4652 14.2777 25.6337 13.4616C25.7179 13.0745 25.8922 12.224 25.9742 11.9211C26.1292 11.8491 26.2793 11.7786 26.4297 11.7786C26.7746 11.7786 26.7326 12.0815 26.7189 12.2021C26.7063 12.405 26.5798 13.0664 26.4478 13.6345L26.3659 14.0011C26.3032 14.2722 26.235 14.5351 26.1747 14.8039L26.2009 14.8575C26.9057 14.8199 27.1118 14.8199 27.7152 14.8301L27.788 14.7756C27.8938 14.1457 27.9224 13.9772 28.1206 13.0608L28.215 12.6393C28.4039 11.815 28.4995 11.3974 28.3596 11.0569C28.2048 10.6754 27.8417 10.5833 27.5149 10.5833C27.2983 10.5833 26.9011 10.6354 26.5481 10.8097C26.4219 10.8759 26.2954 10.952 26.1712 11.0283L26.2793 10.6095L26.2213 10.5387C25.4687 10.6914 25.2968 10.7118 24.6022 10.8097L24.5488 10.8485C24.4646 11.518 24.3961 12.0211 24.0967 13.3374C23.9828 13.8225 23.8644 14.3121 23.7461 14.796L23.7779 14.8575C24.4917 14.8199 24.7048 14.8199 25.323 14.8301ZM30.5012 14.8574C30.5456 14.6411 30.8088 13.3592 30.8111 13.3592C30.8111 13.3592 31.0352 12.4186 31.0489 12.3845C31.0489 12.3845 31.1195 12.2865 31.19 12.2477H31.2938C32.2729 12.2477 33.3784 12.2477 34.245 11.6103C34.8347 11.1731 35.2378 10.5274 35.4176 9.74278C35.4643 9.55041 35.4986 9.3216 35.4986 9.09279C35.4986 8.79227 35.4383 8.49496 35.264 8.26265C34.8221 7.64443 33.9421 7.63306 32.9263 7.6284C32.9231 7.6284 32.4256 7.63306 32.4256 7.63306C31.1253 7.64909 30.6038 7.64443 30.3896 7.6182C30.3715 7.71293 30.3374 7.8814 30.3374 7.8814C30.3374 7.8814 29.8717 10.0401 29.8717 10.0436C29.8717 10.0436 28.757 14.6332 28.7046 14.8495C29.8399 14.8358 30.3054 14.8358 30.5012 14.8574ZM31.3643 11.0227C31.3643 11.0227 31.8595 8.86835 31.8572 8.87651L31.8732 8.76604L31.8802 8.6818L32.0781 8.7022C32.0781 8.7022 33.0995 8.78994 33.1234 8.79227C33.5265 8.94821 33.6926 9.35016 33.5766 9.87482C33.4708 10.3543 33.1598 10.7574 32.7602 10.9521C32.4311 11.1171 32.028 11.1308 31.6127 11.1308H31.3439L31.3643 11.0227ZM34.4477 12.8798C34.3168 13.4376 34.1664 14.4567 35.0989 14.8198C35.3962 14.9463 35.6626 14.9839 35.9334 14.9702C36.2193 14.9548 36.4842 14.8114 36.7297 14.605C36.7075 14.6898 36.6854 14.7747 36.6632 14.8598L36.7055 14.9143C37.3762 14.886 37.5843 14.886 38.3109 14.8915L38.3768 14.8414C38.4829 14.2176 38.5829 13.612 38.8586 12.4186C38.993 11.8471 39.1271 11.281 39.265 10.7117L39.2434 10.6491C38.4931 10.7881 38.2926 10.8178 37.5709 10.9202L37.5161 10.9647C37.5088 11.0228 37.5012 11.0784 37.4942 11.1341C37.382 10.9528 37.2194 10.798 36.9684 10.7015C36.6475 10.5753 35.8937 10.738 35.2458 11.3279C34.7905 11.7491 34.5719 12.3262 34.4477 12.8798ZM36.0234 12.9139C36.184 12.2263 36.3685 11.6445 36.8466 11.6445C37.1488 11.6445 37.308 11.9234 37.2756 12.3991C37.25 12.5177 37.2223 12.6428 37.1893 12.7842C37.1415 12.9885 37.0897 13.1911 37.0392 13.3939C36.9879 13.5327 36.9282 13.6635 36.8626 13.7507C36.7396 13.925 36.4469 14.0331 36.2785 14.0331C36.2307 14.0331 35.9357 14.0331 35.9255 13.5983C35.9232 13.3817 35.9677 13.1587 36.0234 12.9139ZM44.252 10.6435L44.194 10.5773C43.4516 10.7277 43.3172 10.7516 42.6352 10.8438L42.585 10.8939C42.5827 10.902 42.5807 10.9146 42.5772 10.926L42.5748 10.9146C42.0671 12.086 42.0819 11.8333 41.6686 12.7556C41.6663 12.7136 41.6663 12.6874 41.664 12.6428L41.5605 10.6435L41.4955 10.5773C40.7178 10.7277 40.6995 10.7516 39.9813 10.8438L39.9253 10.8939C39.9174 10.9178 39.9174 10.944 39.9128 10.9726L39.9174 10.9828C40.0072 11.4416 39.9856 11.3393 40.0757 12.0633C40.1177 12.4186 40.1736 12.776 40.2156 13.1269C40.2864 13.7142 40.3261 14.0034 40.4126 14.8997C39.9276 15.7001 39.8128 16.0029 39.3458 16.7054L39.349 16.7124L39.0203 17.2324C38.9827 17.2872 38.9486 17.3248 38.9008 17.3408C38.8483 17.3667 38.7801 17.3714 38.6853 17.3714H38.5032L38.2324 18.2721L39.1613 18.2881C39.7067 18.2858 40.0495 18.0307 40.234 17.688L40.8181 16.687H40.8088L40.8703 16.6165C41.2632 15.7706 44.252 10.6435 44.252 10.6435ZM34.4477 22.4724H34.0536L35.5121 17.6482H35.996L36.1496 17.1512L36.1645 17.7038C36.1464 18.0455 36.4151 18.3483 37.1211 18.2982H37.9375L38.2185 17.3692H37.9113C37.7347 17.3692 37.6528 17.3246 37.663 17.229L37.6481 16.6668H36.1362V16.6697C35.6474 16.6799 34.1877 16.7166 33.8921 16.7953C33.5345 16.8874 33.1576 17.1585 33.1576 17.1585L33.3056 16.6609H31.8914L31.5967 17.6482L30.1186 22.5462H29.8318L29.5505 23.4684H32.3674L32.2729 23.7759H33.661L33.7531 23.4684H34.1425L34.4477 22.4724ZM33.2919 18.6284C33.0655 18.6911 32.644 18.8811 32.644 18.8811L33.0188 17.6482H34.1425L33.8714 18.5465C33.8714 18.5465 33.5243 18.5669 33.2919 18.6284ZM33.3135 20.3898C33.3135 20.3898 32.9605 20.4341 32.7282 20.4866C32.4994 20.556 32.0704 20.7746 32.0704 20.7746L32.4574 19.4915H33.5869L33.3135 20.3898ZM32.6839 22.4838H31.5568L31.8835 21.401H33.0072L32.6839 22.4838ZM35.3983 19.4915H37.023L36.7896 20.2476H35.1433L34.8961 21.0742H36.3366L35.2459 22.61C35.1695 22.7228 35.101 22.7627 35.025 22.7945C34.9486 22.8333 34.8483 22.8787 34.7323 22.8787H34.3327L34.0581 23.7841H35.1034C35.6467 23.7841 35.9676 23.5369 36.2046 23.2125L36.9525 22.1888L37.1131 23.2282C37.1472 23.4229 37.2871 23.5369 37.3819 23.5812C37.4865 23.6337 37.5946 23.7237 37.7474 23.7372C37.9112 23.7441 38.0295 23.7497 38.1082 23.7497H38.6218L38.9302 22.7365H38.7276C38.6113 22.7365 38.4111 22.717 38.377 22.6805C38.3429 22.6362 38.3429 22.568 38.3245 22.4643L38.1616 21.4225H37.4944L37.787 21.0742H39.4301L39.6828 20.2476H38.1616L38.3985 19.4915H39.9151L40.1964 18.559H35.675L35.3983 19.4915ZM21.6761 22.6943L22.0553 21.4328H23.6138L23.8986 20.4945H22.3386L22.5767 19.718H24.1012L24.3836 18.8095H20.5693L20.2927 19.718H21.1593L20.9281 20.4945H20.0592L19.7713 21.4488H20.6375L20.1321 23.1178C20.0639 23.3388 20.1642 23.423 20.2277 23.5256C20.2927 23.6256 20.3586 23.6918 20.5067 23.7294C20.6594 23.7635 20.764 23.7839 20.9063 23.7839H22.6633L22.9764 22.7445L22.1975 22.8514C22.0471 22.8514 21.6306 22.8334 21.6761 22.6943ZM21.8548 16.6552L21.4599 17.3691C21.3754 17.525 21.2993 17.6218 21.2308 17.6664C21.1704 17.704 21.0509 17.7197 20.8778 17.7197H20.6717L20.3963 18.6329H21.0807C21.4097 18.6329 21.6625 18.5123 21.7831 18.4519C21.9128 18.3825 21.9469 18.4222 22.0472 18.3254L22.2783 18.1252H24.4155L24.6991 17.1744H23.1347L23.4078 16.6552H21.8548ZM25.0099 22.7127C24.9735 22.6602 24.9997 22.5678 25.0554 22.3754L25.6395 20.442H27.7175C28.0203 20.4377 28.2389 20.4342 28.3812 20.424C28.5339 20.4079 28.7 20.3534 28.881 20.2555C29.0679 20.1529 29.1635 20.0448 29.2442 19.9206C29.3343 19.7967 29.4789 19.5256 29.603 19.1077L30.3373 16.661L28.1809 16.6735C28.1809 16.6735 27.5169 16.7715 27.2246 16.8796C26.9296 17.0003 26.5081 17.3372 26.5081 17.3372L26.7028 16.6665H25.3708L23.5059 22.8514C23.4397 23.0916 23.3954 23.2659 23.3852 23.3705C23.3817 23.4833 23.5275 23.595 23.6219 23.6792C23.7335 23.7634 23.8985 23.7497 24.0568 23.7634C24.2232 23.776 24.4599 23.7838 24.7866 23.7838H25.8103L26.1245 22.7229L25.2081 22.8094C25.1102 22.8094 25.0394 22.757 25.0099 22.7127ZM26.0164 19.1362H28.199L28.0602 19.5711C28.0407 19.5813 27.9941 19.5495 27.772 19.5758H25.882L26.0164 19.1362ZM26.4536 17.6777H28.6546L28.4963 18.2015C28.4963 18.2015 27.4589 18.1913 27.2928 18.2219C26.5617 18.3484 26.1347 18.7389 26.1347 18.7389L26.4536 17.6777ZM28.1091 21.0274C28.091 21.0924 28.0624 21.1321 28.0225 21.1618C27.9782 21.1904 27.9065 21.2006 27.7995 21.2006H27.4885L27.5069 20.6709H26.2133L26.1608 23.2601C26.1588 23.447 26.1769 23.5551 26.3136 23.6417C26.4503 23.7498 26.8715 23.7635 27.4384 23.7635H28.249L28.5416 22.7944L27.836 22.8331L27.6013 22.8468C27.5693 22.8331 27.5387 22.8206 27.5046 22.7865C27.4748 22.7571 27.4247 22.7751 27.4329 22.5883L27.4384 21.9246L28.1785 21.894C28.5781 21.894 28.7489 21.764 28.8946 21.6401C29.0337 21.5215 29.0791 21.3851 29.1316 21.2006L29.2558 20.6129H28.2388L28.1091 21.0274Z", fill: "var(--fill-0, #FEFEFE)" })
] }) }));
const PaymentVisaIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 38 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Vector", d: "M18.8154 0.213061L16.278 11.8188H13.2042L15.7416 0.213061H18.813H18.8154ZM31.7346 7.70694L33.3497 3.34776L34.2793 7.70694H31.7358H31.7346ZM35.1619 11.8188H38L35.5191 0.213061H32.9023C32.3106 0.213061 31.814 0.548571 31.5939 1.06408L26.9857 11.8188H30.211L30.8507 10.0861H34.7903L35.1631 11.8188H35.1619ZM27.1444 8.0302C27.1564 4.96653 22.8152 4.79755 22.8428 3.42612C22.8524 3.01225 23.2577 2.56898 24.1452 2.4551C24.5841 2.4 25.7963 2.35714 27.1721 2.97551L27.7108 0.514286C26.9712 0.252245 26.0212 0 24.8367 0C21.8026 0 19.6656 1.57714 19.65 3.83633C19.6307 5.50653 21.1748 6.43837 22.3365 6.99551C23.5343 7.56367 23.9359 7.92857 23.9299 8.43674C23.9227 9.21551 22.9763 9.56082 22.0948 9.57306C20.5495 9.59755 19.6536 9.16531 18.9405 8.83837L18.3849 11.3853C19.104 11.7061 20.4293 11.9853 21.8002 12C25.0255 12 27.136 10.4412 27.1456 8.02898L27.1444 8.0302ZM14.4284 0.211837L9.4522 11.8176H6.20526L3.75923 2.55796C3.61132 1.98735 3.48264 1.77796 3.03048 1.53673C2.2909 1.1449 1.07029 0.777551 0 0.549796L0.072154 0.213061H5.29732C5.96354 0.213061 6.56242 0.646531 6.71395 1.39592L8.00791 8.11347L11.2007 0.21551H14.4272L14.4284 0.211837Z", fill: "var(--fill-0, #1334CB)" }) }));
const PaymentWechatPayIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M8.00122 12.6511C7.90186 12.703 7.78999 12.7327 7.67107 12.7327C7.39637 12.7327 7.15725 12.5765 7.0316 12.3459L6.98352 12.2376L4.98113 7.70989C4.95934 7.66035 4.94587 7.60486 4.94587 7.5507C4.94587 7.34196 5.10999 7.17286 5.31257 7.17286C5.39494 7.17286 5.47091 7.20094 5.53213 7.24784L7.89513 8.98144C8.0679 9.09802 8.274 9.16606 8.49581 9.16606C8.62819 9.16606 8.75449 9.14063 8.87212 9.09637L19.9854 3.99993C17.9933 1.58069 14.7126 0 10.9998 0C4.92472 0 0 4.22881 0 9.44514C0 12.2914 1.48184 14.853 3.80092 16.5846C3.98715 16.7217 4.10863 16.9463 4.10863 17.1999C4.10863 17.2838 4.09132 17.3608 4.07017 17.4407C3.8849 18.1528 3.58808 19.2929 3.5743 19.3461C3.55154 19.4356 3.51532 19.5287 3.51532 19.6222C3.51532 19.8309 3.67943 20 3.88201 20C3.96151 20 4.02657 19.9696 4.09389 19.93L6.50208 18.4973C6.68318 18.3896 6.87486 18.3229 7.08609 18.3229C7.1986 18.3229 7.30694 18.3407 7.40951 18.3727C8.53299 18.706 9.74494 18.8909 10.9998 18.8909C17.075 18.8909 22 14.6618 22 9.44514C22 7.86512 21.5458 6.37724 20.7473 5.06837L8.08168 12.6032L8.00122 12.6511Z", fill: "var(--fill-0, #1AAD19)" }) }));
const PersonalAdviceIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M685.2 937c-5 0-10.1-.8-15-2.4-12.2-4-22.2-12.5-28-24s-6.8-24.6-2.8-36.8l22.1-67.4-57.5-41.5c-12.6-9-20.1-23.8-20-39.3.1-12.9 5.1-25 14.3-34 9.1-9 21.1-14 33.9-14h.2l70.9.2 21.8-67.5c4.7-14.7 16.4-26.4 31.1-31.1 25.3-8.1 52.5 5.8 60.7 31.1l21.8 67.5 70.9-.2h.2c15.4 0 30.1 7.5 39.1 20.1 15.5 21.6 10.6 51.8-11 67.3l-57.4 41.5 22.1 67.4c4.8 14.7 2.2 31-6.9 43.5-15.7 21.5-45.9 26.1-67.4 10.4L771 886l-57.3 41.8c-8.3 6.1-18.3 9.2-28.5 9.2m-52.9-211.3 71.8 51.9c8.5 6.1 12.1 17.1 8.8 27l-27.5 84.1 71.5-52.2c8.5-6.2 20-6.2 28.4 0l71.5 52.2-27.5-84.1c-3.3-10 .3-20.9 8.8-27l71.7-51.9-88.5.2h-.1c-10.5 0-19.7-6.7-22.9-16.7L771 625l-27.2 84.3c-3.2 10-12.5 16.7-22.9 16.7h-.1zM107.5 875H59.3c0-82.2 66.9-149.1 149.1-149.1h270.8v48.2H208.4c-55.6 0-100.9 45.3-100.9 100.9m309.3-250c-114.9 0-208.3-93.5-208.3-208.3v-125c0-114.9 93.5-208.3 208.3-208.3 114.9 0 208.3 93.5 208.3 208.3v125c0 114.8-93.5 208.3-208.3 208.3m0-493.5c-88.3 0-160.1 71.8-160.1 160.1v125c0 88.3 71.8 160.1 160.1 160.1s160.1-71.8 160.1-160.1v-125c0-88.2-71.8-160.1-160.1-160.1" }) }));
const PhoneIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M499.664 125c-13.807 0-25 11.193-25 25s11.193 25 25 25c179.318 0 324.65 145.482 324.65 325 0 13.807 11.193 25 25 25s25-11.193 25-25c0-207.082-167.667-375-374.65-375m0 150c-13.807 0-25 11.193-25 25s11.193 25 25 25c96.477 0 174.8 78.291 174.8 175 0 13.807 11.193 25 25 25s25-11.193 25-25c0-124.291-100.676-225-224.8-225m-198.125-48.259a45.65 45.65 0 0 0-32.489 2.941L150.806 285.38l-.434.215c-8.341 4.129-15.219 10.711-19.71 18.862s-6.379 17.5-5.413 26.756c6.565 62.471 33.694 213.668 181.477 361.606 147.789 147.945 298.841 175.075 361.303 181.692l.141.015a45.55 45.55 0 0 0 26.679-5.515 45.55 45.55 0 0 0 18.763-19.753l55.864-118.636a45.696 45.696 0 0 0-16.565-58.747l-114.397-73.786-.255-.159a45.65 45.65 0 0 0-56.592 6.411l-44.824 44.871c-20.374-2.939-70.186-15.129-120.745-65.732-50.599-50.643-62.775-100.592-65.704-120.957l44.79-44.839a45.7 45.7 0 0 0 6.5-56.504l-73.921-114.839a45.65 45.65 0 0 0-26.224-19.6M175.314 329.11l112.231-52.87L357.4 384.76l-43.852 43.9a45.6 45.6 0 0 0-13.037 38.081c3.41 26.931 18.118 89.927 80.216 152.079 62.068 62.123 124.937 76.856 151.906 80.277a45.5 45.5 0 0 0 38.091-13.053l.047-.047 43.802-43.849 108.382 69.904-52.919 112.381c-57.554-6.491-193.533-32.406-327.937-166.951C207.582 522.823 181.734 386.581 175.314 329.11", clipRule: "evenodd" }) }));
const PickupIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", id: "Layer_1", x: 0, y: 0, fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("style", { children: ".st0{fill-rule:evenodd;clip-rule:evenodd}" }),
  /* @__PURE__ */ jsx("path", { d: "M500 275c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125m0 200c-41.4 0-75-33.6-75-75s33.6-75 75-75 75 33.6 75 75-33.6 75-75 75", className: "st0" }),
  /* @__PURE__ */ jsx("path", { d: "M500 100c-162 0-293.3 125.4-293.3 280 0 253.3 293.3 520 293.3 520s293.3-266.7 293.3-520c0-154.6-131.3-280-293.3-280m9.5 719.9c-3.2 3.3-6.4 6.7-9.6 10-3-3.1-6.2-6.5-9.6-10-26.5-27.9-61.8-67.6-97-114.8-72-96.6-136.7-215.4-136.7-325.1 0-124.9 106.7-230 243.3-230s243.3 105.1 243.3 230c0 109.7-64.7 228.5-136.8 325.1-35 47.2-70.3 86.9-96.9 114.8", className: "st0" })
] }));
const PinterestIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 42 42", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M21 0C9.3964 0 0 9.40346 0 21.0158C0 29.9143 5.51802 37.5192 13.3378 40.58C13.1486 38.9076 12.991 36.3832 13.4009 34.553C13.7793 32.9121 15.8604 24.1082 15.8604 24.1082C15.8604 24.1082 15.2297 22.846 15.2297 20.9842C15.2297 18.0496 16.9324 15.8723 19.0135 15.8723C20.8108 15.8723 21.6622 17.2292 21.6622 18.8385C21.6622 20.6371 20.527 23.3509 19.9279 25.8437C19.4234 27.9264 20.9685 29.6304 23.0496 29.6304C26.7703 29.6304 29.6396 25.6859 29.6396 20.006C29.6396 14.9887 26.0135 11.4545 20.8739 11.4545C14.9144 11.4545 11.3829 15.9354 11.3829 20.574C11.3829 22.3727 12.0766 24.3291 12.9595 25.3704C13.1171 25.5913 13.1486 25.7491 13.1171 25.9699C12.9595 26.6326 12.6126 28.0526 12.5496 28.3366C12.455 28.7153 12.2342 28.8099 11.8559 28.6206C9.23874 27.3899 7.5991 23.5718 7.5991 20.4793C7.5991 13.8527 12.4234 7.76258 21.473 7.76258C28.7568 7.76258 34.4009 12.9692 34.4009 19.8798C34.4009 26.7904 29.8288 32.9437 23.5225 32.9437C21.4099 32.9437 19.3919 31.8392 18.6982 30.5455C18.6982 30.5455 17.6577 34.553 17.4054 35.5312C16.9324 37.3614 15.6396 39.6334 14.7883 41.0533C16.7432 41.6529 18.8243 42 21 42C32.6036 42 42 32.5965 42 20.9842C42 9.3719 32.6036 0 21 0Z" }) }));
const PlayIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Outline", fillRule: "evenodd", clipRule: "evenodd", d: "M0 1.00159C0 0.218078 0.860162 -0.261083 1.52635 0.151321L10.5764 5.75375C11.208 6.14469 11.208 7.06333 10.5764 7.45428L1.52635 13.0567C0.860165 13.4691 0 12.9899 0 12.2064V1.00159ZM10.0501 6.60401L1 1.00159V12.2064L10.0501 6.60401Z", fill: "var(--fill-0, #2D2E2C)" }) }));
const PlusIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M484.788 250a4 4 0 0 0-4 4v226.81H254a4 4 0 0 0-4 4v40.077a4 4 0 0 0 4 4h226.788V746a4 4 0 0 0 4 4h40.077a4 4 0 0 0 4-4V528.887H746a4 4 0 0 0 4-4V484.81a4 4 0 0 0-4-4H528.865V254a4 4 0 0 0-4-4z", clipRule: "evenodd" }) }));
const ProfileIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M925 900h-50v-75c0-55.1-44.9-100-100-100H225c-55.1 0-100 44.9-100 100v75H75v-75c0-82.7 67.3-150 150-150h550c82.7 0 150 67.3 150 150zM659.1 165.9c-42.5-42.5-99-65.9-159.1-65.9s-116.6 23.4-159.1 65.9S275 264.9 275 325v50c0 60.1 23.4 116.6 65.9 159.1S439.9 600 500 600s116.6-23.4 159.1-65.9S725 435.1 725 375v-50c0-60.1-23.4-116.6-65.9-159.1M675 375c0 96.5-78.5 175-175 175s-175-78.5-175-175v-50c0-96.5 78.5-175 175-175s175 78.5 175 175z" }) }));
const QrIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 20 20", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("rect", { x: 3.5, y: 3.5, width: 5, height: 5, rx: 1, fill: "none", stroke: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: 3.5, y: 11.5, width: 5, height: 5, rx: 1, fill: "none", stroke: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: 11.5, y: 3.5, width: 5, height: 5, rx: 1, fill: "none", stroke: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: 11, y: 11, width: 2, height: 2 }),
  /* @__PURE__ */ jsx("rect", { x: 13, y: 13, width: 2, height: 2 }),
  /* @__PURE__ */ jsx("rect", { x: 11, y: 15, width: 2, height: 2 }),
  /* @__PURE__ */ jsx("rect", { x: 15, y: 15, width: 2, height: 2 }),
  /* @__PURE__ */ jsx("rect", { x: 15, y: 11, width: 2, height: 2 })
] }));
const RecommendedIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsx("path", { id: "Recommended", d: "M9.77848 15C10.0497 15 10.2034 14.8624 10.2396 14.5873C10.3481 13.7188 10.4656 13.0439 10.5922 12.5623C10.7188 12.0722 10.9132 11.7025 11.1754 11.4531C11.4467 11.2038 11.8445 11.0146 12.3689 10.8856C12.8933 10.7567 13.6166 10.6234 14.5389 10.4858C14.8463 10.4342 15 10.288 15 10.0473C15 9.80653 14.8644 9.66036 14.5931 9.60877C13.6709 9.4454 12.9385 9.29923 12.396 9.17025C11.8626 9.03267 11.4602 8.84351 11.189 8.60275C10.9177 8.362 10.7188 8.00516 10.5922 7.53224C10.4656 7.05073 10.3481 6.37575 10.2396 5.50731C10.2034 5.23216 10.0497 5.09458 9.77848 5.09458C9.50723 5.09458 9.35353 5.22786 9.31736 5.49441C9.19982 6.37145 9.07776 7.05933 8.95117 7.55804C8.83363 8.04815 8.63924 8.42218 8.36799 8.68014C8.10579 8.92949 7.70796 9.11866 7.1745 9.24763C6.64105 9.36801 5.90416 9.48839 4.96383 9.60877C4.84629 9.62597 4.74684 9.67326 4.66546 9.75064C4.59313 9.82803 4.55696 9.92691 4.55696 10.0473C4.55696 10.288 4.69259 10.4342 4.96383 10.4858C5.90416 10.6492 6.64105 10.7997 7.1745 10.9372C7.70796 11.0748 8.10579 11.2683 8.36799 11.5176C8.63924 11.7584 8.83363 12.1195 8.95117 12.601C9.07776 13.0825 9.19982 13.7532 9.31736 14.6131C9.33544 14.7248 9.38517 14.8194 9.46655 14.8968C9.54792 14.9656 9.6519 15 9.77848 15ZM3.29566 6.26827C3.44937 6.26827 3.53978 6.19089 3.56691 6.03611C3.67541 5.50301 3.77034 5.08598 3.85172 4.78504C3.94213 4.47549 4.0642 4.24334 4.2179 4.08856C4.38065 3.92519 4.62477 3.80052 4.95027 3.71453C5.28481 3.61995 5.74593 3.51677 6.33363 3.40499C6.50543 3.37919 6.59132 3.28891 6.59132 3.13414C6.59132 2.98796 6.50543 2.90198 6.33363 2.87618C5.74593 2.7558 5.28933 2.65262 4.96383 2.56664C4.64738 2.47206 4.40778 2.34738 4.24503 2.19261C4.09132 2.02923 3.96926 1.79708 3.87884 1.49613C3.79747 1.19518 3.69349 0.77816 3.56691 0.245056C3.53978 0.0816853 3.44937 0 3.29566 0C3.14195 0 3.04702 0.0816853 3.01085 0.245056C2.89331 0.77816 2.78933 1.19518 2.69892 1.49613C2.61754 1.79708 2.49548 2.02923 2.33273 2.19261C2.17902 2.34738 1.93942 2.47206 1.61392 2.56664C1.29747 2.65262 0.845389 2.7558 0.257685 2.87618C0.0858951 2.90198 0 2.98796 0 3.13414C0 3.28891 0.0858951 3.37919 0.257685 3.40499C0.845389 3.52537 1.30199 3.63285 1.62749 3.72743C1.95298 3.81341 2.19711 3.93379 2.35986 4.08856C2.5226 4.24334 2.64467 4.47549 2.72604 4.78504C2.80741 5.08598 2.90235 5.50301 3.01085 6.03611C3.04702 6.19089 3.14195 6.26827 3.29566 6.26827Z", fill: `url(#${uid}paint0_linear_13120_20417)` }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_13120_20417`, x1: 12.5, y1: 13.75, x2: 0.749872, y2: 1.06525, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#DBA4EE" }),
      /* @__PURE__ */ jsx("stop", { offset: 0.395833, stopColor: "#B758D8" }),
      /* @__PURE__ */ jsx("stop", { offset: 0.630208, stopColor: "#B758D8" }),
      /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#743FE5" })
    ] }) })
  ] }));
};
const RefreshIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M790 270c-72-88-176-137-290-137-202 0-367 165-367 367h67c0-165 135-300 300-300 96 0 183 45 239 121l-121 121h282V160zm-29 230c0 165-135 300-300 300-96 0-183-45-239-121l121-121H61v282l113-113c72 88 176 137 290 137 202 0 367-165 367-367z" }) }));
const ResetIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M250 500c0-137.851 106.798-250 238.089-250 100.91 0 190.517 67.218 224.126 165.624l24.356.251c12.539.07 17.11 9.099 10.222 20.087l-39.042 84.341c-6.937 10.997-18.143 10.91-24.941-.147l-52.297-85.009c-6.823-11.048-2.114-20.043 10.425-19.974l25.055.156c-31.211-72.244-100.495-120.424-177.888-120.424-107.708 0-195.322 92.019-195.322 205.086 0 113.077 87.614 205.13 195.322 205.13 56.225 0 109.726-25.476 146.84-69.861 7.782-9.333 21.298-10.26 30.145-2.071 8.897 8.198 9.791 22.383 2.017 31.698C621.869 719.003 556.634 750 488.105 750 356.798 750 250 637.877 250 500" }) }));
const ReturnArrowIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.70703 12.3535H11.207C12.8639 12.3535 14.207 11.0104 14.207 9.35355C14.207 7.6967 12.8639 6.35355 11.207 6.35355H2.91414L5.06059 8.5L4.35348 9.20711L0.999925 5.85355L4.35348 2.5L5.06059 3.20711L2.91414 5.35355H11.207C13.4162 5.35355 15.207 7.14442 15.207 9.35355C15.207 11.5627 13.4162 13.3535 11.207 13.3535H7.70703V12.3535Z" }) }));
const SearchIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M721.8 686.5C770.6 629.6 800 555.7 800 475c0-179.5-145.5-325-325-325S150 295.5 150 475s145.5 325 325 325c80.7 0 154.6-29.4 211.5-78.2l170.9 170.9 35.4-35.4zM475 750c-151.9 0-275-123.1-275-275s123.1-275 275-275 275 123.1 275 275-123.1 275-275 275", clipRule: "evenodd" }) }));
const ShareIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M768.182 508.337c-13.637 0-27.273 12.5-27.273 25v212.5H254.545v-212.5c0-12.5-13.636-25-27.272-25-13.637 0-27.273 12.5-27.273 25v266.667h600V533.337c0-12.5-13.636-25-31.818-25" }),
  /* @__PURE__ */ jsx("path", { d: "m379.933 365.768 87.318-80.862v315.363c0 4.044 0 8.087 4.366 12.13 4.366 8.086 13.098 16.172 26.196 16.172 13.097 0 26.195-12.129 26.195-24.258V288.949l87.318 80.862c8.732 8.087 26.196 8.087 39.293 0 8.732-8.086 8.732-24.258 0-36.388L519.642 212.129 506.545 200c-13.098 0-21.83 0-30.562 8.086L340.64 329.38c-8.732 8.086-8.732 24.259 0 36.388 13.098 12.13 30.561 12.13 39.293 0" })
] }));
const ShowIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M499.9 275c161-2 307.1 77.2 369.6 200.3l-.2.3c3.8 7.7 5.7 16 5.7 24.5s-2 16.8-5.7 24.5C806.8 647.8 660.6 727 499.9 725c-160.4 1.8-306.5-77.4-369.1-200.4-3.8-7.7-5.8-16.1-5.8-24.6s2-16.9 5.8-24.6C193.3 352.2 339.5 273 499.9 275m0 404.7c139 2.1 265.3-66.3 319.6-171.9l-.2-.3c1.2-2.4 1.8-5 1.8-7.7s-.6-5.3-1.8-7.7c-54.2-106-180.7-174.2-319.4-172.1-138.5-2-264.8 66.2-319.3 172.4q-1.8 3.6-1.8 7.5c0 2.6.6 5.2 1.8 7.5 54 106.2 180.6 174.4 319.3 172.3m-33.2-300.2c21.8-6 44.8-6 66.6 0 15.7 4 30.4 11.3 43.3 21.2 12.9 10 23.7 22.4 31.9 36.7 8.1 14.3 13.4 30.1 15.5 46.5s1 33.1-3.3 49.1c-9.4 32.3-30.8 59.6-59.6 75.9s-62.7 20.4-94.4 11.4c-15.7-4.1-30.4-11.3-43.3-21.3s-23.7-22.5-31.9-36.8-13.4-30.1-15.5-46.5-1-33.1 3.3-49.1c1.9-6.4 6.2-11.9 11.9-15.1 5.8-3.3 12.5-4.1 18.9-2.3 3.1.8 6.1 2.3 8.7 4.2 2.6 2 4.8 4.5 6.4 7.4s2.7 6 3.1 9.3.2 6.6-.6 9.8c-3.6 13.1-3.6 26.9 0 40 5.7 19.4 18.5 35.7 35.8 45.5s37.6 12.2 56.6 6.8c9.4-2.4 18.2-6.8 26-12.8 7.7-6 14.2-13.5 19.1-22.1s8-18.1 9.3-27.9.6-19.9-2-29.4c-5.7-19.4-18.6-35.7-35.8-45.5-17.3-9.8-37.6-12.2-56.6-6.8-6.3 1.8-13.1 1-18.9-2.3s-10-8.7-11.9-15.2c-.8-3.2-1.1-6.5-.6-9.8.4-3.3 1.5-6.4 3.1-9.3s3.8-5.4 6.4-7.3c2.4-2 5.3-3.5 8.5-4.3", clipRule: "evenodd" }) }));
const SilkIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 25 25", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M.5 24.137v-1.13A7.27 7.27 0 0 1 4.52 16.5l10.98-5.49" }),
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M18.869 5.43c1.625.12 3.39.471 4.889 1.081-.526 4.232-3.241 8.195-7.424 10.478s-9.062 2.394-13.2.709a13.6 13.6 0 0 1 2.611-6.457" }),
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M19.75 4.317c-2.248 3.567-5.992 3.568-7.85 3.722-1.11.092-1.684.2-2.073.401-.225.117-.552.339-.824 1.216a2.491 2.491 0 0 1-4.758-1.474c.618-1.991 1.743-3.36 3.29-4.162 1.383-.717 2.9-.855 3.953-.942 2.47-.206 3.345-.3 4.047-1.415a2.49 2.49 0 0 1 4.215 2.654Z" })
] }));
const SizePassportIcon = (props) => {
  const uid = useId$1().replace(/[^a-zA-Z0-9_-]/g, "");
  return /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "xMidYMid meet", width: "1em", height: "1em", overflow: "visible", style: {
    display: "block"
  }, viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: [
    /* @__PURE__ */ jsxs("g", { id: "Outline", children: [
      /* @__PURE__ */ jsxs("g", { id: "Intersect", children: [
        /* @__PURE__ */ jsx("path", { d: "M16.175 1.19976L16.6249 0C17.5888 0.0173395 18.2498 0.984325 17.9095 1.89134L13.6377 13.0913C13.4327 13.6378 12.9108 13.9998 12.3268 13.9998H11.375L11.825 12.7998H12.1224C12.3299 12.7998 12.5157 12.6716 12.5896 12.4777L16.6986 1.68795C16.7874 1.45143 16.611 1.19976 16.3584 1.19976H16.175Z", fill: "var(--fill-0, #D9D9D9)" }),
        /* @__PURE__ */ jsx("path", { d: "M16.175 1.19976L16.6249 0C17.5888 0.0173395 18.2498 0.984325 17.9095 1.89134L13.6377 13.0913C13.4327 13.6378 12.9108 13.9998 12.3268 13.9998H11.375L11.825 12.7998H12.1224C12.3299 12.7998 12.5157 12.6716 12.5896 12.4777L16.6986 1.68795C16.7874 1.45143 16.611 1.19976 16.3584 1.19976H16.175Z", fill: `url(#${uid}paint0_linear_13120_20401)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_2", children: [
        /* @__PURE__ */ jsx("path", { d: "M13.0496 13.7989L12.5706 12.5213C12.487 12.6906 12.3139 12.7998 12.1224 12.7998H1.63689C1.42685 12.7998 1.28183 12.5895 1.35647 12.3932L1.77213 11.2998H0.489896L0.0778684 12.3776C0.0247574 12.5188 0 12.6617 0 12.8012C0 13.4366 0.51405 13.9998 1.2019 13.9998H12.3268C12.5877 13.9998 12.8362 13.9275 13.0496 13.7989Z", fill: "var(--fill-0, #D9D9D9)" }),
        /* @__PURE__ */ jsx("path", { d: "M13.0496 13.7989L12.5706 12.5213C12.487 12.6906 12.3139 12.7998 12.1224 12.7998H1.63689C1.42685 12.7998 1.28183 12.5895 1.35647 12.3932L1.77213 11.2998H0.489896L0.0778684 12.3776C0.0247574 12.5188 0 12.6617 0 12.8012C0 13.4366 0.51405 13.9998 1.2019 13.9998H12.3268C12.5877 13.9998 12.8362 13.9275 13.0496 13.7989Z", fill: `url(#${uid}paint1_linear_13120_20401)` })
      ] }),
      /* @__PURE__ */ jsxs("g", { id: "Intersect_3", children: [
        /* @__PURE__ */ jsx("path", { d: "M17.5028 0.329907L16.6899 1.41367C16.634 1.29035 16.51 1.2 16.3586 1.2H5.88755C5.72147 1.2 5.57282 1.30262 5.51381 1.45786L5.19367 2.3H3.93066L4.48781 0.842611C4.67847 0.335701 5.16361 0 5.70551 0H16.5987C16.9501 0 17.2626 0.126001 17.5028 0.329907Z", fill: "var(--fill-0, #D9D9D9)" }),
        /* @__PURE__ */ jsx("path", { d: "M17.5028 0.329907L16.6899 1.41367C16.634 1.29035 16.51 1.2 16.3586 1.2H5.88755C5.72147 1.2 5.57282 1.30262 5.51381 1.45786L5.19367 2.3H3.93066L4.48781 0.842611C4.67847 0.335701 5.16361 0 5.70551 0H16.5987C16.9501 0 17.2626 0.126001 17.5028 0.329907Z", fill: `url(#${uid}paint2_linear_13120_20401)` })
      ] }),
      /* @__PURE__ */ jsx("path", { id: "Vector", d: "M6.8 6.40039H0V6.90039H6.8V6.40039Z", fill: "var(--fill-0, #2D2E2C)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_2", d: "M6 8.90039H1V9.40039H6V8.90039Z", fill: "var(--fill-0, #2D2E2C)" }),
      /* @__PURE__ */ jsx("path", { id: "Vector_3", d: "M7.40039 3.90039H2.40039V4.40039H7.40039V3.90039Z", fill: "var(--fill-0, #2D2E2C)" })
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint0_linear_13120_20401`, x1: 17.0458, y1: 0.590532, x2: 12.2882, y2: 13.3863, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#58B64A" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#DC9F1C" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint1_linear_13120_20401`, x1: -905854e-15, y1: 12.7726, x2: 12.0771, y2: 12.7337, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E42922" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#DC9F1C" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: `${uid}paint2_linear_13120_20401`, x1: 4.95693, y1: 1.46001, x2: 16.5933, y2: 1.54265, gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#2085CE" }),
        /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#58B64A" })
      ] })
    ] })
  ] }));
};
const StoreAppointmentIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M145.8 166.7c0-11.5 9.3-20.8 20.8-20.8h666.7c11.5 0 20.8 9.3 20.8 20.8V875c0 11.5-9.3 20.8-20.8 20.8H166.7c-11.5 0-20.8-9.3-20.8-20.8V166.7zm41.7 20.8v666.7h625V187.5z", clipRule: "evenodd" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M479.2 500c0-11.5 9.3-20.8 20.8-20.8h166.7c11.5 0 20.8 9.3 20.8 20.8v375c0 11.5-9.3 20.8-20.8 20.8H500c-11.5 0-20.8-9.3-20.8-20.8zm41.6 20.8v333.3h125V520.8z", clipRule: "evenodd" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M312.5 500c0-11.5 9.3-20.8 20.8-20.8H500c11.5 0 20.8 9.3 20.8 20.8v375c0 11.5-9.3 20.8-20.8 20.8H333.3c-11.5 0-20.8-9.3-20.8-20.8zm41.7 20.8v333.3h125V520.8zm479.1-187.5H166.7v-41.7h666.7v41.7z", clipRule: "evenodd" })
] }));
const StoreIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M825 150H175c-41.4 0-75 33.6-75 75v625h800V225c0-41.4-33.6-75-75-75M475 800H350V500h125zm175 0H525V500h125zm200 0H700V450H300v350H150V225c0-13.8 11.2-25 25-25h650c13.8 0 25 11.2 25 25z", clipRule: "evenodd" }) }));
const ThumbsDownIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", strokeLinecap: "round", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M7 10v10H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3zm0 0 4-7a2 2 0 0 1 2 2v4h5.2a2 2 0 0 1 2 2.3l-1.2 7A2 2 0 0 1 17 20H7", transform: "rotate(180 12 12)" }) }));
const ThumbsUpIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", strokeLinecap: "round", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M7 10v10H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3zm0 0 4-7a2 2 0 0 1 2 2v4h5.2a2 2 0 0 1 2 2.3l-1.2 7A2 2 0 0 1 17 20H7" }) }));
const TiktokIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M713.89 290.311c-37.678-24.591-64.879-63.92-73.358-109.771-1.834-9.911-2.838-20.103-2.838-30.54H517.431l-.198 482.305c-2.021 54.009-46.437 97.358-100.898 97.358-16.923 0-32.866-4.231-46.892-11.629-32.177-16.947-54.193-50.701-54.193-89.539 0-55.786 45.351-101.169 101.085-101.169 10.406 0 20.381 1.718 29.829 4.675V409.14c-9.775-1.333-19.703-2.162-29.829-2.162C294.298 406.989 195 506.358 195 628.495c0 74.941 37.421 141.257 94.498 181.358C325.447 835.11 369.186 850 416.347 850c122.049 0 221.347-99.369 221.347-221.505V383.929c47.161 33.883 104.95 53.846 167.306 53.846V317.426c-33.59 0-64.879-9.993-91.11-27.115" }) }));
const TrashIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsxs("g", { id: "Outline", children: [
  /* @__PURE__ */ jsx("path", { d: "M5.5 1C5.22386 1 5 1.22386 5 1.5V2H4V1.5C4 0.671573 4.67157 0 5.5 0H8.5C9.32843 0 10 0.671573 10 1.5V2H9V1.5C9 1.22386 8.77614 1 8.5 1H5.5Z", fill: "currentColor" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.53993 4H0V3H14V4H12.4601L11.5747 14.6246C11.5099 15.402 10.86 16 10.0799 16H3.92013C3.14 16 2.4901 15.402 2.42531 14.6246L1.53993 4ZM2.5434 4L3.42186 14.5415C3.44346 14.8007 3.66009 15 3.92013 15H10.0799C10.3399 15 10.5565 14.8007 10.5781 14.5415L11.4566 4H2.5434Z", fill: "currentColor" })
] }) }));
const TwitterIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M691.486 200.034H793.64l-223.121 254.14L833 800H627.437L466.464 590.268 282.262 800H180.109l238.64-271.814L167 200h210.725l145.521 191.716L691.52 200zM655.658 739.08h56.578L346.957 257.74h-60.722z" }) }));
const UnlinkedIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "m18.84 12.25 1.72-1.71a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
  /* @__PURE__ */ jsx("path", { d: "m5.17 11.75-1.71 1.71a5 5 0 0 0 7.07 7.07l1.71-1.71" }),
  /* @__PURE__ */ jsx("path", { d: "M8 2v3M2 8h3M16 19v3M19 16h3" })
] }));
const WarningIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { d: "M474.9,599.98v-250h50v250h-50Z" }),
  /* @__PURE__ */ jsx("path", { d: "M499.9,649.98c-16.57,0-30,13.43-30,30s13.43,30,30,30,30-13.43,30-30-13.43-30-30-30Z" }),
  /* @__PURE__ */ jsx("path", { d: "M435.59,133.58c29.13-48.55,99.49-48.55,128.62,0l361.69,602.82c29.99,49.99-6.02,113.59-64.31,113.59H138.21c-58.3,0-94.31-63.6-64.31-113.59L435.59,133.58ZM521.34,159.31c-9.71-16.18-33.17-16.18-42.88,0L116.77,762.13c-10,16.66,2.01,37.86,21.44,37.86h723.38c19.43,0,31.43-21.2,21.43-37.86L521.34,159.31Z" })
] }));
const WhatsappIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M701.1 585.1c-2.3-3.8-8.5-6.1-17.6-10.6-9.2-4.5-54.4-26.7-62.9-29.7-8.4-3-14.6-4.5-20.7 4.5-6.1 9.1-23.8 29.7-29.2 35.8-5.3 6.1-10.7 6.8-19.9 2.3s-38.8-14.2-74-45.2C449.5 518 431 488.1 425.7 479s-.5-14.1 4-18.6c4.1-4.1 9.2-10.6 13.8-15.9 4.6-5.4 6.1-9.2 9.2-15.3s1.5-11.4-.8-16c-2.3-4.5-20.7-49.4-28.4-67.7-7.6-18.2-15.3-15.2-20.7-15.2-5.3 0-11.5-.8-17.6-.8s-16.1 2.3-24.5 11.4-32.2 31.2-32.2 76c0 44.9 32.9 88.3 37.5 94.4S429.6 612.5 523.1 649s93.5 24.3 110.3 22.8 54.4-22 62.1-43.4c7.9-21.2 7.9-39.5 5.6-43.3", clipRule: "evenodd" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M512.7 157.3c-185.4 0-335.5 149.1-335.5 332.7 0 62.8 17.6 121.6 48.1 171.7l5.1 8.3-54.3 160 166.5-53 7.8 4.3c48 26.4 103.3 41.4 162.2 41.4 185.4 0 335.5-149.1 335.5-332.7 0-183.5-150-332.7-335.4-332.7M135.5 490.1c0-206.9 169-374.4 377.2-374.4 208.1 0 377.1 167.5 377.1 374.4s-169 374.4-377.1 374.4c-62.9 0-122.1-15.3-174.3-42.3l-228.2 72.5L184.7 675c-31.3-54.6-49.2-117.7-49.2-184.9", clipRule: "evenodd" })
] }));
const WishlistActiveIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M250 175c0-41.4 33.6-75 75-75h350c41.4 0 75 33.6 75 75v721.7L500 730 250 896.7z", clipRule: "evenodd" }) }));
const WishlistOutlineIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Outline", fillRule: "evenodd", clipRule: "evenodd", d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H8.5C9.32843 0 10 0.671572 10 1.5V15.9343L5 12.6009L0 15.9343V1.5ZM1.5 1C1.22386 1 1 1.22386 1 1.5V14.0657L5 11.3991L9 14.0657V1.5C9 1.22386 8.77614 1 8.5 1H1.5Z", fill: "var(--fill-0, #2D2E2C)" }) }));
const WishlistSavedIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M250 175c0-41.4 33.6-75 75-75h350c41.4 0 75 33.6 75 75v721.7L500 730 250 896.7z", clipRule: "evenodd" }) }));
const WishlistIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M675 100H325c-41.4 0-75 33.6-75 75v721.7L500 730l250 166.7V175c0-41.4-33.6-75-75-75m25 703.3L500 670 300 803.3V175c0-13.8 11.2-25 25-25h350c13.8 0 25 11.2 25 25z", clipRule: "evenodd" }) }));
const WoolIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 25 25", width: "1em", height: "1em" }, props), { children: [
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M12.5.5c1.592 0 3 .79 3.852 2.001l.183.259.312-.055a4.7 4.7 0 0 1 4.138 1.31 4.7 4.7 0 0 1 1.31 4.138l-.055.312.259.182A4.7 4.7 0 0 1 24.5 12.5c0 1.592-.79 3-2.001 3.852l-.259.183.055.312a4.7 4.7 0 0 1-1.31 4.138 4.7 4.7 0 0 1-4.138 1.31l-.313-.055-.181.259A4.7 4.7 0 0 1 12.5 24.5c-1.592 0-3-.79-3.853-2.001l-.182-.259-.312.055a4.7 4.7 0 0 1-4.138-1.31 4.7 4.7 0 0 1-1.31-4.138l.055-.312-.259-.183A4.7 4.7 0 0 1 .5 12.5c0-1.592.79-3 2.001-3.853l.259-.182-.055-.312a4.7 4.7 0 0 1 1.31-4.138 4.7 4.7 0 0 1 4.138-1.31l.312.055.182-.259A4.7 4.7 0 0 1 12.5.5Z" }),
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "M18.952 7.5c-5 .455-7.88.436-12.813 0-.64 1.995 1.084 2.494 2.027 2.494a8.4 8.4 0 0 0-.425 2.666c0 3.577 2.15 6.476 4.805 6.476 2.653 0 4.804-2.9 4.804-6.476 0-.95-.152-1.853-.425-2.666.943 0 2.667-.5 2.027-2.494ZM12.498 16.864l-1.455-1.09m1.455 1.09 1.454-1.09m-1.454 1.09v1.818" }),
  /* @__PURE__ */ jsx("path", { stroke: "#000", d: "m14.5 13.5.053-.105A1.62 1.62 0 0 1 16 12.5M10.5 13.5l-.053-.105A1.62 1.62 0 0 0 9 12.5" })
] }));
const XIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ preserveAspectRatio: "none", width: "1em", height: "1em", overflow: "visible", style: {
  display: "block"
}, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx("path", { id: "Outline", d: "M8.3319 5.925L13.5437 0H12.3087L7.78327 5.1446L4.16883 0H0L5.46574 7.77954L0 13.9928H1.2351L6.01406 8.55995L9.83117 13.9928H14L8.3319 5.925ZM1.68013 0.909309H3.57717L12.3093 13.1249H10.4122L1.68013 0.909309Z", fill: "var(--fill-0, #2D2E2C)" }) }));
const YoutubeIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em" }, props), { children: /* @__PURE__ */ jsx("path", { d: "M754.09 207.137c-120.133-8.199-387.7-8.166-507.666 0-129.9 8.867-145.2 87.333-146.167 293.863.967 206.164 16.133 284.963 146.167 293.863 119.999 8.166 387.533 8.199 507.666 0 129.9-8.867 145.2-87.333 146.167-293.863-.967-206.164-16.134-284.963-146.167-293.863M400.257 634.331V367.669l266.666 133.098z" }) }));
const iconMap = {
  alterations: AlterationsIcon,
  apple: AppleIcon,
  "arrow-back": ArrowBackIcon,
  "arrow-forward": ArrowForwardIcon,
  "arrow-top-right": ArrowTopRightIcon,
  bag: BagIcon,
  "base-style": BaseStyleIcon,
  bell: BellIcon,
  "brand-pickup": BrandPickupIcon,
  "brand-register": BrandRegisterIcon,
  "brand-return-package": BrandReturnPackageIcon,
  "buy-again": BuyAgainIcon,
  calendar: CalendarIcon,
  call: CallIcon,
  cart: CartIcon,
  cashmere: CashmereIcon,
  change: ChangeIcon,
  check: CheckIcon,
  checkmark: CheckmarkIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  circle: CircleIcon,
  clock: ClockIcon,
  close: CloseIcon,
  copy: CopyIcon,
  cotton: CottonIcon,
  "csr-co2": CsrCo2Icon,
  "csr-fair-wear": CsrFairWearIcon,
  "csr-zero-waste": CsrZeroWasteIcon,
  "custom-made": CustomMadeIcon,
  "delivery-dhl": DeliveryDhlIcon,
  "delivery-dpd": DeliveryDpdIcon,
  "delivery-fedex": DeliveryFedexIcon,
  "delivery-sf-express": DeliverySfExpressIcon,
  "delivery-tnt": DeliveryTntIcon,
  "delivery-ups": DeliveryUpsIcon,
  delivery: DeliveryIcon,
  document: DocumentIcon,
  dot: DotIcon,
  dots: DotsIcon,
  edit: EditIcon,
  email: EmailIcon,
  facebook: FacebookIcon,
  filter: FilterIcon,
  "free-returns": FreeReturnsIcon,
  gift: GiftIcon,
  google: GoogleIcon,
  "gradient-checkmark": GradientCheckmarkIcon,
  "gradient-circle": GradientCircleIcon,
  hide: HideIcon,
  home: HomeIcon,
  "info-circle": InfoCircleIcon,
  info: InfoIcon,
  instagram: InstagramIcon,
  linen: LinenIcon,
  link: LinkIcon,
  linkedin: LinkedinIcon,
  "location-full": LocationFullIcon,
  location: LocationIcon,
  lock: LockIcon,
  logout: LogoutIcon,
  "look-builder": LookBuilderIcon,
  menu: MenuIcon,
  message: MessageIcon,
  minus: MinusIcon,
  none: NoneIcon,
  "payment-alipay": PaymentAlipayIcon,
  "payment-amex": PaymentAmexIcon,
  "payment-apple-pay": PaymentApplePayIcon,
  "payment-bancontact": PaymentBancontactIcon,
  "payment-credit-card": PaymentCreditCardIcon,
  "payment-dotpay": PaymentDotpayIcon,
  "payment-giropay": PaymentGiropayIcon,
  "payment-google-pay": PaymentGooglePayIcon,
  "payment-ideal": PaymentIdealIcon,
  "payment-klarna": PaymentKlarnaIcon,
  "payment-mastercard": PaymentMastercardIcon,
  "payment-paypal": PaymentPaypalIcon,
  "payment-paytrail": PaymentPaytrailIcon,
  "payment-trustly": PaymentTrustlyIcon,
  "payment-unionpay": PaymentUnionpayIcon,
  "payment-visa": PaymentVisaIcon,
  "payment-wechat-pay": PaymentWechatPayIcon,
  "personal-advice": PersonalAdviceIcon,
  phone: PhoneIcon,
  pickup: PickupIcon,
  pinterest: PinterestIcon,
  play: PlayIcon,
  plus: PlusIcon,
  profile: ProfileIcon,
  qr: QrIcon,
  recommended: RecommendedIcon,
  refresh: RefreshIcon,
  reset: ResetIcon,
  "return-arrow": ReturnArrowIcon,
  search: SearchIcon,
  share: ShareIcon,
  show: ShowIcon,
  silk: SilkIcon,
  "size-passport": SizePassportIcon,
  "store-appointment": StoreAppointmentIcon,
  store: StoreIcon,
  "thumbs-down": ThumbsDownIcon,
  "thumbs-up": ThumbsUpIcon,
  tiktok: TiktokIcon,
  trash: TrashIcon,
  twitter: TwitterIcon,
  unlinked: UnlinkedIcon,
  warning: WarningIcon,
  whatsapp: WhatsappIcon,
  "wishlist-active": WishlistActiveIcon,
  "wishlist-outline": WishlistOutlineIcon,
  "wishlist-saved": WishlistSavedIcon,
  wishlist: WishlistIcon,
  wool: WoolIcon,
  x: XIcon,
  youtube: YoutubeIcon
};
const falsyToString = (value) => typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const cx = clsx;
const cva = (base, config) => (props) => {
  var _config_compoundVariants;
  if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  const { variants, defaultVariants } = config;
  const getVariantClassNames = Object.keys(variants).map((variant) => {
    const variantProp = props === null || props === void 0 ? void 0 : props[variant];
    const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
    if (variantProp === null) return null;
    const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
    return variants[variant][variantKey];
  });
  const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
    let [key, value] = param;
    if (value === void 0) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param) => {
    let _a = param, { class: cvClass, className: cvClassName } = _a, compoundVariantOptions = __objRest(_a, ["class", "className"]);
    return Object.entries(compoundVariantOptions).every((param2) => {
      let [key, value] = param2;
      return Array.isArray(value) ? value.includes(__spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key]) : __spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key] === value;
    }) ? [
      ...acc,
      cvClass,
      cvClassName
    ] : acc;
  }, []);
  return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
};
const iconVariants = cva("flex shrink-0 items-center justify-center leading-none transition-[color]", {
  variants: {
    size: {
      "extra-small": "text-xs",
      // xs
      small: "text-base",
      // base
      medium: "text-xl",
      // xl
      large: "text-2xl",
      // 2xl
      "extra-large": "text-[28px]"
      // 28px
    },
    color: {
      current: "text-current",
      text: "text-text",
      black: "text-black",
      white: "text-white",
      default: "text-icon",
      hover: "text-icon-hover",
      pressed: "text-icon-pressed",
      selected: "text-icon-selected",
      disabled: "text-icon-disabled",
      secondary: "text-icon-secondary",
      tertiary: "text-icon-tertiary",
      inverse: "text-icon-inverse",
      "inverse-secondary": "text-icon-inverse-secondary",
      info: "text-icon-info",
      error: "text-icon-error",
      success: "text-icon-success",
      warning: "text-icon-warning"
    }
  },
  defaultVariants: {
    size: "medium",
    color: "default"
  }
});
const Icon = forwardRef((_a, ref) => {
  var _b = _a, {
    name,
    className,
    size: size2 = "medium",
    color = "default",
    ariaLabel
  } = _b, props = __objRest(_b, [
    "name",
    "className",
    "size",
    "color",
    "ariaLabel"
  ]);
  const IconComponent = iconMap[name];
  const isNumericSize = typeof size2 === "number";
  const inlineStyles = isNumericSize ? {
    height: `${size2}px`
  } : void 0;
  const isValidComponent = IconComponent && typeof IconComponent === "function";
  return /* @__PURE__ */ jsx("span", __spreadProps(__spreadValues({ ref, className: cn(isNumericSize ? iconVariants({
    color
  }) : iconVariants({
    size: size2,
    color
  }), className), style: inlineStyles, "aria-label": ariaLabel, "aria-hidden": ariaLabel ? void 0 : "true" }, props), { children: isValidComponent ? /* @__PURE__ */ jsx(IconComponent, { className: "h-full w-auto" }) : /* @__PURE__ */ jsx("span", { className: "h-full w-auto bg-gray-200", title: `Icon: ${name}` }) }));
});
Icon.displayName = "Icon";
const accordionButtonVariants = cva("flex w-full items-center justify-between overflow-hidden text-left transition-colors", {
  variants: {
    disabled: {
      true: "cursor-default text-text-disabled",
      false: "cursor-pointer hover:text-text-inverse-hover"
    },
    size: {
      s: "py-8 text-sm leading-sm font-light",
      m: "py-16 text-base leading-base font-medium",
      l: "py-24 text-lg leading-lg font-medium",
      "lg-compact": "py-24 text-sm leading-sm font-medium"
    }
  },
  defaultVariants: {
    disabled: false,
    size: "s"
  }
});
const accordionIconWrapperVariants = cva("relative size-20 shrink-0 transition-transform", {
  variants: {
    expanded: {
      true: "rotate-180",
      false: ""
    }
  },
  defaultVariants: {
    expanded: false
  }
});
const accordionIconVariants = cva("inset-0 absolute text-current transition-opacity", {
  variants: {
    visible: {
      true: "opacity-100",
      false: "opacity-0"
    }
  },
  defaultVariants: {
    visible: true
  }
});
const accordionContentWrapperVariants = cva("transition-grid ease-in-out grid duration-300", {
  variants: {
    expanded: {
      true: "grid-rows-[1fr]",
      false: "grid-rows-[0fr]"
    }
  },
  defaultVariants: {
    expanded: false
  }
});
const accordionContentVariants = cva("", {
  variants: {
    size: {
      s: "pb-8",
      m: "pb-16",
      l: "pb-24",
      "lg-compact": "pb-24"
    },
    expanded: {
      true: "visible",
      false: "invisible delay-300"
    }
  },
  defaultVariants: {
    size: "s",
    expanded: false
  }
});
const Accordion = ({
  className,
  headerClassName,
  contentClassName,
  open,
  defaultOpen,
  children,
  disabled,
  title,
  titleTag: TitleTag = "span",
  size: size2,
  onClick,
  headerProps,
  skipAnimation,
  dataTestId
}) => {
  const [expanded, setExpanded] = useState(!!defaultOpen);
  const uniqueId = useId$1();
  useEffect(() => {
    if (open !== void 0) setExpanded(!!open);
  }, [open]);
  return /* @__PURE__ */ jsxs("div", { className: cn("w-full border-b border-border-tertiary", className), "data-testid": dataTestId, children: [
    /* @__PURE__ */ jsx(TitleTag, { className: "contents", children: /* @__PURE__ */ jsxs("button", __spreadProps(__spreadValues({ type: "button", className: accordionButtonVariants({
      disabled,
      size: size2,
      className: headerClassName
    }), onClick: (event) => {
      if (open === void 0) {
        setExpanded(!expanded);
      } else {
        onClick == null ? void 0 : onClick(event);
      }
    }, id: `accordion-button-${uniqueId}`, disabled, "aria-expanded": expanded, "aria-controls": `accordion-content-${uniqueId}`, "data-testid": dataTestId ? `${dataTestId}-button` : void 0 }, headerProps), { children: [
      /* @__PURE__ */ jsx("span", { children: title }),
      /* @__PURE__ */ jsxs("div", { className: accordionIconWrapperVariants({
        expanded
      }), "aria-hidden": "true", children: [
        /* @__PURE__ */ jsx(Icon, { name: "plus", className: accordionIconVariants({
          visible: !expanded
        }) }),
        /* @__PURE__ */ jsx(Icon, { name: "minus", className: accordionIconVariants({
          visible: expanded
        }) })
      ] })
    ] })) }),
    /* @__PURE__ */ jsx("div", { id: `accordion-content-${uniqueId}`, className: cn(accordionContentWrapperVariants({
      expanded
    }), skipAnimation && "duration-0"), "aria-hidden": !expanded, role: "region", "aria-labelledby": `accordion-button-${uniqueId}`, "data-testid": dataTestId ? `${dataTestId}-content` : void 0, children: /* @__PURE__ */ jsx("div", { className: "overflow-hidden", children: /* @__PURE__ */ jsx("div", { className: accordionContentVariants({
      size: size2,
      expanded,
      className: contentClassName
    }), children }) }) })
  ] });
};
Accordion.displayName = "Accordion";
const actionCard = cva("group flex w-full items-center rounded-lg border border-border bg-surface transition-colors", {
  variants: {
    variant: {
      default: "p-[19px]",
      checkbox: "p-[19px]",
      avatar: "px-[15px] py-[13px]",
      image: "px-[15px] py-[19px]",
      products: "p-[15px]"
    },
    state: {
      default: "hover:border-border-hover",
      pressed: "border-border-pressed bg-surface-hover",
      selected: "border-border-selected",
      disabled: "cursor-default border-border-disabled bg-surface-secondary",
      focused: "border-border-focus bg-background"
    }
  },
  defaultVariants: {
    variant: "default",
    state: "default"
  }
});
const ActionCard = forwardRef((_c, ref) => {
  var _d = _c, {
    className,
    variant,
    state,
    title,
    description,
    leadingIcon,
    leadingAvatar,
    leadingImage,
    leadingProducts,
    hasCustomMadeIcon,
    showTrailingIcon = true,
    showTrailingCheckbox,
    children,
    onClick,
    disabled
  } = _d, props = __objRest(_d, [
    "className",
    "variant",
    "state",
    "title",
    "description",
    "leadingIcon",
    "leadingAvatar",
    "leadingImage",
    "leadingProducts",
    "hasCustomMadeIcon",
    "showTrailingIcon",
    "showTrailingCheckbox",
    "children",
    "onClick",
    "disabled"
  ]);
  const cardVariant = leadingAvatar ? "avatar" : leadingImage ? "image" : leadingProducts ? "products" : variant;
  const visualState = disabled ? "disabled" : state != null ? state : "default";
  const leadingGapClass = leadingAvatar || leadingProducts ? "gap-20" : leadingIcon || leadingImage ? "gap-12" : void 0;
  const iconColor = visualState === "disabled" ? "disabled" : visualState === "selected" ? "selected" : visualState === "pressed" ? "pressed" : "default";
  return /* @__PURE__ */ jsxs("button", __spreadProps(__spreadValues({ ref, type: "button", className: cn(actionCard({
    variant: cardVariant,
    state: visualState
  }), className), onClick: disabled ? void 0 : onClick, disabled }, props), { children: [
    /* @__PURE__ */ jsxs("div", { className: cn("flex flex-1 items-center", leadingGapClass), children: [
      leadingIcon && /* @__PURE__ */ jsx("div", { className: "flex h-20 w-20 flex-shrink-0 items-center justify-center", children: /* @__PURE__ */ jsx(Icon, { name: leadingIcon, size: 20, color: iconColor, className: cn(visualState === "disabled" && "text-text-disabled") }) }),
      leadingAvatar && /* @__PURE__ */ jsx("div", { className: cn("size-60 flex-shrink-0 overflow-hidden rounded-full bg-background-gray-dark transition-opacity", visualState === "disabled" && "opacity-50", visualState !== "disabled" && "group-hover:opacity-60"), children: leadingAvatar }),
      leadingImage && /* @__PURE__ */ jsx("div", { className: cn("h-[34px] w-[34px] flex-shrink-0", visualState === "disabled" && "opacity-50"), children: leadingImage }),
      leadingProducts && /* @__PURE__ */ jsxs("div", { className: cn("md:w-[130px] md:h-[156px] relative flex h-[108px] w-[90px] flex-shrink-0 flex-col items-center justify-center", visualState === "disabled" && "opacity-50"), children: [
        /* @__PURE__ */ jsx("div", { className: "inset-0 absolute -rotate-[5deg] overflow-hidden rounded-md border border-border bg-background-gray-dark" }),
        /* @__PURE__ */ jsx("div", { className: "relative flex h-full w-full flex-col items-center justify-center overflow-hidden rounded-md border border-border bg-background-gray-dark", children: leadingProducts }),
        hasCustomMadeIcon && /* @__PURE__ */ jsx("div", { className: "backdrop-blur-sm absolute top-[6px] left-[6px] flex h-[22px] w-[22px] items-center justify-center rounded-md bg-white-alpha-600", children: /* @__PURE__ */ jsx(Icon, { name: "custom-made", size: 14 }) })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: cn("flex flex-1 flex-col items-start gap-2 pr-20 transition-colors", visualState === "default" && "text-text", visualState === "disabled" && "text-text-disabled", visualState === "selected" && "text-text-selected", visualState === "pressed" && "text-text-pressed", visualState !== "disabled" && "group-hover:text-text-hover"), children: [
        children,
        /* @__PURE__ */ jsx("div", { className: "text-left", children: /* @__PURE__ */ jsx("span", { className: "display-block text-base leading-base font-medium", children: title }) }),
        description && /* @__PURE__ */ jsx("span", { className: "display-block w-full text-left text-sm leading-sm font-light", children: description })
      ] })
    ] }),
    showTrailingIcon && /* @__PURE__ */ jsx("div", { className: "flex h-24 w-24 flex-shrink-0 items-center justify-center", children: /* @__PURE__ */ jsx(Icon, { name: "chevron-right", size: 24, color: iconColor, className: cn("transition-colors", visualState === "disabled" && "text-text-disabled", visualState !== "disabled" && "group-hover:text-icon-hover") }) }),
    showTrailingCheckbox && /* @__PURE__ */ jsx("div", { className: "flex h-16 w-16 flex-shrink-0 items-center justify-center", children: /* @__PURE__ */ jsx("span", { className: cn("block size-16 rounded-md border border-border-button-secondary transition-colors", visualState === "default" && "text-text", visualState === "disabled" && "border-border-button-secondary-disabled", visualState === "selected" && "border-button-selected bg-button-selected", visualState === "pressed" && "border-border-button-secondary-pressed"), children: /* @__PURE__ */ jsx("span", { className: cn("flex size-full shrink-0 items-center justify-center text-icon-inverse transition-opacity", visualState === "selected" && "opacity-100", visualState !== "selected" && "opacity-0"), "aria-hidden": "true", children: /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 1000 1000", width: "1em", height: "1em", className: "h-full w-auto", children: [
      /* @__PURE__ */ jsx("title", { children: "Checkbox" }),
      /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M695.275 300.394a.5.5 0 0 0-.732.001l-27.181 29.393c-75.834 81.439-156.724 173.864-232.487 256.458a.5.5 0 0 1-.698.036l-104.465-92.159-29.828-26.3a.5.5 0 0 0-.727.071l-48.874 63.741a.5.5 0 0 0 .065.678l29.632 26.336L412.6 675.704l27.187 23.973a.5.5 0 0 0 .698-.036l24.531-26.553c84.01-90.227 175.027-195.745 257.438-284.258l27.231-29.447a.5.5 0 0 0-.002-.681z" })
    ] }) }) }) })
  ] }));
});
ActionCard.displayName = "ActionCard";
const loaderVariants = cva("grid h-full w-full place-items-center", {
  variants: {
    type: {
      bar: ""
    }
  },
  defaultVariants: {
    type: "bar"
  }
});
function Loader({
  type = "bar",
  style,
  className,
  ariaLabel
}) {
  return /* @__PURE__ */ jsx("div", { className: loaderVariants({
    type,
    className
  }), style, "data-testid": "loader", role: "status", "aria-live": "polite", "aria-label": ariaLabel, children: type === "bar" && /* @__PURE__ */ jsx("div", { className: cn("relative h-[2px] w-full max-w-[80px] min-w-[40px] overflow-hidden rounded-[1px] bg-current/20"), children: /* @__PURE__ */ jsx("div", { className: "absolute right-full h-full w-[200%] animate-loading-bar bg-current" }) }) });
}
const buttonVariants = cva("ease-in-out relative flex items-center justify-center transition-[color,background-color,border-color] not-disabled:not-aria-disabled:cursor-pointer aria-disabled:cursor-not-allowed", {
  variants: {
    variant: {
      filled: "bg-button text-text-button hover:not-disabled:not-aria-disabled:bg-button-hover disabled:not-aria-busy:bg-button-disabled disabled:not-aria-busy:text-text-button-disabled aria-disabled:bg-button-disabled aria-disabled:text-text-button-disabled",
      outlined: "border border-border-button-secondary bg-transparent text-text-button-secondary hover:not-disabled:not-aria-disabled:border-border-button-secondary-hover hover:not-disabled:not-aria-disabled:bg-button-secondary-hover hover:not-disabled:not-aria-disabled:text-text-button-secondary-hover disabled:not-aria-busy:border-border-button-secondary-disabled disabled:not-aria-busy:bg-button-secondary-disabled disabled:not-aria-busy:text-text-button-secondary-disabled aria-disabled:border-border-button-secondary-disabled aria-disabled:bg-button-secondary-disabled aria-disabled:text-text-button-secondary-disabled",
      transparent: "border border-current bg-transparent text-current hover:not-disabled:not-aria-disabled:bg-current/10 disabled:opacity-50 aria-disabled:opacity-50",
      link: "bg-transparent text-text hover:not-disabled:text-text-hover disabled:text-text-disabled",
      secondary: "border border-border-button-secondary bg-button-secondary text-text-button-secondary hover:not-disabled:not-aria-disabled:bg-background-gray-light disabled:not-aria-busy:border-transparent disabled:not-aria-busy:bg-button-secondary-disabled disabled:not-aria-busy:text-text-button-secondary-disabled aria-disabled:border-transparent aria-disabled:bg-button-secondary-disabled aria-disabled:text-text-button-secondary-disabled"
    },
    size: {
      s: "h-36 text-xs",
      m: "h-40 text-sm",
      l: "h-44 text-sm"
    },
    shape: {
      default: "rounded-md",
      pill: "rounded-full"
    }
  },
  compoundVariants: [
    // Default padding for non-secondary variants
    {
      variant: "filled",
      size: "s",
      className: "px-16"
    },
    {
      variant: "filled",
      size: "m",
      className: "px-20"
    },
    {
      variant: "filled",
      size: "l",
      className: "px-20"
    },
    {
      variant: "outlined",
      size: "s",
      className: "px-16"
    },
    {
      variant: "outlined",
      size: "m",
      className: "px-20"
    },
    {
      variant: "outlined",
      size: "l",
      className: "px-20"
    },
    {
      variant: "transparent",
      size: "s",
      className: "px-16"
    },
    {
      variant: "transparent",
      size: "m",
      className: "px-20"
    },
    {
      variant: "transparent",
      size: "l",
      className: "px-20"
    },
    // Secondary variant with asymmetric padding for icons
    {
      variant: "secondary",
      size: "s",
      className: "pr-16 pl-14"
    },
    {
      variant: "secondary",
      size: "m",
      className: "pr-20 pl-16"
    },
    {
      variant: "secondary",
      size: "l",
      className: "pr-20 pl-16"
    }
  ],
  defaultVariants: {
    size: "l",
    variant: "filled",
    shape: "default"
  }
});
const iconOnlyWidth = {
  s: "w-36",
  m: "w-40",
  l: "w-44"
};
const iconOnlyIconSize = {
  s: "small",
  m: "medium",
  l: "medium"
};
const Button = forwardRef((_e, ref) => {
  var _f = _e, {
    className,
    variant,
    size: size2,
    shape,
    leadingIcon,
    trailingIcon,
    iconOnly,
    loading,
    disabled,
    children
  } = _f, props = __objRest(_f, [
    "className",
    "variant",
    "size",
    "shape",
    "leadingIcon",
    "trailingIcon",
    "iconOnly",
    "loading",
    "disabled",
    "children"
  ]);
  const hasIcon = leadingIcon || trailingIcon;
  return /* @__PURE__ */ jsxs("button", __spreadProps(__spreadValues({ ref, type: "button", className: cn(buttonVariants({
    variant,
    size: size2,
    shape
  }), iconOnly && ["px-0", iconOnlyWidth[size2 != null ? size2 : "l"]], className) }, props), { disabled: disabled || loading, "aria-busy": loading || props["aria-busy"] || void 0, children: [
    /* @__PURE__ */ jsxs("span", { className: cn(
      "flex items-center justify-center",
      // The bottom padding optically centers text; an icon alone needs none.
      !iconOnly && "pb-1",
      hasIcon ? "gap-6" : "gap-8",
      loading && !iconOnly && "invisible"
    ), children: [
      iconOnly && isValidElement(leadingIcon) ? cloneElement(leadingIcon, {
        size: iconOnlyIconSize[size2 != null ? size2 : "l"]
      }) : leadingIcon,
      children && /* @__PURE__ */ jsx("span", { className: cn("pb-2", (variant === "secondary" || variant === "link") && "font-light"), children }),
      trailingIcon
    ] }),
    loading && !iconOnly && /* @__PURE__ */ jsx(Loader, { className: "absolute" })
  ] }));
});
Button.displayName = "Button";
const checkboxWrapperVariants = cva("focus-group flex w-fit items-center gap-8", {
  variants: {
    disabled: {
      true: "cursor-default",
      false: "cursor-pointer"
    }
  },
  defaultVariants: {
    disabled: false
  }
});
const checkboxIconVariants = cva(["block size-16 transition-colors", "rounded-md border-1 border-border-button-secondary", "peer-checked:border-button-selected peer-checked:bg-button-selected peer-checked:[&>*]:opacity-100", "peer-disabled:cursor-default peer-disabled:opacity-50"], {
  variants: {
    disabled: {
      true: "border-border-button-secondary-disabled",
      false: "peer-hover:border-border-button-secondary-hover peer-active:border-border-button-secondary-pressed"
    }
  },
  defaultVariants: {
    disabled: false
  }
});
const labelVariants$1 = cva("select-none", {
  variants: {
    size: {
      s: "text-sm leading-sm",
      l: "text-base leading-base"
    },
    disabled: {
      true: "text-text-disabled",
      false: "text-text"
    }
  },
  defaultVariants: {
    size: "s",
    disabled: false
  }
});
function CheckboxIndicator({
  isActive,
  disabled,
  label,
  size: size2
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { className: checkboxIconVariants({
      disabled,
      className: isActive === true ? "border-button-selected bg-button-selected *:opacity-100" : void 0
    }), children: /* @__PURE__ */ jsx(Icon, { name: "check", className: "ease-out size-full opacity-0 transition-opacity", "aria-hidden": "true", color: "inverse" }) }),
    label && /* @__PURE__ */ jsx("span", { className: labelVariants$1({
      size: size2,
      disabled
    }), children: label })
  ] });
}
const Checkbox = forwardRef((_g, ref) => {
  var _h = _g, {
    className,
    label,
    size: size2,
    disabled,
    expandClickArea
  } = _h, props = __objRest(_h, [
    "className",
    "label",
    "size",
    "disabled",
    "expandClickArea"
  ]);
  return /* @__PURE__ */ jsxs("label", { className: checkboxWrapperVariants({
    disabled,
    className
  }), children: [
    /* @__PURE__ */ jsx("input", __spreadProps(__spreadValues({}, props), { type: "checkbox", ref, disabled, className: "peer sr-only" })),
    /* @__PURE__ */ jsx(CheckboxIndicator, { disabled, label, size: size2 }),
    expandClickArea && /* @__PURE__ */ jsx("span", { className: "inset-0 absolute" })
  ] });
});
Checkbox.displayName = "Checkbox";
const InputField = forwardRef((_i, ref) => {
  var _j = _i, {
    id,
    label,
    labelHidden,
    inputClassName,
    name,
    error,
    className,
    "data-testid": testId,
    onChange,
    onFocus,
    onBlur
  } = _j, props = __objRest(_j, [
    "id",
    "label",
    "labelHidden",
    "inputClassName",
    "name",
    "error",
    "className",
    "data-testid",
    "onChange",
    "onFocus",
    "onBlur"
  ]);
  const inputRef = useRef(null);
  useImperativeHandle(ref, () => inputRef.current);
  const [isFocused, setIsFocused] = useState(false);
  const [internalError, setInternalError] = useState(void 0);
  const hasValue = props.value !== void 0 ? String(props.value).length > 0 : false;
  const isLabelFloating = isFocused || hasValue;
  const validateInput = () => {
    const input = inputRef.current;
    if (!input) return;
    if (input.validity.valid) {
      setInternalError(void 0);
    } else {
      setInternalError(input.validationMessage);
    }
  };
  const handleChange = (e) => {
    setIsFocused(true);
    if (internalError) {
      validateInput();
    }
    onChange == null ? void 0 : onChange(e);
  };
  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus == null ? void 0 : onFocus(e);
  };
  const handleBlur = (e) => {
    setIsFocused(false);
    validateInput();
    onBlur == null ? void 0 : onBlur(e);
  };
  const handleInvalid = (e) => {
    e.preventDefault();
    validateInput();
  };
  const displayError = error || internalError;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex w-full flex-col gap-8", className), "data-has-value": hasValue ? "true" : "false", "data-testid": testId, children: [
    /* @__PURE__ */ jsxs("div", { className: "input-group relative", children: [
      /* @__PURE__ */ jsx("input", __spreadValues({ ref: inputRef, className: cn("w-full rounded-md border border-border bg-background px-[19px] py-[9px] text-base leading-base font-light text-text transition-colors outline-none placeholder:text-transparent", displayError && "border-border-error hover:border-border-error focus:border-border-error", props.disabled && "cursor-default border-border-disabled text-text-disabled", !props.disabled && !displayError && "hover:border-border-pressed focus:border-border-selected", inputClassName), id, name, "data-testid": `${testId}-input`, onChange: (e) => handleChange(e), onFocus: handleFocus, onBlur: handleBlur, onInvalid: handleInvalid }, props)),
      !labelHidden && /* @__PURE__ */ jsx("label", { className: cn("pointer-events-none absolute top-10 left-10 bg-background px-10 text-base leading-base font-light text-text-placeholder transition-all", isLabelFloating && "-top-8 text-xs leading-xs", displayError && "text-text-error", props.disabled && "text-text-disabled"), htmlFor: id, children: label })
    ] }),
    displayError && /* @__PURE__ */ jsx("span", { className: cn("text-xs leading-xs", displayError ? "text-text-error" : "text-text-secondary"), "data-testid": `${testId}-error`, children: displayError })
  ] });
});
InputField.displayName = "InputField";
function useIntlTelInput(inputRef, options = {}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const instanceRef = useRef(null);
  const optionsRef = useRef(options);
  useEffect(() => {
    optionsRef.current = options;
  }, [options]);
  useEffect(() => {
    if (typeof window === "undefined" || !inputRef.current) return;
    if (instanceRef.current) return;
    let isMounted = true;
    const initializeIntlTelInput = () => __async(null, null, function* () {
      var _a, _b, _c;
      try {
        const intlTelInputModule = yield import("./index-CdD_wO6A.js").then((n) => n.i);
        const intlTelInput = intlTelInputModule.default || intlTelInputModule;
        yield Promise.resolve({                 });
        if (!isMounted || !inputRef.current || instanceRef.current) return;
        const opts = optionsRef.current;
        const instance = intlTelInput(inputRef.current, {
          initialCountry: opts.initialCountry || "us",
          preferredCountries: opts.preferredCountries || ["us", "gb", "nl", "be", "de", "fr", "it", "ca"],
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.21/build/js/utils.js",
          separateDialCode: (_a = opts.separateDialCode) != null ? _a : true,
          autoPlaceholder: (_b = opts.autoPlaceholder) != null ? _b : "polite",
          nationalMode: (_c = opts.nationalMode) != null ? _c : true
        });
        instanceRef.current = instance;
        if (instance.promise) {
          yield instance.promise;
        }
        if (!isMounted) return;
        setIsLoaded(true);
      } catch (error) {
        console.error("Failed to initialize intl-tel-input:", error);
      }
    });
    initializeIntlTelInput();
    return () => {
      isMounted = false;
      if (instanceRef.current) {
        try {
          instanceRef.current.destroy();
        } catch (e) {
        }
        instanceRef.current = null;
        setIsLoaded(false);
      }
    };
  }, []);
  const validateNumber = useCallback(() => {
    if (instanceRef.current && isLoaded) {
      return instanceRef.current.isValidNumber();
    }
    return false;
  }, [isLoaded]);
  const getNumber = useCallback(() => {
    if (instanceRef.current && isLoaded) {
      try {
        return instanceRef.current.getNumber();
      } catch (e) {
        return "";
      }
    }
    return "";
  }, [isLoaded]);
  const setNumber = useCallback((number) => {
    if (instanceRef.current && isLoaded && number) {
      try {
        instanceRef.current.setNumber(number);
      } catch (e) {
      }
    }
  }, [isLoaded]);
  return useMemo(() => ({
    isLoaded,
    validateNumber,
    getNumber,
    setNumber,
    instance: instanceRef.current
  }), [isLoaded, validateNumber, getNumber, setNumber]);
}
const InputPhoneNumber = forwardRef((_k, forwardedRef) => {
  var _l = _k, {
    className,
    "data-testid": testId,
    onChange,
    onValidityChange,
    onFullNumberChange,
    countryCode,
    value,
    error
  } = _l, props = __objRest(_l, [
    "className",
    "data-testid",
    "onChange",
    "onValidityChange",
    "onFullNumberChange",
    "countryCode",
    "value",
    "error"
  ]);
  const inputElRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const onValidityChangeRef = useRef(onValidityChange);
  useEffect(() => {
    onValidityChangeRef.current = onValidityChange;
  }, [onValidityChange]);
  const onFullNumberChangeRef = useRef(onFullNumberChange);
  useEffect(() => {
    onFullNumberChangeRef.current = onFullNumberChange;
  }, [onFullNumberChange]);
  const setRefs = (node) => {
    inputElRef.current = node;
    if (typeof forwardedRef === "function") forwardedRef(node);
    else if (forwardedRef && "current" in forwardedRef) forwardedRef.current = node;
  };
  const initialCountry = useMemo(() => {
    if (typeof countryCode === "string" && countryCode.length === 2) {
      return countryCode.toLowerCase();
    }
    return "us";
  }, [countryCode]);
  const phoneInputOptions = useMemo(() => ({
    initialCountry,
    preferredCountries: ["us", "gb", "nl", "be", "de", "fr", "it", "ca"],
    separateDialCode: true,
    autoPlaceholder: "polite",
    nationalMode: true
  }), [initialCountry]);
  const phoneInput = useIntlTelInput(inputElRef, phoneInputOptions);
  useEffect(() => {
    var _a;
    if (!phoneInput.isLoaded || !inputElRef.current) return;
    const input = inputElRef.current;
    const phoneValue = typeof value === "string" ? value : "";
    if (!phoneValue) return;
    const currentValue = input.value;
    if (!currentValue || currentValue !== phoneValue) {
      phoneInput.setNumber(phoneValue);
    }
    (_a = onValidityChangeRef.current) == null ? void 0 : _a.call(onValidityChangeRef, phoneInput.validateNumber());
    const handleCountryChange = () => {
      var _a2, _b;
      (_a2 = onValidityChangeRef.current) == null ? void 0 : _a2.call(onValidityChangeRef, phoneInput.validateNumber());
      (_b = onFullNumberChangeRef.current) == null ? void 0 : _b.call(onFullNumberChangeRef, phoneInput.getNumber());
    };
    input.addEventListener("countrychange", handleCountryChange);
    document.addEventListener("open:countrydropdown", () => {
      setIsDropdownOpen(true);
    });
    document.addEventListener("close:countrydropdown", () => {
      setIsDropdownOpen(false);
    });
    return () => {
      input.removeEventListener("countrychange", handleCountryChange);
    };
  }, [phoneInput.isLoaded, value, phoneInput]);
  return /* @__PURE__ */ jsx("div", { className: cn("flex w-full flex-col gap-8", className), "data-testid": testId, children: /* @__PURE__ */ jsx("div", { className: "phone-input relative", children: /* @__PURE__ */ jsx(InputField, __spreadValues({ inputClassName: cn(isDropdownOpen && "rounded-t-md rounded-b-none"), ref: setRefs, id: "phone-number", label: "Phone", labelHidden: true, type: "tel", name: "phone", defaultValue: "", onChange: (e) => {
    onChange == null ? void 0 : onChange(e);
    setTimeout(() => {
      var _a, _b;
      (_a = onValidityChangeRef.current) == null ? void 0 : _a.call(onValidityChangeRef, phoneInput.validateNumber());
      (_b = onFullNumberChangeRef.current) == null ? void 0 : _b.call(onFullNumberChangeRef, phoneInput.getNumber());
    }, 0);
  }, error, "data-testid": "phone-input" }, props)) }) });
});
InputPhoneNumber.displayName = "InputPhoneNumber";
const listItem = cva("group flex w-full items-center border-solid transition-colors", {
  variants: {
    variant: {
      default: "border-b border-border py-20",
      avatar: "border-b border-border py-14",
      bordered: "rounded-8 border border-border py-20"
    },
    state: {
      default: "hover:border-border-hover",
      pressed: "border-border-pressed bg-surface-hover",
      selected: "border-border-selected",
      disabled: "cursor-default border-border-disabled bg-surface-secondary",
      focused: "border-border-focus bg-background"
    }
  },
  defaultVariants: {
    variant: "default",
    state: "default"
  }
});
const ListItem = forwardRef((_m, ref) => {
  var _n = _m, {
    className,
    variant,
    state,
    title,
    description,
    leadingIcon,
    leadingAvatar,
    showTrailingIcon = true,
    onClick,
    disabled
  } = _n, props = __objRest(_n, [
    "className",
    "variant",
    "state",
    "title",
    "description",
    "leadingIcon",
    "leadingAvatar",
    "showTrailingIcon",
    "onClick",
    "disabled"
  ]);
  const effectiveVariant = leadingAvatar ? "avatar" : variant;
  const effectiveState = disabled ? "disabled" : state;
  return /* @__PURE__ */ jsxs("button", __spreadProps(__spreadValues({ ref, type: "button", className: cn(listItem({
    variant: effectiveVariant,
    state: effectiveState
  }), className), onClick: disabled ? void 0 : onClick, disabled }, props), { children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-1 items-center gap-20", children: [
      leadingIcon && /* @__PURE__ */ jsx("div", { className: "flex h-20 w-20 flex-shrink-0 items-center justify-center", children: /* @__PURE__ */ jsx(Icon, { name: leadingIcon, size: 20, color: disabled ? "disabled" : effectiveState === "selected" ? "selected" : effectiveState === "pressed" ? "pressed" : "default", className: cn(effectiveState === "disabled" && "text-text-disabled") }) }),
      leadingAvatar && /* @__PURE__ */ jsx("div", { className: cn("size-60 flex-shrink-0 overflow-hidden rounded-full bg-background-gray-dark transition-opacity", effectiveState === "disabled" && "opacity-50", effectiveState !== "disabled" && "group-hover:opacity-60"), children: leadingAvatar }),
      /* @__PURE__ */ jsxs("div", { className: cn("flex flex-1 flex-col items-start gap-2 pr-20 transition-colors", effectiveState === "default" && "text-text", effectiveState === "disabled" && "text-text-disabled", effectiveState === "selected" && "text-text-selected", effectiveState === "pressed" && "text-text-pressed", effectiveState !== "disabled" && "group-hover:text-text-hover"), children: [
        /* @__PURE__ */ jsx("div", { className: "text-left", children: /* @__PURE__ */ jsx("span", { className: "display-block text-base leading-base font-medium", children: title }) }),
        description && /* @__PURE__ */ jsx("span", { className: "display-block w-full text-left text-sm leading-sm font-light", children: description })
      ] })
    ] }),
    showTrailingIcon && /* @__PURE__ */ jsx("div", { className: "flex h-24 w-24 flex-shrink-0 items-center justify-center", children: /* @__PURE__ */ jsx(Icon, { name: "chevron-right", size: 20, color: disabled ? "disabled" : effectiveState === "selected" ? "selected" : effectiveState === "pressed" ? "pressed" : "default", className: cn("transition-colors", effectiveState === "disabled" && "text-text-disabled", effectiveState !== "disabled" && "group-hover:text-icon-hover") }) })
  ] }));
});
ListItem.displayName = "ListItem";
const NumericRangeContext = createContext(null);
function useNumericRangeContext(part) {
  const context = useContext(NumericRangeContext);
  if (!context) throw new Error(`<${part}> must be used within <NumericRange>`);
  return context;
}
function roundToPrecision(n, precision) {
  return Number(n.toPrecision(precision));
}
function getNextValue(current, direction, {
  step,
  precision,
  limit,
  skipValues
}) {
  let next = roundToPrecision(current + direction * step, precision);
  while (skipValues.has(next)) {
    next = roundToPrecision(next + direction * step, precision);
  }
  if (limit === void 0) return next;
  return direction === 1 ? next <= limit ? next : void 0 : next >= limit ? next : void 0;
}
function NumericRange(_o) {
  var _p = _o, {
    children,
    value,
    onValueChange,
    min: min2,
    max: max2,
    step = 1,
    skipValues,
    precision,
    active = false,
    readOnly = false,
    disabled = false,
    holdToRepeat = false,
    holdDelay = 500,
    holdInterval = 100,
    className
  } = _p, props = __objRest(_p, [
    "children",
    "value",
    "onValueChange",
    "min",
    "max",
    "step",
    "skipValues",
    "precision",
    "active",
    "readOnly",
    "disabled",
    "holdToRepeat",
    "holdDelay",
    "holdInterval",
    "className"
  ]);
  const valueRef = useRef(value != null ? value : 0);
  useEffect(() => {
    valueRef.current = value != null ? value : 0;
  }, [value]);
  const skipRef = useRef(/* @__PURE__ */ new Set());
  useEffect(() => {
    skipRef.current = new Set(skipValues);
  }, [skipValues]);
  const stepBy = useCallback((direction) => {
    const next = getNextValue(valueRef.current, direction, {
      step,
      precision,
      limit: direction === 1 ? max2 : min2,
      skipValues: skipRef.current
    });
    if (next === void 0) return false;
    valueRef.current = next;
    onValueChange(next);
    return true;
  }, [max2, min2, onValueChange, precision, step]);
  const context = useMemo(() => ({
    value,
    min: min2,
    max: max2,
    disabled,
    readOnly,
    holdToRepeat,
    holdDelay,
    holdInterval,
    stepBy
  }), [value, min2, max2, disabled, readOnly, holdToRepeat, holdDelay, holdInterval, stepBy]);
  return /* @__PURE__ */ jsx(NumericRangeContext.Provider, { value: context, children: /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({}, props), { role: "group", "data-active": active || void 0, "data-disabled": disabled || void 0, "data-readonly": readOnly || void 0, className: cn("ease-out box-border flex h-44 w-[164px] items-center overflow-hidden rounded-md border border-border bg-surface font-sans text-base leading-base font-light text-text transition-[border-color] duration-200", "has-[:focus-visible]:border-border-focus has-[:focus-visible]:shadow-[inset_0_0_0_2px_var(--color-border-focus)]", "data-[active]:border-border-selected", "data-[disabled]:border-border-disabled data-[disabled]:bg-surface-secondary data-[readonly]:bg-surface-secondary", className), children })) });
}
const stepButtonClassName = "box-border flex size-44 shrink-0 touch-manipulation items-center justify-center bg-button-secondary p-10 text-text-button-secondary outline-none transition-[background-color] duration-200 not-disabled:cursor-pointer not-disabled:hover:bg-button-secondary-hover not-disabled:active:bg-button-secondary-pressed disabled:bg-button-secondary-disabled disabled:text-text-button-secondary-disabled";
function useStepButton(direction) {
  const {
    value,
    min: min2,
    max: max2,
    disabled,
    readOnly,
    holdToRepeat,
    holdDelay,
    holdInterval,
    stepBy
  } = useNumericRangeContext(direction === 1 ? "NumericRangeIncrement" : "NumericRangeDecrement");
  const waitTimer = useRef(void 0);
  const repeatTimer = useRef(void 0);
  const stop = useCallback(() => {
    clearTimeout(waitTimer.current);
    clearTimeout(repeatTimer.current);
    waitTimer.current = void 0;
    repeatTimer.current = void 0;
  }, []);
  useEffect(() => stop, [stop]);
  const repeat = useCallback(() => {
    if (stepBy(direction)) {
      repeatTimer.current = setTimeout(repeat, holdInterval);
    }
  }, [direction, holdInterval, stepBy]);
  const limit = direction === 1 ? max2 : min2;
  const isAtLimit = value !== void 0 && limit !== void 0 && (direction === 1 ? value >= limit : value <= limit);
  const isDisabled = disabled || readOnly || isAtLimit;
  return {
    isDisabled,
    handlers: {
      onPointerDown: (event) => {
        if (event.button !== 0) return;
        event.preventDefault();
        event.currentTarget.focus();
        if (holdToRepeat) {
          waitTimer.current = setTimeout(() => {
            waitTimer.current = void 0;
            repeat();
          }, holdDelay);
        } else {
          stepBy(direction);
        }
      },
      onPointerUp: () => {
        if (waitTimer.current !== void 0) {
          stop();
          stepBy(direction);
          return;
        }
        stop();
      },
      onPointerLeave: stop,
      onPointerCancel: stop,
      /* Pointer presses are handled on pointerdown; a click without pointer detail comes from the keyboard. */
      onClick: (event) => {
        if (event.detail === 0) stepBy(direction);
      }
    }
  };
}
function NumericRangeDecrement(_q) {
  var _r = _q, {
    removeItem = false,
    className,
    onClick
  } = _r, props = __objRest(_r, [
    "removeItem",
    "className",
    "onClick"
  ]);
  const {
    isDisabled,
    handlers
  } = useStepButton(-1);
  return /* @__PURE__ */ jsx("button", __spreadProps(__spreadValues(__spreadValues({ type: "button" }, props), handlers), { onClick: (event) => {
    handlers.onClick(event);
    onClick == null ? void 0 : onClick(event);
  }, disabled: isDisabled, className: cn(stepButtonClassName, className), children: /* @__PURE__ */ jsx(Icon, { color: "current", name: removeItem ? "trash" : "minus", size: "medium" }) }));
}
function NumericRangeIncrement(_s) {
  var _t = _s, {
    className,
    onClick
  } = _t, props = __objRest(_t, [
    "className",
    "onClick"
  ]);
  const {
    isDisabled,
    handlers
  } = useStepButton(1);
  return /* @__PURE__ */ jsx("button", __spreadProps(__spreadValues(__spreadValues({ type: "button" }, props), handlers), { onClick: (event) => {
    handlers.onClick(event);
    onClick == null ? void 0 : onClick(event);
  }, disabled: isDisabled, className: cn(stepButtonClassName, className), children: /* @__PURE__ */ jsx(Icon, { color: "current", name: "plus", size: "medium" }) }));
}
function NumericRangeValue(_u) {
  var _v = _u, {
    children,
    className
  } = _v, props = __objRest(_v, [
    "children",
    "className"
  ]);
  const {
    value,
    disabled,
    readOnly
  } = useNumericRangeContext("NumericRangeValue");
  return /* @__PURE__ */ jsx("span", __spreadProps(__spreadValues({}, props), { className: cn("min-w-0 flex-1 truncate px-4 text-center select-none", readOnly && "text-text-secondary", disabled && "text-text-disabled", className), children: children != null ? children : value }));
}
const radioWrapperVariants = cva("focus-group flex w-fit items-center gap-8", {
  variants: {
    disabled: {
      true: "cursor-default",
      false: "cursor-pointer"
    }
  },
  defaultVariants: {
    disabled: false
  }
});
const radioInputVariants = cva(["ease-out transition-[color,background-color,border-color] duration-150", "relative size-16 appearance-none rounded-full border-1 border-border-button-secondary", "before:absolute before:top-1/2 before:left-1/2 before:-translate-1/2 before:rounded-full before:bg-surface before:content-['']", "before:ease-out before:size-full before:transition-[width,height] before:duration-150 focus:outline-none", "checked:before:size-[7px]"], {
  variants: {
    disabled: {
      true: "cursor-default checked:border-button-disabled checked:bg-button-disabled",
      false: "cursor-pointer checked:border-button-selected checked:bg-button-selected hover:border-border-button-secondary-hover active:border-border-button-secondary-pressed"
    }
  },
  defaultVariants: {
    disabled: false
  }
});
const labelVariants = cva("font-light select-none", {
  variants: {
    size: {
      s: "text-sm leading-sm",
      l: "text-base leading-base"
    },
    disabled: {
      true: "text-text-disabled",
      false: "text-text"
    }
  },
  defaultVariants: {
    size: "s",
    disabled: false
  }
});
const Radio = forwardRef((_w, ref) => {
  var _x = _w, {
    className,
    label,
    size: size2,
    disabled
  } = _x, props = __objRest(_x, [
    "className",
    "label",
    "size",
    "disabled"
  ]);
  return /* @__PURE__ */ jsxs("label", { className: radioWrapperVariants({
    disabled,
    className
  }), children: [
    /* @__PURE__ */ jsx("input", __spreadProps(__spreadValues({}, props), { type: "radio", ref, disabled, className: radioInputVariants({
      disabled
    }) })),
    label && /* @__PURE__ */ jsx("span", { className: labelVariants({
      size: size2,
      disabled
    }), children: label })
  ] });
});
Radio.displayName = "Radio";
const SelectField = memo(function SelectField2({
  id,
  label,
  name,
  value,
  options,
  onChange,
  error,
  disabled = false,
  placeholder,
  "data-testid": testId
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const listboxRef = useRef(null);
  const selectedOption = options.find((opt) => opt.value === value);
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      const path = event.composedPath();
      if (containerRef.current && !path.includes(containerRef.current)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown2 = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown2);
    return () => {
      document.removeEventListener("keydown", handleKeyDown2);
    };
  }, [isOpen]);
  const handleToggle = useCallback(() => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
  }, [disabled]);
  const handleSelect = useCallback((optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  }, [onChange]);
  const handleKeyDown = useCallback((event) => {
    if (disabled) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsOpen((prev) => !prev);
      return;
    }
    if (!isOpen) return;
    const currentIndex = options.findIndex((opt) => opt.value === value);
    if (event.key === "ArrowDown") {
      event.preventDefault();
      const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
      onChange(options[nextIndex].value);
    }
    if (event.key === "ArrowUp") {
      event.preventDefault();
      const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
      onChange(options[prevIndex].value);
    }
  }, [disabled, isOpen, options, value, onChange]);
  return /* @__PURE__ */ jsxs("div", { ref: containerRef, className: cn("relative w-full", isOpen && "z-[120]"), "data-testid": testId, children: [
    /* @__PURE__ */ jsxs("button", { id, type: "button", role: "combobox", name, "aria-expanded": isOpen, "aria-haspopup": "listbox", "aria-controls": `${id}-listbox`, "aria-invalid": !!error, "aria-describedby": error ? `${id}-error` : void 0, disabled, onClick: handleToggle, onKeyDown: handleKeyDown, className: cn("w-full border bg-background pt-8 pr-12 pb-10 pl-[19px] text-left text-base leading-base font-light text-text transition-colors", "flex items-center justify-between", !isOpen && "rounded-md", isOpen && "rounded-t-md", error && "border-border-error", disabled && "cursor-default border-border-disabled text-text-disabled", !disabled && !error && "hover:border-border-pressed", !disabled && !error && isOpen && "rounded-t-md border-border-selected", !disabled && !error && !isOpen && "border-border"), children: [
      /* @__PURE__ */ jsx("span", { className: cn(!selectedOption && "text-text-placeholder"), children: (selectedOption == null ? void 0 : selectedOption.label) || placeholder || "" }),
      /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: 20, color: "text", className: cn("mt-4 transition-transform", isOpen && "rotate-180", error && "text-text-error", disabled && "text-text-disabled") })
    ] }),
    /* @__PURE__ */ jsx("label", { htmlFor: id, className: cn("pointer-events-none absolute -top-8 left-10 bg-background px-10 text-xs leading-xs font-light text-text-placeholder transition-all", error && "text-text-error", disabled && "text-text-disabled"), children: label }),
    isOpen && /* @__PURE__ */ jsx("ul", { ref: listboxRef, id: `${id}-listbox`, role: "listbox", "aria-labelledby": id, className: "left-0 right-0 shadow-lg absolute top-44 z-[120] max-h-[180px] overflow-y-auto rounded-b-md border-x-1 border-b-1 border-border bg-surface", children: options.map((option) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs("button", { type: "button", role: "option", "aria-selected": value === option.value, onClick: () => handleSelect(option.value), className: cn("flex w-full items-center justify-between py-8 pr-16 pl-20 text-left text-base leading-base font-light text-text transition-colors", "hover:bg-surface-secondary", value === option.value && "bg-surface-secondary"), children: [
      /* @__PURE__ */ jsx("span", { children: option.label }),
      value === option.value && /* @__PURE__ */ jsx(Icon, { name: "checkmark", size: 20, color: "text" })
    ] }) }, option.value)) }),
    error && /* @__PURE__ */ jsx("span", { id: `${id}-error`, className: "block pt-8 text-xs leading-xs text-text-error", children: error })
  ] });
});
var __defProp$n = Object.defineProperty;
var __name$n = (target, value) => __defProp$n(target, "name", { value, configurable: true });
var canUseDOM$1 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function composeEventHandlers$1(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return /* @__PURE__ */ __name$n(function handleEvent(event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  }, "handleEvent");
}
__name$n(composeEventHandlers$1, "composeEventHandlers");
function getOwnerWindow$1(element) {
  var _a, _b;
  if (!canUseDOM$1) {
    throw new Error("Cannot access window outside of the DOM");
  }
  return (_b = (_a = element == null ? void 0 : element.ownerDocument) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
__name$n(getOwnerWindow$1, "getOwnerWindow");
function getOwnerDocument$1(element) {
  var _a;
  if (!canUseDOM$1) {
    throw new Error("Cannot access document outside of the DOM");
  }
  return (_a = element == null ? void 0 : element.ownerDocument) != null ? _a : document;
}
__name$n(getOwnerDocument$1, "getOwnerDocument");
function getActiveElement$1(node, activeDescendant = false) {
  const { activeElement } = getOwnerDocument$1(node);
  if (!(activeElement == null ? void 0 : activeElement.nodeName)) {
    return null;
  }
  if (isFrame$1(activeElement) && activeElement.contentDocument) {
    return getActiveElement$1(activeElement.contentDocument.body, activeDescendant);
  }
  if (activeDescendant) {
    const id = activeElement.getAttribute("aria-activedescendant");
    if (id) {
      const element = getOwnerDocument$1(activeElement).getElementById(id);
      if (element) {
        return element;
      }
    }
  }
  return activeElement;
}
__name$n(getActiveElement$1, "getActiveElement");
function isFrame$1(element) {
  return element.tagName === "IFRAME";
}
__name$n(isFrame$1, "isFrame");
var __defProp$m = Object.defineProperty;
var __name$m = (target, value) => __defProp$m(target, "name", { value, configurable: true });
function setRef$1(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
__name$m(setRef$1, "setRef");
function composeRefs(...refs) {
  return (node) => {
    let hasCleanup = false;
    const cleanups = refs.map((ref) => {
      const cleanup = setRef$1(ref, node);
      if (!hasCleanup && typeof cleanup == "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0; i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup == "function") {
            cleanup();
          } else {
            setRef$1(refs[i], null);
          }
        }
      };
    }
  };
}
__name$m(composeRefs, "composeRefs");
function useComposedRefs(...refs) {
  return React.useCallback(composeRefs(...refs), refs);
}
__name$m(useComposedRefs, "useComposedRefs");
var __defProp$l = Object.defineProperty;
var __name$l = (target, value) => __defProp$l(target, "name", { value, configurable: true });
// @__NO_SIDE_EFFECTS__
function createContext2$1(rootComponentName, defaultContext) {
  const Context = React.createContext(defaultContext);
  Context.displayName = rootComponentName + "Context";
  const Provider2 = /* @__PURE__ */ __name$l((props) => {
    const _a = props, { children } = _a, context = __objRest(_a, ["children"]);
    const value = React.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  }, "Provider");
  Provider2.displayName = rootComponentName + "Provider";
  function useContext2(consumerName, options = {}) {
    const { optional = false } = options;
    const context = React.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    if (optional) return void 0;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  __name$l(useContext2, "useContext");
  return [Provider2, useContext2];
}
__name$l(createContext2$1, "createContext");
// @__NO_SIDE_EFFECTS__
function createContextScope$1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = React.createContext(defaultContext);
    BaseContext.displayName = rootComponentName + "Context";
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider2 = /* @__PURE__ */ __name$l((props) => {
      var _b;
      const _a = props, { scope, children } = _a, context = __objRest(_a, ["scope", "children"]);
      const Context = ((_b = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _b[index2]) || BaseContext;
      const value = React.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx(Context.Provider, { value, children });
    }, "Provider");
    Provider2.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, scope, options = {}) {
      var _a;
      const { optional = false } = options;
      const Context = ((_a = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _a[index2]) || BaseContext;
      const context = React.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      if (optional) return void 0;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    __name$l(useContext2, "useContext");
    return [Provider2, useContext2];
  }
  __name$l(createContext3, "createContext");
  const createScope = /* @__PURE__ */ __name$l(() => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React.createContext(defaultContext);
    });
    return /* @__PURE__ */ __name$l(function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return React.useMemo(
        () => ({ [`__scope${scopeName}`]: __spreadProps(__spreadValues({}, scope), { [scopeName]: contexts }) }),
        [scope, contexts]
      );
    }, "useScope");
  }, "createScope");
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes$1(createScope, ...createContextScopeDeps)];
}
__name$l(createContextScope$1, "createContextScope");
function composeContextScopes$1(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = /* @__PURE__ */ __name$l(() => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return /* @__PURE__ */ __name$l(function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return __spreadValues(__spreadValues({}, nextScopes2), currentScope);
      }, {});
      return React.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    }, "useComposedScopes");
  }, "createScope");
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
__name$l(composeContextScopes$1, "composeContextScopes");
var useLayoutEffect2 = (globalThis == null ? void 0 : globalThis.document) ? React.useLayoutEffect : () => {
};
var __defProp$k = Object.defineProperty;
var __name$k = (target, value) => __defProp$k(target, "name", { value, configurable: true });
var useReactEffectEvent = React[" useEffectEvent ".trim().toString()];
var useReactInsertionEffect = React[" useInsertionEffect ".trim().toString()];
function useEffectEvent(callback) {
  if (typeof useReactEffectEvent === "function") {
    return useReactEffectEvent(callback);
  }
  const ref = React.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  if (typeof useReactInsertionEffect === "function") {
    useReactInsertionEffect(() => {
      ref.current = callback;
    });
  } else {
    useLayoutEffect2(() => {
      ref.current = callback;
    });
  }
  return React.useMemo(() => ((...args) => {
    var _a;
    return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
  }), []);
}
__name$k(useEffectEvent, "useEffectEvent");
var __defProp$j = Object.defineProperty;
var __name$j = (target, value) => __defProp$j(target, "name", { value, configurable: true });
var useInsertionEffect$1 = React[" useInsertionEffect ".trim().toString()] || useLayoutEffect2;
function useControllableState$1({
  prop,
  defaultProp,
  onChange = /* @__PURE__ */ __name$j(() => {
  }, "onChange"),
  caller
}) {
  const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState$1({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  const setValue = React.useCallback(
    (nextValue) => {
      var _a;
      if (isControlled) {
        const value2 = isFunction$2(nextValue) ? nextValue(prop) : nextValue;
        if (value2 !== prop) {
          (_a = onChangeRef.current) == null ? void 0 : _a.call(onChangeRef, value2);
        }
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, onChangeRef]
  );
  return [value, setValue];
}
__name$j(useControllableState$1, "useControllableState");
function useUncontrolledState$1({
  defaultProp,
  onChange
}) {
  const [value, setValue] = React.useState(defaultProp);
  const prevValueRef = React.useRef(value);
  const onChangeRef = React.useRef(onChange);
  useInsertionEffect$1(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  React.useEffect(() => {
    var _a;
    if (prevValueRef.current !== value) {
      (_a = onChangeRef.current) == null ? void 0 : _a.call(onChangeRef, value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}
__name$j(useUncontrolledState$1, "useUncontrolledState");
function isFunction$2(value) {
  return typeof value === "function";
}
__name$j(isFunction$2, "isFunction");
var SYNC_STATE$1 = Symbol("RADIX:SYNC_STATE");
function useControllableStateReducer$1(reducer, userArgs, initialArg, init) {
  const { prop: controlledState, defaultProp, onChange: onChangeProp, caller } = userArgs;
  const isControlled = controlledState !== void 0;
  const onChange = useEffectEvent(onChangeProp);
  const args = [__spreadProps(__spreadValues({}, initialArg), { state: defaultProp })];
  if (init) {
    args.push(init);
  }
  const [internalState, dispatch] = React.useReducer(
    (state2, action) => {
      if (action.type === SYNC_STATE$1) {
        return __spreadProps(__spreadValues({}, state2), { state: action.state });
      }
      const next = reducer(state2, action);
      if (isControlled && !Object.is(next.state, state2.state)) {
        onChange(next.state);
      }
      return next;
    },
    ...args
  );
  const uncontrolledState = internalState.state;
  const prevValueRef = React.useRef(uncontrolledState);
  React.useEffect(() => {
    if (prevValueRef.current !== uncontrolledState) {
      prevValueRef.current = uncontrolledState;
      if (!isControlled) {
        onChange(uncontrolledState);
      }
    }
  }, [uncontrolledState, prevValueRef, isControlled]);
  const state = React.useMemo(() => {
    const isControlled2 = controlledState !== void 0;
    if (isControlled2) {
      return __spreadProps(__spreadValues({}, internalState), { state: controlledState });
    }
    return internalState;
  }, [internalState, controlledState]);
  React.useEffect(() => {
    if (isControlled && !Object.is(controlledState, internalState.state)) {
      dispatch({ type: SYNC_STATE$1, state: controlledState });
    }
  }, [controlledState, internalState.state, isControlled]);
  return [state, dispatch];
}
__name$j(useControllableStateReducer$1, "useControllableStateReducer");
var __defProp$i = Object.defineProperty;
var __name$i = (target, value) => __defProp$i(target, "name", { value, configurable: true });
function useSize$1(element) {
  const [size2, setSize] = React.useState(void 0);
  useLayoutEffect2(() => {
    if (element) {
      setSize({ width: element.offsetWidth, height: element.offsetHeight });
      let rAF = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        window.cancelAnimationFrame(rAF);
        rAF = window.requestAnimationFrame(() => {
          let width;
          let height;
          if ("borderBoxSize" in entry) {
            const borderSizeEntry = entry["borderBoxSize"];
            const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
            width = borderSize["inlineSize"];
            height = borderSize["blockSize"];
          } else {
            width = element.offsetWidth;
            height = element.offsetHeight;
          }
          setSize({ width, height });
        });
      });
      resizeObserver.observe(element, { box: "border-box" });
      return () => {
        window.cancelAnimationFrame(rAF);
        resizeObserver.unobserve(element);
      };
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size2;
}
__name$i(useSize$1, "useSize");
var __defProp$h = Object.defineProperty;
var __name$h = (target, value) => __defProp$h(target, "name", { value, configurable: true });
// @__NO_SIDE_EFFECTS__
function createSlot$1(ownerName) {
  const Slot2 = React.forwardRef((props, forwardedRef) => {
    var _b;
    let _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
    let slottableElement = null;
    let hasSlottable = false;
    const newChildren = [];
    children = useUnwrappedLazy(children);
    React.Children.forEach(children, (maybeSlottable) => {
      var _a2;
      if (isSlottable$1(maybeSlottable)) {
        hasSlottable = true;
        const slottable = maybeSlottable;
        let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
        while (isLazyComponent$1(child) && typeof use$1 === "function") {
          child = use$1(child._payload);
        }
        slottableElement = getSlottableElementFromSlottable$1(slottable, child);
        newChildren.push((_a2 = slottableElement == null ? void 0 : slottableElement.props) == null ? void 0 : _a2.children);
      } else {
        newChildren.push(maybeSlottable);
      }
    });
    if (slottableElement) {
      slottableElement = React.cloneElement(slottableElement, void 0, newChildren);
    } else if (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !hasSlottable && React.Children.count(children) === 1 && React.isValidElement(children)
    ) {
      slottableElement = children;
    }
    const slottableElementRef = slottableElement ? getElementRef$2(slottableElement) : void 0;
    const composedRef = useComposedRefs(forwardedRef, slottableElementRef);
    if (!slottableElement) {
      if (children || children === 0) {
        throw new Error(
          hasSlottable ? createSlottableError$1(ownerName) : createSlotError$1(ownerName)
        );
      }
      return children;
    }
    const mergedProps = mergeProps$1(slotProps, (_b = slottableElement.props) != null ? _b : {});
    if (slottableElement.type !== React.Fragment) {
      mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
    }
    return React.cloneElement(slottableElement, mergedProps);
  });
  Slot2.displayName = `${ownerName}.Slot`;
  return Slot2;
}
__name$h(createSlot$1, "createSlot");
var SLOTTABLE_IDENTIFIER$1 = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable$1(ownerName) {
  const Slottable2 = /* @__PURE__ */ __name$h((props) => "child" in props ? props.children(props.child) : props.children, "Slottable");
  Slottable2.displayName = `${ownerName}.Slottable`;
  Slottable2.__radixId = SLOTTABLE_IDENTIFIER$1;
  return Slottable2;
}
__name$h(createSlottable$1, "createSlottable");
var getSlottableElementFromSlottable$1 = /* @__PURE__ */ __name$h((slottable, child) => {
  if ("child" in slottable.props) {
    if (!React.isValidElement(child)) return null;
    return React.cloneElement(child, void 0, slottable.props.children(child.props.children));
  }
  return React.isValidElement(child) ? child : null;
}, "getSlottableElementFromSlottable");
function mergeProps$1(slotProps, childProps) {
  const overrideProps = __spreadValues({}, childProps);
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = __spreadValues(__spreadValues({}, slotPropValue), childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    } else if (propName === "aria-describedby") {
      overrideProps[propName] = concatAriaDescribedby(childPropValue, slotPropValue);
    }
  }
  return __spreadValues(__spreadValues({}, slotProps), overrideProps);
}
__name$h(mergeProps$1, "mergeProps");
function getElementRef$2(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
__name$h(getElementRef$2, "getElementRef");
function isSlottable$1(child) {
  return React.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER$1;
}
__name$h(isSlottable$1, "isSlottable");
var REACT_LAZY_TYPE$1 = Symbol.for("react.lazy");
function isLazyComponent$1(element) {
  return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === REACT_LAZY_TYPE$1 && "_payload" in element && isPromiseLike$1(element._payload);
}
__name$h(isLazyComponent$1, "isLazyComponent");
function isPromiseLike$1(value) {
  return typeof value === "object" && value !== null && "then" in value;
}
__name$h(isPromiseLike$1, "isPromiseLike");
function useUnwrappedLazy(value) {
  let unwrapped = value;
  while (isLazyComponent$1(unwrapped) && typeof use$1 === "function") {
    unwrapped = use$1(unwrapped._payload);
  }
  return unwrapped;
}
__name$h(useUnwrappedLazy, "useUnwrappedLazy");
function concatAriaDescribedby(...values) {
  const ids = /* @__PURE__ */ new Set();
  for (const value of values) {
    if (typeof value !== "string") continue;
    for (const id of String(value).trim().split(/\s+/)) {
      if (id) ids.add(id);
    }
  }
  return ids.size > 0 ? Array.from(ids).join(" ") : void 0;
}
__name$h(concatAriaDescribedby, "concatAriaDescribedby");
var createSlotError$1 = /* @__PURE__ */ __name$h((ownerName) => {
  return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
}, "createSlotError");
var createSlottableError$1 = /* @__PURE__ */ __name$h((ownerName) => {
  return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
}, "createSlottableError");
var use$1 = React[" use ".trim().toString()];
var __defProp$g = Object.defineProperty;
var __name$g = (target, value) => __defProp$g(target, "name", { value, configurable: true });
var NODES$1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive$1 = NODES$1.reduce((primitive, node) => {
  const Slot = /* @__PURE__ */ createSlot$1(`Primitive.${node}`);
  const Node2 = React.forwardRef((props, forwardedRef) => {
    const _a = props, { asChild } = _a, primitiveProps = __objRest(_a, ["asChild"]);
    const Comp = asChild ? Slot : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx(Comp, __spreadProps(__spreadValues({}, primitiveProps), { ref: forwardedRef }));
  });
  Node2.displayName = `Primitive.${node}`;
  return __spreadProps(__spreadValues({}, primitive), { [node]: Node2 });
}, {});
function dispatchDiscreteCustomEvent$1(target, event) {
  if (target) ReactDOM.flushSync(() => target.dispatchEvent(event));
}
__name$g(dispatchDiscreteCustomEvent$1, "dispatchDiscreteCustomEvent");
var __defProp$f = Object.defineProperty;
var __name$f = (target, value) => __defProp$f(target, "name", { value, configurable: true });
var SWITCH_NAME = "Switch";
var [createSwitchContext, createSwitchScope] = /* @__PURE__ */ createContextScope$1(SWITCH_NAME);
var [SwitchProviderImpl, useSwitchContext$1] = createSwitchContext(SWITCH_NAME);
function SwitchProvider(props) {
  const {
    __scopeSwitch,
    checked: checkedProp,
    children,
    defaultChecked,
    disabled,
    form,
    name,
    onCheckedChange,
    required,
    value = "on",
    // @ts-expect-error
    internal_do_not_use_render
  } = props;
  const [checked, setChecked] = useControllableState$1({
    prop: checkedProp,
    defaultProp: defaultChecked != null ? defaultChecked : false,
    onChange: onCheckedChange,
    caller: SWITCH_NAME
  });
  const [control, setControl] = React.useState(null);
  const [bubbleInput, setBubbleInput] = React.useState(null);
  const [userClick, setUserClick] = React.useState(null);
  const isFormControl = control ? !!form || !!control.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    true
  );
  const context = {
    checked,
    setChecked,
    disabled,
    control,
    setControl,
    name,
    form,
    value,
    userClick,
    onUserClick: setUserClick,
    required,
    defaultChecked,
    isFormControl,
    bubbleInput,
    setBubbleInput
  };
  return /* @__PURE__ */ jsx(SwitchProviderImpl, __spreadProps(__spreadValues({ scope: __scopeSwitch }, context), { children: isFunction$1(internal_do_not_use_render) ? internal_do_not_use_render(context) : children }));
}
__name$f(SwitchProvider, "SwitchProvider");
var TRIGGER_NAME$1 = "SwitchTrigger";
var SwitchTrigger = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$f(function SwitchTrigger2(_y, forwardedRef) {
    var _z = _y, { __scopeSwitch, onClick } = _z, switchProps = __objRest(_z, ["__scopeSwitch", "onClick"]);
    const {
      control,
      form,
      value,
      disabled,
      checked,
      required,
      setControl,
      setChecked,
      onUserClick,
      isFormControl,
      bubbleInput
    } = useSwitchContext$1(TRIGGER_NAME$1, __scopeSwitch);
    const composedRefs = useComposedRefs(forwardedRef, setControl);
    const initialCheckedStateRef = React.useRef(checked);
    React.useEffect(() => {
      const associatedForm = form ? control == null ? void 0 : control.ownerDocument.getElementById(form) : control == null ? void 0 : control.form;
      if (associatedForm instanceof HTMLFormElement) {
        const reset = /* @__PURE__ */ __name$f(() => setChecked(initialCheckedStateRef.current), "reset");
        associatedForm.addEventListener("reset", reset);
        return () => associatedForm.removeEventListener("reset", reset);
      }
    }, [control, form, setChecked]);
    return /* @__PURE__ */ jsx(
      Primitive$1.button,
      __spreadProps(__spreadValues({
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-required": required,
        "data-state": getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled,
        value
      }, switchProps), {
        ref: composedRefs,
        onClick: composeEventHandlers$1(onClick, (event) => {
          const hasConsumerStoppedPropagation = event.isPropagationStopped();
          onUserClick({ requestedChecked: !checked, hasConsumerStoppedPropagation });
          setChecked((prevChecked) => !prevChecked);
          if (bubbleInput && isFormControl) {
            if (!hasConsumerStoppedPropagation) {
              event.stopPropagation();
            }
          }
        })
      })
    );
  }, "SwitchTrigger")
);
var Switch$1 = /* @__PURE__ */ React.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ __name$f(function Switch2(props, forwardedRef) {
    const _a = props, {
      __scopeSwitch,
      name,
      checked,
      defaultChecked,
      required,
      disabled,
      value,
      onCheckedChange,
      form
    } = _a, switchProps = __objRest(_a, [
      "__scopeSwitch",
      "name",
      "checked",
      "defaultChecked",
      "required",
      "disabled",
      "value",
      "onCheckedChange",
      "form"
    ]);
    return /* @__PURE__ */ jsx(
      SwitchProvider,
      {
        __scopeSwitch,
        checked,
        defaultChecked,
        disabled,
        required,
        onCheckedChange,
        name,
        form,
        value,
        internal_do_not_use_render: ({ isFormControl }) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            SwitchTrigger,
            __spreadProps(__spreadValues({}, switchProps), {
              ref: forwardedRef,
              __scopeSwitch
            })
          ),
          isFormControl && /* @__PURE__ */ jsx(
            SwitchBubbleInput,
            {
              __scopeSwitch
            }
          )
        ] })
      }
    );
  }, "Switch")
);
var THUMB_NAME = "SwitchThumb";
var SwitchThumb$1 = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$f(function SwitchThumb2(props, forwardedRef) {
    const _a = props, { __scopeSwitch } = _a, thumbProps = __objRest(_a, ["__scopeSwitch"]);
    const context = useSwitchContext$1(THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ jsx(
      Primitive$1.span,
      __spreadProps(__spreadValues({
        "data-state": getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0
      }, thumbProps), {
        ref: forwardedRef
      })
    );
  }, "SwitchThumb")
);
var BUBBLE_INPUT_NAME = "SwitchBubbleInput";
var SwitchBubbleInput = /* @__PURE__ */ React.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ __name$f(function SwitchBubbleInput2(_A, forwardedRef) {
    var _B = _A, { __scopeSwitch, onClick } = _B, props = __objRest(_B, ["__scopeSwitch", "onClick"]);
    const {
      control,
      userClick,
      checked,
      defaultChecked,
      required,
      disabled,
      name,
      value,
      form,
      bubbleInput,
      setBubbleInput
    } = useSwitchContext$1(BUBBLE_INPUT_NAME, __scopeSwitch);
    const composedRefs = useComposedRefs(forwardedRef, setBubbleInput);
    const controlSize = useSize$1(control);
    const shouldStopClickPropagationRef = React.useRef(false);
    const prevCheckedRef = React.useRef(checked);
    const handledUserClickRef = React.useRef(userClick);
    const pendingUserClickRef = React.useRef(null);
    React.useEffect(() => {
      const input = bubbleInput;
      if (!input) return;
      const inputProto = window.HTMLInputElement.prototype;
      const descriptor = Object.getOwnPropertyDescriptor(
        inputProto,
        "checked"
      );
      const setChecked = descriptor.set;
      if (!setChecked) {
        return;
      }
      const checkedChanged = prevCheckedRef.current !== checked;
      prevCheckedRef.current = checked;
      const isNewUserClick = userClick !== null && userClick !== handledUserClickRef.current;
      handledUserClickRef.current = userClick;
      if (isNewUserClick) {
        pendingUserClickRef.current = checkedChanged ? null : userClick;
        if (checkedChanged) {
          setChecked.call(input, checked);
        }
        input.dispatchEvent(
          new Event("click", { bubbles: !userClick.hasConsumerStoppedPropagation })
        );
      } else if (checkedChanged) {
        const pendingUserClick = pendingUserClickRef.current;
        pendingUserClickRef.current = null;
        const isPendingUserChange = (pendingUserClick == null ? void 0 : pendingUserClick.requestedChecked) === checked;
        shouldStopClickPropagationRef.current = true;
        setChecked.call(input, checked);
        input.dispatchEvent(
          new Event("click", {
            bubbles: !(isPendingUserChange && pendingUserClick.hasConsumerStoppedPropagation)
          })
        );
        shouldStopClickPropagationRef.current = false;
      }
    }, [bubbleInput, checked, userClick]);
    const defaultCheckedRef = React.useRef(checked);
    return /* @__PURE__ */ jsx(
      Primitive$1.input,
      __spreadProps(__spreadValues({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked != null ? defaultChecked : defaultCheckedRef.current,
        required,
        disabled,
        name,
        value,
        form
      }, props), {
        tabIndex: -1,
        ref: composedRefs,
        onClick: composeEventHandlers$1(onClick, (event) => {
          if (shouldStopClickPropagationRef.current) {
            event.stopPropagation();
          }
        }),
        style: __spreadProps(__spreadValues(__spreadValues({}, props.style), controlSize), {
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        })
      })
    );
  }, "SwitchBubbleInput")
);
function isFunction$1(value) {
  return typeof value === "function";
}
__name$f(isFunction$1, "isFunction");
function getState(checked) {
  return checked ? "checked" : "unchecked";
}
__name$f(getState, "getState");
const SwitchContext = createContext(null);
function useSwitchContext(part) {
  const context = useContext(SwitchContext);
  if (!context) throw new Error(`<${part}> must be used within <Switch>`);
  return context;
}
function Switch(_C) {
  var _D = _C, {
    children,
    checked,
    defaultChecked = false,
    onCheckedChange,
    className
  } = _D, props = __objRest(_D, [
    "children",
    "checked",
    "defaultChecked",
    "onCheckedChange",
    "className"
  ]);
  const [uncontrolledChecked, setUncontrolledChecked] = useState(defaultChecked);
  const isChecked = checked != null ? checked : uncontrolledChecked;
  const context = useMemo(() => ({
    checked: isChecked
  }), [isChecked]);
  return /* @__PURE__ */ jsx(SwitchContext.Provider, { value: context, children: /* @__PURE__ */ jsx(Switch$1, __spreadProps(__spreadValues({}, props), { checked: isChecked, className: cn("relative inline-flex h-32 w-[52px] shrink-0 items-center rounded-full bg-surface-alt-2 p-2 transition-[background-color] not-disabled:cursor-pointer hover:not-disabled:bg-surface-alt-2-hover disabled:opacity-50 data-[state=checked]:bg-button data-[state=checked]:hover:not-disabled:bg-button-hover", className), onCheckedChange: (next) => {
    setUncontrolledChecked(next);
    onCheckedChange == null ? void 0 : onCheckedChange(next);
  }, children })) });
}
function SwitchThumb({
  children,
  className
}) {
  return /* @__PURE__ */ jsx(SwitchThumb$1, { className: cn("pointer-events-none grid size-28 place-items-center rounded-full border border-border bg-surface text-xs leading-xs font-normal whitespace-nowrap text-text transition-[translate] data-[state=checked]:translate-x-20", className), children });
}
function SwitchLabel({
  state,
  children
}) {
  const {
    checked
  } = useSwitchContext("SwitchLabel");
  return state === "on" === checked ? /* @__PURE__ */ jsx(Fragment, { children }) : null;
}
var __defProp$e = Object.defineProperty;
var __name$e = (target, value) => __defProp$e(target, "name", { value, configurable: true });
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return /* @__PURE__ */ __name$e(function handleEvent(event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  }, "handleEvent");
}
__name$e(composeEventHandlers, "composeEventHandlers");
function getOwnerWindow(element) {
  var _a, _b;
  if (!canUseDOM) {
    throw new Error("Cannot access window outside of the DOM");
  }
  return (_b = (_a = element == null ? void 0 : element.ownerDocument) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
__name$e(getOwnerWindow, "getOwnerWindow");
function getOwnerDocument(element) {
  var _a;
  if (!canUseDOM) {
    throw new Error("Cannot access document outside of the DOM");
  }
  return (_a = element == null ? void 0 : element.ownerDocument) != null ? _a : document;
}
__name$e(getOwnerDocument, "getOwnerDocument");
function getActiveElement(node, activeDescendant = false) {
  const { activeElement } = getOwnerDocument(node);
  if (!(activeElement == null ? void 0 : activeElement.nodeName)) {
    return null;
  }
  if (isFrame(activeElement) && activeElement.contentDocument) {
    return getActiveElement(activeElement.contentDocument.body, activeDescendant);
  }
  if (activeDescendant) {
    const id = activeElement.getAttribute("aria-activedescendant");
    if (id) {
      const element = getOwnerDocument(activeElement).getElementById(id);
      if (element) {
        return element;
      }
    }
  }
  return activeElement;
}
__name$e(getActiveElement, "getActiveElement");
function isFrame(element) {
  return element.tagName === "IFRAME";
}
__name$e(isFrame, "isFrame");
var __defProp$d = Object.defineProperty;
var __name$d = (target, value) => __defProp$d(target, "name", { value, configurable: true });
// @__NO_SIDE_EFFECTS__
function createContext2(rootComponentName, defaultContext) {
  const Context = React.createContext(defaultContext);
  Context.displayName = rootComponentName + "Context";
  const Provider2 = /* @__PURE__ */ __name$d((props) => {
    const _a = props, { children } = _a, context = __objRest(_a, ["children"]);
    const value = React.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  }, "Provider");
  Provider2.displayName = rootComponentName + "Provider";
  function useContext2(consumerName, options = {}) {
    const { optional = false } = options;
    const context = React.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    if (optional) return void 0;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  __name$d(useContext2, "useContext");
  return [Provider2, useContext2];
}
__name$d(createContext2, "createContext");
// @__NO_SIDE_EFFECTS__
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = React.createContext(defaultContext);
    BaseContext.displayName = rootComponentName + "Context";
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider2 = /* @__PURE__ */ __name$d((props) => {
      var _b;
      const _a = props, { scope, children } = _a, context = __objRest(_a, ["scope", "children"]);
      const Context = ((_b = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _b[index2]) || BaseContext;
      const value = React.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx(Context.Provider, { value, children });
    }, "Provider");
    Provider2.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, scope, options = {}) {
      var _a;
      const { optional = false } = options;
      const Context = ((_a = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _a[index2]) || BaseContext;
      const context = React.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      if (optional) return void 0;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    __name$d(useContext2, "useContext");
    return [Provider2, useContext2];
  }
  __name$d(createContext3, "createContext");
  const createScope = /* @__PURE__ */ __name$d(() => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React.createContext(defaultContext);
    });
    return /* @__PURE__ */ __name$d(function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return React.useMemo(
        () => ({ [`__scope${scopeName}`]: __spreadProps(__spreadValues({}, scope), { [scopeName]: contexts }) }),
        [scope, contexts]
      );
    }, "useScope");
  }, "createScope");
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes(createScope, ...createContextScopeDeps)];
}
__name$d(createContextScope, "createContextScope");
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = /* @__PURE__ */ __name$d(() => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return /* @__PURE__ */ __name$d(function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return __spreadValues(__spreadValues({}, nextScopes2), currentScope);
      }, {});
      return React.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    }, "useComposedScopes");
  }, "createScope");
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
__name$d(composeContextScopes, "composeContextScopes");
var __defProp$c = Object.defineProperty;
var __name$c = (target, value) => __defProp$c(target, "name", { value, configurable: true });
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
  const Slot2 = React.forwardRef((props, forwardedRef) => {
    var _b;
    let _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
    let slottableElement = null;
    let hasSlottable = false;
    const newChildren = [];
    if (isLazyComponent(children) && typeof use === "function") {
      children = use(children._payload);
    }
    React.Children.forEach(children, (maybeSlottable) => {
      var _a2;
      if (isSlottable(maybeSlottable)) {
        hasSlottable = true;
        const slottable = maybeSlottable;
        let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
        if (isLazyComponent(child) && typeof use === "function") {
          child = use(child._payload);
        }
        slottableElement = getSlottableElementFromSlottable(slottable, child);
        newChildren.push((_a2 = slottableElement == null ? void 0 : slottableElement.props) == null ? void 0 : _a2.children);
      } else {
        newChildren.push(maybeSlottable);
      }
    });
    if (slottableElement) {
      slottableElement = React.cloneElement(slottableElement, void 0, newChildren);
    } else if (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !hasSlottable && React.Children.count(children) === 1 && React.isValidElement(children)
    ) {
      slottableElement = children;
    }
    const slottableElementRef = slottableElement ? getElementRef$1(slottableElement) : void 0;
    const composedRef = useComposedRefs(forwardedRef, slottableElementRef);
    if (!slottableElement) {
      if (children || children === 0) {
        throw new Error(
          hasSlottable ? createSlottableError(ownerName) : createSlotError(ownerName)
        );
      }
      return children;
    }
    const mergedProps = mergeProps(slotProps, (_b = slottableElement.props) != null ? _b : {});
    if (slottableElement.type !== React.Fragment) {
      mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
    }
    return React.cloneElement(slottableElement, mergedProps);
  });
  Slot2.displayName = `${ownerName}.Slot`;
  return Slot2;
}
__name$c(createSlot, "createSlot");
var SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable(ownerName) {
  const Slottable2 = /* @__PURE__ */ __name$c((props) => "child" in props ? props.children(props.child) : props.children, "Slottable");
  Slottable2.displayName = `${ownerName}.Slottable`;
  Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
  return Slottable2;
}
__name$c(createSlottable, "createSlottable");
var getSlottableElementFromSlottable = /* @__PURE__ */ __name$c((slottable, child) => {
  if ("child" in slottable.props) {
    const child2 = slottable.props.child;
    if (!React.isValidElement(child2)) return null;
    return React.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
  }
  return React.isValidElement(child) ? child : null;
}, "getSlottableElementFromSlottable");
function mergeProps(slotProps, childProps) {
  const overrideProps = __spreadValues({}, childProps);
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = __spreadValues(__spreadValues({}, slotPropValue), childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return __spreadValues(__spreadValues({}, slotProps), overrideProps);
}
__name$c(mergeProps, "mergeProps");
function getElementRef$1(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
__name$c(getElementRef$1, "getElementRef");
function isSlottable(child) {
  return React.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
__name$c(isSlottable, "isSlottable");
var REACT_LAZY_TYPE = Symbol.for("react.lazy");
function isLazyComponent(element) {
  return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === REACT_LAZY_TYPE && "_payload" in element && isPromiseLike(element._payload);
}
__name$c(isLazyComponent, "isLazyComponent");
function isPromiseLike(value) {
  return typeof value === "object" && value !== null && "then" in value;
}
__name$c(isPromiseLike, "isPromiseLike");
var createSlotError = /* @__PURE__ */ __name$c((ownerName) => {
  return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
}, "createSlotError");
var createSlottableError = /* @__PURE__ */ __name$c((ownerName) => {
  return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
}, "createSlottableError");
var use = React[" use ".trim().toString()];
var __defProp$b = Object.defineProperty;
var __name$b = (target, value) => __defProp$b(target, "name", { value, configurable: true });
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Slot = /* @__PURE__ */ createSlot(`Primitive.${node}`);
  const Node2 = React.forwardRef((props, forwardedRef) => {
    const _a = props, { asChild } = _a, primitiveProps = __objRest(_a, ["asChild"]);
    const Comp = asChild ? Slot : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx(Comp, __spreadProps(__spreadValues({}, primitiveProps), { ref: forwardedRef }));
  });
  Node2.displayName = `Primitive.${node}`;
  return __spreadProps(__spreadValues({}, primitive), { [node]: Node2 });
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) ReactDOM.flushSync(() => target.dispatchEvent(event));
}
__name$b(dispatchDiscreteCustomEvent, "dispatchDiscreteCustomEvent");
var __defProp$a = Object.defineProperty;
var __name$a = (target, value) => __defProp$a(target, "name", { value, configurable: true });
function useCallbackRef(callback) {
  const callbackRef = React.useRef(callback);
  React.useEffect(() => {
    callbackRef.current = callback;
  });
  return React.useMemo(() => ((...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }), []);
}
__name$a(useCallbackRef, "useCallbackRef");
var __defProp$9 = Object.defineProperty;
var __name$9 = (target, value) => __defProp$9(target, "name", { value, configurable: true });
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = React.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
});
var DismissableLayer = /* @__PURE__ */ React.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ __name$9(function DismissableLayer2(props, forwardedRef) {
    var _b;
    const _a = props, {
      disableOutsidePointerEvents = false,
      deferPointerDownOutside = false,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss
    } = _a, layerProps = __objRest(_a, [
      "disableOutsidePointerEvents",
      "deferPointerDownOutside",
      "onEscapeKeyDown",
      "onPointerDownOutside",
      "onFocusOutside",
      "onInteractOutside",
      "onDismiss"
    ]);
    const context = React.useContext(DismissableLayerContext);
    const [node, setNode] = React.useState(null);
    const ownerDocument = (_b = node == null ? void 0 : node.ownerDocument) != null ? _b : globalThis == null ? void 0 : globalThis.document;
    const [, force] = React.useState({});
    const composedRefs = useComposedRefs(forwardedRef, setNode);
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
      ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
    const index2 = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = React.useRef(false);
    const pointerDownOutside = usePointerDownOutside(
      (event) => {
        onPointerDownOutside == null ? void 0 : onPointerDownOutside(event);
        onInteractOutside == null ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss == null ? void 0 : onDismiss();
      },
      {
        ownerDocument,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces,
        shouldHandlePointerDownOutside: React.useCallback(
          (target) => {
            if (!(target instanceof Node)) {
              return false;
            }
            const isPointerDownOnBranch = [...context.branches].some(
              (branch) => branch.contains(target)
            );
            return isPointerEventsEnabled && !isPointerDownOnBranch;
          },
          [context.branches, isPointerEventsEnabled]
        )
      }
    );
    const focusOutside = useFocusOutside((event) => {
      if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) {
        return;
      }
      const target = event.target;
      const isFocusInBranch = [...context.branches].some((branch) => branch.contains(target));
      if (isFocusInBranch) return;
      onFocusOutside == null ? void 0 : onFocusOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented) onDismiss == null ? void 0 : onDismiss();
    }, ownerDocument);
    const isHighestLayer = node ? index2 === layers.length - 1 : false;
    const handleKeyDown = useCallbackRef((event) => {
      if (event.key !== "Escape") {
        return;
      }
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(event);
      if (!event.defaultPrevented && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    });
    React.useEffect(() => {
      if (!isHighestLayer) {
        return;
      }
      ownerDocument.addEventListener("keydown", handleKeyDown, { capture: true });
      return () => ownerDocument.removeEventListener("keydown", handleKeyDown, { capture: true });
    }, [ownerDocument, isHighestLayer, handleKeyDown]);
    React.useEffect(() => {
      if (!node) return;
      if (disableOutsidePointerEvents) {
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
          ownerDocument.body.style.pointerEvents = "none";
        }
        context.layersWithOutsidePointerEventsDisabled.add(node);
      }
      context.layers.add(node);
      dispatchUpdate();
      return () => {
        if (disableOutsidePointerEvents) {
          context.layersWithOutsidePointerEventsDisabled.delete(node);
          if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
            ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
          }
        }
      };
    }, [node, ownerDocument, disableOutsidePointerEvents, context]);
    React.useEffect(() => {
      return () => {
        if (!node) return;
        context.layers.delete(node);
        context.layersWithOutsidePointerEventsDisabled.delete(node);
        dispatchUpdate();
      };
    }, [node, context]);
    React.useEffect(() => {
      const handleUpdate = /* @__PURE__ */ __name$9(() => force({}), "handleUpdate");
      document.addEventListener(CONTEXT_UPDATE, handleUpdate);
      return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      __spreadProps(__spreadValues({}, layerProps), {
        ref: composedRefs,
        style: __spreadValues({
          pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0
        }, props.style),
        onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: composeEventHandlers(
          props.onPointerDownCapture,
          pointerDownOutside.onPointerDownCapture
        )
      })
    );
  }, "DismissableLayer")
);
function useDismissableLayerSurface() {
  const context = React.useContext(DismissableLayerContext);
  const [node, setNode] = React.useState(null);
  React.useEffect(() => {
    if (!node) {
      return;
    }
    context.dismissableSurfaces.add(node);
    return () => {
      context.dismissableSurfaces.delete(node);
    };
  }, [node, context.dismissableSurfaces]);
  return setNode;
}
__name$9(useDismissableLayerSurface, "useDismissableLayerSurface");
var IS_TRUE = /* @__PURE__ */ __name$9(() => true, "IS_TRUE");
function usePointerDownOutside(onPointerDownOutside, args) {
  const {
    ownerDocument = globalThis == null ? void 0 : globalThis.document,
    deferPointerDownOutside = false,
    isDeferredPointerDownOutsideRef,
    dismissableSurfaces,
    shouldHandlePointerDownOutside = IS_TRUE
  } = args;
  const handlePointerDownOutside = useCallbackRef(onPointerDownOutside);
  const isPointerInsideReactTreeRef = React.useRef(false);
  const isPointerDownOutsideRef = React.useRef(false);
  const interceptedOutsideInteractionEventsRef = React.useRef(/* @__PURE__ */ new Map());
  const handleClickRef = React.useRef(() => {
  });
  React.useEffect(() => {
    function resetOutsideInteraction() {
      isPointerDownOutsideRef.current = false;
      isDeferredPointerDownOutsideRef.current = false;
      interceptedOutsideInteractionEventsRef.current.clear();
    }
    __name$9(resetOutsideInteraction, "resetOutsideInteraction");
    function isOutsideInteractionIntercepted() {
      return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
    }
    __name$9(isOutsideInteractionIntercepted, "isOutsideInteractionIntercepted");
    function handleInteractionCapture(event) {
      if (!isPointerDownOutsideRef.current) {
        return;
      }
      const target = event.target;
      const isDismissableSurface = target instanceof Node && [...dismissableSurfaces].some((surface) => surface.contains(target));
      if (!isDismissableSurface) {
        interceptedOutsideInteractionEventsRef.current.set(event.type, true);
      }
      if (event.type === "click") {
        window.setTimeout(() => {
          if (isPointerDownOutsideRef.current) {
            handleClickRef.current();
          }
        }, 0);
      }
    }
    __name$9(handleInteractionCapture, "handleInteractionCapture");
    function handleInteractionBubble(event) {
      if (isPointerDownOutsideRef.current) {
        interceptedOutsideInteractionEventsRef.current.set(event.type, false);
      }
    }
    __name$9(handleInteractionBubble, "handleInteractionBubble");
    const handlePointerDown = /* @__PURE__ */ __name$9((event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
          resetOutsideInteraction();
          if (!wasOutsideInteractionIntercepted) {
            handleAndDispatchCustomEvent(
              POINTER_DOWN_OUTSIDE,
              handlePointerDownOutside,
              eventDetail,
              { discrete: true }
            );
          }
        };
        __name$9(handleAndDispatchPointerDownOutsideEvent2, "handleAndDispatchPointerDownOutsideEvent");
        if (!shouldHandlePointerDownOutside(event.target)) {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          resetOutsideInteraction();
          isPointerInsideReactTreeRef.current = false;
          return;
        }
        const eventDetail = { originalEvent: event };
        isPointerDownOutsideRef.current = true;
        isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
        interceptedOutsideInteractionEventsRef.current.clear();
        if (!deferPointerDownOutside || event.button !== 0) {
          handleAndDispatchPointerDownOutsideEvent2();
        } else {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, { once: true });
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
        resetOutsideInteraction();
      }
      isPointerInsideReactTreeRef.current = false;
    }, "handlePointerDown");
    const outsideInteractionEvents = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const eventName of outsideInteractionEvents) {
      ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
      ownerDocument.addEventListener(eventName, handleInteractionBubble);
    }
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
      for (const eventName of outsideInteractionEvents) {
        ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
        ownerDocument.removeEventListener(eventName, handleInteractionBubble);
      }
    };
  }, [
    ownerDocument,
    handlePointerDownOutside,
    deferPointerDownOutside,
    isDeferredPointerDownOutsideRef,
    dismissableSurfaces,
    shouldHandlePointerDownOutside
  ]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: /* @__PURE__ */ __name$9(() => isPointerInsideReactTreeRef.current = true, "onPointerDownCapture")
  };
}
__name$9(usePointerDownOutside, "usePointerDownOutside");
function useFocusOutside(onFocusOutside, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const handleFocusOutside = useCallbackRef(onFocusOutside);
  const isFocusInsideReactTreeRef = React.useRef(false);
  React.useEffect(() => {
    const handleFocus = /* @__PURE__ */ __name$9((event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    }, "handleFocus");
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: /* @__PURE__ */ __name$9(() => isFocusInsideReactTreeRef.current = true, "onFocusCapture"),
    onBlurCapture: /* @__PURE__ */ __name$9(() => isFocusInsideReactTreeRef.current = false, "onBlurCapture")
  };
}
__name$9(useFocusOutside, "useFocusOutside");
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
__name$9(dispatchUpdate, "dispatchUpdate");
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler) target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
__name$9(handleAndDispatchCustomEvent, "handleAndDispatchCustomEvent");
var __defProp$8 = Object.defineProperty;
var __name$8 = (target, value) => __defProp$8(target, "name", { value, configurable: true });
var useReactId = React[" useId ".trim().toString()] || (() => void 0);
var count = 0;
function useId(deterministicId) {
  const [id, setId] = React.useState(useReactId());
  useLayoutEffect2(() => {
    if (!deterministicId) setId((reactId) => reactId != null ? reactId : String(count++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}
__name$8(useId, "useId");
const sides = ["top", "right", "bottom", "left"];
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  const side = getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  return __spreadValues({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
function detectOverflow(state, options) {
  return __async(this, null, function* () {
    var _await$platform$isEle;
    if (options === void 0) {
      options = {};
    }
    const {
      x,
      y,
      platform: platform2,
      rects,
      elements,
      strategy
    } = state;
    const {
      boundary = "clippingAncestors",
      rootBoundary = "viewport",
      elementContext = "floating",
      altBoundary = false,
      padding = 0
    } = evaluate(options, state);
    const paddingObject = getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = rectToClientRect(yield platform2.getClippingRect({
      element: ((_await$platform$isEle = yield platform2.isElement == null ? void 0 : platform2.isElement(element)) != null ? _await$platform$isEle : true) ? element : element.contextElement || (yield platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
      boundary,
      rootBoundary,
      strategy
    }));
    const rect = elementContext === "floating" ? {
      x,
      y,
      width: rects.floating.width,
      height: rects.floating.height
    } : rects.reference;
    const offsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating);
    const offsetScale = (yield platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? (yield platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    };
    const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? yield platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements,
      rect,
      offsetParent,
      strategy
    }) : rect);
    return {
      top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
      bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
      left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
      right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
  });
}
const MAX_RESET_COUNT = 50;
const computePosition$1 = (reference, floating, config) => __async(null, null, function* () {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const platformWithDetectOverflow = platform2.detectOverflow ? platform2 : __spreadProps(__spreadValues({}, platform2), {
    detectOverflow
  });
  const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(floating);
  let rects = yield platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i = 0; i < middleware.length; i++) {
    const currentMiddleware = middleware[i];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name,
      fn
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = yield fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData[name] = __spreadValues(__spreadValues({}, middlewareData[name]), data);
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? yield platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
});
const arrow$3 = (options) => ({
  name: "arrow",
  options,
  fn(state) {
    return __async(this, null, function* () {
      const {
        x,
        y,
        placement,
        rects,
        platform: platform2,
        elements,
        middlewareData
      } = state;
      const {
        element,
        padding = 0
      } = evaluate(options, state) || {};
      if (element == null) {
        return {};
      }
      const paddingObject = getPaddingObject(padding);
      const coords = {
        x,
        y
      };
      const axis = getAlignmentAxis(placement);
      const length = getAxisLength(axis);
      const arrowDimensions = yield platform2.getDimensions(element);
      const isYAxis = axis === "y";
      const minProp = isYAxis ? "top" : "left";
      const maxProp = isYAxis ? "bottom" : "right";
      const clientProp = isYAxis ? "clientHeight" : "clientWidth";
      const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
      const startDiff = coords[axis] - rects.reference[axis];
      const arrowOffsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element);
      let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
      if (!clientSize || !(yield platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
        clientSize = elements.floating[clientProp] || rects.floating[length];
      }
      const centerToReference = endDiff / 2 - startDiff / 2;
      const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
      const minPadding = min(paddingObject[minProp], largestPossiblePadding);
      const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
      const min$1 = minPadding;
      const max2 = clientSize - arrowDimensions[length] - maxPadding;
      const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
      const offset2 = clamp(min$1, center, max2);
      const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
      const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
      return {
        [axis]: coords[axis] + alignmentOffset,
        data: __spreadValues({
          [axis]: offset2,
          centerOffset: center - offset2 - alignmentOffset
        }, shouldAddOffset && {
          alignmentOffset
        }),
        reset: shouldAddOffset
      };
    });
  }
});
const flip$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$arrow, _middlewareData$flip;
        const {
          placement,
          middlewareData,
          rects,
          initialPlacement,
          platform: platform2,
          elements
        } = state;
        const _a2 = evaluate(options, state), {
          mainAxis: checkMainAxis = true,
          crossAxis: checkCrossAxis = true,
          fallbackPlacements: specifiedFallbackPlacements,
          fallbackStrategy = "bestFit",
          fallbackAxisSideDirection = "none",
          flipAlignment = true
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "mainAxis",
          "crossAxis",
          "fallbackPlacements",
          "fallbackStrategy",
          "fallbackAxisSideDirection",
          "flipAlignment"
        ]);
        if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
          return {};
        }
        const side = getSide(placement);
        const initialSideAxis = getSideAxis(initialPlacement);
        const isBasePlacement = getSide(initialPlacement) === initialPlacement;
        const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
        const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
        const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
        if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
          fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
        }
        const placements = [initialPlacement, ...fallbackPlacements];
        const overflow = yield platform2.detectOverflow(state, detectOverflowOptions);
        const overflows = [];
        let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
        if (checkMainAxis) {
          overflows.push(overflow[side]);
        }
        if (checkCrossAxis) {
          const sides2 = getAlignmentSides(placement, rects, rtl);
          overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
        }
        overflowsData = [...overflowsData, {
          placement,
          overflows
        }];
        if (!overflows.every((side2) => side2 <= 0)) {
          var _middlewareData$flip2, _overflowsData$filter;
          const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
          const nextPlacement = placements[nextIndex];
          if (nextPlacement) {
            const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
            if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
            // overflows the main axis.
            overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
              return {
                data: {
                  index: nextIndex,
                  overflows: overflowsData
                },
                reset: {
                  placement: nextPlacement
                }
              };
            }
          }
          let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
          if (!resetPlacement) {
            switch (fallbackStrategy) {
              case "bestFit": {
                var _overflowsData$filter2;
                const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === "y";
                  }
                  return true;
                }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement2) {
                  resetPlacement = placement2;
                }
                break;
              }
              case "initialPlacement":
                resetPlacement = initialPlacement;
                break;
            }
          }
          if (placement !== resetPlacement) {
            return {
              reset: {
                placement: resetPlacement
              }
            };
          }
        }
        return {};
      });
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
const hide$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    fn(state) {
      return __async(this, null, function* () {
        const {
          rects,
          platform: platform2
        } = state;
        const _a2 = evaluate(options, state), {
          strategy = "referenceHidden"
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "strategy"
        ]);
        switch (strategy) {
          case "referenceHidden": {
            const overflow = yield platform2.detectOverflow(state, __spreadProps(__spreadValues({}, detectOverflowOptions), {
              elementContext: "reference"
            }));
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
          case "escaped": {
            const overflow = yield platform2.detectOverflow(state, __spreadProps(__spreadValues({}, detectOverflowOptions), {
              altBoundary: true
            }));
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
          default: {
            return {};
          }
        }
      });
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
function convertValueToCoords(state, options) {
  return __async(this, null, function* () {
    const {
      placement,
      platform: platform2,
      elements
    } = state;
    const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
    const side = getSide(placement);
    const alignment = getAlignment(placement);
    const isVertical = getSideAxis(placement) === "y";
    const mainAxisMulti = originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = evaluate(options, state);
    let {
      mainAxis,
      crossAxis,
      alignmentAxis
    } = typeof rawValue === "number" ? {
      mainAxis: rawValue,
      crossAxis: 0,
      alignmentAxis: null
    } : {
      mainAxis: rawValue.mainAxis || 0,
      crossAxis: rawValue.crossAxis || 0,
      alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") {
      crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    }
    return isVertical ? {
      x: crossAxis * crossAxisMulti,
      y: mainAxis * mainAxisMulti
    } : {
      x: mainAxis * mainAxisMulti,
      y: crossAxis * crossAxisMulti
    };
  });
}
const offset$2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$offse, _middlewareData$arrow;
        const {
          x,
          y,
          placement,
          middlewareData
        } = state;
        const diffCoords = yield convertValueToCoords(state, options);
        if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
          return {};
        }
        return {
          x: x + diffCoords.x,
          y: y + diffCoords.y,
          data: __spreadProps(__spreadValues({}, diffCoords), {
            placement
          })
        };
      });
    }
  };
};
const shift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    fn(state) {
      return __async(this, null, function* () {
        const {
          x,
          y,
          placement,
          platform: platform2
        } = state;
        const _a2 = evaluate(options, state), {
          mainAxis: checkMainAxis = true,
          crossAxis: checkCrossAxis = false,
          limiter = {
            fn: (_ref) => {
              let {
                x: x2,
                y: y2
              } = _ref;
              return {
                x: x2,
                y: y2
              };
            }
          }
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "mainAxis",
          "crossAxis",
          "limiter"
        ]);
        const coords = {
          x,
          y
        };
        const overflow = yield platform2.detectOverflow(state, detectOverflowOptions);
        const crossAxis = getSideAxis(getSide(placement));
        const mainAxis = getOppositeAxis(crossAxis);
        let mainAxisCoord = coords[mainAxis];
        let crossAxisCoord = coords[crossAxis];
        if (checkMainAxis) {
          const minSide = mainAxis === "y" ? "top" : "left";
          const maxSide = mainAxis === "y" ? "bottom" : "right";
          const min2 = mainAxisCoord + overflow[minSide];
          const max2 = mainAxisCoord - overflow[maxSide];
          mainAxisCoord = clamp(min2, mainAxisCoord, max2);
        }
        if (checkCrossAxis) {
          const minSide = crossAxis === "y" ? "top" : "left";
          const maxSide = crossAxis === "y" ? "bottom" : "right";
          const min2 = crossAxisCoord + overflow[minSide];
          const max2 = crossAxisCoord - overflow[maxSide];
          crossAxisCoord = clamp(min2, crossAxisCoord, max2);
        }
        const limitedCoords = limiter.fn(__spreadProps(__spreadValues({}, state), {
          [mainAxis]: mainAxisCoord,
          [crossAxis]: crossAxisCoord
        }));
        return __spreadProps(__spreadValues({}, limitedCoords), {
          data: {
            x: limitedCoords.x - x,
            y: limitedCoords.y - y,
            enabled: {
              [mainAxis]: checkMainAxis,
              [crossAxis]: checkCrossAxis
            }
          }
        });
      });
    }
  };
};
const limitShift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset2, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : __spreadValues({
        mainAxis: 0,
        crossAxis: 0
      }, rawOffset);
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
const size$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _state$middlewareData, _state$middlewareData2;
        const {
          placement,
          rects,
          platform: platform2,
          elements
        } = state;
        const _a2 = evaluate(options, state), {
          apply = () => {
          }
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "apply"
        ]);
        const overflow = yield platform2.detectOverflow(state, detectOverflowOptions);
        const side = getSide(placement);
        const alignment = getAlignment(placement);
        const isYAxis = getSideAxis(placement) === "y";
        const {
          width,
          height
        } = rects.floating;
        let heightSide;
        let widthSide;
        if (side === "top" || side === "bottom") {
          heightSide = side;
          widthSide = alignment === ((yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
        } else {
          widthSide = side;
          heightSide = alignment === "end" ? "top" : "bottom";
        }
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        const maximumClippingWidth = width - overflow.left - overflow.right;
        const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
        const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
        const noShift = !state.middlewareData.shift;
        let availableHeight = overflowAvailableHeight;
        let availableWidth = overflowAvailableWidth;
        if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
          availableWidth = maximumClippingWidth;
        }
        if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
          availableHeight = maximumClippingHeight;
        }
        if (noShift && !alignment) {
          const xMin = max(overflow.left, 0);
          const xMax = max(overflow.right, 0);
          const yMin = max(overflow.top, 0);
          const yMax = max(overflow.bottom, 0);
          if (isYAxis) {
            availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
          } else {
            availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
          }
        }
        yield apply(__spreadProps(__spreadValues({}, state), {
          availableWidth,
          availableHeight
        }));
        const nextDimensions = yield platform2.getDimensions(elements.floating);
        if (width !== nextDimensions.width || height !== nextDimensions.height) {
          return {
            reset: {
              rects: true
            }
          };
        }
        return {};
      });
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function isTableElement(element) {
  return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
  try {
    if (element.matches(":popover-open")) {
      return true;
    }
  } catch (_e) {
  }
  try {
    return element.matches(":modal");
  } catch (_e) {
    return false;
  }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = (value) => !!value && value !== "none";
let isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || "") || containRe.test(css.contain || "");
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
  }
  return isWebKitValue;
}
function isLastTraversableNode(node) {
  return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === "absolute" || currentContainingBlockComputedStyle.position === "fixed") || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
  let top = firstRect.top;
  let right = firstRect.right;
  let bottom = firstRect.bottom;
  let left = firstRect.left;
  for (let i = 1; i < clippingAncestors.length; i++) {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
    top = max(rect.top, top);
    right = min(rect.right, right);
    bottom = min(rect.bottom, bottom);
    left = max(rect.left, left);
  }
  return {
    width: right - left,
    height: bottom - top,
    x: left,
    y: top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = function(data) {
  return __async(this, null, function* () {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = yield getDimensionsFn(data.floating);
    return {
      reference: getRectRelativeToOffsetParent(data.reference, yield getOffsetParentFn(data.floating), data.strategy),
      floating: {
        x: 0,
        y: 0,
        width: floatingDimensions.width,
        height: floatingDimensions.height
      }
    };
  });
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, __spreadProps(__spreadValues({}, options), {
        // Handle <iframe>s
        root: root.ownerDocument
      }));
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...floating ? getOverflowAncestors(floating) : []] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating) {
      resizeObserver.observe(floating);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$1 = offset$2;
const shift$1 = shift$2;
const flip$1 = flip$2;
const size$1 = size$2;
const hide$1 = hide$2;
const arrow$2 = arrow$3;
const limitShift$1 = limitShift$2;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = __spreadValues({
    platform
  }, options);
  const platformWithCache = __spreadProps(__spreadValues({}, mergedOptions.platform), {
    _c: cache
  });
  return computePosition$1(reference, floating, __spreadProps(__spreadValues({}, mergedOptions), {
    platform: platformWithCache
  }));
};
var isClient = typeof document !== "undefined";
var noop = function noop2() {
};
var index = isClient ? useLayoutEffect : noop;
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = __spreadProps(__spreadValues({}, data2), {
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      });
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => __spreadProps(__spreadValues({}, data2), {
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return __spreadValues(__spreadProps(__spreadValues({}, initialStyles), {
        transform: "translate(" + x + "px, " + y + "px)"
      }), getDPR(elements.floating) >= 1.5 && {
        willChange: "transform"
      });
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => __spreadProps(__spreadValues({}, data), {
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
const arrow$1 = (options) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === "function" ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$2({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow$2({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
const offset = (options, deps) => {
  const result = offset$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const shift = (options, deps) => {
  const result = shift$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const limitShift = (options, deps) => {
  const result = limitShift$1(options);
  return {
    fn: result.fn,
    options: [options, deps]
  };
};
const flip = (options, deps) => {
  const result = flip$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const size = (options, deps) => {
  const result = size$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const hide = (options, deps) => {
  const result = hide$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const arrow = (options, deps) => {
  const result = arrow$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
var __defProp$7 = Object.defineProperty;
var __name$7 = (target, value) => __defProp$7(target, "name", { value, configurable: true });
var Arrow$1 = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$7(function Arrow2(props, forwardedRef) {
    const _a = props, { children, width = 10, height = 5 } = _a, arrowProps = __objRest(_a, ["children", "width", "height"]);
    return /* @__PURE__ */ jsx(
      Primitive.svg,
      __spreadProps(__spreadValues({}, arrowProps), {
        ref: forwardedRef,
        width,
        height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ jsx("polygon", { points: "0,0 30,0 15,10" })
      })
    );
  }, "Arrow")
);
var Root$1 = Arrow$1;
var __defProp$6 = Object.defineProperty;
var __name$6 = (target, value) => __defProp$6(target, "name", { value, configurable: true });
function useSize(element) {
  const [size2, setSize] = React.useState(void 0);
  useLayoutEffect2(() => {
    if (element) {
      setSize({ width: element.offsetWidth, height: element.offsetHeight });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({ width, height });
      });
      resizeObserver.observe(element, { box: "border-box" });
      return () => resizeObserver.unobserve(element);
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size2;
}
__name$6(useSize, "useSize");
var __defProp$5 = Object.defineProperty;
var __name$5 = (target, value) => __defProp$5(target, "name", { value, configurable: true });
var POPPER_NAME = "Popper";
var [createPopperContext, createPopperScope] = /* @__PURE__ */ createContextScope(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = /* @__PURE__ */ __name$5((props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = React.useState(null);
  const [placementState, setPlacementState] = React.useState(void 0);
  return /* @__PURE__ */ jsx(
    PopperProvider,
    {
      scope: __scopePopper,
      anchor,
      onAnchorChange: setAnchor,
      placementState,
      setPlacementState,
      children
    }
  );
}, "Popper");
var ANCHOR_NAME = "PopperAnchor";
var PopperAnchor = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$5(function PopperAnchor2(props, forwardedRef) {
    const _a = props, { __scopePopper, virtualRef } = _a, anchorProps = __objRest(_a, ["__scopePopper", "virtualRef"]);
    const context = usePopperContext(ANCHOR_NAME, __scopePopper);
    const ref = React.useRef(null);
    const onAnchorChange = context.onAnchorChange;
    const callbackRef = React.useCallback(
      (node) => {
        ref.current = node;
        if (node) {
          onAnchorChange(node);
        }
      },
      [onAnchorChange]
    );
    const composedRefs = useComposedRefs(forwardedRef, callbackRef);
    const anchorRef = React.useRef(null);
    React.useEffect(() => {
      if (!virtualRef) {
        return;
      }
      const previousAnchor = anchorRef.current;
      anchorRef.current = virtualRef.current;
      if (previousAnchor !== anchorRef.current) {
        onAnchorChange(anchorRef.current);
      }
    });
    const sideAndAlign = context.placementState && getSideAndAlignFromPlacement(context.placementState);
    const placedSide = sideAndAlign == null ? void 0 : sideAndAlign[0];
    const placedAlign = sideAndAlign == null ? void 0 : sideAndAlign[1];
    return virtualRef ? null : /* @__PURE__ */ jsx(
      Primitive.div,
      __spreadProps(__spreadValues({
        "data-radix-popper-side": placedSide,
        "data-radix-popper-align": placedAlign
      }, anchorProps), {
        ref: composedRefs
      })
    );
  }, "PopperAnchor")
);
var CONTENT_NAME$1 = "PopperContent";
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME$1);
var PopperContent = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$5(function PopperContent2(props, forwardedRef) {
    var _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const _a = props, {
      __scopePopper,
      side = "bottom",
      sideOffset = 0,
      align = "center",
      alignOffset = 0,
      arrowPadding = 0,
      avoidCollisions = true,
      collisionBoundary = [],
      collisionPadding: collisionPaddingProp = 0,
      sticky = "partial",
      hideWhenDetached = false,
      updatePositionStrategy = "optimized",
      onPlaced
    } = _a, contentProps = __objRest(_a, [
      "__scopePopper",
      "side",
      "sideOffset",
      "align",
      "alignOffset",
      "arrowPadding",
      "avoidCollisions",
      "collisionBoundary",
      "collisionPadding",
      "sticky",
      "hideWhenDetached",
      "updatePositionStrategy",
      "onPlaced"
    ]);
    const context = usePopperContext(CONTENT_NAME$1, __scopePopper);
    const [content, setContent] = React.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, setContent);
    const [arrow$12, setArrow] = React.useState(null);
    const arrowSize = useSize(arrow$12);
    const arrowWidth = (_b = arrowSize == null ? void 0 : arrowSize.width) != null ? _b : 0;
    const arrowHeight = (_c = arrowSize == null ? void 0 : arrowSize.height) != null ? _c : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : __spreadValues({ top: 0, right: 0, bottom: 0, left: 0 }, collisionPaddingProp);
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
      padding: collisionPadding,
      boundary: boundary.filter(isNotNull),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: hasExplicitBoundaries
    };
    const { refs, floatingStyles, placement, isPositioned, middlewareData } = useFloating({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: desiredPlacement,
      whileElementsMounted: /* @__PURE__ */ __name$5((...args) => {
        const cleanup = autoUpdate(...args, {
          animationFrame: updatePositionStrategy === "always"
        });
        return cleanup;
      }, "whileElementsMounted"),
      elements: {
        reference: context.anchor
      },
      middleware: [
        offset({ mainAxis: sideOffset + arrowHeight, alignmentAxis: alignOffset }),
        avoidCollisions && shift(__spreadValues({
          mainAxis: true,
          crossAxis: false,
          limiter: sticky === "partial" ? limitShift() : void 0
        }, detectOverflowOptions)),
        avoidCollisions && flip(__spreadValues({}, detectOverflowOptions)),
        size(__spreadProps(__spreadValues({}, detectOverflowOptions), {
          apply: /* @__PURE__ */ __name$5(({ elements, rects, availableWidth, availableHeight }) => {
            const { width: anchorWidth, height: anchorHeight } = rects.reference;
            const contentStyle = elements.floating.style;
            contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
            contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
            contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
            contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
          }, "apply")
        })),
        arrow$12 && arrow({ element: arrow$12, padding: arrowPadding }),
        transformOrigin({ arrowWidth, arrowHeight }),
        hideWhenDetached && hide(__spreadProps(__spreadValues({
          strategy: "referenceHidden"
        }, detectOverflowOptions), {
          // `hide` detects whether the anchor (reference) is clipped, so when
          // no explicit `collisionBoundary` is set we fall back to Floating
          // UI's default clipping ancestors (e.g. a scrollable menu). This
          // lets an occluded submenu hide once its anchor scrolls out of view
          // (#3237). The collision/size middlewares deliberately keep the
          // viewport-based default to avoid clamping content rendered inside
          // transformed or overflow-clipping portal containers.
          boundary: hasExplicitBoundaries ? detectOverflowOptions.boundary : void 0
        }))
      ]
    });
    const setPlacementState = context.setPlacementState;
    useLayoutEffect2(() => {
      setPlacementState(placement);
      return () => {
        setPlacementState(void 0);
      };
    }, [placement, setPlacementState]);
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const handlePlaced = useCallbackRef(onPlaced);
    useLayoutEffect2(() => {
      if (isPositioned) {
        handlePlaced == null ? void 0 : handlePlaced();
      }
    }, [isPositioned, handlePlaced]);
    const arrowX = (_d = middlewareData.arrow) == null ? void 0 : _d.x;
    const arrowY = (_e = middlewareData.arrow) == null ? void 0 : _e.y;
    const cannotCenterArrow = ((_f = middlewareData.arrow) == null ? void 0 : _f.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = React.useState();
    useLayoutEffect2(() => {
      if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [content]);
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: __spreadValues(__spreadProps(__spreadValues({}, floatingStyles), {
          transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: contentZIndex,
          "--radix-popper-transform-origin": [
            (_g = middlewareData.transformOrigin) == null ? void 0 : _g.x,
            (_h = middlewareData.transformOrigin) == null ? void 0 : _h.y
          ].join(" ")
        }), ((_i = middlewareData.hide) == null ? void 0 : _i.referenceHidden) && {
          visibility: "hidden",
          pointerEvents: "none"
        }),
        dir: props.dir,
        children: /* @__PURE__ */ jsx(
          PopperContentProvider,
          {
            scope: __scopePopper,
            placedSide,
            placedAlign,
            onArrowChange: setArrow,
            arrowX,
            arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ jsx(
              Primitive.div,
              __spreadProps(__spreadValues({
                "data-side": placedSide,
                "data-align": placedAlign
              }, contentProps), {
                ref: composedRefs,
                style: __spreadProps(__spreadValues({}, contentProps.style), {
                  // if the PopperContent hasn't been placed yet (not all
                  // measurements done) we prevent animations so that users'
                  // animations don't kick in too early from the wrong sides.
                  animation: !isPositioned ? "none" : (_j = contentProps.style) == null ? void 0 : _j.animation
                })
              })
            )
          }
        )
      }
    );
  }, "PopperContent")
);
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var PopperArrow = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$5(function PopperArrow2(props, forwardedRef) {
    const _a = props, { __scopePopper } = _a, arrowProps = __objRest(_a, ["__scopePopper"]);
    const contentContext = useContentContext(ARROW_NAME, __scopePopper);
    const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
    return (
      // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
      // doesn't report size as we'd expect on SVG elements.
      // it reports their bounding box which is effectively the largest path inside the SVG.
      /* @__PURE__ */ jsx(
        "span",
        {
          ref: contentContext.onArrowChange,
          style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
              top: "",
              right: "0 0",
              bottom: "center 0",
              left: "100% 0"
            }[contentContext.placedSide],
            transform: {
              top: "translateY(100%)",
              right: "translateY(50%) rotate(90deg) translateX(-50%)",
              bottom: `rotate(180deg)`,
              left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
          },
          children: /* @__PURE__ */ jsx(
            Root$1,
            __spreadProps(__spreadValues({}, arrowProps), {
              ref: forwardedRef,
              style: __spreadProps(__spreadValues({}, arrowProps.style), {
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
              })
            })
          )
        }
      )
    );
  }, "PopperArrow")
);
function isNotNull(value) {
  return value !== null;
}
__name$5(isNotNull, "isNotNull");
var transformOrigin = /* @__PURE__ */ __name$5((options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _a, _b, _c, _d, _e;
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = ((_a = middlewareData.arrow) == null ? void 0 : _a.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const noArrowAlign = { start: "0%", center: "50%", end: "100%" }[placedAlign];
    const arrowXCenter = ((_c = (_b = middlewareData.arrow) == null ? void 0 : _b.x) != null ? _c : 0) + arrowWidth / 2;
    const arrowYCenter = ((_e = (_d = middlewareData.arrow) == null ? void 0 : _d.y) != null ? _e : 0) + arrowHeight / 2;
    let x = "";
    let y = "";
    if (placedSide === "bottom") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x = `${-arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x = `${rects.floating.width + arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return { data: { x, y } };
  }
}), "transformOrigin");
function getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
__name$5(getSideAndAlignFromPlacement, "getSideAndAlignFromPlacement");
var Root2 = Popper;
var Anchor = PopperAnchor;
var Content = PopperContent;
var Arrow = PopperArrow;
var __defProp$4 = Object.defineProperty;
var __name$4 = (target, value) => __defProp$4(target, "name", { value, configurable: true });
var Portal$1 = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$4(function Portal2(props, forwardedRef) {
    var _b;
    const _a = props, { container: containerProp } = _a, portalProps = __objRest(_a, ["container"]);
    const [mounted, setMounted] = React.useState(false);
    useLayoutEffect2(() => setMounted(true), []);
    const container = containerProp || mounted && ((_b = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _b.body);
    return container ? ReactDOM.createPortal(/* @__PURE__ */ jsx(Primitive.div, __spreadProps(__spreadValues({}, portalProps), { ref: forwardedRef })), container) : null;
  }, "Portal")
);
var __defProp$3 = Object.defineProperty;
var __name$3 = (target, value) => __defProp$3(target, "name", { value, configurable: true });
function useStateMachine(initialState, machine) {
  return React.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState != null ? nextState : state;
  }, initialState);
}
__name$3(useStateMachine, "useStateMachine");
var Presence = /* @__PURE__ */ __name$3((props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : React.Children.only(children);
  const ref = useStableComposedRefs(presence.ref, getElementRef(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? React.cloneElement(child, { ref }) : null;
}, "Presence");
function usePresence(present) {
  const [node, setNode] = React.useState();
  const stylesRef = React.useRef(null);
  const prevPresentRef = React.useRef(present);
  const prevAnimationNameRef = React.useRef("none");
  const mountAnimationNameRef = React.useRef(void 0);
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  React.useEffect(() => {
    var _a;
    if (state === "mounted") {
      prevAnimationNameRef.current = (_a = mountAnimationNameRef.current) != null ? _a : getAnimationName(stylesRef.current);
      mountAnimationNameRef.current = void 0;
    } else {
      prevAnimationNameRef.current = "none";
    }
  }, [state]);
  useLayoutEffect2(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        mountAnimationNameRef.current = currentAnimationName;
        send("MOUNT");
      } else if (currentAnimationName === "none" || (styles == null ? void 0 : styles.display) === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    var _a;
    if (node) {
      let timeoutId;
      const ownerWindow = (_a = node.ownerDocument.defaultView) != null ? _a : window;
      const handleAnimationEnd = /* @__PURE__ */ __name$3((event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
        if (event.target === node && isCurrentAnimation) {
          send("ANIMATION_END");
          if (!prevPresentRef.current) {
            const currentFillMode = node.style.animationFillMode;
            node.style.animationFillMode = "forwards";
            timeoutId = ownerWindow.setTimeout(() => {
              if (node.style.animationFillMode === "forwards") {
                node.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      }, "handleAnimationEnd");
      const handleAnimationStart = /* @__PURE__ */ __name$3((event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      }, "handleAnimationStart");
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: React.useCallback((node2) => {
      if (node2) {
        const styles = getComputedStyle(node2);
        stylesRef.current = styles;
        mountAnimationNameRef.current = getAnimationName(styles);
      } else {
        stylesRef.current = null;
      }
      setNode(node2);
    }, [])
  };
}
__name$3(usePresence, "usePresence");
function setRef(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
__name$3(setRef, "setRef");
function useStableComposedRefs(...refs) {
  const refsRef = React.useRef(refs);
  refsRef.current = refs;
  return React.useCallback((node) => {
    const currentRefs = refsRef.current;
    let hasCleanup = false;
    const cleanups = currentRefs.map((ref) => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup === "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0; i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup === "function") {
            cleanup();
          } else {
            setRef(currentRefs[i], null);
          }
        }
      };
    }
  }, []);
}
__name$3(useStableComposedRefs, "useStableComposedRefs");
function getAnimationName(styles) {
  return (styles == null ? void 0 : styles.animationName) || "none";
}
__name$3(getAnimationName, "getAnimationName");
function getElementRef(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
__name$3(getElementRef, "getElementRef");
var __defProp$2 = Object.defineProperty;
var __name$2 = (target, value) => __defProp$2(target, "name", { value, configurable: true });
var useInsertionEffect = React[" useInsertionEffect ".trim().toString()] || useLayoutEffect2;
function useControllableState({
  prop,
  defaultProp,
  onChange = /* @__PURE__ */ __name$2(() => {
  }, "onChange"),
  caller
}) {
  const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  const setValue = React.useCallback(
    (nextValue) => {
      var _a;
      if (isControlled) {
        const value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
        if (value2 !== prop) {
          (_a = onChangeRef.current) == null ? void 0 : _a.call(onChangeRef, value2);
        }
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, onChangeRef]
  );
  return [value, setValue];
}
__name$2(useControllableState, "useControllableState");
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const [value, setValue] = React.useState(defaultProp);
  const prevValueRef = React.useRef(value);
  const onChangeRef = React.useRef(onChange);
  useInsertionEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  React.useEffect(() => {
    var _a;
    if (prevValueRef.current !== value) {
      (_a = onChangeRef.current) == null ? void 0 : _a.call(onChangeRef, value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}
__name$2(useUncontrolledState, "useUncontrolledState");
function isFunction(value) {
  return typeof value === "function";
}
__name$2(isFunction, "isFunction");
var SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function useControllableStateReducer(reducer, userArgs, initialArg, init) {
  const { prop: controlledState, defaultProp, onChange: onChangeProp, caller } = userArgs;
  const isControlled = controlledState !== void 0;
  const onChange = useEffectEvent(onChangeProp);
  const args = [__spreadProps(__spreadValues({}, initialArg), { state: defaultProp })];
  if (init) {
    args.push(init);
  }
  const [internalState, dispatch] = React.useReducer(
    (state2, action) => {
      if (action.type === SYNC_STATE) {
        return __spreadProps(__spreadValues({}, state2), { state: action.state });
      }
      const next = reducer(state2, action);
      if (isControlled && !Object.is(next.state, state2.state)) {
        onChange(next.state);
      }
      return next;
    },
    ...args
  );
  const uncontrolledState = internalState.state;
  const prevValueRef = React.useRef(uncontrolledState);
  React.useEffect(() => {
    if (prevValueRef.current !== uncontrolledState) {
      prevValueRef.current = uncontrolledState;
      if (!isControlled) {
        onChange(uncontrolledState);
      }
    }
  }, [uncontrolledState, prevValueRef, isControlled]);
  const state = React.useMemo(() => {
    const isControlled2 = controlledState !== void 0;
    if (isControlled2) {
      return __spreadProps(__spreadValues({}, internalState), { state: controlledState });
    }
    return internalState;
  }, [internalState, controlledState]);
  React.useEffect(() => {
    if (isControlled && !Object.is(controlledState, internalState.state)) {
      dispatch({ type: SYNC_STATE, state: controlledState });
    }
  }, [controlledState, internalState.state, isControlled]);
  return [state, dispatch];
}
__name$2(useControllableStateReducer, "useControllableStateReducer");
var __defProp$1 = Object.defineProperty;
var __name$1 = (target, value) => __defProp$1(target, "name", { value, configurable: true });
var VISUALLY_HIDDEN_STYLES = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
});
var VisuallyHidden = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name$1(function VisuallyHidden2(props, forwardedRef) {
    return /* @__PURE__ */ jsx(
      Primitive.span,
      __spreadProps(__spreadValues({}, props), {
        ref: forwardedRef,
        style: __spreadValues(__spreadValues({}, VISUALLY_HIDDEN_STYLES), props.style)
      })
    );
  }, "VisuallyHidden")
);
var Root = VisuallyHidden;
var __defProp2 = Object.defineProperty;
var __name = (target, value) => __defProp2(target, "name", { value, configurable: true });
var [createTooltipContext, createTooltipScope] = /* @__PURE__ */ createContextScope("Tooltip", [
  createPopperScope
]);
var usePopperScope = createPopperScope();
var PROVIDER_NAME = "TooltipProvider";
var DEFAULT_DELAY_DURATION = 700;
var TOOLTIP_OPEN = "tooltip.open";
var [TooltipProviderContextProvider, useTooltipProviderContext] = createTooltipContext(PROVIDER_NAME);
var TooltipProvider = /* @__PURE__ */ __name((props) => {
  const {
    __scopeTooltip,
    delayDuration = DEFAULT_DELAY_DURATION,
    skipDelayDuration = 300,
    disableHoverableContent = false,
    children
  } = props;
  const isOpenDelayedRef = React.useRef(true);
  const isPointerInTransitRef = React.useRef(false);
  const skipDelayTimerRef = React.useRef(0);
  React.useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current;
    return () => window.clearTimeout(skipDelayTimer);
  }, []);
  return /* @__PURE__ */ jsx(
    TooltipProviderContextProvider,
    {
      scope: __scopeTooltip,
      isOpenDelayedRef,
      delayDuration,
      onOpen: React.useCallback(() => {
        if (skipDelayDuration <= 0) return;
        window.clearTimeout(skipDelayTimerRef.current);
        isOpenDelayedRef.current = false;
      }, [skipDelayDuration]),
      onClose: React.useCallback(() => {
        if (skipDelayDuration <= 0) return;
        window.clearTimeout(skipDelayTimerRef.current);
        skipDelayTimerRef.current = window.setTimeout(
          () => isOpenDelayedRef.current = true,
          skipDelayDuration
        );
      }, [skipDelayDuration]),
      isPointerInTransitRef,
      onPointerInTransitChange: React.useCallback((inTransit) => {
        isPointerInTransitRef.current = inTransit;
      }, []),
      disableHoverableContent,
      children
    }
  );
}, "TooltipProvider");
var TOOLTIP_NAME = "Tooltip";
var [TooltipContextProvider, useTooltipContext$1] = createTooltipContext(TOOLTIP_NAME);
var Tooltip$1 = /* @__PURE__ */ __name((props) => {
  const {
    __scopeTooltip,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    disableHoverableContent: disableHoverableContentProp,
    delayDuration: delayDurationProp
  } = props;
  const providerContext = useTooltipProviderContext(TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = usePopperScope(__scopeTooltip);
  const [trigger, setTrigger] = React.useState(null);
  const [contentIdState, setContentId] = React.useState(void 0);
  const generatedContentId = useId();
  const openTimerRef = React.useRef(0);
  const disableHoverableContent = disableHoverableContentProp != null ? disableHoverableContentProp : providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp != null ? delayDurationProp : providerContext.delayDuration;
  const wasOpenDelayedRef = React.useRef(false);
  const [open, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen != null ? defaultOpen : false,
    onChange: /* @__PURE__ */ __name((open2) => {
      if (open2) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent(TOOLTIP_OPEN));
      } else {
        providerContext.onClose();
      }
      onOpenChange == null ? void 0 : onOpenChange(open2);
    }, "onChange"),
    caller: TOOLTIP_NAME
  });
  const stateAttribute = React.useMemo(() => {
    return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [open]);
  const handleOpen = React.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = 0;
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [setOpen]);
  const handleClose = React.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = 0;
    setOpen(false);
  }, [setOpen]);
  const handleDelayedOpen = React.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
      openTimerRef.current = 0;
    }, delayDuration);
  }, [delayDuration, setOpen]);
  React.useEffect(() => {
    return () => {
      if (openTimerRef.current) {
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
      }
    };
  }, []);
  const contentId = contentIdState != null ? contentIdState : generatedContentId;
  return /* @__PURE__ */ jsx(Root2, __spreadProps(__spreadValues({}, popperScope), { children: /* @__PURE__ */ jsx(
    TooltipContextProvider,
    {
      scope: __scopeTooltip,
      contentId,
      setContentId,
      open,
      stateAttribute,
      trigger,
      onTriggerChange: setTrigger,
      onTriggerEnter: React.useCallback(() => {
        if (providerContext.isOpenDelayedRef.current) handleDelayedOpen();
        else handleOpen();
      }, [providerContext.isOpenDelayedRef, handleDelayedOpen, handleOpen]),
      onTriggerLeave: React.useCallback(() => {
        if (disableHoverableContent) {
          handleClose();
        } else {
          window.clearTimeout(openTimerRef.current);
          openTimerRef.current = 0;
        }
      }, [handleClose, disableHoverableContent]),
      onOpen: handleOpen,
      onClose: handleClose,
      disableHoverableContent,
      children
    }
  ) }));
}, "Tooltip");
var TRIGGER_NAME = "TooltipTrigger";
var TooltipTrigger$1 = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name(function TooltipTrigger2(props, forwardedRef) {
    const _a = props, { __scopeTooltip } = _a, triggerProps = __objRest(_a, ["__scopeTooltip"]);
    const context = useTooltipContext$1(TRIGGER_NAME, __scopeTooltip);
    const providerContext = useTooltipProviderContext(TRIGGER_NAME, __scopeTooltip);
    const popperScope = usePopperScope(__scopeTooltip);
    const ref = React.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = React.useRef(false);
    const hasPointerMoveOpenedRef = React.useRef(false);
    const handlePointerUp = React.useCallback(() => isPointerDownRef.current = false, []);
    React.useEffect(() => {
      return () => document.removeEventListener("pointerup", handlePointerUp);
    }, [handlePointerUp]);
    return /* @__PURE__ */ jsx(Anchor, __spreadProps(__spreadValues({ asChild: true }, popperScope), { children: /* @__PURE__ */ jsx(
      Primitive.button,
      __spreadProps(__spreadValues({
        "aria-describedby": context.open ? context.contentId : void 0,
        "data-state": context.stateAttribute
      }, triggerProps), {
        ref: composedRefs,
        onPointerMove: composeEventHandlers(props.onPointerMove, (event) => {
          if (event.pointerType === "touch") return;
          if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
            context.onTriggerEnter();
            hasPointerMoveOpenedRef.current = true;
          }
        }),
        onPointerLeave: composeEventHandlers(props.onPointerLeave, () => {
          context.onTriggerLeave();
          hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: composeEventHandlers(props.onPointerDown, () => {
          if (context.open) {
            context.onClose();
          }
          isPointerDownRef.current = true;
          document.addEventListener("pointerup", handlePointerUp, { once: true });
        }),
        onFocus: composeEventHandlers(props.onFocus, () => {
          if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: composeEventHandlers(props.onBlur, context.onClose),
        onClick: composeEventHandlers(props.onClick, context.onClose)
      })
    ) }));
  }, "TooltipTrigger")
);
var PORTAL_NAME = "TooltipPortal";
var [PortalProvider, usePortalContext] = createTooltipContext(PORTAL_NAME, {
  forceMount: void 0
});
var TooltipPortal = /* @__PURE__ */ __name((props) => {
  const { __scopeTooltip, forceMount, children, container } = props;
  const context = useTooltipContext$1(PORTAL_NAME, __scopeTooltip);
  return /* @__PURE__ */ jsx(PortalProvider, { scope: __scopeTooltip, forceMount, children: /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Portal$1, { asChild: true, container, children }) }) });
}, "TooltipPortal");
var CONTENT_NAME = "TooltipContent";
var TooltipContent$1 = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name(function TooltipContent2(props, forwardedRef) {
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopeTooltip);
    const _a = props, { forceMount = portalContext.forceMount, side = "top" } = _a, contentProps = __objRest(_a, ["forceMount", "side"]);
    const context = useTooltipContext$1(CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: context.disableHoverableContent ? /* @__PURE__ */ jsx(TooltipContentImpl, __spreadProps(__spreadValues({ side }, contentProps), { ref: forwardedRef })) : /* @__PURE__ */ jsx(TooltipContentHoverable, __spreadProps(__spreadValues({ side }, contentProps), { ref: forwardedRef })) });
  }, "TooltipContent")
);
var TooltipContentHoverable = /* @__PURE__ */ React.forwardRef(/* @__PURE__ */ __name(function TooltipContentHoverable2(props, forwardedRef) {
  const context = useTooltipContext$1(CONTENT_NAME, props.__scopeTooltip);
  const providerContext = useTooltipProviderContext(CONTENT_NAME, props.__scopeTooltip);
  const ref = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = React.useState(null);
  const { trigger, onClose } = context;
  const content = ref.current;
  const { onPointerInTransitChange } = providerContext;
  const handleRemoveGraceArea = React.useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [onPointerInTransitChange]);
  const handleCreateGraceArea = React.useCallback(
    (event, hoverTarget) => {
      const currentTarget = event.currentTarget;
      const exitPoint = { x: event.clientX, y: event.clientY };
      const exitSide = getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
      const paddedExitPoints = getPaddedExitPoints(exitPoint, exitSide);
      const hoverTargetPoints = getPointsFromRect(hoverTarget.getBoundingClientRect());
      const graceArea = getHull([...paddedExitPoints, ...hoverTargetPoints]);
      setPointerGraceArea(graceArea);
      onPointerInTransitChange(true);
    },
    [onPointerInTransitChange]
  );
  React.useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [handleRemoveGraceArea]);
  React.useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = /* @__PURE__ */ __name((event) => handleCreateGraceArea(event, content), "handleTriggerLeave");
      const handleContentLeave = /* @__PURE__ */ __name((event) => handleCreateGraceArea(event, trigger), "handleContentLeave");
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [trigger, content, handleCreateGraceArea, handleRemoveGraceArea]);
  React.useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = /* @__PURE__ */ __name((event) => {
        const target = event.target;
        const pointerPosition = { x: event.clientX, y: event.clientY };
        const hasEnteredTarget = (trigger == null ? void 0 : trigger.contains(target)) || (content == null ? void 0 : content.contains(target));
        const isPointerOutsideGraceArea = !isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) {
          handleRemoveGraceArea();
        } else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      }, "handleTrackPointerGrace");
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [trigger, content, pointerGraceArea, onClose, handleRemoveGraceArea]);
  return /* @__PURE__ */ jsx(TooltipContentImpl, __spreadProps(__spreadValues({}, props), { ref: composedRefs }));
}, "TooltipContentHoverable"));
var Slottable = /* @__PURE__ */ createSlottable("TooltipContent");
var TooltipContentImpl = /* @__PURE__ */ React.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ __name(function TooltipContentImpl2(props, forwardedRef) {
    const _a = props, {
      __scopeTooltip,
      children,
      "aria-label": ariaLabel,
      id: idProp,
      onEscapeKeyDown,
      onPointerDownOutside
    } = _a, contentProps = __objRest(_a, [
      "__scopeTooltip",
      "children",
      "aria-label",
      "id",
      "onEscapeKeyDown",
      "onPointerDownOutside"
    ]);
    const context = useTooltipContext$1(CONTENT_NAME, __scopeTooltip);
    const popperScope = usePopperScope(__scopeTooltip);
    const { onClose } = context;
    React.useEffect(() => {
      document.addEventListener(TOOLTIP_OPEN, onClose);
      return () => document.removeEventListener(TOOLTIP_OPEN, onClose);
    }, [onClose]);
    React.useEffect(() => {
      if (context.trigger) {
        const handleScroll = /* @__PURE__ */ __name((event) => {
          if (event.target instanceof Node && event.target.contains(context.trigger)) {
            onClose();
          }
        }, "handleScroll");
        window.addEventListener("scroll", handleScroll, { capture: true });
        return () => window.removeEventListener("scroll", handleScroll, { capture: true });
      }
    }, [context.trigger, onClose]);
    const { setContentId } = context;
    useLayoutEffect2(() => {
      setContentId(idProp);
      return () => {
        setContentId(void 0);
      };
    }, [idProp, setContentId]);
    return /* @__PURE__ */ jsx(
      DismissableLayer,
      {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown,
        onPointerDownOutside,
        onFocusOutside: (event) => event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ jsxs(
          Content,
          __spreadProps(__spreadValues(__spreadValues({
            "data-state": context.stateAttribute,
            role: ariaLabel ? void 0 : "tooltip",
            id: ariaLabel ? void 0 : context.contentId
          }, popperScope), contentProps), {
            ref: forwardedRef,
            style: __spreadValues(__spreadValues({}, contentProps.style), {
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            }),
            children: [
              /* @__PURE__ */ jsx(Slottable, { children }),
              ariaLabel ? /* @__PURE__ */ jsx(Root, { id: context.contentId, role: "tooltip", children: ariaLabel }) : null
            ]
          })
        )
      }
    );
  }, "TooltipContentImpl")
);
var TooltipArrow = /* @__PURE__ */ React.forwardRef(
  /* @__PURE__ */ __name(function TooltipArrow2(props, forwardedRef) {
    const _a = props, { __scopeTooltip } = _a, arrowProps = __objRest(_a, ["__scopeTooltip"]);
    const popperScope = usePopperScope(__scopeTooltip);
    return /* @__PURE__ */ jsx(Arrow, __spreadProps(__spreadValues(__spreadValues({}, popperScope), arrowProps), { ref: forwardedRef }));
  }, "TooltipArrow")
);
function getExitSideFromRect(point, rect) {
  const top = Math.abs(rect.top - point.y);
  const bottom = Math.abs(rect.bottom - point.y);
  const right = Math.abs(rect.right - point.x);
  const left = Math.abs(rect.left - point.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
__name(getExitSideFromRect, "getExitSideFromRect");
function getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
  const paddedExitPoints = [];
  switch (exitSide) {
    case "top":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y + padding },
        { x: exitPoint.x + padding, y: exitPoint.y + padding }
      );
      break;
    case "bottom":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y - padding },
        { x: exitPoint.x + padding, y: exitPoint.y - padding }
      );
      break;
    case "left":
      paddedExitPoints.push(
        { x: exitPoint.x + padding, y: exitPoint.y - padding },
        { x: exitPoint.x + padding, y: exitPoint.y + padding }
      );
      break;
    case "right":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y - padding },
        { x: exitPoint.x - padding, y: exitPoint.y + padding }
      );
      break;
  }
  return paddedExitPoints;
}
__name(getPaddedExitPoints, "getPaddedExitPoints");
function getPointsFromRect(rect) {
  const { top, right, bottom, left } = rect;
  return [
    { x: left, y: top },
    { x: right, y: top },
    { x: right, y: bottom },
    { x: left, y: bottom }
  ];
}
__name(getPointsFromRect, "getPointsFromRect");
function isPointInPolygon(point, polygon) {
  const { x, y } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const ii = polygon[i];
    const jj = polygon[j];
    const xi = ii.x;
    const yi = ii.y;
    const xj = jj.x;
    const yj = jj.y;
    const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
__name(isPointInPolygon, "isPointInPolygon");
function getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a, b) => {
    if (a.x < b.x) return -1;
    else if (a.x > b.x) return 1;
    else if (a.y < b.y) return -1;
    else if (a.y > b.y) return 1;
    else return 0;
  });
  return getHullPresorted(newPoints);
}
__name(getHull, "getHull");
function getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  const upperHull = [];
  for (let i = 0; i < points.length; i++) {
    const p = points[i];
    while (upperHull.length >= 2) {
      const q = upperHull[upperHull.length - 1];
      const r2 = upperHull[upperHull.length - 2];
      if ((q.x - r2.x) * (p.y - r2.y) >= (q.y - r2.y) * (p.x - r2.x)) upperHull.pop();
      else break;
    }
    upperHull.push(p);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i = points.length - 1; i >= 0; i--) {
    const p = points[i];
    while (lowerHull.length >= 2) {
      const q = lowerHull[lowerHull.length - 1];
      const r2 = lowerHull[lowerHull.length - 2];
      if ((q.x - r2.x) * (p.y - r2.y) >= (q.y - r2.y) * (p.x - r2.x)) lowerHull.pop();
      else break;
    }
    lowerHull.push(p);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) {
    return upperHull;
  } else {
    return upperHull.concat(lowerHull);
  }
}
__name(getHullPresorted, "getHullPresorted");
var Provider = TooltipProvider;
var Root3 = Tooltip$1;
var Trigger = TooltipTrigger$1;
var Portal = TooltipPortal;
var Content2 = TooltipContent$1;
var Arrow22 = TooltipArrow;
const VIEWPORT_GUTTER_PX = 16;
const TooltipContext = createContext(null);
function useTooltipContext(part) {
  const context = useContext(TooltipContext);
  if (!context) throw new Error(`<${part}> must be used within <Tooltip>`);
  return context;
}
function Tooltip({
  children
}) {
  const [openState, setOpenState] = useState("closed");
  const triggerRef = useRef(null);
  const handleOpenChange = (isOpen) => {
    setOpenState((current) => {
      if (isOpen) return current === "closed" ? "transient" : current;
      return current === "pinned" ? current : "closed";
    });
  };
  const context = useMemo(() => ({
    close: () => setOpenState("closed"),
    togglePinned: () => setOpenState((current) => current === "pinned" ? "closed" : "pinned"),
    triggerRef
  }), []);
  return /* @__PURE__ */ jsx(TooltipContext.Provider, { value: context, children: /* @__PURE__ */ jsx(Provider, { delayDuration: 0, children: /* @__PURE__ */ jsx(Root3, { open: openState !== "closed", onOpenChange: handleOpenChange, children }) }) });
}
function TooltipTrigger(_E) {
  var _F = _E, {
    onClick,
    onPointerDown
  } = _F, props = __objRest(_F, [
    "onClick",
    "onPointerDown"
  ]);
  const {
    togglePinned,
    triggerRef
  } = useTooltipContext("TooltipTrigger");
  const handlePointerDown = (event) => {
    onPointerDown == null ? void 0 : onPointerDown(event);
    event.preventDefault();
  };
  const handleClick = (event) => {
    onClick == null ? void 0 : onClick(event);
    if (event.defaultPrevented) return;
    event.preventDefault();
    togglePinned();
  };
  return /* @__PURE__ */ jsx(Trigger, __spreadProps(__spreadValues({}, props), { ref: triggerRef, onClick: handleClick, onPointerDown: handlePointerDown }));
}
function TooltipContent({
  children,
  align = "center",
  alignOffset = align === "center" ? 0 : -16,
  portal = true,
  className
}) {
  const {
    close,
    triggerRef
  } = useTooltipContext("TooltipContent");
  const panel = /* @__PURE__ */ jsxs(Content2, { align, alignOffset, className: cn("z-50 grid w-[309px] max-w-[calc(100vw-32px)] grid-cols-[minmax(0,1fr)_auto] items-start gap-y-8 rounded-lg bg-surface p-16 text-left text-xs leading-xs text-text drop-shadow-tooltip", className), collisionPadding: VIEWPORT_GUTTER_PX, side: "top", sideOffset: 8, onEscapeKeyDown: close, onPointerDownOutside: (event) => {
    var _a;
    if ((_a = triggerRef.current) == null ? void 0 : _a.contains(event.target)) {
      event.preventDefault();
      return;
    }
    close();
  }, children: [
    children,
    /* @__PURE__ */ jsx(Arrow22, { className: "fill-surface", height: 6, width: 17 })
  ] });
  return portal ? /* @__PURE__ */ jsx(Portal, { children: panel }) : panel;
}
function TooltipDescription({
  children,
  className
}) {
  return /* @__PURE__ */ jsx("span", { className: cn("col-start-1 font-light", className), children });
}
function LocalizationProvider({
  children,
  namespaces,
  language,
  fallback
}) {
  const [translations, setTranslations] = useState(null);
  const namespacesKey = namespaces.join(",");
  const normalizedLanguage = language.toLowerCase();
  useEffect(() => {
    let isCurrent = true;
    const namespacesToLoad = namespacesKey ? namespacesKey.split(",") : [];
    void loadNamespaceMessages(namespacesToLoad, normalizedLanguage).then((loadedTranslations) => {
      if (isCurrent) startTransition(() => setTranslations(loadedTranslations));
    }).catch((error) => {
      trackDatadogLogs({
        eventName: "i18n_provider_load_failed",
        eventType: "error",
        eventDetails: {
          namespaces: namespacesKey,
          language: normalizedLanguage,
          error: String(error)
        }
      });
      if (isCurrent) startTransition(() => setTranslations(createEmptyMessages(normalizedLanguage)));
    });
    return () => {
      isCurrent = false;
    };
  }, [normalizedLanguage, namespacesKey]);
  if (!translations) return fallback === void 0 ? /* @__PURE__ */ jsx(Loader, {}) : fallback;
  return /* @__PURE__ */ jsx(ClientI18NProvider, { language: normalizedLanguage, messages: translations, onMissingKey: handleMissingKey, children });
}
class MeasErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorDetails: "",
      hasError: false,
      infoStack: ""
    };
  }
  static getDerivedStateFromError(error) {
    const {
      mainText,
      stackText
    } = collectRuntimeErrorDetails(error);
    return {
      errorDetails: mainText,
      hasError: true,
      infoStack: stackText
    };
  }
  componentDidCatch(_error, _info) {
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsxs("div", { className: "meas-container--vh-centered", children: [
        /* @__PURE__ */ jsxs("div", { className: "meas-content--500-centered meas-offsets--ext-bl-e-40", children: [
          /* @__PURE__ */ jsx("div", { className: "meas-text--centered title-01-regular", style: {
            marginBlockEnd: "20px"
          }, children: "Sorry, we ran into technical difficulties" }),
          /* @__PURE__ */ jsx("div", { className: "meas-text--centered title-03-light", children: "Please, report the issue with the details you see" })
        ] }),
        this.props.fallbackComponent ? /* @__PURE__ */ jsx("div", { className: "meas-offsets--ext-bl-e-40", children: this.props.fallbackComponent }) : null,
        /* @__PURE__ */ jsxs("div", { className: "meas-content--640-centered meas-error-stack-section", children: [
          /* @__PURE__ */ jsx("div", { className: "body-small-medium", children: this.state.errorDetails }),
          /* @__PURE__ */ jsx("div", { className: "meas-content-separator has-equal-small-v-offsets is-dark" }),
          /* @__PURE__ */ jsx("div", { className: "body-small-light", children: this.state.infoStack })
        ] })
      ] });
    }
    return this.props.children;
  }
}
function BaseProvider(t0) {
  "use memo";
  const $ = distExports.c(6);
  const {
    children,
    env
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] !== children || $[1] !== queryClient) {
    t1 = /* @__PURE__ */ jsx(StrictMode, { children: /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClient, children }) });
    $[0] = children;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== env || $[4] !== t1) {
    t2 = /* @__PURE__ */ jsx(MeasErrorBoundary, { children: /* @__PURE__ */ jsx(CommonConfigProvider, { env, children: t1 }) });
    $[3] = env;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp() {
  return new QueryClient(COMMON_QUERY_CLIENT_CONFIG);
}
export {
  Accordion as A,
  BaseProvider as B,
  createI18n as C,
  DEFAULT_LANGUAGE as D,
  InputField as E,
  InputPhoneNumber as F,
  ListItem as G,
  Checkbox as H,
  Icon as I,
  clsx as J,
  useI18N as K,
  LocalizationProvider as L,
  SelectField as M,
  ClientI18NProvider as N,
  NumericRangeDecrement as O,
  NumericRangeIncrement as P,
  NumericRangeValue as Q,
  NumericRange as R,
  SwitchLabel as S,
  Tooltip as T,
  LOCALIZATION_NAMESPACES as a,
  cn as b,
  commonErrorHandler as c,
  buildMeasurementsTranslationPrefix as d,
  executeFunctionSafely as e,
  translateProductType as f,
  getApiErrorStatusKey as g,
  Button as h,
  Loader as i,
  TooltipTrigger as j,
  TooltipContent as k,
  TooltipDescription as l,
  checkForNotFoundErrorStatus as m,
  translateProductTypeInSentence as n,
  checkForAuthErrorStatus as o,
  ActionCard as p,
  translateDataDrivenTerm as q,
  useLocalizationLanguage as r,
  safeParseErrorToText as s,
  translatePassportTerm as t,
  useLocalization as u,
  SwitchThumb as v,
  Switch as w,
  cva as x,
  translateWithFallback as y,
  translateTailorInstructionTitle as z
};
